// This file is auto-generated by @hey-api/openapi-ts

import { type Options, getAuth0EmailVerificationStatus, resendAuth0VerificationEmail, generatePasswordResetUrl, getCheckMailingAddress, getLicenseTypes, getFeeStructureFriendlyNames, getLicenseTypeQuestions, getLicenseTypeConfiguration, getNonRegistrantLicenses, getNonRegistrantLicenseStats, getNonRegistrantLicenseFilterValues, getNonRegistrantLicenseMapPins, exportNonRegistrantLicenses, getNonRegistrantLicenseListQuestionColumns, getNonRegistrantRegistrantAccounts, searchRegistrantAccounts, getNonRegistrantRegistrantAccount, getNonRegistrantRegistrantAccountLoginIdentities, getNonRegistrantOrganizations, getNonRegistrantOrganization, getInspections, getLicenseDetails, updateLicense, getLicenseHistory, getLicenseQuestionAnswerHistory, listLicenseNotificationEmails, getLicenseNotificationEmail, updateLicenseAdditionalQuestions, updateLicenseRegistrant, deriveLicenseFromPayments, approveLicense, createLicenseModificationRequest, approveLicenseModificationRequest, denyLicenseModificationRequest, cancelLicense, getLicenseDeregistrationQuestions, startDeregisterLicense, getNonRegistrantLicenseComments, createLicenseComment, resolveRegistryNotification, flagComplianceIssue, clearComplianceIssue, uploadSharedAnswerFile, deleteLicenseComment, getNonRegistrantLicensePayments, makeSharedLicensePayment, getPaymentReceiptTemplateAvailable, getRegistrationCertificateTemplateAvailable, getLicenseRegistrationCertificatePdf, getLicensePaymentReceiptOptions, getLicensePaymentReceiptPdf, getInspectionPaymentReceiptPdf, rejectLicense, previewLicenseTransfer, transferLicense, createManualPayment, getManualPaymentAvailablePeriods, updateLicensePaymentPeriod, deleteManualPayment, updateManualPayment, getAdminUsers, createAdminUser, getOperatorAccess, getAdminUser, updateAdminUser, getAllLicenseTypeQuestions, createLicenseTypeQuestion, getLicenseTypeQuestion, updateLicenseTypeQuestion, getParties, createParty, getParty, updateParty, getPreviousPropertyManagers, getQuestionOptions, createQuestionOption, getQuestionOption, updateQuestionOption, lookupParcelByAddress, lookupParcelByApn, generateReport, getAnswerFile, getFeesForNewLicense, getFeesForRenewal, getFeesForPayment, updateInspection, uploadTempFile, getAttomForeclosureCaseDetails, fetchLiveLinkUrl, searchRegistrantsForImpersonation, getRegistrantAccount, updateRegistrantAccount, getRegistrantAccountUsers, addSecondaryUser, getRegistrantOrgPaymentAccount, updateRegistrantOrgPaymentAccount, updateRegistrantAccountLoginIdentityAccountsContact, updateRegistrantLoginIdentityInspectionAccess, updateRegistrantAccountUserAccountsContact, updateRegistrantAccountUserInspectionAccess, getRegistrantLicenses, createLicense, listActiveLicensesByProperty, getRegistrantLicenseStats, getRegistrantLicenseFilterValues, getRegistrantLicenseJurisdictionOptions, getRegistrantLicenseMapPins, exportRegistrantLicenses, getRegistrantUnregisteredProperties, getLicenseComments, createRegistrantLicenseComment, getLicensePayments, makeLicensePayment, createPendingPaymentRecords, getBulkPaymentFees, createBulkPendingPaymentRecords, makeBulkLicensePayment, createBulkCheckPayment, createRegistrantCheckPayment, createBulkInvoicePayment, createRegistrantInvoicePayment, getRegistrantPayments, getRegistrantInvoices, getRegistrantPaymentProcessorPaymentDetail, getRegistrantPaymentDetail, getRegistrantInvoicePdf, cancelRegistrantPayment, renewLicense, getStripeCheckoutSessionUrl, getLicenseFromCheckoutSession, abandonStripeCheckoutSession, getStripePortalUrl, cancelSecondaryUserInvite, getRegistrantAccountUser, updateRegistrantAccountUser, disableSecondaryUser, reenableSecondaryUser, transferPrimaryOwnership, updateRegistrantAccountUserAdmin, updateRegistrantAccountUserCanMakePayments, getPendingInviteInfo, acceptPendingInvite, rejectPendingInvite, uploadAnswerFile, listInspectionPortalLicenses, listInspectionDispatchLicenses, listInspectionOrgUsers, listInspectionImpersonationCandidates, bulkAssignInspections, ensureInspectionLicenseAccess, unassignInspection, inviteInspectionUser, disableInspectionUser, uploadInspectionAnswerFile, getInspectionServerTime, getJurisdictionInspectionLogoKey, getOmtAmsAccess, searchOmtAmsPartiesForImpersonation, getOmtAmsAccount, getOmtAmsLicenses, getOmtAmsLicenseStats, getOmtAmsLicenseFilterValues, getOmtAmsLicenseMapPins, getOmtAmsLicenseComments, getOmtAmsLicensePayments, getOmtAmsInvoices, getOmtAmsAccountUsers, addOmtAmsSecondaryUser, cancelOmtAmsSecondaryUserInvite, disableOmtAmsSecondaryUser, reenableOmtAmsSecondaryUser, updateOmtAmsAccountUserAdmin, getOmtAmsPendingInviteInfo, acceptOmtAmsPendingInvite, rejectOmtAmsPendingInvite, getJurisdictions, createJurisdiction, getJurisdiction, updateJurisdiction, dryrunJurisdictionCreation, createJurisdictions, updateJurisdictionThemeColor, clearJurisdictionLogo, uploadJurisdictionLogo, listOperatorInspectionImpersonationCandidates, getJurisdictionBranding, refreshJurisdictionBranding, createOrdinanceVersion, deleteOrdinanceVersion, updateOrdinanceVersion, exportOrdinancesCsv, dryrunOrdinanceImport, applyOrdinanceImport, lookupJurisdictionByFipsCode, lookupJurisdictionByTigerCode, fuzzySearchJurisdictionsByName, operatorGetRegistrantByEmail, listLicenseLinkCandidates, linkLicense, operatorCreateLicense, listSavedImportMappings, createSavedImportMapping, deleteSavedImportMapping, updateSavedImportMapping, applySavedImportMapping, getTempFileHeadersAndRowCounts, getJurisdictionFieldMappingForTempFile, getOrdinanceFieldMappingForTempFile, getLicenseFieldMappingForTempFile, getGovernmentUserFieldMappingForTempFile, dryrunGovernmentUserUpsert, upsertGovernmentUsers, dryrunLicenseCreation, createLicenses, getQuestionFieldMappingForTempFile, getQuestionGroupFieldMappingForTempFile, dryrunQuestionCreation, createQuestions, dryrunQuestionGroupCreation, createQuestionGroups, getPartyFieldMappingForTempFile, dryrunPartyCreation, createParties, getCaseNumberFieldMappingForTempFile, dryrunCaseNumberImport, applyCaseNumberImport, previewBulkServiceTransfer, commitBulkServiceTransfer, getHeraConfigurationEndpointOperatorHeraConfigurationGet, updateHeraConfigurationEndpointOperatorHeraConfigurationPut, getManualCheckPayments, getManualCheckPaymentDetail, cancelManualCheckPayment, finaliseManualCheckPayment, markManualCheckPaymentDeposited, getRefundAllocations, getRefundAllocationDetail, finaliseRefundAllocation, getManualInvoicePayments, generateOperatorInvoices, getManualInvoicePaymentDetail, getManualInvoicePaymentPdf, cancelManualInvoicePayment, finaliseManualInvoicePayment, updateRegistrantLoginIdentityOperator, updateOperatorRegistrantAccountAccountsContact, operatorDisableRegistrantUser, operatorReenableRegistrantUser, operatorTransferPrimaryOwnership, operatorAcceptPendingRegistrantInvite, createLicenseType, getLicenseType, updateLicenseType, getAffectedJurisdictionsCount, cascadeJurisdictionStatus, getAllTemplateDocumentsStatus, deleteTemplateDocumentEndpoint, createTemplateDocumentEndpoint, getAllJurisdictionDocumentsStatus, getJurisdictionConfigurationQuestionGroups, updateJurisdictionConfigurationQuestionGroups, deleteJurisdictionDocumentEndpoint, createJurisdictionDocumentEndpoint, getQuestionGroupsOperatorLicenseTypesLicenseTypeIdQuestionGroupsGet, createQuestionGroupOperatorLicenseTypesLicenseTypeIdQuestionGroupsPost, deleteQuestionGroupOperatorQuestionGroupsGroupIdDelete, updateQuestionGroupOperatorQuestionGroupsGroupIdPatch, getQuestionGroupJurisdictions, updateQuestionGroupJurisdictions, getOperatorLicenseFeeAnalysis, getOperatorRevenueAudit, getOperatorRevenueAuditStripeCash, getOperatorPortalKpis, getOperatorPortalPaymentPeriods, getOperatorPortalTrends, getOperatorSystemUsage, getOperatorSystemUsageDetail, getOperatorPortalForeclosureVsRegistrations, getOperatorPortalNotifiedRenewals, getOperatorPortalNeedsAttentionCompliance, getOperatorPortalComplianceTrends, streamOperatorPortalTrendRegistrations, streamOperatorPortalTrendInspections, streamOperatorPortalTrendPayments, streamOperatorPortalTrendInspectionFees, streamOperatorPortalTrendRefunds, streamOperatorPortalTrendRemittance, streamOperatorPortalForecast, getOperatorPortalPaymentLag, getOperatorPortalActivity, getOperatorHubspotScorecard, getOperatorHubspotClosedDealsByWeek, getOperatorLeadershipRenewalCompliance, getOperatorLeadershipReceivablesOverdue, getOperatorLeadershipRegistrationsRenewalsInitiated, getOperatorLeadershipHeraRemittance, getInfoSystemJurisdictionSummaries, getInfoSystemLicenses, getAttomTaxAssessorStatus, getAttomIntegrationStatus, getNextForeclosureLenderPrompt, submitForeclosureInstigatorLabel, undoForeclosureInstigatorLabel, getForeclosureInstigatorMetrics, setForeclosureInstigatorGold, adjudicateForeclosureInstigator, getOperatorForeclosureCases, getOperatorForeclosureCaseFilterValues, getOperatorForeclosureCaseMapPins, getOperatorForeclosureReviewStatusSummary, getOperatorForeclosureCaseChartData, suggestOperatorForeclosureCaseParties, suggestOperatorForeclosureCaseReview, getOperatorForeclosureLicenseAssignmentCandidates, assignOperatorForeclosureLicenses, getOperatorForeclosureLicenseMatches, linkOperatorForeclosureCaseToLicense, updateOperatorForeclosureCaseReview, getOperatorForeclosureCaseReviewHistory, preflightOperatorBulkCreateUnregistered, bulkCreateOperatorUnregisteredFromCases, getOperatorForeclosureUnregisteredMatch, linkOperatorForeclosureCaseToUnregistered, operatorAddressResolutionLookup, operatorAddressResolutionSave, getResidentialOwnerAccess, listResidentialOwnerJurisdictions, listResidentialOwnerMailingAddresses, getResidentialOwnerMailingAddress, updateResidentialOwnerMailingAddress, unlinkResidentialOwnerMailingAddress, linkResidentialOwnerMailingAddresses, listResidentialOwnerCompanies, getResidentialOwnerCompany, updateResidentialOwnerCompany, getResidentialOwnerMailingAddressHistory, confirmResidentialOwnerCompanyFields, rejectResidentialOwnerCompanyFields, mergeResidentialOwnerCompanies, enqueueResidentialOwnerRefresh, enqueueResidentialOwnerEnrichment, listResidentialOwnerJobs, cancelResidentialOwnerJob, getLatestResidentialOwnerRefreshRun, listCompanyQuestionTabs, listCompanyQuestionAnswers, rewriteCompanyQuestionAnswers, getStrListings, getStrListingFilterValues, getStrListingMapPins, getStrProperties, getStrPropertyFilterValues, getStrPropertyMapPins, getStrPropertyDetail, getNextStrAddressMapping, getStrAddressMappingCities, getStrAddressMappingTarget, confirmStrAddressMapping, lookupStrAttomParcel, skipStrAddressMapping, undoStrAddressMapping, getStrAddressMappingNearby, suggestStrUnitClassifications, setStrListingUnitCategory, setStrPropertyUnitCategory, getNextStrDedupPair, submitStrDedupLabel, undoStrDedupLabel, lookupStrDedupListing, loadManualStrDedupPair, getStrDedupMetrics, listGovernmentStrProperties, getGovernmentStrPropertyFilterValues, listGovernmentStrPropertyPins, getGovernmentStrProperty, searchGovernmentUsersForImpersonation, getGovernmentImpersonationMe, getGovernmentJurisdiction, getGovernmentLicenseTypeConfigurations, createGovernmentOrdinanceVersion, deleteGovernmentOrdinanceVersion, updateGovernmentOrdinanceVersion, exportGovernmentOrdinancesCsv, dryrunGovernmentOrdinanceImport, applyGovernmentOrdinanceImport, listGovernmentSavedImportMappings, createGovernmentSavedImportMapping, getGovernmentOrdinanceFieldMappingForTempFile, getGovernmentPortalKpis, getGovernmentPortalTrends, getGovernmentPortalForeclosureVsRegistrations, getGovernmentPortalNotifiedRenewals, getGovernmentPortalComplianceTrends, streamGovernmentPortalTrendRegistrations, streamGovernmentPortalTrendInspections, streamGovernmentPortalTrendPayments, streamGovernmentPortalTrendInspectionFees, streamGovernmentPortalTrendRefunds, streamGovernmentPortalTrendRemittance, getGovernmentPortalPaymentLag, getGovernmentPortalActivity, updateRegistrantLoginIdentityGovernment, updateGovernmentRegistrantAccountAccountsContact, getGovernmentForeclosureCases, getGovernmentForeclosureCaseFilterValues, getGovernmentForeclosureCaseMapPins, getGovernmentForeclosureCaseChartData, suggestGovernmentForeclosureCaseParties, suggestGovernmentForeclosureCaseReview, getGovernmentForeclosureLicenseAssignmentCandidates, assignGovernmentForeclosureLicenses, getGovernmentForeclosureLicenseMatches, linkGovernmentForeclosureCaseToLicense, updateGovernmentForeclosureCaseReview, getGovernmentForeclosureCaseReviewHistory, preflightGovernmentBulkCreateUnregistered, bulkCreateGovernmentUnregisteredFromCases, getGovernmentForeclosureUnregisteredMatch, linkGovernmentForeclosureCaseToUnregistered, getUnregisteredProperties, createUnregisteredProperty, deleteUnregisteredProperty, getUnregisteredProperty, updateUnregisteredProperty, listUnregisteredSavedImportMappings, createUnregisteredSavedImportMapping, deleteUnregisteredSavedImportMapping, updateUnregisteredSavedImportMapping, applyUnregisteredSavedImportMapping, getUnregisteredFieldMappingForTempFile, dryrunUnregisteredCreation, createUnregisteredProperties, getUnregisteredComments, createUnregisteredComment, checkApnRegistered, getTitleAccount, updateTitleAccount, getTitleAccountUsers, addTitleAccountUser, cancelTitleAccountInvite, disableTitleAccountUser, reenableTitleAccountUser, makeTitleAccountPrimary, updateTitleAccountUserAdmin, getTitlePendingInvite, acceptTitlePendingInvite, rejectTitlePendingInvite, searchTitleAccountsForImpersonation, searchOperatorTitleAccounts, createOperatorTitleAccount, lookupTitleRequestAddress, createTitleRequest, claimTitleRequest, listMyTitleRequests, getMyTitleRequest, addMyTitleRequestComment, requestFurtherTitleReview, cancelMyTitleRequest, getMyTitleRequestAttachment, listOperatorTitleRequests, getOperatorTitleRequest, updateOperatorTitleRequest, cancelOperatorTitleRequest, addOperatorTitleRequestComment, sendTitleRequestPropertyCompliant, draftTitleRequestPropertyNonCompliant, sendTitleRequestPropertyNonCompliant, getOperatorTitleRequestAttachment, listPublicCommunities, listPublicRegistrationCommunities, getPublicJurisdiction, listPublicLicenseTypes, getPublicHeraConfiguration, listPublicJurisdictionPages, getPublicJurisdictionPage, getPublicJurisdictionPageLogo, getPublicDemoPlaceSeal, listPublicDemoStateTopPlaces, listPublicDemoHeraCustomersHeatmap, resolvePublicDemoPlace, resolvePublicDemoPlaceAt, getPublicDemoPlaceSummary, getPublicDemoPlaceHubSpotCompany, createPublicDemoPlaceHubSpotCompany, getPublicDemoPlaceEvents, getPublicDemoPlaceBoundary, emailPublicDemoPlaceSummary, listJurisdictionRegions, createJurisdictionRegion, getJurisdictionRegionBoundary, previewJurisdictionRegionUpload, commitJurisdictionRegionUpload, promptJurisdictionRegions, commandJurisdictionRegions, downloadRegionDraftShapefile, deleteJurisdictionRegion, updateJurisdictionRegion, downloadJurisdictionRegionShapefile, checkHealth, onAuth0Login, onStripeEvent, onHubSpotCompanyEvent, listHubSpotCompanyGeofipsOptions, selectHubSpotCompanyGeofips, onHubSpotContactEvent } from '../sdk.gen';
import { queryOptions, type UseMutationOptions, type DefaultError, infiniteQueryOptions, type InfiniteData } from '@tanstack/react-query';
import type { GetAuth0EmailVerificationStatusData, ResendAuth0VerificationEmailData, ResendAuth0VerificationEmailResponse, GeneratePasswordResetUrlData, GeneratePasswordResetUrlResponse, GetCheckMailingAddressData, GetLicenseTypesData, GetFeeStructureFriendlyNamesData, GetLicenseTypeQuestionsData, GetLicenseTypeConfigurationData, GetNonRegistrantLicensesData, GetNonRegistrantLicensesError, GetNonRegistrantLicensesResponse, GetNonRegistrantLicenseStatsData, GetNonRegistrantLicenseFilterValuesData, GetNonRegistrantLicenseMapPinsData, ExportNonRegistrantLicensesData, GetNonRegistrantLicenseListQuestionColumnsData, GetNonRegistrantRegistrantAccountsData, SearchRegistrantAccountsData, GetNonRegistrantRegistrantAccountData, GetNonRegistrantRegistrantAccountLoginIdentitiesData, GetNonRegistrantOrganizationsData, GetNonRegistrantOrganizationData, GetInspectionsData, GetLicenseDetailsData, UpdateLicenseData, UpdateLicenseError, UpdateLicenseResponse, GetLicenseHistoryData, GetLicenseQuestionAnswerHistoryData, ListLicenseNotificationEmailsData, GetLicenseNotificationEmailData, UpdateLicenseAdditionalQuestionsData, UpdateLicenseAdditionalQuestionsError, UpdateLicenseAdditionalQuestionsResponse, UpdateLicenseRegistrantData, UpdateLicenseRegistrantError, UpdateLicenseRegistrantResponse, DeriveLicenseFromPaymentsData, DeriveLicenseFromPaymentsError, DeriveLicenseFromPaymentsResponse, ApproveLicenseData, ApproveLicenseError, ApproveLicenseResponse, CreateLicenseModificationRequestData, CreateLicenseModificationRequestError, CreateLicenseModificationRequestResponse, ApproveLicenseModificationRequestData, ApproveLicenseModificationRequestError, ApproveLicenseModificationRequestResponse, DenyLicenseModificationRequestData, DenyLicenseModificationRequestError, DenyLicenseModificationRequestResponse, CancelLicenseData, CancelLicenseError, CancelLicenseResponse, GetLicenseDeregistrationQuestionsData, StartDeregisterLicenseData, StartDeregisterLicenseError, StartDeregisterLicenseResponse, GetNonRegistrantLicenseCommentsData, CreateLicenseCommentData, CreateLicenseCommentError, CreateLicenseCommentResponse, ResolveRegistryNotificationData, ResolveRegistryNotificationError, ResolveRegistryNotificationResponse, FlagComplianceIssueData, FlagComplianceIssueError, FlagComplianceIssueResponse, ClearComplianceIssueData, ClearComplianceIssueError, ClearComplianceIssueResponse, UploadSharedAnswerFileData, UploadSharedAnswerFileError, UploadSharedAnswerFileResponse, DeleteLicenseCommentData, DeleteLicenseCommentError, DeleteLicenseCommentResponse, GetNonRegistrantLicensePaymentsData, MakeSharedLicensePaymentData, MakeSharedLicensePaymentError, MakeSharedLicensePaymentResponse, GetPaymentReceiptTemplateAvailableData, GetRegistrationCertificateTemplateAvailableData, GetLicenseRegistrationCertificatePdfData, GetLicensePaymentReceiptOptionsData, GetLicensePaymentReceiptPdfData, GetInspectionPaymentReceiptPdfData, RejectLicenseData, RejectLicenseError, RejectLicenseResponse, PreviewLicenseTransferData, TransferLicenseData, TransferLicenseError, TransferLicenseResponse, CreateManualPaymentData, CreateManualPaymentError, CreateManualPaymentResponse, GetManualPaymentAvailablePeriodsData, UpdateLicensePaymentPeriodData, UpdateLicensePaymentPeriodError, UpdateLicensePaymentPeriodResponse, DeleteManualPaymentData, DeleteManualPaymentError, DeleteManualPaymentResponse, UpdateManualPaymentData, UpdateManualPaymentError, UpdateManualPaymentResponse, GetAdminUsersData, CreateAdminUserData, CreateAdminUserError, CreateAdminUserResponse, GetOperatorAccessData, GetAdminUserData, UpdateAdminUserData, UpdateAdminUserError, UpdateAdminUserResponse, GetAllLicenseTypeQuestionsData, CreateLicenseTypeQuestionData, CreateLicenseTypeQuestionError, CreateLicenseTypeQuestionResponse, GetLicenseTypeQuestionData, UpdateLicenseTypeQuestionData, UpdateLicenseTypeQuestionError, UpdateLicenseTypeQuestionResponse, GetPartiesData, CreatePartyData, CreatePartyError, CreatePartyResponse, GetPartyData, UpdatePartyData, UpdatePartyError, UpdatePartyResponse, GetPreviousPropertyManagersData, GetQuestionOptionsData, CreateQuestionOptionData, CreateQuestionOptionError, CreateQuestionOptionResponse, GetQuestionOptionData, UpdateQuestionOptionData, UpdateQuestionOptionError, UpdateQuestionOptionResponse, LookupParcelByAddressData, LookupParcelByAddressError, LookupParcelByAddressResponse, LookupParcelByApnData, LookupParcelByApnError, LookupParcelByApnResponse, GenerateReportData, GenerateReportError, GetAnswerFileData, GetFeesForNewLicenseData, GetFeesForRenewalData, GetFeesForPaymentData, UpdateInspectionData, UpdateInspectionError, UpdateInspectionResponse, UploadTempFileData, UploadTempFileError, UploadTempFileResponse, GetAttomForeclosureCaseDetailsData, FetchLiveLinkUrlData, FetchLiveLinkUrlError, FetchLiveLinkUrlResponse, SearchRegistrantsForImpersonationData, GetRegistrantAccountData, UpdateRegistrantAccountData, UpdateRegistrantAccountError, UpdateRegistrantAccountResponse, GetRegistrantAccountUsersData, AddSecondaryUserData, AddSecondaryUserError, AddSecondaryUserResponse, GetRegistrantOrgPaymentAccountData, UpdateRegistrantOrgPaymentAccountData, UpdateRegistrantOrgPaymentAccountError, UpdateRegistrantOrgPaymentAccountResponse, UpdateRegistrantAccountLoginIdentityAccountsContactData, UpdateRegistrantAccountLoginIdentityAccountsContactError, UpdateRegistrantAccountLoginIdentityAccountsContactResponse, UpdateRegistrantLoginIdentityInspectionAccessData, UpdateRegistrantLoginIdentityInspectionAccessError, UpdateRegistrantLoginIdentityInspectionAccessResponse, UpdateRegistrantAccountUserAccountsContactData, UpdateRegistrantAccountUserAccountsContactError, UpdateRegistrantAccountUserAccountsContactResponse, UpdateRegistrantAccountUserInspectionAccessData, UpdateRegistrantAccountUserInspectionAccessError, UpdateRegistrantAccountUserInspectionAccessResponse, GetRegistrantLicensesData, GetRegistrantLicensesError, GetRegistrantLicensesResponse, CreateLicenseData, CreateLicenseError, CreateLicenseResponse, ListActiveLicensesByPropertyData, GetRegistrantLicenseStatsData, GetRegistrantLicenseFilterValuesData, GetRegistrantLicenseJurisdictionOptionsData, GetRegistrantLicenseMapPinsData, ExportRegistrantLicensesData, GetRegistrantUnregisteredPropertiesData, GetRegistrantUnregisteredPropertiesError, GetRegistrantUnregisteredPropertiesResponse, GetLicenseCommentsData, CreateRegistrantLicenseCommentData, CreateRegistrantLicenseCommentError, CreateRegistrantLicenseCommentResponse, GetLicensePaymentsData, MakeLicensePaymentData, MakeLicensePaymentError, MakeLicensePaymentResponse, CreatePendingPaymentRecordsData, CreatePendingPaymentRecordsError, CreatePendingPaymentRecordsResponse, GetBulkPaymentFeesData, CreateBulkPendingPaymentRecordsData, CreateBulkPendingPaymentRecordsError, CreateBulkPendingPaymentRecordsResponse, MakeBulkLicensePaymentData, MakeBulkLicensePaymentError, MakeBulkLicensePaymentResponse, CreateBulkCheckPaymentData, CreateBulkCheckPaymentError, CreateBulkCheckPaymentResponse, CreateRegistrantCheckPaymentData, CreateRegistrantCheckPaymentError, CreateRegistrantCheckPaymentResponse, CreateBulkInvoicePaymentData, CreateBulkInvoicePaymentError, CreateBulkInvoicePaymentResponse, CreateRegistrantInvoicePaymentData, CreateRegistrantInvoicePaymentError, CreateRegistrantInvoicePaymentResponse, GetRegistrantPaymentsData, GetRegistrantInvoicesData, GetRegistrantPaymentProcessorPaymentDetailData, GetRegistrantPaymentDetailData, GetRegistrantInvoicePdfData, CancelRegistrantPaymentData, CancelRegistrantPaymentError, CancelRegistrantPaymentResponse, RenewLicenseData, RenewLicenseError, RenewLicenseResponse, GetStripeCheckoutSessionUrlData, GetLicenseFromCheckoutSessionData, AbandonStripeCheckoutSessionData, AbandonStripeCheckoutSessionError, AbandonStripeCheckoutSessionResponse, GetStripePortalUrlData, CancelSecondaryUserInviteData, CancelSecondaryUserInviteError, CancelSecondaryUserInviteResponse, GetRegistrantAccountUserData, UpdateRegistrantAccountUserData, UpdateRegistrantAccountUserError, UpdateRegistrantAccountUserResponse, DisableSecondaryUserData, DisableSecondaryUserError, DisableSecondaryUserResponse, ReenableSecondaryUserData, ReenableSecondaryUserError, ReenableSecondaryUserResponse, TransferPrimaryOwnershipData, TransferPrimaryOwnershipError, TransferPrimaryOwnershipResponse, UpdateRegistrantAccountUserAdminData, UpdateRegistrantAccountUserAdminError, UpdateRegistrantAccountUserAdminResponse, UpdateRegistrantAccountUserCanMakePaymentsData, UpdateRegistrantAccountUserCanMakePaymentsError, UpdateRegistrantAccountUserCanMakePaymentsResponse, GetPendingInviteInfoData, AcceptPendingInviteData, AcceptPendingInviteResponse, RejectPendingInviteData, RejectPendingInviteResponse, UploadAnswerFileData, UploadAnswerFileError, UploadAnswerFileResponse, ListInspectionPortalLicensesData, ListInspectionDispatchLicensesData, ListInspectionOrgUsersData, ListInspectionImpersonationCandidatesData, BulkAssignInspectionsData, BulkAssignInspectionsError, BulkAssignInspectionsResponse, EnsureInspectionLicenseAccessData, EnsureInspectionLicenseAccessError, EnsureInspectionLicenseAccessResponse, UnassignInspectionData, UnassignInspectionError, UnassignInspectionResponse, InviteInspectionUserData, InviteInspectionUserError, InviteInspectionUserResponse, DisableInspectionUserData, DisableInspectionUserError, DisableInspectionUserResponse, UploadInspectionAnswerFileData, UploadInspectionAnswerFileError, UploadInspectionAnswerFileResponse, GetInspectionServerTimeData, GetJurisdictionInspectionLogoKeyData, GetOmtAmsAccessData, SearchOmtAmsPartiesForImpersonationData, GetOmtAmsAccountData, GetOmtAmsLicensesData, GetOmtAmsLicensesError, GetOmtAmsLicenseStatsData, GetOmtAmsLicenseFilterValuesData, GetOmtAmsLicenseMapPinsData, GetOmtAmsLicenseCommentsData, GetOmtAmsLicensePaymentsData, GetOmtAmsInvoicesData, GetOmtAmsAccountUsersData, AddOmtAmsSecondaryUserData, AddOmtAmsSecondaryUserError, AddOmtAmsSecondaryUserResponse, CancelOmtAmsSecondaryUserInviteData, CancelOmtAmsSecondaryUserInviteError, CancelOmtAmsSecondaryUserInviteResponse, DisableOmtAmsSecondaryUserData, DisableOmtAmsSecondaryUserError, DisableOmtAmsSecondaryUserResponse, ReenableOmtAmsSecondaryUserData, ReenableOmtAmsSecondaryUserError, ReenableOmtAmsSecondaryUserResponse, UpdateOmtAmsAccountUserAdminData, UpdateOmtAmsAccountUserAdminError, UpdateOmtAmsAccountUserAdminResponse, GetOmtAmsPendingInviteInfoData, AcceptOmtAmsPendingInviteData, AcceptOmtAmsPendingInviteResponse, RejectOmtAmsPendingInviteData, RejectOmtAmsPendingInviteResponse, GetJurisdictionsData, CreateJurisdictionData, CreateJurisdictionError, CreateJurisdictionResponse, GetJurisdictionData, UpdateJurisdictionData, UpdateJurisdictionError, UpdateJurisdictionResponse, DryrunJurisdictionCreationData, DryrunJurisdictionCreationError, DryrunJurisdictionCreationResponse, CreateJurisdictionsData, CreateJurisdictionsError, CreateJurisdictionsResponse, UpdateJurisdictionThemeColorData, UpdateJurisdictionThemeColorError, UpdateJurisdictionThemeColorResponse, ClearJurisdictionLogoData, ClearJurisdictionLogoError, ClearJurisdictionLogoResponse, UploadJurisdictionLogoData, UploadJurisdictionLogoError, UploadJurisdictionLogoResponse, ListOperatorInspectionImpersonationCandidatesData, GetJurisdictionBrandingData, RefreshJurisdictionBrandingData, RefreshJurisdictionBrandingError, RefreshJurisdictionBrandingResponse, CreateOrdinanceVersionData, CreateOrdinanceVersionError, CreateOrdinanceVersionResponse, DeleteOrdinanceVersionData, DeleteOrdinanceVersionError, DeleteOrdinanceVersionResponse, UpdateOrdinanceVersionData, UpdateOrdinanceVersionError, UpdateOrdinanceVersionResponse, ExportOrdinancesCsvData, DryrunOrdinanceImportData, DryrunOrdinanceImportError, DryrunOrdinanceImportResponse, ApplyOrdinanceImportData, ApplyOrdinanceImportError, ApplyOrdinanceImportResponse, LookupJurisdictionByFipsCodeData, LookupJurisdictionByTigerCodeData, FuzzySearchJurisdictionsByNameData, OperatorGetRegistrantByEmailData, ListLicenseLinkCandidatesData, LinkLicenseData, LinkLicenseError, LinkLicenseResponse, OperatorCreateLicenseData, OperatorCreateLicenseError, OperatorCreateLicenseResponse, ListSavedImportMappingsData, CreateSavedImportMappingData, CreateSavedImportMappingError, CreateSavedImportMappingResponse, DeleteSavedImportMappingData, DeleteSavedImportMappingError, DeleteSavedImportMappingResponse, UpdateSavedImportMappingData, UpdateSavedImportMappingError, UpdateSavedImportMappingResponse, ApplySavedImportMappingData, ApplySavedImportMappingError, ApplySavedImportMappingResponse, GetTempFileHeadersAndRowCountsData, GetJurisdictionFieldMappingForTempFileData, GetOrdinanceFieldMappingForTempFileData, GetLicenseFieldMappingForTempFileData, GetGovernmentUserFieldMappingForTempFileData, DryrunGovernmentUserUpsertData, DryrunGovernmentUserUpsertError, DryrunGovernmentUserUpsertResponse, UpsertGovernmentUsersData, UpsertGovernmentUsersError, UpsertGovernmentUsersResponse, DryrunLicenseCreationData, DryrunLicenseCreationError, DryrunLicenseCreationResponse, CreateLicensesData, CreateLicensesError, CreateLicensesResponse, GetQuestionFieldMappingForTempFileData, GetQuestionGroupFieldMappingForTempFileData, DryrunQuestionCreationData, DryrunQuestionCreationError, DryrunQuestionCreationResponse, CreateQuestionsData, CreateQuestionsError, CreateQuestionsResponse, DryrunQuestionGroupCreationData, DryrunQuestionGroupCreationError, DryrunQuestionGroupCreationResponse, CreateQuestionGroupsData, CreateQuestionGroupsError, CreateQuestionGroupsResponse, GetPartyFieldMappingForTempFileData, DryrunPartyCreationData, DryrunPartyCreationError, DryrunPartyCreationResponse, CreatePartiesData, CreatePartiesError, CreatePartiesResponse, GetCaseNumberFieldMappingForTempFileData, DryrunCaseNumberImportData, DryrunCaseNumberImportError, DryrunCaseNumberImportResponse, ApplyCaseNumberImportData, ApplyCaseNumberImportError, ApplyCaseNumberImportResponse, PreviewBulkServiceTransferData, PreviewBulkServiceTransferError, PreviewBulkServiceTransferResponse, CommitBulkServiceTransferData, CommitBulkServiceTransferError, CommitBulkServiceTransferResponse, GetHeraConfigurationEndpointOperatorHeraConfigurationGetData, UpdateHeraConfigurationEndpointOperatorHeraConfigurationPutData, UpdateHeraConfigurationEndpointOperatorHeraConfigurationPutError, UpdateHeraConfigurationEndpointOperatorHeraConfigurationPutResponse, GetManualCheckPaymentsData, GetManualCheckPaymentDetailData, CancelManualCheckPaymentData, CancelManualCheckPaymentError, CancelManualCheckPaymentResponse, FinaliseManualCheckPaymentData, FinaliseManualCheckPaymentError, FinaliseManualCheckPaymentResponse, MarkManualCheckPaymentDepositedData, MarkManualCheckPaymentDepositedError, MarkManualCheckPaymentDepositedResponse, GetRefundAllocationsData, GetRefundAllocationDetailData, FinaliseRefundAllocationData, FinaliseRefundAllocationError, FinaliseRefundAllocationResponse, GetManualInvoicePaymentsData, GenerateOperatorInvoicesData, GenerateOperatorInvoicesError, GenerateOperatorInvoicesResponse, GetManualInvoicePaymentDetailData, GetManualInvoicePaymentPdfData, CancelManualInvoicePaymentData, CancelManualInvoicePaymentError, CancelManualInvoicePaymentResponse, FinaliseManualInvoicePaymentData, FinaliseManualInvoicePaymentError, FinaliseManualInvoicePaymentResponse, UpdateRegistrantLoginIdentityOperatorData, UpdateRegistrantLoginIdentityOperatorError, UpdateRegistrantLoginIdentityOperatorResponse, UpdateOperatorRegistrantAccountAccountsContactData, UpdateOperatorRegistrantAccountAccountsContactError, UpdateOperatorRegistrantAccountAccountsContactResponse, OperatorDisableRegistrantUserData, OperatorDisableRegistrantUserError, OperatorDisableRegistrantUserResponse, OperatorReenableRegistrantUserData, OperatorReenableRegistrantUserError, OperatorReenableRegistrantUserResponse, OperatorTransferPrimaryOwnershipData, OperatorTransferPrimaryOwnershipError, OperatorTransferPrimaryOwnershipResponse, OperatorAcceptPendingRegistrantInviteData, OperatorAcceptPendingRegistrantInviteError, OperatorAcceptPendingRegistrantInviteResponse, CreateLicenseTypeData, CreateLicenseTypeError, CreateLicenseTypeResponse, GetLicenseTypeData, UpdateLicenseTypeData, UpdateLicenseTypeError, UpdateLicenseTypeResponse, GetAffectedJurisdictionsCountData, CascadeJurisdictionStatusData, CascadeJurisdictionStatusError, CascadeJurisdictionStatusResponse, GetAllTemplateDocumentsStatusData, DeleteTemplateDocumentEndpointData, DeleteTemplateDocumentEndpointError, DeleteTemplateDocumentEndpointResponse, CreateTemplateDocumentEndpointData, CreateTemplateDocumentEndpointError, CreateTemplateDocumentEndpointResponse, GetAllJurisdictionDocumentsStatusData, GetJurisdictionConfigurationQuestionGroupsData, UpdateJurisdictionConfigurationQuestionGroupsData, UpdateJurisdictionConfigurationQuestionGroupsError, UpdateJurisdictionConfigurationQuestionGroupsResponse, DeleteJurisdictionDocumentEndpointData, DeleteJurisdictionDocumentEndpointError, DeleteJurisdictionDocumentEndpointResponse, CreateJurisdictionDocumentEndpointData, CreateJurisdictionDocumentEndpointError, CreateJurisdictionDocumentEndpointResponse, GetQuestionGroupsOperatorLicenseTypesLicenseTypeIdQuestionGroupsGetData, CreateQuestionGroupOperatorLicenseTypesLicenseTypeIdQuestionGroupsPostData, CreateQuestionGroupOperatorLicenseTypesLicenseTypeIdQuestionGroupsPostError, CreateQuestionGroupOperatorLicenseTypesLicenseTypeIdQuestionGroupsPostResponse, DeleteQuestionGroupOperatorQuestionGroupsGroupIdDeleteData, DeleteQuestionGroupOperatorQuestionGroupsGroupIdDeleteError, DeleteQuestionGroupOperatorQuestionGroupsGroupIdDeleteResponse, UpdateQuestionGroupOperatorQuestionGroupsGroupIdPatchData, UpdateQuestionGroupOperatorQuestionGroupsGroupIdPatchError, UpdateQuestionGroupOperatorQuestionGroupsGroupIdPatchResponse, GetQuestionGroupJurisdictionsData, UpdateQuestionGroupJurisdictionsData, UpdateQuestionGroupJurisdictionsError, UpdateQuestionGroupJurisdictionsResponse, GetOperatorLicenseFeeAnalysisData, GetOperatorRevenueAuditData, GetOperatorRevenueAuditStripeCashData, GetOperatorPortalKpisData, GetOperatorPortalPaymentPeriodsData, GetOperatorPortalTrendsData, GetOperatorSystemUsageData, GetOperatorSystemUsageDetailData, GetOperatorPortalForeclosureVsRegistrationsData, GetOperatorPortalNotifiedRenewalsData, GetOperatorPortalNeedsAttentionComplianceData, GetOperatorPortalComplianceTrendsData, StreamOperatorPortalTrendRegistrationsData, StreamOperatorPortalTrendInspectionsData, StreamOperatorPortalTrendPaymentsData, StreamOperatorPortalTrendInspectionFeesData, StreamOperatorPortalTrendRefundsData, StreamOperatorPortalTrendRemittanceData, StreamOperatorPortalForecastData, GetOperatorPortalPaymentLagData, GetOperatorPortalActivityData, GetOperatorHubspotScorecardData, GetOperatorHubspotClosedDealsByWeekData, GetOperatorLeadershipRenewalComplianceData, GetOperatorLeadershipReceivablesOverdueData, GetOperatorLeadershipRegistrationsRenewalsInitiatedData, GetOperatorLeadershipHeraRemittanceData, GetInfoSystemJurisdictionSummariesData, GetInfoSystemLicensesData, GetAttomTaxAssessorStatusData, GetAttomIntegrationStatusData, GetNextForeclosureLenderPromptData, SubmitForeclosureInstigatorLabelData, SubmitForeclosureInstigatorLabelError, SubmitForeclosureInstigatorLabelResponse, UndoForeclosureInstigatorLabelData, UndoForeclosureInstigatorLabelResponse, GetForeclosureInstigatorMetricsData, SetForeclosureInstigatorGoldData, SetForeclosureInstigatorGoldError, SetForeclosureInstigatorGoldResponse, AdjudicateForeclosureInstigatorData, AdjudicateForeclosureInstigatorError, AdjudicateForeclosureInstigatorResponse, GetOperatorForeclosureCasesData, GetOperatorForeclosureCasesError, GetOperatorForeclosureCasesResponse, GetOperatorForeclosureCaseFilterValuesData, GetOperatorForeclosureCaseMapPinsData, GetOperatorForeclosureReviewStatusSummaryData, GetOperatorForeclosureCaseChartDataData, SuggestOperatorForeclosureCasePartiesData, SuggestOperatorForeclosureCasePartiesError, SuggestOperatorForeclosureCasePartiesResponse, SuggestOperatorForeclosureCaseReviewData, SuggestOperatorForeclosureCaseReviewError, SuggestOperatorForeclosureCaseReviewResponse, GetOperatorForeclosureLicenseAssignmentCandidatesData, GetOperatorForeclosureLicenseAssignmentCandidatesError, GetOperatorForeclosureLicenseAssignmentCandidatesResponse, AssignOperatorForeclosureLicensesData, AssignOperatorForeclosureLicensesError, AssignOperatorForeclosureLicensesResponse, GetOperatorForeclosureLicenseMatchesData, LinkOperatorForeclosureCaseToLicenseData, LinkOperatorForeclosureCaseToLicenseError, LinkOperatorForeclosureCaseToLicenseResponse, UpdateOperatorForeclosureCaseReviewData, UpdateOperatorForeclosureCaseReviewError, UpdateOperatorForeclosureCaseReviewResponse, GetOperatorForeclosureCaseReviewHistoryData, PreflightOperatorBulkCreateUnregisteredData, PreflightOperatorBulkCreateUnregisteredError, PreflightOperatorBulkCreateUnregisteredResponse, BulkCreateOperatorUnregisteredFromCasesData, BulkCreateOperatorUnregisteredFromCasesError, BulkCreateOperatorUnregisteredFromCasesResponse, GetOperatorForeclosureUnregisteredMatchData, LinkOperatorForeclosureCaseToUnregisteredData, LinkOperatorForeclosureCaseToUnregisteredError, LinkOperatorForeclosureCaseToUnregisteredResponse, OperatorAddressResolutionLookupData, OperatorAddressResolutionLookupError, OperatorAddressResolutionLookupResponse, OperatorAddressResolutionSaveData, OperatorAddressResolutionSaveError, OperatorAddressResolutionSaveResponse, GetResidentialOwnerAccessData, ListResidentialOwnerJurisdictionsData, ListResidentialOwnerMailingAddressesData, ListResidentialOwnerMailingAddressesError, ListResidentialOwnerMailingAddressesResponse, GetResidentialOwnerMailingAddressData, UpdateResidentialOwnerMailingAddressData, UpdateResidentialOwnerMailingAddressError, UpdateResidentialOwnerMailingAddressResponse, UnlinkResidentialOwnerMailingAddressData, UnlinkResidentialOwnerMailingAddressError, UnlinkResidentialOwnerMailingAddressResponse, LinkResidentialOwnerMailingAddressesData, LinkResidentialOwnerMailingAddressesError, LinkResidentialOwnerMailingAddressesResponse, ListResidentialOwnerCompaniesData, ListResidentialOwnerCompaniesError, ListResidentialOwnerCompaniesResponse, GetResidentialOwnerCompanyData, UpdateResidentialOwnerCompanyData, UpdateResidentialOwnerCompanyError, UpdateResidentialOwnerCompanyResponse, GetResidentialOwnerMailingAddressHistoryData, ConfirmResidentialOwnerCompanyFieldsData, ConfirmResidentialOwnerCompanyFieldsError, ConfirmResidentialOwnerCompanyFieldsResponse, RejectResidentialOwnerCompanyFieldsData, RejectResidentialOwnerCompanyFieldsError, RejectResidentialOwnerCompanyFieldsResponse, MergeResidentialOwnerCompaniesData, MergeResidentialOwnerCompaniesError, MergeResidentialOwnerCompaniesResponse, EnqueueResidentialOwnerRefreshData, EnqueueResidentialOwnerRefreshError, EnqueueResidentialOwnerRefreshResponse, EnqueueResidentialOwnerEnrichmentData, EnqueueResidentialOwnerEnrichmentError, EnqueueResidentialOwnerEnrichmentResponse, ListResidentialOwnerJobsData, CancelResidentialOwnerJobData, CancelResidentialOwnerJobError, CancelResidentialOwnerJobResponse, GetLatestResidentialOwnerRefreshRunData, ListCompanyQuestionTabsData, ListCompanyQuestionAnswersData, RewriteCompanyQuestionAnswersData, RewriteCompanyQuestionAnswersError, RewriteCompanyQuestionAnswersResponse, GetStrListingsData, GetStrListingsError, GetStrListingsResponse, GetStrListingFilterValuesData, GetStrListingMapPinsData, GetStrPropertiesData, GetStrPropertiesError, GetStrPropertiesResponse, GetStrPropertyFilterValuesData, GetStrPropertyMapPinsData, GetStrPropertyDetailData, GetNextStrAddressMappingData, GetStrAddressMappingCitiesData, GetStrAddressMappingTargetData, ConfirmStrAddressMappingData, ConfirmStrAddressMappingError, ConfirmStrAddressMappingResponse, LookupStrAttomParcelData, LookupStrAttomParcelError, LookupStrAttomParcelResponse, SkipStrAddressMappingData, SkipStrAddressMappingError, SkipStrAddressMappingResponse, UndoStrAddressMappingData, UndoStrAddressMappingResponse, GetStrAddressMappingNearbyData, SuggestStrUnitClassificationsData, SuggestStrUnitClassificationsError, SuggestStrUnitClassificationsResponse, SetStrListingUnitCategoryData, SetStrListingUnitCategoryError, SetStrListingUnitCategoryResponse, SetStrPropertyUnitCategoryData, SetStrPropertyUnitCategoryError, SetStrPropertyUnitCategoryResponse, GetNextStrDedupPairData, SubmitStrDedupLabelData, SubmitStrDedupLabelError, SubmitStrDedupLabelResponse, UndoStrDedupLabelData, UndoStrDedupLabelResponse, LookupStrDedupListingData, LoadManualStrDedupPairData, LoadManualStrDedupPairError, LoadManualStrDedupPairResponse, GetStrDedupMetricsData, ListGovernmentStrPropertiesData, ListGovernmentStrPropertiesError, ListGovernmentStrPropertiesResponse, GetGovernmentStrPropertyFilterValuesData, ListGovernmentStrPropertyPinsData, GetGovernmentStrPropertyData, SearchGovernmentUsersForImpersonationData, GetGovernmentImpersonationMeData, GetGovernmentJurisdictionData, GetGovernmentLicenseTypeConfigurationsData, CreateGovernmentOrdinanceVersionData, CreateGovernmentOrdinanceVersionError, CreateGovernmentOrdinanceVersionResponse, DeleteGovernmentOrdinanceVersionData, DeleteGovernmentOrdinanceVersionError, DeleteGovernmentOrdinanceVersionResponse, UpdateGovernmentOrdinanceVersionData, UpdateGovernmentOrdinanceVersionError, UpdateGovernmentOrdinanceVersionResponse, ExportGovernmentOrdinancesCsvData, DryrunGovernmentOrdinanceImportData, DryrunGovernmentOrdinanceImportError, DryrunGovernmentOrdinanceImportResponse, ApplyGovernmentOrdinanceImportData, ApplyGovernmentOrdinanceImportError, ApplyGovernmentOrdinanceImportResponse, ListGovernmentSavedImportMappingsData, CreateGovernmentSavedImportMappingData, CreateGovernmentSavedImportMappingError, CreateGovernmentSavedImportMappingResponse, GetGovernmentOrdinanceFieldMappingForTempFileData, GetGovernmentPortalKpisData, GetGovernmentPortalTrendsData, GetGovernmentPortalForeclosureVsRegistrationsData, GetGovernmentPortalNotifiedRenewalsData, GetGovernmentPortalComplianceTrendsData, StreamGovernmentPortalTrendRegistrationsData, StreamGovernmentPortalTrendInspectionsData, StreamGovernmentPortalTrendPaymentsData, StreamGovernmentPortalTrendInspectionFeesData, StreamGovernmentPortalTrendRefundsData, StreamGovernmentPortalTrendRemittanceData, GetGovernmentPortalPaymentLagData, GetGovernmentPortalActivityData, UpdateRegistrantLoginIdentityGovernmentData, UpdateRegistrantLoginIdentityGovernmentError, UpdateRegistrantLoginIdentityGovernmentResponse, UpdateGovernmentRegistrantAccountAccountsContactData, UpdateGovernmentRegistrantAccountAccountsContactError, UpdateGovernmentRegistrantAccountAccountsContactResponse, GetGovernmentForeclosureCasesData, GetGovernmentForeclosureCasesError, GetGovernmentForeclosureCasesResponse, GetGovernmentForeclosureCaseFilterValuesData, GetGovernmentForeclosureCaseMapPinsData, GetGovernmentForeclosureCaseChartDataData, SuggestGovernmentForeclosureCasePartiesData, SuggestGovernmentForeclosureCasePartiesError, SuggestGovernmentForeclosureCasePartiesResponse, SuggestGovernmentForeclosureCaseReviewData, SuggestGovernmentForeclosureCaseReviewError, SuggestGovernmentForeclosureCaseReviewResponse, GetGovernmentForeclosureLicenseAssignmentCandidatesData, GetGovernmentForeclosureLicenseAssignmentCandidatesError, GetGovernmentForeclosureLicenseAssignmentCandidatesResponse, AssignGovernmentForeclosureLicensesData, AssignGovernmentForeclosureLicensesError, AssignGovernmentForeclosureLicensesResponse, GetGovernmentForeclosureLicenseMatchesData, LinkGovernmentForeclosureCaseToLicenseData, LinkGovernmentForeclosureCaseToLicenseError, LinkGovernmentForeclosureCaseToLicenseResponse, UpdateGovernmentForeclosureCaseReviewData, UpdateGovernmentForeclosureCaseReviewError, UpdateGovernmentForeclosureCaseReviewResponse, GetGovernmentForeclosureCaseReviewHistoryData, PreflightGovernmentBulkCreateUnregisteredData, PreflightGovernmentBulkCreateUnregisteredError, PreflightGovernmentBulkCreateUnregisteredResponse, BulkCreateGovernmentUnregisteredFromCasesData, BulkCreateGovernmentUnregisteredFromCasesError, BulkCreateGovernmentUnregisteredFromCasesResponse, GetGovernmentForeclosureUnregisteredMatchData, LinkGovernmentForeclosureCaseToUnregisteredData, LinkGovernmentForeclosureCaseToUnregisteredError, LinkGovernmentForeclosureCaseToUnregisteredResponse, GetUnregisteredPropertiesData, CreateUnregisteredPropertyData, CreateUnregisteredPropertyError, CreateUnregisteredPropertyResponse, DeleteUnregisteredPropertyData, DeleteUnregisteredPropertyError, DeleteUnregisteredPropertyResponse, GetUnregisteredPropertyData, UpdateUnregisteredPropertyData, UpdateUnregisteredPropertyError, UpdateUnregisteredPropertyResponse, ListUnregisteredSavedImportMappingsData, CreateUnregisteredSavedImportMappingData, CreateUnregisteredSavedImportMappingError, CreateUnregisteredSavedImportMappingResponse, DeleteUnregisteredSavedImportMappingData, DeleteUnregisteredSavedImportMappingError, DeleteUnregisteredSavedImportMappingResponse, UpdateUnregisteredSavedImportMappingData, UpdateUnregisteredSavedImportMappingError, UpdateUnregisteredSavedImportMappingResponse, ApplyUnregisteredSavedImportMappingData, ApplyUnregisteredSavedImportMappingError, ApplyUnregisteredSavedImportMappingResponse, GetUnregisteredFieldMappingForTempFileData, DryrunUnregisteredCreationData, DryrunUnregisteredCreationError, DryrunUnregisteredCreationResponse, CreateUnregisteredPropertiesData, CreateUnregisteredPropertiesError, CreateUnregisteredPropertiesResponse, GetUnregisteredCommentsData, CreateUnregisteredCommentData, CreateUnregisteredCommentError, CreateUnregisteredCommentResponse, CheckApnRegisteredData, CheckApnRegisteredError, CheckApnRegisteredResponse, GetTitleAccountData, UpdateTitleAccountData, UpdateTitleAccountError, UpdateTitleAccountResponse, GetTitleAccountUsersData, AddTitleAccountUserData, AddTitleAccountUserError, AddTitleAccountUserResponse, CancelTitleAccountInviteData, CancelTitleAccountInviteError, CancelTitleAccountInviteResponse, DisableTitleAccountUserData, DisableTitleAccountUserError, DisableTitleAccountUserResponse, ReenableTitleAccountUserData, ReenableTitleAccountUserError, ReenableTitleAccountUserResponse, MakeTitleAccountPrimaryData, MakeTitleAccountPrimaryError, MakeTitleAccountPrimaryResponse, UpdateTitleAccountUserAdminData, UpdateTitleAccountUserAdminError, UpdateTitleAccountUserAdminResponse, GetTitlePendingInviteData, AcceptTitlePendingInviteData, AcceptTitlePendingInviteResponse, RejectTitlePendingInviteData, RejectTitlePendingInviteResponse, SearchTitleAccountsForImpersonationData, SearchOperatorTitleAccountsData, CreateOperatorTitleAccountData, CreateOperatorTitleAccountError, CreateOperatorTitleAccountResponse, LookupTitleRequestAddressData, LookupTitleRequestAddressError, LookupTitleRequestAddressResponse, CreateTitleRequestData, CreateTitleRequestError, CreateTitleRequestResponse, ClaimTitleRequestData, ClaimTitleRequestError, ClaimTitleRequestResponse, ListMyTitleRequestsData, GetMyTitleRequestData, AddMyTitleRequestCommentData, AddMyTitleRequestCommentError, AddMyTitleRequestCommentResponse, RequestFurtherTitleReviewData, RequestFurtherTitleReviewError, RequestFurtherTitleReviewResponse, CancelMyTitleRequestData, CancelMyTitleRequestError, CancelMyTitleRequestResponse, GetMyTitleRequestAttachmentData, ListOperatorTitleRequestsData, GetOperatorTitleRequestData, UpdateOperatorTitleRequestData, UpdateOperatorTitleRequestError, UpdateOperatorTitleRequestResponse, CancelOperatorTitleRequestData, CancelOperatorTitleRequestError, CancelOperatorTitleRequestResponse, AddOperatorTitleRequestCommentData, AddOperatorTitleRequestCommentError, AddOperatorTitleRequestCommentResponse, SendTitleRequestPropertyCompliantData, SendTitleRequestPropertyCompliantError, SendTitleRequestPropertyCompliantResponse, DraftTitleRequestPropertyNonCompliantData, DraftTitleRequestPropertyNonCompliantError, DraftTitleRequestPropertyNonCompliantResponse, SendTitleRequestPropertyNonCompliantData, SendTitleRequestPropertyNonCompliantError, SendTitleRequestPropertyNonCompliantResponse, GetOperatorTitleRequestAttachmentData, ListPublicCommunitiesData, ListPublicRegistrationCommunitiesData, GetPublicJurisdictionData, ListPublicLicenseTypesData, GetPublicHeraConfigurationData, ListPublicJurisdictionPagesData, GetPublicJurisdictionPageData, GetPublicJurisdictionPageLogoData, GetPublicDemoPlaceSealData, ListPublicDemoStateTopPlacesData, ListPublicDemoHeraCustomersHeatmapData, ResolvePublicDemoPlaceData, ResolvePublicDemoPlaceError, ResolvePublicDemoPlaceResponse, ResolvePublicDemoPlaceAtData, ResolvePublicDemoPlaceAtError, ResolvePublicDemoPlaceAtResponse, GetPublicDemoPlaceSummaryData, GetPublicDemoPlaceHubSpotCompanyData, CreatePublicDemoPlaceHubSpotCompanyData, CreatePublicDemoPlaceHubSpotCompanyError, CreatePublicDemoPlaceHubSpotCompanyResponse, GetPublicDemoPlaceEventsData, GetPublicDemoPlaceBoundaryData, EmailPublicDemoPlaceSummaryData, EmailPublicDemoPlaceSummaryError, EmailPublicDemoPlaceSummaryResponse, ListJurisdictionRegionsData, CreateJurisdictionRegionData, CreateJurisdictionRegionError, CreateJurisdictionRegionResponse, GetJurisdictionRegionBoundaryData, PreviewJurisdictionRegionUploadData, PreviewJurisdictionRegionUploadError, PreviewJurisdictionRegionUploadResponse, CommitJurisdictionRegionUploadData, CommitJurisdictionRegionUploadError, CommitJurisdictionRegionUploadResponse, PromptJurisdictionRegionsData, PromptJurisdictionRegionsError, PromptJurisdictionRegionsResponse, CommandJurisdictionRegionsData, CommandJurisdictionRegionsError, CommandJurisdictionRegionsResponse, DownloadRegionDraftShapefileData, DeleteJurisdictionRegionData, DeleteJurisdictionRegionError, DeleteJurisdictionRegionResponse, UpdateJurisdictionRegionData, UpdateJurisdictionRegionError, UpdateJurisdictionRegionResponse, DownloadJurisdictionRegionShapefileData, CheckHealthData, OnAuth0LoginData, OnAuth0LoginError, OnAuth0LoginResponse, OnStripeEventData, OnStripeEventError, OnStripeEventResponse, OnHubSpotCompanyEventData, OnHubSpotCompanyEventResponse, ListHubSpotCompanyGeofipsOptionsData, SelectHubSpotCompanyGeofipsData, SelectHubSpotCompanyGeofipsError, SelectHubSpotCompanyGeofipsResponse, OnHubSpotContactEventData, OnHubSpotContactEventResponse } from '../types.gen';
import { client as _heyApiClient } from '../client.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: (options?.client ?? _heyApiClient).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [
        params
    ];
};

export const getAuth0EmailVerificationStatusQueryKey = (options?: Options<GetAuth0EmailVerificationStatusData>) => createQueryKey('getAuth0EmailVerificationStatus', options);

/**
 * Get Auth0 Email Verification Status Endpoint
 * Get the email verification status for the Auth0 user.
 */
export const getAuth0EmailVerificationStatusOptions = (options?: Options<GetAuth0EmailVerificationStatusData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAuth0EmailVerificationStatus({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAuth0EmailVerificationStatusQueryKey(options)
    });
};

export const resendAuth0VerificationEmailQueryKey = (options?: Options<ResendAuth0VerificationEmailData>) => createQueryKey('resendAuth0VerificationEmail', options);

/**
 * Resend Auth0 Verification Email Endpoint
 * Resend the verification email for the Auth0 user.
 */
export const resendAuth0VerificationEmailOptions = (options?: Options<ResendAuth0VerificationEmailData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await resendAuth0VerificationEmail({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: resendAuth0VerificationEmailQueryKey(options)
    });
};

/**
 * Resend Auth0 Verification Email Endpoint
 * Resend the verification email for the Auth0 user.
 */
export const resendAuth0VerificationEmailMutation = (options?: Partial<Options<ResendAuth0VerificationEmailData>>): UseMutationOptions<ResendAuth0VerificationEmailResponse, DefaultError, Options<ResendAuth0VerificationEmailData>> => {
    const mutationOptions: UseMutationOptions<ResendAuth0VerificationEmailResponse, DefaultError, Options<ResendAuth0VerificationEmailData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await resendAuth0VerificationEmail({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const generatePasswordResetUrlQueryKey = (options?: Options<GeneratePasswordResetUrlData>) => createQueryKey('generatePasswordResetUrl', options);

/**
 * Generate Auth0 Password Reset Url Endpoint
 * Generate a password reset URL for the Auth0 user.
 */
export const generatePasswordResetUrlOptions = (options?: Options<GeneratePasswordResetUrlData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await generatePasswordResetUrl({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: generatePasswordResetUrlQueryKey(options)
    });
};

/**
 * Generate Auth0 Password Reset Url Endpoint
 * Generate a password reset URL for the Auth0 user.
 */
export const generatePasswordResetUrlMutation = (options?: Partial<Options<GeneratePasswordResetUrlData>>): UseMutationOptions<GeneratePasswordResetUrlResponse, DefaultError, Options<GeneratePasswordResetUrlData>> => {
    const mutationOptions: UseMutationOptions<GeneratePasswordResetUrlResponse, DefaultError, Options<GeneratePasswordResetUrlData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await generatePasswordResetUrl({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCheckMailingAddressQueryKey = (options?: Options<GetCheckMailingAddressData>) => createQueryKey('getCheckMailingAddress', options);

/**
 * Get Check Mailing Address Endpoint
 * Get the HERA address for mailing checks (used in check payment instructions).
 */
export const getCheckMailingAddressOptions = (options?: Options<GetCheckMailingAddressData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCheckMailingAddress({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getCheckMailingAddressQueryKey(options)
    });
};

export const getLicenseTypesQueryKey = (options?: Options<GetLicenseTypesData>) => createQueryKey('getLicenseTypes', options);

/**
 * Get License Types Endpoint
 * Get all license types.
 */
export const getLicenseTypesOptions = (options?: Options<GetLicenseTypesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getLicenseTypes({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getLicenseTypesQueryKey(options)
    });
};

export const getFeeStructureFriendlyNamesQueryKey = (options?: Options<GetFeeStructureFriendlyNamesData>) => createQueryKey('getFeeStructureFriendlyNames', options);

/**
 * Get Fee Structure Friendly Names Endpoint
 * Return display names (and optional hints) for every registration/inspection fee structure.
 */
export const getFeeStructureFriendlyNamesOptions = (options?: Options<GetFeeStructureFriendlyNamesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getFeeStructureFriendlyNames({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getFeeStructureFriendlyNamesQueryKey(options)
    });
};

export const getLicenseTypeQuestionsQueryKey = (options: Options<GetLicenseTypeQuestionsData>) => createQueryKey('getLicenseTypeQuestions', options);

/**
 * Get License Type Questions Endpoint
 * Get all questions for a license type.
 */
export const getLicenseTypeQuestionsOptions = (options: Options<GetLicenseTypeQuestionsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getLicenseTypeQuestions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getLicenseTypeQuestionsQueryKey(options)
    });
};

export const getLicenseTypeConfigurationQueryKey = (options: Options<GetLicenseTypeConfigurationData>) => createQueryKey('getLicenseTypeConfiguration', options);

/**
 * Get License Type Configuration Endpoint
 * Returns a list of available license periods for a given license type, jurisdiction and initial date.
 *
 * This is used by the registrant flow to fetch the questions to display during registration.
 */
export const getLicenseTypeConfigurationOptions = (options: Options<GetLicenseTypeConfigurationData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getLicenseTypeConfiguration({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getLicenseTypeConfigurationQueryKey(options)
    });
};

export const getNonRegistrantLicensesQueryKey = (options?: Options<GetNonRegistrantLicensesData>) => createQueryKey('getNonRegistrantLicenses', options);

/**
 * Get Licenses Endpoint
 * Return one page of non-registrant licenses as JSON.
 */
export const getNonRegistrantLicensesOptions = (options?: Options<GetNonRegistrantLicensesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getNonRegistrantLicenses({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getNonRegistrantLicensesQueryKey(options)
    });
};

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = queryKey[0];
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const getNonRegistrantLicensesInfiniteQueryKey = (options?: Options<GetNonRegistrantLicensesData>): QueryKey<Options<GetNonRegistrantLicensesData>> => createQueryKey('getNonRegistrantLicenses', options, true);

/**
 * Get Licenses Endpoint
 * Return one page of non-registrant licenses as JSON.
 */
export const getNonRegistrantLicensesInfiniteOptions = (options?: Options<GetNonRegistrantLicensesData>) => {
    return infiniteQueryOptions<GetNonRegistrantLicensesResponse, GetNonRegistrantLicensesError, InfiniteData<GetNonRegistrantLicensesResponse>, QueryKey<Options<GetNonRegistrantLicensesData>>, number | Pick<QueryKey<Options<GetNonRegistrantLicensesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetNonRegistrantLicensesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getNonRegistrantLicenses({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getNonRegistrantLicensesInfiniteQueryKey(options)
    });
};

export const getNonRegistrantLicenseStatsQueryKey = (options?: Options<GetNonRegistrantLicenseStatsData>) => createQueryKey('getNonRegistrantLicenseStats', options);

/**
 * Get License Stats Endpoint
 * Dashboard tile aggregates for the non-deleted, header-scoped set.
 */
export const getNonRegistrantLicenseStatsOptions = (options?: Options<GetNonRegistrantLicenseStatsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getNonRegistrantLicenseStats({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getNonRegistrantLicenseStatsQueryKey(options)
    });
};

export const getNonRegistrantLicenseFilterValuesQueryKey = (options: Options<GetNonRegistrantLicenseFilterValuesData>) => createQueryKey('getNonRegistrantLicenseFilterValues', options);

/**
 * Get License Filter Values Endpoint
 * Distinct display strings for one list column's filter popover.
 */
export const getNonRegistrantLicenseFilterValuesOptions = (options: Options<GetNonRegistrantLicenseFilterValuesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getNonRegistrantLicenseFilterValues({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getNonRegistrantLicenseFilterValuesQueryKey(options)
    });
};

export const getNonRegistrantLicenseMapPinsQueryKey = (options?: Options<GetNonRegistrantLicenseMapPinsData>) => createQueryKey('getNonRegistrantLicenseMapPins', options);

/**
 * Get License Map Pins Endpoint
 * Pins or clusters for matching licenses that have coordinates.
 */
export const getNonRegistrantLicenseMapPinsOptions = (options?: Options<GetNonRegistrantLicenseMapPinsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getNonRegistrantLicenseMapPins({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getNonRegistrantLicenseMapPinsQueryKey(options)
    });
};

export const exportNonRegistrantLicensesQueryKey = (options?: Options<ExportNonRegistrantLicensesData>) => createQueryKey('exportNonRegistrantLicenses', options);

/**
 * Export Licenses Endpoint
 * All licenses matching the current list filters/sort (not just one page).
 */
export const exportNonRegistrantLicensesOptions = (options?: Options<ExportNonRegistrantLicensesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await exportNonRegistrantLicenses({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: exportNonRegistrantLicensesQueryKey(options)
    });
};

export const getNonRegistrantLicenseListQuestionColumnsQueryKey = (options?: Options<GetNonRegistrantLicenseListQuestionColumnsData>) => createQueryKey('getNonRegistrantLicenseListQuestionColumns', options);

/**
 * Get License List Question Columns Endpoint
 * List question-backed columns for the non-registrant licenses list.
 *
 * Columns come from questions flagged "show in list" (per field for
 * contact-shaped questions). Each license list row carries the matching
 * values in ``question_column_values``.
 */
export const getNonRegistrantLicenseListQuestionColumnsOptions = (options?: Options<GetNonRegistrantLicenseListQuestionColumnsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getNonRegistrantLicenseListQuestionColumns({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getNonRegistrantLicenseListQuestionColumnsQueryKey(options)
    });
};

export const getNonRegistrantRegistrantAccountsQueryKey = (options?: Options<GetNonRegistrantRegistrantAccountsData>) => createQueryKey('getNonRegistrantRegistrantAccounts', options);

/**
 * Get Non Registrant Registrant Accounts Endpoint
 * List all registrant accounts for operator and government portals.
 *
 * Jurisdiction filtering is intentionally not applied. Registrant pickers and
 * the registrants list must include accounts that have not yet licensed in a
 * given jurisdiction. ``jurisdiction_ids`` is accepted for API compatibility
 * but ignored.
 *
 * ``primaries_only`` limits the list to primary contacts: accounts that are
 * not secondary members and not pending an organization invite.
 */
export const getNonRegistrantRegistrantAccountsOptions = (options?: Options<GetNonRegistrantRegistrantAccountsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getNonRegistrantRegistrantAccounts({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getNonRegistrantRegistrantAccountsQueryKey(options)
    });
};

export const searchRegistrantAccountsQueryKey = (options?: Options<SearchRegistrantAccountsData>) => createQueryKey('searchRegistrantAccounts', options);

/**
 * Search Registrant Accounts Endpoint
 * Search registrant accounts by email, name, or company for operator pickers.
 *
 * Lives on the shared router so the operator portal can call it with an
 * operator-audience token. The registrant-router equivalent only accepts
 * registrant-audience tokens and 401s from the operator portal.
 */
export const searchRegistrantAccountsOptions = (options?: Options<SearchRegistrantAccountsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await searchRegistrantAccounts({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: searchRegistrantAccountsQueryKey(options)
    });
};

export const getNonRegistrantRegistrantAccountQueryKey = (options: Options<GetNonRegistrantRegistrantAccountData>) => createQueryKey('getNonRegistrantRegistrantAccount', options);

/**
 * Get Non Registrant Registrant Account Endpoint
 * Get a single registrant account by id. Government users only if account has a license in their jurisdiction.
 */
export const getNonRegistrantRegistrantAccountOptions = (options: Options<GetNonRegistrantRegistrantAccountData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getNonRegistrantRegistrantAccount({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getNonRegistrantRegistrantAccountQueryKey(options)
    });
};

export const getNonRegistrantRegistrantAccountLoginIdentitiesQueryKey = (options: Options<GetNonRegistrantRegistrantAccountLoginIdentitiesData>) => createQueryKey('getNonRegistrantRegistrantAccountLoginIdentities', options);

/**
 * Get Non Registrant Registrant Account Login Identities Endpoint
 * Portal login identities for the registrant org (invoice / accounts-contact toggles).
 */
export const getNonRegistrantRegistrantAccountLoginIdentitiesOptions = (options: Options<GetNonRegistrantRegistrantAccountLoginIdentitiesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getNonRegistrantRegistrantAccountLoginIdentities({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getNonRegistrantRegistrantAccountLoginIdentitiesQueryKey(options)
    });
};

export const getNonRegistrantOrganizationsQueryKey = (options?: Options<GetNonRegistrantOrganizationsData>) => createQueryKey('getNonRegistrantOrganizations', options);

/**
 * Get Non Registrant Organizations Endpoint
 * List organizations (primary accounts that have at least one secondary). Government see only those in their jurisdiction.
 */
export const getNonRegistrantOrganizationsOptions = (options?: Options<GetNonRegistrantOrganizationsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getNonRegistrantOrganizations({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getNonRegistrantOrganizationsQueryKey(options)
    });
};

export const getNonRegistrantOrganizationQueryKey = (options: Options<GetNonRegistrantOrganizationData>) => createQueryKey('getNonRegistrantOrganization', options);

/**
 * Get Non Registrant Organization Endpoint
 * Get organization detail: primary account and all registrants (primary + secondaries).
 */
export const getNonRegistrantOrganizationOptions = (options: Options<GetNonRegistrantOrganizationData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getNonRegistrantOrganization({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getNonRegistrantOrganizationQueryKey(options)
    });
};

export const getInspectionsQueryKey = (options?: Options<GetInspectionsData>) => createQueryKey('getInspections', options);

/**
 * Get Inspections Endpoint
 * Get all inspections, optionally filtered by jurisdiction.
 */
export const getInspectionsOptions = (options?: Options<GetInspectionsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getInspections({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getInspectionsQueryKey(options)
    });
};

export const getLicenseDetailsQueryKey = (options: Options<GetLicenseDetailsData>) => createQueryKey('getLicenseDetails', options);

/**
 * Get License Details Endpoint
 * Get the details of a registrant's license.
 */
export const getLicenseDetailsOptions = (options: Options<GetLicenseDetailsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getLicenseDetails({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getLicenseDetailsQueryKey(options)
    });
};

/**
 * Update License Endpoint
 * Update a license.
 */
export const updateLicenseMutation = (options?: Partial<Options<UpdateLicenseData>>): UseMutationOptions<UpdateLicenseResponse, UpdateLicenseError, Options<UpdateLicenseData>> => {
    const mutationOptions: UseMutationOptions<UpdateLicenseResponse, UpdateLicenseError, Options<UpdateLicenseData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateLicense({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getLicenseHistoryQueryKey = (options: Options<GetLicenseHistoryData>) => createQueryKey('getLicenseHistory', options);

/**
 * Get License History Endpoint
 * Return who changed what on a license, from the database audit log.
 */
export const getLicenseHistoryOptions = (options: Options<GetLicenseHistoryData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getLicenseHistory({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getLicenseHistoryQueryKey(options)
    });
};

export const getLicenseQuestionAnswerHistoryQueryKey = (options: Options<GetLicenseQuestionAnswerHistoryData>) => createQueryKey('getLicenseQuestionAnswerHistory', options);

/**
 * Get License Question Answer History Endpoint
 * Return typed additional-question changes visible to the current user.
 */
export const getLicenseQuestionAnswerHistoryOptions = (options: Options<GetLicenseQuestionAnswerHistoryData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getLicenseQuestionAnswerHistory({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getLicenseQuestionAnswerHistoryQueryKey(options)
    });
};

export const listLicenseNotificationEmailsQueryKey = (options: Options<ListLicenseNotificationEmailsData>) => createQueryKey('listLicenseNotificationEmails', options);

/**
 * List License Notification Emails Endpoint
 * List sent upcoming-renewal and needs-attention emails for this license.
 */
export const listLicenseNotificationEmailsOptions = (options: Options<ListLicenseNotificationEmailsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listLicenseNotificationEmails({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listLicenseNotificationEmailsQueryKey(options)
    });
};

export const getLicenseNotificationEmailQueryKey = (options: Options<GetLicenseNotificationEmailData>) => createQueryKey('getLicenseNotificationEmail', options);

/**
 * Get License Notification Email Endpoint
 * Return the stored body of a notification email linked to this license.
 */
export const getLicenseNotificationEmailOptions = (options: Options<GetLicenseNotificationEmailData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getLicenseNotificationEmail({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getLicenseNotificationEmailQueryKey(options)
    });
};

/**
 * Update License Additional Questions Endpoint
 * Update registration additional questions (e.g. NAC) for a license.
 *
 * Registrants, operators, and government users may call this when they have
 * license access (same rules as get license details). Operators previously
 * hit the registrant-only route and failed JWT audience validation.
 */
export const updateLicenseAdditionalQuestionsMutation = (options?: Partial<Options<UpdateLicenseAdditionalQuestionsData>>): UseMutationOptions<UpdateLicenseAdditionalQuestionsResponse, UpdateLicenseAdditionalQuestionsError, Options<UpdateLicenseAdditionalQuestionsData>> => {
    const mutationOptions: UseMutationOptions<UpdateLicenseAdditionalQuestionsResponse, UpdateLicenseAdditionalQuestionsError, Options<UpdateLicenseAdditionalQuestionsData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateLicenseAdditionalQuestions({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update License Registrant Endpoint
 * Correct the registrant assigned to a license without transferring it.
 */
export const updateLicenseRegistrantMutation = (options?: Partial<Options<UpdateLicenseRegistrantData>>): UseMutationOptions<UpdateLicenseRegistrantResponse, UpdateLicenseRegistrantError, Options<UpdateLicenseRegistrantData>> => {
    const mutationOptions: UseMutationOptions<UpdateLicenseRegistrantResponse, UpdateLicenseRegistrantError, Options<UpdateLicenseRegistrantData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateLicenseRegistrant({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deriveLicenseFromPaymentsQueryKey = (options: Options<DeriveLicenseFromPaymentsData>) => createQueryKey('deriveLicenseFromPayments', options);

/**
 * Derive License From Payments Endpoint
 * Derive renewal, approval, and status fields from payment history.
 */
export const deriveLicenseFromPaymentsOptions = (options: Options<DeriveLicenseFromPaymentsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await deriveLicenseFromPayments({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: deriveLicenseFromPaymentsQueryKey(options)
    });
};

/**
 * Derive License From Payments Endpoint
 * Derive renewal, approval, and status fields from payment history.
 */
export const deriveLicenseFromPaymentsMutation = (options?: Partial<Options<DeriveLicenseFromPaymentsData>>): UseMutationOptions<DeriveLicenseFromPaymentsResponse, DeriveLicenseFromPaymentsError, Options<DeriveLicenseFromPaymentsData>> => {
    const mutationOptions: UseMutationOptions<DeriveLicenseFromPaymentsResponse, DeriveLicenseFromPaymentsError, Options<DeriveLicenseFromPaymentsData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await deriveLicenseFromPayments({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const approveLicenseQueryKey = (options: Options<ApproveLicenseData>) => createQueryKey('approveLicense', options);

/**
 * Approve License Endpoint
 * Approve a license.
 */
export const approveLicenseOptions = (options: Options<ApproveLicenseData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await approveLicense({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: approveLicenseQueryKey(options)
    });
};

/**
 * Approve License Endpoint
 * Approve a license.
 */
export const approveLicenseMutation = (options?: Partial<Options<ApproveLicenseData>>): UseMutationOptions<ApproveLicenseResponse, ApproveLicenseError, Options<ApproveLicenseData>> => {
    const mutationOptions: UseMutationOptions<ApproveLicenseResponse, ApproveLicenseError, Options<ApproveLicenseData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await approveLicense({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const createLicenseModificationRequestQueryKey = (options: Options<CreateLicenseModificationRequestData>) => createQueryKey('createLicenseModificationRequest', options);

/**
 * Create License Modification Request Endpoint
 * Stage a change without updating the certificate until it is approved.
 */
export const createLicenseModificationRequestOptions = (options: Options<CreateLicenseModificationRequestData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createLicenseModificationRequest({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createLicenseModificationRequestQueryKey(options)
    });
};

/**
 * Create License Modification Request Endpoint
 * Stage a change without updating the certificate until it is approved.
 */
export const createLicenseModificationRequestMutation = (options?: Partial<Options<CreateLicenseModificationRequestData>>): UseMutationOptions<CreateLicenseModificationRequestResponse, CreateLicenseModificationRequestError, Options<CreateLicenseModificationRequestData>> => {
    const mutationOptions: UseMutationOptions<CreateLicenseModificationRequestResponse, CreateLicenseModificationRequestError, Options<CreateLicenseModificationRequestData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createLicenseModificationRequest({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const approveLicenseModificationRequestQueryKey = (options: Options<ApproveLicenseModificationRequestData>) => createQueryKey('approveLicenseModificationRequest', options);

/**
 * Approve License Modification Request Endpoint
 * Copy the staged answers onto the license and refresh the certificate.
 */
export const approveLicenseModificationRequestOptions = (options: Options<ApproveLicenseModificationRequestData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await approveLicenseModificationRequest({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: approveLicenseModificationRequestQueryKey(options)
    });
};

/**
 * Approve License Modification Request Endpoint
 * Copy the staged answers onto the license and refresh the certificate.
 */
export const approveLicenseModificationRequestMutation = (options?: Partial<Options<ApproveLicenseModificationRequestData>>): UseMutationOptions<ApproveLicenseModificationRequestResponse, ApproveLicenseModificationRequestError, Options<ApproveLicenseModificationRequestData>> => {
    const mutationOptions: UseMutationOptions<ApproveLicenseModificationRequestResponse, ApproveLicenseModificationRequestError, Options<ApproveLicenseModificationRequestData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await approveLicenseModificationRequest({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const denyLicenseModificationRequestQueryKey = (options: Options<DenyLicenseModificationRequestData>) => createQueryKey('denyLicenseModificationRequest', options);

/**
 * Deny License Modification Request Endpoint
 * Leave the certificate unchanged and tell the registrant it is still valid.
 */
export const denyLicenseModificationRequestOptions = (options: Options<DenyLicenseModificationRequestData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await denyLicenseModificationRequest({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: denyLicenseModificationRequestQueryKey(options)
    });
};

/**
 * Deny License Modification Request Endpoint
 * Leave the certificate unchanged and tell the registrant it is still valid.
 */
export const denyLicenseModificationRequestMutation = (options?: Partial<Options<DenyLicenseModificationRequestData>>): UseMutationOptions<DenyLicenseModificationRequestResponse, DenyLicenseModificationRequestError, Options<DenyLicenseModificationRequestData>> => {
    const mutationOptions: UseMutationOptions<DenyLicenseModificationRequestResponse, DenyLicenseModificationRequestError, Options<DenyLicenseModificationRequestData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await denyLicenseModificationRequest({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const cancelLicenseQueryKey = (options: Options<CancelLicenseData>) => createQueryKey('cancelLicense', options);

/**
 * Cancel License Endpoint
 * Cancel a license.
 */
export const cancelLicenseOptions = (options: Options<CancelLicenseData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cancelLicense({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: cancelLicenseQueryKey(options)
    });
};

/**
 * Cancel License Endpoint
 * Cancel a license.
 */
export const cancelLicenseMutation = (options?: Partial<Options<CancelLicenseData>>): UseMutationOptions<CancelLicenseResponse, CancelLicenseError, Options<CancelLicenseData>> => {
    const mutationOptions: UseMutationOptions<CancelLicenseResponse, CancelLicenseError, Options<CancelLicenseData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await cancelLicense({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getLicenseDeregistrationQuestionsQueryKey = (options: Options<GetLicenseDeregistrationQuestionsData>) => createQueryKey('getLicenseDeregistrationQuestions', options);

/**
 * Get License Deregistration Questions Endpoint
 * Get deregistration questions for a license (for the deregistration flow).
 */
export const getLicenseDeregistrationQuestionsOptions = (options: Options<GetLicenseDeregistrationQuestionsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getLicenseDeregistrationQuestions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getLicenseDeregistrationQuestionsQueryKey(options)
    });
};

export const startDeregisterLicenseQueryKey = (options: Options<StartDeregisterLicenseData>) => createQueryKey('startDeregisterLicense', options);

/**
 * Start Deregister License Endpoint
 * Start deregistration: set effective end date and answers, create $25 fee; user then pays.
 */
export const startDeregisterLicenseOptions = (options: Options<StartDeregisterLicenseData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await startDeregisterLicense({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: startDeregisterLicenseQueryKey(options)
    });
};

/**
 * Start Deregister License Endpoint
 * Start deregistration: set effective end date and answers, create $25 fee; user then pays.
 */
export const startDeregisterLicenseMutation = (options?: Partial<Options<StartDeregisterLicenseData>>): UseMutationOptions<StartDeregisterLicenseResponse, StartDeregisterLicenseError, Options<StartDeregisterLicenseData>> => {
    const mutationOptions: UseMutationOptions<StartDeregisterLicenseResponse, StartDeregisterLicenseError, Options<StartDeregisterLicenseData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await startDeregisterLicense({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getNonRegistrantLicenseCommentsQueryKey = (options: Options<GetNonRegistrantLicenseCommentsData>) => createQueryKey('getNonRegistrantLicenseComments', options);

/**
 * Get License Comments Endpoint
 * Get all comments for a license.
 */
export const getNonRegistrantLicenseCommentsOptions = (options: Options<GetNonRegistrantLicenseCommentsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getNonRegistrantLicenseComments({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getNonRegistrantLicenseCommentsQueryKey(options)
    });
};

export const createLicenseCommentQueryKey = (options: Options<CreateLicenseCommentData>) => createQueryKey('createLicenseComment', options);

/**
 * Create License Comment Endpoint
 * Create a comment for a license.
 */
export const createLicenseCommentOptions = (options: Options<CreateLicenseCommentData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createLicenseComment({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createLicenseCommentQueryKey(options)
    });
};

/**
 * Create License Comment Endpoint
 * Create a comment for a license.
 */
export const createLicenseCommentMutation = (options?: Partial<Options<CreateLicenseCommentData>>): UseMutationOptions<CreateLicenseCommentResponse, CreateLicenseCommentError, Options<CreateLicenseCommentData>> => {
    const mutationOptions: UseMutationOptions<CreateLicenseCommentResponse, CreateLicenseCommentError, Options<CreateLicenseCommentData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createLicenseComment({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const resolveRegistryNotificationQueryKey = (options: Options<ResolveRegistryNotificationData>) => createQueryKey('resolveRegistryNotification', options);

/**
 * Resolve Registry Notification Endpoint
 * Clear a registrant notify-Hera comment without changing license status.
 */
export const resolveRegistryNotificationOptions = (options: Options<ResolveRegistryNotificationData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await resolveRegistryNotification({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: resolveRegistryNotificationQueryKey(options)
    });
};

/**
 * Resolve Registry Notification Endpoint
 * Clear a registrant notify-Hera comment without changing license status.
 */
export const resolveRegistryNotificationMutation = (options?: Partial<Options<ResolveRegistryNotificationData>>): UseMutationOptions<ResolveRegistryNotificationResponse, ResolveRegistryNotificationError, Options<ResolveRegistryNotificationData>> => {
    const mutationOptions: UseMutationOptions<ResolveRegistryNotificationResponse, ResolveRegistryNotificationError, Options<ResolveRegistryNotificationData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await resolveRegistryNotification({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const flagComplianceIssueQueryKey = (options: Options<FlagComplianceIssueData>) => createQueryKey('flagComplianceIssue', options);

/**
 * Flag Compliance Issue Endpoint
 * Flag a compliance issue. License status is unchanged.
 */
export const flagComplianceIssueOptions = (options: Options<FlagComplianceIssueData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await flagComplianceIssue({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: flagComplianceIssueQueryKey(options)
    });
};

/**
 * Flag Compliance Issue Endpoint
 * Flag a compliance issue. License status is unchanged.
 */
export const flagComplianceIssueMutation = (options?: Partial<Options<FlagComplianceIssueData>>): UseMutationOptions<FlagComplianceIssueResponse, FlagComplianceIssueError, Options<FlagComplianceIssueData>> => {
    const mutationOptions: UseMutationOptions<FlagComplianceIssueResponse, FlagComplianceIssueError, Options<FlagComplianceIssueData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await flagComplianceIssue({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const clearComplianceIssueQueryKey = (options: Options<ClearComplianceIssueData>) => createQueryKey('clearComplianceIssue', options);

/**
 * Clear Compliance Issue Endpoint
 * Clear the active compliance issue when this party type raised it.
 */
export const clearComplianceIssueOptions = (options: Options<ClearComplianceIssueData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await clearComplianceIssue({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clearComplianceIssueQueryKey(options)
    });
};

/**
 * Clear Compliance Issue Endpoint
 * Clear the active compliance issue when this party type raised it.
 */
export const clearComplianceIssueMutation = (options?: Partial<Options<ClearComplianceIssueData>>): UseMutationOptions<ClearComplianceIssueResponse, ClearComplianceIssueError, Options<ClearComplianceIssueData>> => {
    const mutationOptions: UseMutationOptions<ClearComplianceIssueResponse, ClearComplianceIssueError, Options<ClearComplianceIssueData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await clearComplianceIssue({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const uploadSharedAnswerFileQueryKey = (options: Options<UploadSharedAnswerFileData>) => createQueryKey('uploadSharedAnswerFile', options);

/**
 * Upload Shared Answer File Endpoint
 * Upload a comment or answer file and return its storage token.
 */
export const uploadSharedAnswerFileOptions = (options: Options<UploadSharedAnswerFileData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await uploadSharedAnswerFile({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: uploadSharedAnswerFileQueryKey(options)
    });
};

/**
 * Upload Shared Answer File Endpoint
 * Upload a comment or answer file and return its storage token.
 */
export const uploadSharedAnswerFileMutation = (options?: Partial<Options<UploadSharedAnswerFileData>>): UseMutationOptions<UploadSharedAnswerFileResponse, UploadSharedAnswerFileError, Options<UploadSharedAnswerFileData>> => {
    const mutationOptions: UseMutationOptions<UploadSharedAnswerFileResponse, UploadSharedAnswerFileError, Options<UploadSharedAnswerFileData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await uploadSharedAnswerFile({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete License Comment Endpoint
 * Delete a comment for a license.
 */
export const deleteLicenseCommentMutation = (options?: Partial<Options<DeleteLicenseCommentData>>): UseMutationOptions<DeleteLicenseCommentResponse, DeleteLicenseCommentError, Options<DeleteLicenseCommentData>> => {
    const mutationOptions: UseMutationOptions<DeleteLicenseCommentResponse, DeleteLicenseCommentError, Options<DeleteLicenseCommentData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await deleteLicenseComment({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getNonRegistrantLicensePaymentsQueryKey = (options: Options<GetNonRegistrantLicensePaymentsData>) => createQueryKey('getNonRegistrantLicensePayments', options);

/**
 * Get License Payments Endpoint
 * Get the payments for a license.
 */
export const getNonRegistrantLicensePaymentsOptions = (options: Options<GetNonRegistrantLicensePaymentsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getNonRegistrantLicensePayments({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getNonRegistrantLicensePaymentsQueryKey(options)
    });
};

export const makeSharedLicensePaymentQueryKey = (options: Options<MakeSharedLicensePaymentData>) => createQueryKey('makeSharedLicensePayment', options);

/**
 * Make Shared License Payment Endpoint
 * Make payment for a license (shared endpoint for all user types).
 */
export const makeSharedLicensePaymentOptions = (options: Options<MakeSharedLicensePaymentData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await makeSharedLicensePayment({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: makeSharedLicensePaymentQueryKey(options)
    });
};

/**
 * Make Shared License Payment Endpoint
 * Make payment for a license (shared endpoint for all user types).
 */
export const makeSharedLicensePaymentMutation = (options?: Partial<Options<MakeSharedLicensePaymentData>>): UseMutationOptions<MakeSharedLicensePaymentResponse, MakeSharedLicensePaymentError, Options<MakeSharedLicensePaymentData>> => {
    const mutationOptions: UseMutationOptions<MakeSharedLicensePaymentResponse, MakeSharedLicensePaymentError, Options<MakeSharedLicensePaymentData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await makeSharedLicensePayment({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPaymentReceiptTemplateAvailableQueryKey = (options: Options<GetPaymentReceiptTemplateAvailableData>) => createQueryKey('getPaymentReceiptTemplateAvailable', options);

/**
 * Get Payment Receipt Template Available Endpoint
 * True when a usable global license-type receipt template exists in Drive and a parent folder is available.
 *
 * Soft-deleted (deregistered / cancelled) licenses are included so the Payments
 * card can still offer receipt download.
 *
 * Soft-deleted global template rows are ignored; the linked Drive file must be a non-trashed Google Doc
 * the service account can read.
 *
 * The parent folder for generated receipts is ``HERA__GOOGLE_DRIVE__DOCS_FOLDER_ID`` when set;
 * otherwise the jurisdiction's configured folder when set; otherwise the global templates folder
 * (``HERA__GOOGLE_DRIVE__TEMPLATES_FOLDER_ID``).
 */
export const getPaymentReceiptTemplateAvailableOptions = (options: Options<GetPaymentReceiptTemplateAvailableData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getPaymentReceiptTemplateAvailable({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getPaymentReceiptTemplateAvailableQueryKey(options)
    });
};

export const getRegistrationCertificateTemplateAvailableQueryKey = (options: Options<GetRegistrationCertificateTemplateAvailableData>) => createQueryKey('getRegistrationCertificateTemplateAvailable', options);

/**
 * Get Registration Certificate Template Available Endpoint
 * True when a usable global registration certificate template exists and a Drive output folder is available.
 *
 * Soft-deleted (deregistered / cancelled) licenses are included so the certificate
 * download remains available on inactive registration details.
 */
export const getRegistrationCertificateTemplateAvailableOptions = (options: Options<GetRegistrationCertificateTemplateAvailableData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getRegistrationCertificateTemplateAvailable({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getRegistrationCertificateTemplateAvailableQueryKey(options)
    });
};

export const getLicenseRegistrationCertificatePdfQueryKey = (options: Options<GetLicenseRegistrationCertificatePdfData>) => createQueryKey('getLicenseRegistrationCertificatePdf', options);

/**
 * Get License Registration Certificate Pdf Endpoint
 * Generate or refresh a filled registration certificate (Google Doc template) and return the PDF.
 *
 * Google Drive stores the filled Doc/PDF as ``registration-certificate-{license_id}``.
 * The browser download name is the property address when available.
 * Soft-deleted (deregistered / cancelled) licenses are included.
 */
export const getLicenseRegistrationCertificatePdfOptions = (options: Options<GetLicenseRegistrationCertificatePdfData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getLicenseRegistrationCertificatePdf({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getLicenseRegistrationCertificatePdfQueryKey(options)
    });
};

export const getLicensePaymentReceiptOptionsQueryKey = (options: Options<GetLicensePaymentReceiptOptionsData>) => createQueryKey('getLicensePaymentReceiptOptions', options);

/**
 * Get License Payment Receipt Options Endpoint
 * Tell the client whether this transaction spans multiple properties.
 */
export const getLicensePaymentReceiptOptionsOptions = (options: Options<GetLicensePaymentReceiptOptionsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getLicensePaymentReceiptOptions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getLicensePaymentReceiptOptionsQueryKey(options)
    });
};

export const getLicensePaymentReceiptPdfQueryKey = (options: Options<GetLicensePaymentReceiptPdfData>) => createQueryKey('getLicensePaymentReceiptPdf', options);

/**
 * Get License Payment Receipt Pdf Endpoint
 * Generate or reuse a filled payment receipt and return the PDF (download filename set).
 */
export const getLicensePaymentReceiptPdfOptions = (options: Options<GetLicensePaymentReceiptPdfData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getLicensePaymentReceiptPdf({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getLicensePaymentReceiptPdfQueryKey(options)
    });
};

export const getInspectionPaymentReceiptPdfQueryKey = (options: Options<GetInspectionPaymentReceiptPdfData>) => createQueryKey('getInspectionPaymentReceiptPdf', options);

/**
 * Get Inspection Payment Receipt Pdf Endpoint
 * Return PDF receipt for an inspection payment (combined with license fees when paid together).
 */
export const getInspectionPaymentReceiptPdfOptions = (options: Options<GetInspectionPaymentReceiptPdfData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getInspectionPaymentReceiptPdf({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getInspectionPaymentReceiptPdfQueryKey(options)
    });
};

export const rejectLicenseQueryKey = (options: Options<RejectLicenseData>) => createQueryKey('rejectLicense', options);

/**
 * Reject License Endpoint
 * Reject a license.
 */
export const rejectLicenseOptions = (options: Options<RejectLicenseData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await rejectLicense({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: rejectLicenseQueryKey(options)
    });
};

/**
 * Reject License Endpoint
 * Reject a license.
 */
export const rejectLicenseMutation = (options?: Partial<Options<RejectLicenseData>>): UseMutationOptions<RejectLicenseResponse, RejectLicenseError, Options<RejectLicenseData>> => {
    const mutationOptions: UseMutationOptions<RejectLicenseResponse, RejectLicenseError, Options<RejectLicenseData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await rejectLicense({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const previewLicenseTransferQueryKey = (options: Options<PreviewLicenseTransferData>) => createQueryKey('previewLicenseTransfer', options);

/**
 * Preview License Transfer Endpoint
 * Preview path/fee outcomes for a service transfer without writing.
 */
export const previewLicenseTransferOptions = (options: Options<PreviewLicenseTransferData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await previewLicenseTransfer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: previewLicenseTransferQueryKey(options)
    });
};

export const transferLicenseQueryKey = (options: Options<TransferLicenseData>) => createQueryKey('transferLicense', options);

/**
 * Transfer License Endpoint
 * Service-transfer a license: create linked successor and close the prior row.
 */
export const transferLicenseOptions = (options: Options<TransferLicenseData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferLicense({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: transferLicenseQueryKey(options)
    });
};

/**
 * Transfer License Endpoint
 * Service-transfer a license: create linked successor and close the prior row.
 */
export const transferLicenseMutation = (options?: Partial<Options<TransferLicenseData>>): UseMutationOptions<TransferLicenseResponse, TransferLicenseError, Options<TransferLicenseData>> => {
    const mutationOptions: UseMutationOptions<TransferLicenseResponse, TransferLicenseError, Options<TransferLicenseData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await transferLicense({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const createManualPaymentQueryKey = (options: Options<CreateManualPaymentData>) => createQueryKey('createManualPayment', options);

/**
 * Create Manual Payment Endpoint
 * Create a manual payment for a license.
 */
export const createManualPaymentOptions = (options: Options<CreateManualPaymentData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createManualPayment({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createManualPaymentQueryKey(options)
    });
};

/**
 * Create Manual Payment Endpoint
 * Create a manual payment for a license.
 */
export const createManualPaymentMutation = (options?: Partial<Options<CreateManualPaymentData>>): UseMutationOptions<CreateManualPaymentResponse, CreateManualPaymentError, Options<CreateManualPaymentData>> => {
    const mutationOptions: UseMutationOptions<CreateManualPaymentResponse, CreateManualPaymentError, Options<CreateManualPaymentData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createManualPayment({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getManualPaymentAvailablePeriodsQueryKey = (options: Options<GetManualPaymentAvailablePeriodsData>) => createQueryKey('getManualPaymentAvailablePeriods', options);

/**
 * Get Manual Payment Available Periods Endpoint
 * Get the available periods for a manual payment for a license.
 */
export const getManualPaymentAvailablePeriodsOptions = (options: Options<GetManualPaymentAvailablePeriodsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getManualPaymentAvailablePeriods({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getManualPaymentAvailablePeriodsQueryKey(options)
    });
};

/**
 * Update License Payment Period Endpoint
 * Update period start and end dates on any license payment, including card payments.
 */
export const updateLicensePaymentPeriodMutation = (options?: Partial<Options<UpdateLicensePaymentPeriodData>>): UseMutationOptions<UpdateLicensePaymentPeriodResponse, UpdateLicensePaymentPeriodError, Options<UpdateLicensePaymentPeriodData>> => {
    const mutationOptions: UseMutationOptions<UpdateLicensePaymentPeriodResponse, UpdateLicensePaymentPeriodError, Options<UpdateLicensePaymentPeriodData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateLicensePaymentPeriod({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Manual Payment Endpoint
 * Delete a manual payment for a license.
 */
export const deleteManualPaymentMutation = (options?: Partial<Options<DeleteManualPaymentData>>): UseMutationOptions<DeleteManualPaymentResponse, DeleteManualPaymentError, Options<DeleteManualPaymentData>> => {
    const mutationOptions: UseMutationOptions<DeleteManualPaymentResponse, DeleteManualPaymentError, Options<DeleteManualPaymentData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await deleteManualPayment({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Manual Payment Endpoint
 * Update a manual payment for a license.
 */
export const updateManualPaymentMutation = (options?: Partial<Options<UpdateManualPaymentData>>): UseMutationOptions<UpdateManualPaymentResponse, UpdateManualPaymentError, Options<UpdateManualPaymentData>> => {
    const mutationOptions: UseMutationOptions<UpdateManualPaymentResponse, UpdateManualPaymentError, Options<UpdateManualPaymentData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateManualPayment({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAdminUsersQueryKey = (options?: Options<GetAdminUsersData>) => createQueryKey('getAdminUsers', options);

/**
 * Get Admin Users Endpoint
 * Get all admin users.
 */
export const getAdminUsersOptions = (options?: Options<GetAdminUsersData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAdminUsers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAdminUsersQueryKey(options)
    });
};

export const createAdminUserQueryKey = (options: Options<CreateAdminUserData>) => createQueryKey('createAdminUser', options);

/**
 * Create Admin User Endpoint
 * Create an admin user.
 */
export const createAdminUserOptions = (options: Options<CreateAdminUserData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createAdminUser({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createAdminUserQueryKey(options)
    });
};

/**
 * Create Admin User Endpoint
 * Create an admin user.
 */
export const createAdminUserMutation = (options?: Partial<Options<CreateAdminUserData>>): UseMutationOptions<CreateAdminUserResponse, CreateAdminUserError, Options<CreateAdminUserData>> => {
    const mutationOptions: UseMutationOptions<CreateAdminUserResponse, CreateAdminUserError, Options<CreateAdminUserData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createAdminUser({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getOperatorAccessQueryKey = (options?: Options<GetOperatorAccessData>) => createQueryKey('getOperatorAccess', options);

/**
 * Get Operator Access Endpoint
 * Return Admin and Sales for the operator identified by the access token.
 *
 * Sales Commission Admin uses this. Matching the Auth0 email claim against the
 * user directory misses operators whose stored email differs, and a
 * jurisdiction-scoped directory omits operators entirely.
 */
export const getOperatorAccessOptions = (options?: Options<GetOperatorAccessData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOperatorAccess({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOperatorAccessQueryKey(options)
    });
};

export const getAdminUserQueryKey = (options: Options<GetAdminUserData>) => createQueryKey('getAdminUser', options);

/**
 * Get Admin User Endpoint
 * Get an admin user.
 */
export const getAdminUserOptions = (options: Options<GetAdminUserData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAdminUser({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAdminUserQueryKey(options)
    });
};

/**
 * Update Admin User Endpoint
 * Update an admin user.
 */
export const updateAdminUserMutation = (options?: Partial<Options<UpdateAdminUserData>>): UseMutationOptions<UpdateAdminUserResponse, UpdateAdminUserError, Options<UpdateAdminUserData>> => {
    const mutationOptions: UseMutationOptions<UpdateAdminUserResponse, UpdateAdminUserError, Options<UpdateAdminUserData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateAdminUser({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAllLicenseTypeQuestionsQueryKey = (options?: Options<GetAllLicenseTypeQuestionsData>) => createQueryKey('getAllLicenseTypeQuestions', options);

/**
 * Get All Questions Endpoint
 * Get all questions.
 *
 * Operators can see all questions. Government users can see all global questions
 * and jurisdiction-specific questions for their own jurisdiction.
 */
export const getAllLicenseTypeQuestionsOptions = (options?: Options<GetAllLicenseTypeQuestionsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAllLicenseTypeQuestions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAllLicenseTypeQuestionsQueryKey(options)
    });
};

export const createLicenseTypeQuestionQueryKey = (options: Options<CreateLicenseTypeQuestionData>) => createQueryKey('createLicenseTypeQuestion', options);

/**
 * Create Question Endpoint
 * Create a question.
 */
export const createLicenseTypeQuestionOptions = (options: Options<CreateLicenseTypeQuestionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createLicenseTypeQuestion({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createLicenseTypeQuestionQueryKey(options)
    });
};

/**
 * Create Question Endpoint
 * Create a question.
 */
export const createLicenseTypeQuestionMutation = (options?: Partial<Options<CreateLicenseTypeQuestionData>>): UseMutationOptions<CreateLicenseTypeQuestionResponse, CreateLicenseTypeQuestionError, Options<CreateLicenseTypeQuestionData>> => {
    const mutationOptions: UseMutationOptions<CreateLicenseTypeQuestionResponse, CreateLicenseTypeQuestionError, Options<CreateLicenseTypeQuestionData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createLicenseTypeQuestion({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getLicenseTypeQuestionQueryKey = (options: Options<GetLicenseTypeQuestionData>) => createQueryKey('getLicenseTypeQuestion', options);

/**
 * Get Question Endpoint
 * Get a single license question.
 */
export const getLicenseTypeQuestionOptions = (options: Options<GetLicenseTypeQuestionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getLicenseTypeQuestion({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getLicenseTypeQuestionQueryKey(options)
    });
};

/**
 * Update Question Endpoint
 * Update a question.
 */
export const updateLicenseTypeQuestionMutation = (options?: Partial<Options<UpdateLicenseTypeQuestionData>>): UseMutationOptions<UpdateLicenseTypeQuestionResponse, UpdateLicenseTypeQuestionError, Options<UpdateLicenseTypeQuestionData>> => {
    const mutationOptions: UseMutationOptions<UpdateLicenseTypeQuestionResponse, UpdateLicenseTypeQuestionError, Options<UpdateLicenseTypeQuestionData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateLicenseTypeQuestion({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPartiesQueryKey = (options?: Options<GetPartiesData>) => createQueryKey('getParties', options);

/**
 * List Parties Endpoint
 * List party records, optionally including soft-deleted.
 *
 * Secondaries and pending invitees are omitted: OMT/AMS selection always
 * uses primary accounts.
 */
export const getPartiesOptions = (options?: Options<GetPartiesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getParties({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getPartiesQueryKey(options)
    });
};

export const createPartyQueryKey = (options: Options<CreatePartyData>) => createQueryKey('createParty', options);

/**
 * Create Party Endpoint
 * Create a party record.
 */
export const createPartyOptions = (options: Options<CreatePartyData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createParty({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createPartyQueryKey(options)
    });
};

/**
 * Create Party Endpoint
 * Create a party record.
 */
export const createPartyMutation = (options?: Partial<Options<CreatePartyData>>): UseMutationOptions<CreatePartyResponse, CreatePartyError, Options<CreatePartyData>> => {
    const mutationOptions: UseMutationOptions<CreatePartyResponse, CreatePartyError, Options<CreatePartyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createParty({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPartyQueryKey = (options: Options<GetPartyData>) => createQueryKey('getParty', options);

/**
 * Get Party Endpoint
 * Get a single party record.
 */
export const getPartyOptions = (options: Options<GetPartyData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getParty({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getPartyQueryKey(options)
    });
};

/**
 * Update Party Endpoint
 * Update a party record (including soft delete/restore).
 */
export const updatePartyMutation = (options?: Partial<Options<UpdatePartyData>>): UseMutationOptions<UpdatePartyResponse, UpdatePartyError, Options<UpdatePartyData>> => {
    const mutationOptions: UseMutationOptions<UpdatePartyResponse, UpdatePartyError, Options<UpdatePartyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateParty({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPreviousPropertyManagersQueryKey = (options?: Options<GetPreviousPropertyManagersData>) => createQueryKey('getPreviousPropertyManagers', options);

/**
 * List Previous Property Managers Endpoint
 * Company contacts already used on other registrations in the same account.
 *
 * Registrants are limited to their own confirmed account network. Operators
 * may request any account. Government users, and operators viewing as
 * government, may request an account only when that account has a license
 * in their jurisdiction.
 */
export const getPreviousPropertyManagersOptions = (options?: Options<GetPreviousPropertyManagersData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getPreviousPropertyManagers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getPreviousPropertyManagersQueryKey(options)
    });
};

export const getQuestionOptionsQueryKey = (options?: Options<GetQuestionOptionsData>) => createQueryKey('getQuestionOptions', options);

/**
 * List Question Options Endpoint
 * List question options, optionally filtered by question_id or party_id.
 *
 * Registrants may only list by question_id (for fixed-list name/address/contact
 * questions during registration); they cannot filter by party_id or include deleted.
 */
export const getQuestionOptionsOptions = (options?: Options<GetQuestionOptionsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getQuestionOptions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getQuestionOptionsQueryKey(options)
    });
};

export const createQuestionOptionQueryKey = (options: Options<CreateQuestionOptionData>) => createQueryKey('createQuestionOption', options);

/**
 * Create Question Option Endpoint
 * Create a question option (link a question to a party for auto-complete).
 */
export const createQuestionOptionOptions = (options: Options<CreateQuestionOptionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createQuestionOption({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createQuestionOptionQueryKey(options)
    });
};

/**
 * Create Question Option Endpoint
 * Create a question option (link a question to a party for auto-complete).
 */
export const createQuestionOptionMutation = (options?: Partial<Options<CreateQuestionOptionData>>): UseMutationOptions<CreateQuestionOptionResponse, CreateQuestionOptionError, Options<CreateQuestionOptionData>> => {
    const mutationOptions: UseMutationOptions<CreateQuestionOptionResponse, CreateQuestionOptionError, Options<CreateQuestionOptionData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createQuestionOption({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getQuestionOptionQueryKey = (options: Options<GetQuestionOptionData>) => createQueryKey('getQuestionOption', options);

/**
 * Get Question Option Endpoint
 * Get a single question option.
 */
export const getQuestionOptionOptions = (options: Options<GetQuestionOptionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getQuestionOption({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getQuestionOptionQueryKey(options)
    });
};

/**
 * Update Question Option Endpoint
 * Update a question option (e.g. soft delete).
 */
export const updateQuestionOptionMutation = (options?: Partial<Options<UpdateQuestionOptionData>>): UseMutationOptions<UpdateQuestionOptionResponse, UpdateQuestionOptionError, Options<UpdateQuestionOptionData>> => {
    const mutationOptions: UseMutationOptions<UpdateQuestionOptionResponse, UpdateQuestionOptionError, Options<UpdateQuestionOptionData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateQuestionOption({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const lookupParcelByAddressQueryKey = (options: Options<LookupParcelByAddressData>) => createQueryKey('lookupParcelByAddress', options);

/**
 * Property Lookup Endpoint
 * Lookup a property by address.
 */
export const lookupParcelByAddressOptions = (options: Options<LookupParcelByAddressData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await lookupParcelByAddress({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: lookupParcelByAddressQueryKey(options)
    });
};

/**
 * Property Lookup Endpoint
 * Lookup a property by address.
 */
export const lookupParcelByAddressMutation = (options?: Partial<Options<LookupParcelByAddressData>>): UseMutationOptions<LookupParcelByAddressResponse, LookupParcelByAddressError, Options<LookupParcelByAddressData>> => {
    const mutationOptions: UseMutationOptions<LookupParcelByAddressResponse, LookupParcelByAddressError, Options<LookupParcelByAddressData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await lookupParcelByAddress({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const lookupParcelByApnQueryKey = (options: Options<LookupParcelByApnData>) => createQueryKey('lookupParcelByApn', options);

/**
 * Apn Lookup Endpoint
 * Lookup a property by APN.
 */
export const lookupParcelByApnOptions = (options: Options<LookupParcelByApnData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await lookupParcelByApn({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: lookupParcelByApnQueryKey(options)
    });
};

/**
 * Apn Lookup Endpoint
 * Lookup a property by APN.
 */
export const lookupParcelByApnMutation = (options?: Partial<Options<LookupParcelByApnData>>): UseMutationOptions<LookupParcelByApnResponse, LookupParcelByApnError, Options<LookupParcelByApnData>> => {
    const mutationOptions: UseMutationOptions<LookupParcelByApnResponse, LookupParcelByApnError, Options<LookupParcelByApnData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await lookupParcelByApn({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const generateReportQueryKey = (options: Options<GenerateReportData>) => createQueryKey('generateReport', options);

/**
 * Generate Report
 * Generate a government report.
 */
export const generateReportOptions = (options: Options<GenerateReportData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await generateReport({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: generateReportQueryKey(options)
    });
};

/**
 * Generate Report
 * Generate a government report.
 */
export const generateReportMutation = (options?: Partial<Options<GenerateReportData>>): UseMutationOptions<unknown, GenerateReportError, Options<GenerateReportData>> => {
    const mutationOptions: UseMutationOptions<unknown, GenerateReportError, Options<GenerateReportData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await generateReport({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAnswerFileQueryKey = (options: Options<GetAnswerFileData>) => createQueryKey('getAnswerFile', options);

/**
 * Get Answer File Endpoint
 * Get an answer file by token.
 *
 * Comment attachments are limited to users who can access that license.
 * Other answer files stay available to any authenticated portal user.
 */
export const getAnswerFileOptions = (options: Options<GetAnswerFileData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAnswerFile({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAnswerFileQueryKey(options)
    });
};

export const getFeesForNewLicenseQueryKey = (options: Options<GetFeesForNewLicenseData>) => createQueryKey('getFeesForNewLicense', options);

/**
 * Get Fees For New License Endpoint
 * Returns a list of periods and fees for a new license.
 */
export const getFeesForNewLicenseOptions = (options: Options<GetFeesForNewLicenseData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getFeesForNewLicense({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getFeesForNewLicenseQueryKey(options)
    });
};

export const getFeesForRenewalQueryKey = (options: Options<GetFeesForRenewalData>) => createQueryKey('getFeesForRenewal', options);

/**
 * Get Fees For Renewal Endpoint
 * Returns a list of periods and fees for a license renewal.
 *
 * Only returns periods with outstanding balances (fee > 0 or late_fee > 0).
 * This includes all periods with payments (including current period) as well as
 * future payable periods that still have amounts due.
 *
 * For renewal and reapply flows, fee-affecting answers can be provided to
 * recalculate fees before they are saved on the license. Omitted answers are
 * read from the license instead of being treated as unanswered, so callers that
 * only want the license's current fees (e.g. the period compliance card) match
 * what the fee engine charges.
 */
export const getFeesForRenewalOptions = (options: Options<GetFeesForRenewalData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getFeesForRenewal({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getFeesForRenewalQueryKey(options)
    });
};

export const getFeesForPaymentQueryKey = (options: Options<GetFeesForPaymentData>) => createQueryKey('getFeesForPayment', options);

/**
 * Get Fees For Payment Endpoint
 * Returns a list of periods and fees for a license payment.
 *
 * This endpoint is called by the Pay Now button and only returns historical
 * unpaid periods (periods before renewal_date), not renewal periods.
 * Also deletes any existing pending payment records to ensure a clean slate
 * for the complete payment screen.
 */
export const getFeesForPaymentOptions = (options: Options<GetFeesForPaymentData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getFeesForPayment({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getFeesForPaymentQueryKey(options)
    });
};

/**
 * Update Inspection Endpoint
 * Update an inspection (reassign, complete, etc.).
 */
export const updateInspectionMutation = (options?: Partial<Options<UpdateInspectionData>>): UseMutationOptions<UpdateInspectionResponse, UpdateInspectionError, Options<UpdateInspectionData>> => {
    const mutationOptions: UseMutationOptions<UpdateInspectionResponse, UpdateInspectionError, Options<UpdateInspectionData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateInspection({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const uploadTempFileQueryKey = (options: Options<UploadTempFileData>) => createQueryKey('uploadTempFile', options);

/**
 * Upload Temp File Endpoint
 * Upload a temp file, save it, and return a token identifying the file.
 */
export const uploadTempFileOptions = (options: Options<UploadTempFileData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await uploadTempFile({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: uploadTempFileQueryKey(options)
    });
};

/**
 * Upload Temp File Endpoint
 * Upload a temp file, save it, and return a token identifying the file.
 */
export const uploadTempFileMutation = (options?: Partial<Options<UploadTempFileData>>): UseMutationOptions<UploadTempFileResponse, UploadTempFileError, Options<UploadTempFileData>> => {
    const mutationOptions: UseMutationOptions<UploadTempFileResponse, UploadTempFileError, Options<UploadTempFileData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await uploadTempFile({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAttomForeclosureCaseDetailsQueryKey = (options: Options<GetAttomForeclosureCaseDetailsData>) => createQueryKey('getAttomForeclosureCaseDetails', options);

/**
 * Get Attom Foreclosure Case Details Endpoint
 * Look up ATTOM foreclosure case summary and foreclosure/recorder documents.
 */
export const getAttomForeclosureCaseDetailsOptions = (options: Options<GetAttomForeclosureCaseDetailsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAttomForeclosureCaseDetails({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAttomForeclosureCaseDetailsQueryKey(options)
    });
};

export const fetchLiveLinkUrlQueryKey = (options: Options<FetchLiveLinkUrlData>) => createQueryKey('fetchLiveLinkUrl', options);

/**
 * Fetch Live Link Url Endpoint
 * Proxy a Live Link POST encrypt/fetch URL and return its JSON body.
 *
 * Browser clients cannot call third-party clerk endpoints directly (CORS), so
 * authenticated Hera users resolve POST live links through this endpoint.
 */
export const fetchLiveLinkUrlOptions = (options: Options<FetchLiveLinkUrlData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await fetchLiveLinkUrl({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: fetchLiveLinkUrlQueryKey(options)
    });
};

/**
 * Fetch Live Link Url Endpoint
 * Proxy a Live Link POST encrypt/fetch URL and return its JSON body.
 *
 * Browser clients cannot call third-party clerk endpoints directly (CORS), so
 * authenticated Hera users resolve POST live links through this endpoint.
 */
export const fetchLiveLinkUrlMutation = (options?: Partial<Options<FetchLiveLinkUrlData>>): UseMutationOptions<FetchLiveLinkUrlResponse, FetchLiveLinkUrlError, Options<FetchLiveLinkUrlData>> => {
    const mutationOptions: UseMutationOptions<FetchLiveLinkUrlResponse, FetchLiveLinkUrlError, Options<FetchLiveLinkUrlData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await fetchLiveLinkUrl({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const searchRegistrantsForImpersonationQueryKey = (options?: Options<SearchRegistrantsForImpersonationData>) => createQueryKey('searchRegistrantsForImpersonation', options);

/**
 * Search Registrants For Impersonation Endpoint
 * Search registrant accounts by email, name, or company (operators only).
 */
export const searchRegistrantsForImpersonationOptions = (options?: Options<SearchRegistrantsForImpersonationData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await searchRegistrantsForImpersonation({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: searchRegistrantsForImpersonationQueryKey(options)
    });
};

export const getRegistrantAccountQueryKey = (options?: Options<GetRegistrantAccountData>) => createQueryKey('getRegistrantAccount', options);

/**
 * Get Registrant Account Endpoint
 * Get the registrant account.
 *
 * For secondary accounts, also includes primary account name and company_name.
 */
export const getRegistrantAccountOptions = (options?: Options<GetRegistrantAccountData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getRegistrantAccount({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getRegistrantAccountQueryKey(options)
    });
};

/**
 * Update Registrant Account Endpoint
 * Update the registrant account.
 */
export const updateRegistrantAccountMutation = (options?: Partial<Options<UpdateRegistrantAccountData>>): UseMutationOptions<UpdateRegistrantAccountResponse, UpdateRegistrantAccountError, Options<UpdateRegistrantAccountData>> => {
    const mutationOptions: UseMutationOptions<UpdateRegistrantAccountResponse, UpdateRegistrantAccountError, Options<UpdateRegistrantAccountData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateRegistrantAccount({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getRegistrantAccountUsersQueryKey = (options?: Options<GetRegistrantAccountUsersData>) => createQueryKey('getRegistrantAccountUsers', options);

/**
 * Get Registrant Account Users Endpoint
 * Get all users (primary and secondary) for the registrant account.
 *
 * If the logged-in account is a secondary account (has primary_id set), returns
 * all users linked to that primary account. Otherwise, returns all users linked
 * to the logged-in account.
 *
 * Returns the primary account and all secondary accounts where primary_id
 * or primary_id_pending equals the primary account ID.
 * Accounts with primary_id_pending but not primary_id have status "pending".
 */
export const getRegistrantAccountUsersOptions = (options?: Options<GetRegistrantAccountUsersData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getRegistrantAccountUsers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getRegistrantAccountUsersQueryKey(options)
    });
};

export const addSecondaryUserQueryKey = (options: Options<AddSecondaryUserData>) => createQueryKey('addSecondaryUser', options);

/**
 * Add Secondary User Endpoint
 * Add a secondary user to the registrant account by email address.
 *
 * Creates a new secondary account if one doesn't exist, or updates the existing
 * account's primary_id_pending to link it to the current account. The user will
 * be     asked to confirm the link when they next log in.
 */
export const addSecondaryUserOptions = (options: Options<AddSecondaryUserData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await addSecondaryUser({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: addSecondaryUserQueryKey(options)
    });
};

/**
 * Add Secondary User Endpoint
 * Add a secondary user to the registrant account by email address.
 *
 * Creates a new secondary account if one doesn't exist, or updates the existing
 * account's primary_id_pending to link it to the current account. The user will
 * be     asked to confirm the link when they next log in.
 */
export const addSecondaryUserMutation = (options?: Partial<Options<AddSecondaryUserData>>): UseMutationOptions<AddSecondaryUserResponse, AddSecondaryUserError, Options<AddSecondaryUserData>> => {
    const mutationOptions: UseMutationOptions<AddSecondaryUserResponse, AddSecondaryUserError, Options<AddSecondaryUserData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await addSecondaryUser({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getRegistrantOrgPaymentAccountQueryKey = (options?: Options<GetRegistrantOrgPaymentAccountData>) => createQueryKey('getRegistrantOrgPaymentAccount', options);

/**
 * Get Registrant Org Payment Account Endpoint
 * Return the effective company Stripe billing account and eligible members.
 */
export const getRegistrantOrgPaymentAccountOptions = (options?: Options<GetRegistrantOrgPaymentAccountData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getRegistrantOrgPaymentAccount({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getRegistrantOrgPaymentAccountQueryKey(options)
    });
};

/**
 * Update Registrant Org Payment Account Endpoint
 * Set the single company Stripe billing account.
 */
export const updateRegistrantOrgPaymentAccountMutation = (options?: Partial<Options<UpdateRegistrantOrgPaymentAccountData>>): UseMutationOptions<UpdateRegistrantOrgPaymentAccountResponse, UpdateRegistrantOrgPaymentAccountError, Options<UpdateRegistrantOrgPaymentAccountData>> => {
    const mutationOptions: UseMutationOptions<UpdateRegistrantOrgPaymentAccountResponse, UpdateRegistrantOrgPaymentAccountError, Options<UpdateRegistrantOrgPaymentAccountData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateRegistrantOrgPaymentAccount({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Registrant Account Login Identity Accounts Contact Endpoint
 * Set accounts-contact for a portal login in this registrant org.
 */
export const updateRegistrantAccountLoginIdentityAccountsContactMutation = (options?: Partial<Options<UpdateRegistrantAccountLoginIdentityAccountsContactData>>): UseMutationOptions<UpdateRegistrantAccountLoginIdentityAccountsContactResponse, UpdateRegistrantAccountLoginIdentityAccountsContactError, Options<UpdateRegistrantAccountLoginIdentityAccountsContactData>> => {
    const mutationOptions: UseMutationOptions<UpdateRegistrantAccountLoginIdentityAccountsContactResponse, UpdateRegistrantAccountLoginIdentityAccountsContactError, Options<UpdateRegistrantAccountLoginIdentityAccountsContactData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateRegistrantAccountLoginIdentityAccountsContact({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Registrant Login Identity Inspection Access Endpoint
 * Toggle registrant-portal access and all-inspections access for an org user.
 *
 * Primary accounts cannot turn off their own registrant portal access.
 * Primary dual-portal identities are always forced to ALL inspections.
 */
export const updateRegistrantLoginIdentityInspectionAccessMutation = (options?: Partial<Options<UpdateRegistrantLoginIdentityInspectionAccessData>>): UseMutationOptions<UpdateRegistrantLoginIdentityInspectionAccessResponse, UpdateRegistrantLoginIdentityInspectionAccessError, Options<UpdateRegistrantLoginIdentityInspectionAccessData>> => {
    const mutationOptions: UseMutationOptions<UpdateRegistrantLoginIdentityInspectionAccessResponse, UpdateRegistrantLoginIdentityInspectionAccessError, Options<UpdateRegistrantLoginIdentityInspectionAccessData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateRegistrantLoginIdentityInspectionAccess({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Registrant Account User Accounts Contact Endpoint
 * Set invoice / accounts-contact for a network user (portal login and/or pre-login).
 */
export const updateRegistrantAccountUserAccountsContactMutation = (options?: Partial<Options<UpdateRegistrantAccountUserAccountsContactData>>): UseMutationOptions<UpdateRegistrantAccountUserAccountsContactResponse, UpdateRegistrantAccountUserAccountsContactError, Options<UpdateRegistrantAccountUserAccountsContactData>> => {
    const mutationOptions: UseMutationOptions<UpdateRegistrantAccountUserAccountsContactResponse, UpdateRegistrantAccountUserAccountsContactError, Options<UpdateRegistrantAccountUserAccountsContactData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateRegistrantAccountUserAccountsContact({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Registrant Account User Inspection Access Endpoint
 * Set portal access for a network user (portal logins and/or pre-login).
 */
export const updateRegistrantAccountUserInspectionAccessMutation = (options?: Partial<Options<UpdateRegistrantAccountUserInspectionAccessData>>): UseMutationOptions<UpdateRegistrantAccountUserInspectionAccessResponse, UpdateRegistrantAccountUserInspectionAccessError, Options<UpdateRegistrantAccountUserInspectionAccessData>> => {
    const mutationOptions: UseMutationOptions<UpdateRegistrantAccountUserInspectionAccessResponse, UpdateRegistrantAccountUserInspectionAccessError, Options<UpdateRegistrantAccountUserInspectionAccessData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateRegistrantAccountUserInspectionAccess({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getRegistrantLicensesQueryKey = (options?: Options<GetRegistrantLicensesData>) => createQueryKey('getRegistrantLicenses', options);

/**
 * Get Registrant Licenses Endpoint
 * Get one page of the registrant's licenses.
 */
export const getRegistrantLicensesOptions = (options?: Options<GetRegistrantLicensesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getRegistrantLicenses({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getRegistrantLicensesQueryKey(options)
    });
};

export const getRegistrantLicensesInfiniteQueryKey = (options?: Options<GetRegistrantLicensesData>): QueryKey<Options<GetRegistrantLicensesData>> => createQueryKey('getRegistrantLicenses', options, true);

/**
 * Get Registrant Licenses Endpoint
 * Get one page of the registrant's licenses.
 */
export const getRegistrantLicensesInfiniteOptions = (options?: Options<GetRegistrantLicensesData>) => {
    return infiniteQueryOptions<GetRegistrantLicensesResponse, GetRegistrantLicensesError, InfiniteData<GetRegistrantLicensesResponse>, QueryKey<Options<GetRegistrantLicensesData>>, number | Pick<QueryKey<Options<GetRegistrantLicensesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetRegistrantLicensesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getRegistrantLicenses({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getRegistrantLicensesInfiniteQueryKey(options)
    });
};

export const createLicenseQueryKey = (options: Options<CreateLicenseData>) => createQueryKey('createLicense', options);

/**
 * Create License Endpoint
 * Create a new registrant license, or transfer from an existing active license.
 */
export const createLicenseOptions = (options: Options<CreateLicenseData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createLicense({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createLicenseQueryKey(options)
    });
};

/**
 * Create License Endpoint
 * Create a new registrant license, or transfer from an existing active license.
 */
export const createLicenseMutation = (options?: Partial<Options<CreateLicenseData>>): UseMutationOptions<CreateLicenseResponse, CreateLicenseError, Options<CreateLicenseData>> => {
    const mutationOptions: UseMutationOptions<CreateLicenseResponse, CreateLicenseError, Options<CreateLicenseData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createLicense({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listActiveLicensesByPropertyQueryKey = (options: Options<ListActiveLicensesByPropertyData>) => createQueryKey('listActiveLicensesByProperty', options);

/**
 * List Active Licenses By Property Endpoint
 * List transferable licenses matching a registrant's property details.
 */
export const listActiveLicensesByPropertyOptions = (options: Options<ListActiveLicensesByPropertyData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listActiveLicensesByProperty({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listActiveLicensesByPropertyQueryKey(options)
    });
};

export const getRegistrantLicenseStatsQueryKey = (options?: Options<GetRegistrantLicenseStatsData>) => createQueryKey('getRegistrantLicenseStats', options);

/**
 * Get Registrant License Stats Endpoint
 * Registrant dashboard tile aggregates (header scope only).
 */
export const getRegistrantLicenseStatsOptions = (options?: Options<GetRegistrantLicenseStatsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getRegistrantLicenseStats({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getRegistrantLicenseStatsQueryKey(options)
    });
};

export const getRegistrantLicenseFilterValuesQueryKey = (options: Options<GetRegistrantLicenseFilterValuesData>) => createQueryKey('getRegistrantLicenseFilterValues', options);

/**
 * Get Registrant License Filter Values Endpoint
 * Distinct display strings for one registrant list column.
 */
export const getRegistrantLicenseFilterValuesOptions = (options: Options<GetRegistrantLicenseFilterValuesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getRegistrantLicenseFilterValues({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getRegistrantLicenseFilterValuesQueryKey(options)
    });
};

export const getRegistrantLicenseJurisdictionOptionsQueryKey = (options?: Options<GetRegistrantLicenseJurisdictionOptionsData>) => createQueryKey('getRegistrantLicenseJurisdictionOptions', options);

/**
 * Get Registrant License Jurisdiction Options Endpoint
 * Jurisdictions the registrant holds licenses in, named for the filter.
 */
export const getRegistrantLicenseJurisdictionOptionsOptions = (options?: Options<GetRegistrantLicenseJurisdictionOptionsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getRegistrantLicenseJurisdictionOptions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getRegistrantLicenseJurisdictionOptionsQueryKey(options)
    });
};

export const getRegistrantLicenseMapPinsQueryKey = (options?: Options<GetRegistrantLicenseMapPinsData>) => createQueryKey('getRegistrantLicenseMapPins', options);

/**
 * Get Registrant License Map Pins Endpoint
 * Pins or clusters for the registrant's matching licenses with coordinates.
 */
export const getRegistrantLicenseMapPinsOptions = (options?: Options<GetRegistrantLicenseMapPinsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getRegistrantLicenseMapPins({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getRegistrantLicenseMapPinsQueryKey(options)
    });
};

export const exportRegistrantLicensesQueryKey = (options?: Options<ExportRegistrantLicensesData>) => createQueryKey('exportRegistrantLicenses', options);

/**
 * Export Registrant Licenses Endpoint
 * All registrant licenses matching the current list filters/sort.
 */
export const exportRegistrantLicensesOptions = (options?: Options<ExportRegistrantLicensesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await exportRegistrantLicenses({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: exportRegistrantLicensesQueryKey(options)
    });
};

export const getRegistrantUnregisteredPropertiesQueryKey = (options?: Options<GetRegistrantUnregisteredPropertiesData>) => createQueryKey('getRegistrantUnregisteredProperties', options);

/**
 * Get Registrant Unregistered Properties Endpoint
 * One sortable/filterable page of the organization's unregistered properties.
 */
export const getRegistrantUnregisteredPropertiesOptions = (options?: Options<GetRegistrantUnregisteredPropertiesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getRegistrantUnregisteredProperties({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getRegistrantUnregisteredPropertiesQueryKey(options)
    });
};

export const getRegistrantUnregisteredPropertiesInfiniteQueryKey = (options?: Options<GetRegistrantUnregisteredPropertiesData>): QueryKey<Options<GetRegistrantUnregisteredPropertiesData>> => createQueryKey('getRegistrantUnregisteredProperties', options, true);

/**
 * Get Registrant Unregistered Properties Endpoint
 * One sortable/filterable page of the organization's unregistered properties.
 */
export const getRegistrantUnregisteredPropertiesInfiniteOptions = (options?: Options<GetRegistrantUnregisteredPropertiesData>) => {
    return infiniteQueryOptions<GetRegistrantUnregisteredPropertiesResponse, GetRegistrantUnregisteredPropertiesError, InfiniteData<GetRegistrantUnregisteredPropertiesResponse>, QueryKey<Options<GetRegistrantUnregisteredPropertiesData>>, number | Pick<QueryKey<Options<GetRegistrantUnregisteredPropertiesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetRegistrantUnregisteredPropertiesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getRegistrantUnregisteredProperties({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getRegistrantUnregisteredPropertiesInfiniteQueryKey(options)
    });
};

export const getLicenseCommentsQueryKey = (options: Options<GetLicenseCommentsData>) => createQueryKey('getLicenseComments', options);

/**
 * Get License Comments Endpoint
 * Get comments visible to the registrant.
 */
export const getLicenseCommentsOptions = (options: Options<GetLicenseCommentsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getLicenseComments({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getLicenseCommentsQueryKey(options)
    });
};

export const createRegistrantLicenseCommentQueryKey = (options: Options<CreateRegistrantLicenseCommentData>) => createQueryKey('createRegistrantLicenseComment', options);

/**
 * Create Registrant License Comment Endpoint
 * Add a registrant comment, optionally notifying Hera or resolving an issue.
 */
export const createRegistrantLicenseCommentOptions = (options: Options<CreateRegistrantLicenseCommentData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createRegistrantLicenseComment({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createRegistrantLicenseCommentQueryKey(options)
    });
};

/**
 * Create Registrant License Comment Endpoint
 * Add a registrant comment, optionally notifying Hera or resolving an issue.
 */
export const createRegistrantLicenseCommentMutation = (options?: Partial<Options<CreateRegistrantLicenseCommentData>>): UseMutationOptions<CreateRegistrantLicenseCommentResponse, CreateRegistrantLicenseCommentError, Options<CreateRegistrantLicenseCommentData>> => {
    const mutationOptions: UseMutationOptions<CreateRegistrantLicenseCommentResponse, CreateRegistrantLicenseCommentError, Options<CreateRegistrantLicenseCommentData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createRegistrantLicenseComment({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getLicensePaymentsQueryKey = (options: Options<GetLicensePaymentsData>) => createQueryKey('getLicensePayments', options);

/**
 * Get License Payments Endpoint
 * Get the payments for a license.
 */
export const getLicensePaymentsOptions = (options: Options<GetLicensePaymentsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getLicensePayments({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getLicensePaymentsQueryKey(options)
    });
};

export const makeLicensePaymentQueryKey = (options: Options<MakeLicensePaymentData>) => createQueryKey('makeLicensePayment', options);

/**
 * Make License Payment Endpoint
 * Make payment for a license using existing pending payment records.
 */
export const makeLicensePaymentOptions = (options: Options<MakeLicensePaymentData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await makeLicensePayment({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: makeLicensePaymentQueryKey(options)
    });
};

/**
 * Make License Payment Endpoint
 * Make payment for a license using existing pending payment records.
 */
export const makeLicensePaymentMutation = (options?: Partial<Options<MakeLicensePaymentData>>): UseMutationOptions<MakeLicensePaymentResponse, MakeLicensePaymentError, Options<MakeLicensePaymentData>> => {
    const mutationOptions: UseMutationOptions<MakeLicensePaymentResponse, MakeLicensePaymentError, Options<MakeLicensePaymentData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await makeLicensePayment({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const createPendingPaymentRecordsQueryKey = (options: Options<CreatePendingPaymentRecordsData>) => createQueryKey('createPendingPaymentRecords', options);

/**
 * Create Pending Payment Records Endpoint
 * Create pending payment records for a license with user-adjusted amounts.
 *
 * This endpoint deletes any existing pending payment processor records
 * and creates new ones with the specified amounts. After calling this,
 * you can call makeLicensePayment to initiate the Stripe checkout session.
 */
export const createPendingPaymentRecordsOptions = (options: Options<CreatePendingPaymentRecordsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createPendingPaymentRecords({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createPendingPaymentRecordsQueryKey(options)
    });
};

/**
 * Create Pending Payment Records Endpoint
 * Create pending payment records for a license with user-adjusted amounts.
 *
 * This endpoint deletes any existing pending payment processor records
 * and creates new ones with the specified amounts. After calling this,
 * you can call makeLicensePayment to initiate the Stripe checkout session.
 */
export const createPendingPaymentRecordsMutation = (options?: Partial<Options<CreatePendingPaymentRecordsData>>): UseMutationOptions<CreatePendingPaymentRecordsResponse, CreatePendingPaymentRecordsError, Options<CreatePendingPaymentRecordsData>> => {
    const mutationOptions: UseMutationOptions<CreatePendingPaymentRecordsResponse, CreatePendingPaymentRecordsError, Options<CreatePendingPaymentRecordsData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createPendingPaymentRecords({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getBulkPaymentFeesQueryKey = (options?: Options<GetBulkPaymentFeesData>) => createQueryKey('getBulkPaymentFees', options);

/**
 * Get Bulk Payment Fees Endpoint
 * Get fees for Pay Later bulk-payment cohort licenses (bulk payment screen).
 *
 * Loads only licenses that can appear on this screen (Pay Later selected + payable
 * statuses). Missing, dirty, or stale runtime cache rows for that subset are
 * recomputed in **parallel**, each in its **own** database transaction. Fresh cache
 * rows (including payable ones) are reused so opening bulk pay after the dashboard
 * does not recompute every license.
 *
 * The optional query params carry the registrant dashboard's global filters
 * (jurisdiction / license type / registrant / AMS). They narrow the cohort *before*
 * the expensive per-license work, so a filtered dashboard also means a faster and
 * matching bulk payment screen. ``ams_question_id`` is the question the dashboard
 * filtered AMS on; it is widened to every question behind that AMS column so this
 * screen keeps the same properties the dashboard showed.
 */
export const getBulkPaymentFeesOptions = (options?: Options<GetBulkPaymentFeesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getBulkPaymentFees({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getBulkPaymentFeesQueryKey(options)
    });
};

export const createBulkPendingPaymentRecordsQueryKey = (options: Options<CreateBulkPendingPaymentRecordsData>) => createQueryKey('createBulkPendingPaymentRecords', options);

/**
 * Create Bulk Pending Payment Records Endpoint
 * Create pending payment records for multiple licenses (for bulk payment).
 */
export const createBulkPendingPaymentRecordsOptions = (options: Options<CreateBulkPendingPaymentRecordsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createBulkPendingPaymentRecords({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createBulkPendingPaymentRecordsQueryKey(options)
    });
};

/**
 * Create Bulk Pending Payment Records Endpoint
 * Create pending payment records for multiple licenses (for bulk payment).
 */
export const createBulkPendingPaymentRecordsMutation = (options?: Partial<Options<CreateBulkPendingPaymentRecordsData>>): UseMutationOptions<CreateBulkPendingPaymentRecordsResponse, CreateBulkPendingPaymentRecordsError, Options<CreateBulkPendingPaymentRecordsData>> => {
    const mutationOptions: UseMutationOptions<CreateBulkPendingPaymentRecordsResponse, CreateBulkPendingPaymentRecordsError, Options<CreateBulkPendingPaymentRecordsData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createBulkPendingPaymentRecords({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const makeBulkLicensePaymentQueryKey = (options: Options<MakeBulkLicensePaymentData>) => createQueryKey('makeBulkLicensePayment', options);

/**
 * Make Bulk License Payment Endpoint
 * Create one Stripe checkout session for all pending payment records.
 */
export const makeBulkLicensePaymentOptions = (options: Options<MakeBulkLicensePaymentData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await makeBulkLicensePayment({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: makeBulkLicensePaymentQueryKey(options)
    });
};

/**
 * Make Bulk License Payment Endpoint
 * Create one Stripe checkout session for all pending payment records.
 */
export const makeBulkLicensePaymentMutation = (options?: Partial<Options<MakeBulkLicensePaymentData>>): UseMutationOptions<MakeBulkLicensePaymentResponse, MakeBulkLicensePaymentError, Options<MakeBulkLicensePaymentData>> => {
    const mutationOptions: UseMutationOptions<MakeBulkLicensePaymentResponse, MakeBulkLicensePaymentError, Options<MakeBulkLicensePaymentData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await makeBulkLicensePayment({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const createBulkCheckPaymentQueryKey = (options: Options<CreateBulkCheckPaymentData>) => createQueryKey('createBulkCheckPayment', options);

/**
 * Create Bulk Check Payment Endpoint
 * Create one check payment for all given licenses (bulk), with processing fee apportioned.
 */
export const createBulkCheckPaymentOptions = (options: Options<CreateBulkCheckPaymentData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createBulkCheckPayment({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createBulkCheckPaymentQueryKey(options)
    });
};

/**
 * Create Bulk Check Payment Endpoint
 * Create one check payment for all given licenses (bulk), with processing fee apportioned.
 */
export const createBulkCheckPaymentMutation = (options?: Partial<Options<CreateBulkCheckPaymentData>>): UseMutationOptions<CreateBulkCheckPaymentResponse, CreateBulkCheckPaymentError, Options<CreateBulkCheckPaymentData>> => {
    const mutationOptions: UseMutationOptions<CreateBulkCheckPaymentResponse, CreateBulkCheckPaymentError, Options<CreateBulkCheckPaymentData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createBulkCheckPayment({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const createRegistrantCheckPaymentQueryKey = (options: Options<CreateRegistrantCheckPaymentData>) => createQueryKey('createRegistrantCheckPayment', options);

/**
 * Create Registrant Check Payment Endpoint
 * Create check payment records and return the manual transaction ID.
 */
export const createRegistrantCheckPaymentOptions = (options: Options<CreateRegistrantCheckPaymentData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createRegistrantCheckPayment({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createRegistrantCheckPaymentQueryKey(options)
    });
};

/**
 * Create Registrant Check Payment Endpoint
 * Create check payment records and return the manual transaction ID.
 */
export const createRegistrantCheckPaymentMutation = (options?: Partial<Options<CreateRegistrantCheckPaymentData>>): UseMutationOptions<CreateRegistrantCheckPaymentResponse, CreateRegistrantCheckPaymentError, Options<CreateRegistrantCheckPaymentData>> => {
    const mutationOptions: UseMutationOptions<CreateRegistrantCheckPaymentResponse, CreateRegistrantCheckPaymentError, Options<CreateRegistrantCheckPaymentData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createRegistrantCheckPayment({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const createBulkInvoicePaymentQueryKey = (options: Options<CreateBulkInvoicePaymentData>) => createQueryKey('createBulkInvoicePayment', options);

/**
 * Create Bulk Invoice Payment Endpoint
 * Create one invoice for multiple owned licenses (no processing fees on invoice lines).
 */
export const createBulkInvoicePaymentOptions = (options: Options<CreateBulkInvoicePaymentData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createBulkInvoicePayment({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createBulkInvoicePaymentQueryKey(options)
    });
};

/**
 * Create Bulk Invoice Payment Endpoint
 * Create one invoice for multiple owned licenses (no processing fees on invoice lines).
 */
export const createBulkInvoicePaymentMutation = (options?: Partial<Options<CreateBulkInvoicePaymentData>>): UseMutationOptions<CreateBulkInvoicePaymentResponse, CreateBulkInvoicePaymentError, Options<CreateBulkInvoicePaymentData>> => {
    const mutationOptions: UseMutationOptions<CreateBulkInvoicePaymentResponse, CreateBulkInvoicePaymentError, Options<CreateBulkInvoicePaymentData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createBulkInvoicePayment({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const createRegistrantInvoicePaymentQueryKey = (options: Options<CreateRegistrantInvoicePaymentData>) => createQueryKey('createRegistrantInvoicePayment', options);

/**
 * Create Registrant Invoice Payment Endpoint
 * Create invoice lines for one license (no processing fees on invoice lines).
 */
export const createRegistrantInvoicePaymentOptions = (options: Options<CreateRegistrantInvoicePaymentData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createRegistrantInvoicePayment({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createRegistrantInvoicePaymentQueryKey(options)
    });
};

/**
 * Create Registrant Invoice Payment Endpoint
 * Create invoice lines for one license (no processing fees on invoice lines).
 */
export const createRegistrantInvoicePaymentMutation = (options?: Partial<Options<CreateRegistrantInvoicePaymentData>>): UseMutationOptions<CreateRegistrantInvoicePaymentResponse, CreateRegistrantInvoicePaymentError, Options<CreateRegistrantInvoicePaymentData>> => {
    const mutationOptions: UseMutationOptions<CreateRegistrantInvoicePaymentResponse, CreateRegistrantInvoicePaymentError, Options<CreateRegistrantInvoicePaymentData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createRegistrantInvoicePayment({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getRegistrantPaymentsQueryKey = (options?: Options<GetRegistrantPaymentsData>) => createQueryKey('getRegistrantPayments', options);

/**
 * Get Registrant Payments Endpoint
 * List payments (check payments) for the current registrant account.
 */
export const getRegistrantPaymentsOptions = (options?: Options<GetRegistrantPaymentsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getRegistrantPayments({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getRegistrantPaymentsQueryKey(options)
    });
};

export const getRegistrantInvoicesQueryKey = (options?: Options<GetRegistrantInvoicesData>) => createQueryKey('getRegistrantInvoices', options);

/**
 * Get Registrant Invoices Endpoint
 * List operator-issued invoices (paid and unpaid) for the registrant network.
 */
export const getRegistrantInvoicesOptions = (options?: Options<GetRegistrantInvoicesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getRegistrantInvoices({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getRegistrantInvoicesQueryKey(options)
    });
};

export const getRegistrantPaymentProcessorPaymentDetailQueryKey = (options: Options<GetRegistrantPaymentProcessorPaymentDetailData>) => createQueryKey('getRegistrantPaymentProcessorPaymentDetail', options);

/**
 * Get Registrant Payment Processor Detail Endpoint
 * Get detail for one card/ACH payment (view only).
 */
export const getRegistrantPaymentProcessorPaymentDetailOptions = (options: Options<GetRegistrantPaymentProcessorPaymentDetailData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getRegistrantPaymentProcessorPaymentDetail({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getRegistrantPaymentProcessorPaymentDetailQueryKey(options)
    });
};

export const getRegistrantPaymentDetailQueryKey = (options: Options<GetRegistrantPaymentDetailData>) => createQueryKey('getRegistrantPaymentDetail', options);

/**
 * Get Registrant Payment Detail Endpoint
 * Get detail for one payment (view only).
 */
export const getRegistrantPaymentDetailOptions = (options: Options<GetRegistrantPaymentDetailData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getRegistrantPaymentDetail({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getRegistrantPaymentDetailQueryKey(options)
    });
};

export const getRegistrantInvoicePdfQueryKey = (options: Options<GetRegistrantInvoicePdfData>) => createQueryKey('getRegistrantInvoicePdf', options);

/**
 * Get Registrant Invoice Pdf Endpoint
 * Generate or reuse a filled invoice (Google Doc template) and return the PDF.
 */
export const getRegistrantInvoicePdfOptions = (options: Options<GetRegistrantInvoicePdfData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getRegistrantInvoicePdf({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getRegistrantInvoicePdfQueryKey(options)
    });
};

export const cancelRegistrantPaymentQueryKey = (options: Options<CancelRegistrantPaymentData>) => createQueryKey('cancelRegistrantPayment', options);

/**
 * Cancel Registrant Payment Endpoint
 * Cancel an awaiting check or invoice payment.
 */
export const cancelRegistrantPaymentOptions = (options: Options<CancelRegistrantPaymentData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cancelRegistrantPayment({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: cancelRegistrantPaymentQueryKey(options)
    });
};

/**
 * Cancel Registrant Payment Endpoint
 * Cancel an awaiting check or invoice payment.
 */
export const cancelRegistrantPaymentMutation = (options?: Partial<Options<CancelRegistrantPaymentData>>): UseMutationOptions<CancelRegistrantPaymentResponse, CancelRegistrantPaymentError, Options<CancelRegistrantPaymentData>> => {
    const mutationOptions: UseMutationOptions<CancelRegistrantPaymentResponse, CancelRegistrantPaymentError, Options<CancelRegistrantPaymentData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await cancelRegistrantPayment({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const renewLicenseQueryKey = (options: Options<RenewLicenseData>) => createQueryKey('renewLicense', options);

/**
 * Renew License Endpoint
 * Renew a license.
 */
export const renewLicenseOptions = (options: Options<RenewLicenseData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await renewLicense({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: renewLicenseQueryKey(options)
    });
};

/**
 * Renew License Endpoint
 * Renew a license.
 */
export const renewLicenseMutation = (options?: Partial<Options<RenewLicenseData>>): UseMutationOptions<RenewLicenseResponse, RenewLicenseError, Options<RenewLicenseData>> => {
    const mutationOptions: UseMutationOptions<RenewLicenseResponse, RenewLicenseError, Options<RenewLicenseData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await renewLicense({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getStripeCheckoutSessionUrlQueryKey = (options: Options<GetStripeCheckoutSessionUrlData>) => createQueryKey('getStripeCheckoutSessionUrl', options);

/**
 * Get Stripe Checkout Session Url Endpoint
 * Get the URL for a checkout session.
 */
export const getStripeCheckoutSessionUrlOptions = (options: Options<GetStripeCheckoutSessionUrlData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getStripeCheckoutSessionUrl({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getStripeCheckoutSessionUrlQueryKey(options)
    });
};

export const getLicenseFromCheckoutSessionQueryKey = (options: Options<GetLicenseFromCheckoutSessionData>) => createQueryKey('getLicenseFromCheckoutSession', options);

/**
 * Get License From Checkout Session Endpoint
 * Get license ID from checkout session.
 */
export const getLicenseFromCheckoutSessionOptions = (options: Options<GetLicenseFromCheckoutSessionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getLicenseFromCheckoutSession({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getLicenseFromCheckoutSessionQueryKey(options)
    });
};

export const abandonStripeCheckoutSessionQueryKey = (options: Options<AbandonStripeCheckoutSessionData>) => createQueryKey('abandonStripeCheckoutSession', options);

/**
 * Abandon Stripe Checkout Session Endpoint
 * Abandon a pending Stripe checkout and restore Pay Later state when applicable.
 */
export const abandonStripeCheckoutSessionOptions = (options: Options<AbandonStripeCheckoutSessionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await abandonStripeCheckoutSession({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: abandonStripeCheckoutSessionQueryKey(options)
    });
};

/**
 * Abandon Stripe Checkout Session Endpoint
 * Abandon a pending Stripe checkout and restore Pay Later state when applicable.
 */
export const abandonStripeCheckoutSessionMutation = (options?: Partial<Options<AbandonStripeCheckoutSessionData>>): UseMutationOptions<AbandonStripeCheckoutSessionResponse, AbandonStripeCheckoutSessionError, Options<AbandonStripeCheckoutSessionData>> => {
    const mutationOptions: UseMutationOptions<AbandonStripeCheckoutSessionResponse, AbandonStripeCheckoutSessionError, Options<AbandonStripeCheckoutSessionData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await abandonStripeCheckoutSession({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getStripePortalUrlQueryKey = (options: Options<GetStripePortalUrlData>) => createQueryKey('getStripePortalUrl', options);

/**
 * Get Stripe Portal Url Endpoint
 * Get a URL to the Stripe Customer Portal for the registrant.
 *
 * Personal and organization billing both use the company billing-account
 * Stripe customer. ``organization_billing`` is retained for API compatibility.
 */
export const getStripePortalUrlOptions = (options: Options<GetStripePortalUrlData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getStripePortalUrl({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getStripePortalUrlQueryKey(options)
    });
};

/**
 * Cancel Secondary User Invite Endpoint
 * Cancel a pending invite for a secondary user by clearing primary_id_pending.
 *
 * This removes the user from the pending users list. Only works if the user
 * has primary_id_pending set to the current account's ID.
 */
export const cancelSecondaryUserInviteMutation = (options?: Partial<Options<CancelSecondaryUserInviteData>>): UseMutationOptions<CancelSecondaryUserInviteResponse, CancelSecondaryUserInviteError, Options<CancelSecondaryUserInviteData>> => {
    const mutationOptions: UseMutationOptions<CancelSecondaryUserInviteResponse, CancelSecondaryUserInviteError, Options<CancelSecondaryUserInviteData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await cancelSecondaryUserInvite({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getRegistrantAccountUserQueryKey = (options: Options<GetRegistrantAccountUserData>) => createQueryKey('getRegistrantAccountUser', options);

/**
 * Get Registrant Account User Endpoint
 * Get a specific user (primary or secondary) for the registrant account.
 *
 * Includes disabled (soft-deleted) users so org admins can view details.
 * Only allows getting users that are linked to the logged-in account's primary account.
 */
export const getRegistrantAccountUserOptions = (options: Options<GetRegistrantAccountUserData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getRegistrantAccountUser({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getRegistrantAccountUserQueryKey(options)
    });
};

/**
 * Update Registrant Account User Endpoint
 * Update a secondary user account.
 *
 * Only allows updating secondary accounts that are linked to the logged-in account's primary account.
 * Primary accounts cannot be updated through this endpoint (use /account instead).
 */
export const updateRegistrantAccountUserMutation = (options?: Partial<Options<UpdateRegistrantAccountUserData>>): UseMutationOptions<UpdateRegistrantAccountUserResponse, UpdateRegistrantAccountUserError, Options<UpdateRegistrantAccountUserData>> => {
    const mutationOptions: UseMutationOptions<UpdateRegistrantAccountUserResponse, UpdateRegistrantAccountUserError, Options<UpdateRegistrantAccountUserData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateRegistrantAccountUser({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Disable Secondary User Endpoint
 * Disable (soft delete) a secondary user account.
 *
 * This will prevent the secondary user from logging in, but the primary user
 * will still be able to see all their previous registrations.
 */
export const disableSecondaryUserMutation = (options?: Partial<Options<DisableSecondaryUserData>>): UseMutationOptions<DisableSecondaryUserResponse, DisableSecondaryUserError, Options<DisableSecondaryUserData>> => {
    const mutationOptions: UseMutationOptions<DisableSecondaryUserResponse, DisableSecondaryUserError, Options<DisableSecondaryUserData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await disableSecondaryUser({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const reenableSecondaryUserQueryKey = (options: Options<ReenableSecondaryUserData>) => createQueryKey('reenableSecondaryUser', options);

/**
 * Reenable Secondary User Endpoint
 * Re-enable (undelete) a disabled secondary user account.
 *
 * This will allow the secondary user to log in again.
 */
export const reenableSecondaryUserOptions = (options: Options<ReenableSecondaryUserData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await reenableSecondaryUser({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: reenableSecondaryUserQueryKey(options)
    });
};

/**
 * Reenable Secondary User Endpoint
 * Re-enable (undelete) a disabled secondary user account.
 *
 * This will allow the secondary user to log in again.
 */
export const reenableSecondaryUserMutation = (options?: Partial<Options<ReenableSecondaryUserData>>): UseMutationOptions<ReenableSecondaryUserResponse, ReenableSecondaryUserError, Options<ReenableSecondaryUserData>> => {
    const mutationOptions: UseMutationOptions<ReenableSecondaryUserResponse, ReenableSecondaryUserError, Options<ReenableSecondaryUserData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await reenableSecondaryUser({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const transferPrimaryOwnershipQueryKey = (options: Options<TransferPrimaryOwnershipData>) => createQueryKey('transferPrimaryOwnership', options);

/**
 * Transfer Primary Ownership Endpoint
 * Transfer primary account ownership to a secondary user.
 *
 * This endpoint allows the current primary user to transfer ownership to a
 * secondary user. The transfer:
 * - Sets primary_id for the current primary user and all other secondary users
 * (including deleted ones) to the new primary user
 * - Clears the primary_id for the new primary user
 * - Copies address fields and company_name from current primary
 * to new primary user
 * - Keeps the existing billing member unless ``move_billing_to_new_primary`` is
 * set, in which case the incoming primary is billed instead
 *
 * Stripe customer IDs are never moved or cleared, so saved cards and bank
 * accounts stay with whichever member owns them.
 *
 * Only organization admins can transfer ownership.
 */
export const transferPrimaryOwnershipOptions = (options: Options<TransferPrimaryOwnershipData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferPrimaryOwnership({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: transferPrimaryOwnershipQueryKey(options)
    });
};

/**
 * Transfer Primary Ownership Endpoint
 * Transfer primary account ownership to a secondary user.
 *
 * This endpoint allows the current primary user to transfer ownership to a
 * secondary user. The transfer:
 * - Sets primary_id for the current primary user and all other secondary users
 * (including deleted ones) to the new primary user
 * - Clears the primary_id for the new primary user
 * - Copies address fields and company_name from current primary
 * to new primary user
 * - Keeps the existing billing member unless ``move_billing_to_new_primary`` is
 * set, in which case the incoming primary is billed instead
 *
 * Stripe customer IDs are never moved or cleared, so saved cards and bank
 * accounts stay with whichever member owns them.
 *
 * Only organization admins can transfer ownership.
 */
export const transferPrimaryOwnershipMutation = (options?: Partial<Options<TransferPrimaryOwnershipData>>): UseMutationOptions<TransferPrimaryOwnershipResponse, TransferPrimaryOwnershipError, Options<TransferPrimaryOwnershipData>> => {
    const mutationOptions: UseMutationOptions<TransferPrimaryOwnershipResponse, TransferPrimaryOwnershipError, Options<TransferPrimaryOwnershipData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await transferPrimaryOwnership({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Registrant Account User Admin Endpoint
 * Grant or revoke org admin on a secondary user. The primary cannot lose admin.
 */
export const updateRegistrantAccountUserAdminMutation = (options?: Partial<Options<UpdateRegistrantAccountUserAdminData>>): UseMutationOptions<UpdateRegistrantAccountUserAdminResponse, UpdateRegistrantAccountUserAdminError, Options<UpdateRegistrantAccountUserAdminData>> => {
    const mutationOptions: UseMutationOptions<UpdateRegistrantAccountUserAdminResponse, UpdateRegistrantAccountUserAdminError, Options<UpdateRegistrantAccountUserAdminData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateRegistrantAccountUserAdmin({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Registrant Account User Can Make Payments Endpoint
 * Grant or revoke pay-now for an org user, including admins and the primary.
 */
export const updateRegistrantAccountUserCanMakePaymentsMutation = (options?: Partial<Options<UpdateRegistrantAccountUserCanMakePaymentsData>>): UseMutationOptions<UpdateRegistrantAccountUserCanMakePaymentsResponse, UpdateRegistrantAccountUserCanMakePaymentsError, Options<UpdateRegistrantAccountUserCanMakePaymentsData>> => {
    const mutationOptions: UseMutationOptions<UpdateRegistrantAccountUserCanMakePaymentsResponse, UpdateRegistrantAccountUserCanMakePaymentsError, Options<UpdateRegistrantAccountUserCanMakePaymentsData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateRegistrantAccountUserCanMakePayments({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPendingInviteInfoQueryKey = (options?: Options<GetPendingInviteInfoData>) => createQueryKey('getPendingInviteInfo', options);

/**
 * Get Pending Invite Info Endpoint
 * Get information about a pending invite to join another account.
 *
 * Returns the primary account details if primary_id_pending is set.
 */
export const getPendingInviteInfoOptions = (options?: Options<GetPendingInviteInfoData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getPendingInviteInfo({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getPendingInviteInfoQueryKey(options)
    });
};

export const acceptPendingInviteQueryKey = (options?: Options<AcceptPendingInviteData>) => createQueryKey('acceptPendingInvite', options);

/**
 * Accept Pending Invite Endpoint
 * Accept a pending invite to join another account.
 *
 * Sets primary_id to primary_id_pending and clears primary_id_pending.
 */
export const acceptPendingInviteOptions = (options?: Options<AcceptPendingInviteData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await acceptPendingInvite({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: acceptPendingInviteQueryKey(options)
    });
};

/**
 * Accept Pending Invite Endpoint
 * Accept a pending invite to join another account.
 *
 * Sets primary_id to primary_id_pending and clears primary_id_pending.
 */
export const acceptPendingInviteMutation = (options?: Partial<Options<AcceptPendingInviteData>>): UseMutationOptions<AcceptPendingInviteResponse, DefaultError, Options<AcceptPendingInviteData>> => {
    const mutationOptions: UseMutationOptions<AcceptPendingInviteResponse, DefaultError, Options<AcceptPendingInviteData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await acceptPendingInvite({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const rejectPendingInviteQueryKey = (options?: Options<RejectPendingInviteData>) => createQueryKey('rejectPendingInvite', options);

/**
 * Reject Pending Invite Endpoint
 * Reject a pending invite to join another account.
 *
 * Clears the primary_id_pending value.
 */
export const rejectPendingInviteOptions = (options?: Options<RejectPendingInviteData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await rejectPendingInvite({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: rejectPendingInviteQueryKey(options)
    });
};

/**
 * Reject Pending Invite Endpoint
 * Reject a pending invite to join another account.
 *
 * Clears the primary_id_pending value.
 */
export const rejectPendingInviteMutation = (options?: Partial<Options<RejectPendingInviteData>>): UseMutationOptions<RejectPendingInviteResponse, DefaultError, Options<RejectPendingInviteData>> => {
    const mutationOptions: UseMutationOptions<RejectPendingInviteResponse, DefaultError, Options<RejectPendingInviteData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await rejectPendingInvite({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const uploadAnswerFileQueryKey = (options: Options<UploadAnswerFileData>) => createQueryKey('uploadAnswerFile', options);

/**
 * Upload Answer File Endpoint
 * Upload an answer file, save it, and return a token identifying the file.
 */
export const uploadAnswerFileOptions = (options: Options<UploadAnswerFileData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await uploadAnswerFile({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: uploadAnswerFileQueryKey(options)
    });
};

/**
 * Upload Answer File Endpoint
 * Upload an answer file, save it, and return a token identifying the file.
 */
export const uploadAnswerFileMutation = (options?: Partial<Options<UploadAnswerFileData>>): UseMutationOptions<UploadAnswerFileResponse, UploadAnswerFileError, Options<UploadAnswerFileData>> => {
    const mutationOptions: UseMutationOptions<UploadAnswerFileResponse, UploadAnswerFileError, Options<UploadAnswerFileData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await uploadAnswerFile({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listInspectionPortalLicensesQueryKey = (options?: Options<ListInspectionPortalLicensesData>) => createQueryKey('listInspectionPortalLicenses', options);

/**
 * List Inspection Portal Licenses
 * List licenses for the inspection portal Requires/Complete queues.
 */
export const listInspectionPortalLicensesOptions = (options?: Options<ListInspectionPortalLicensesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listInspectionPortalLicenses({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listInspectionPortalLicensesQueryKey(options)
    });
};

export const listInspectionDispatchLicensesQueryKey = (options?: Options<ListInspectionDispatchLicensesData>) => createQueryKey('listInspectionDispatchLicenses', options);

/**
 * List Inspection Dispatch Licenses
 * Licenses requiring inspection that the current manager may assign.
 */
export const listInspectionDispatchLicensesOptions = (options?: Options<ListInspectionDispatchLicensesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listInspectionDispatchLicenses({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listInspectionDispatchLicensesQueryKey(options)
    });
};

export const listInspectionOrgUsersQueryKey = (options?: Options<ListInspectionOrgUsersData>) => createQueryKey('listInspectionOrgUsers', options);

/**
 * List Inspection Org Users
 * List registrant users in the org for assign/invite pickers.
 */
export const listInspectionOrgUsersOptions = (options?: Options<ListInspectionOrgUsersData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listInspectionOrgUsers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listInspectionOrgUsersQueryKey(options)
    });
};

export const listInspectionImpersonationCandidatesQueryKey = (options: Options<ListInspectionImpersonationCandidatesData>) => createQueryKey('listInspectionImpersonationCandidates', options);

/**
 * List Inspection Impersonation Candidates
 * Operator: users that can be opened in the inspection portal for a license.
 */
export const listInspectionImpersonationCandidatesOptions = (options: Options<ListInspectionImpersonationCandidatesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listInspectionImpersonationCandidates({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listInspectionImpersonationCandidatesQueryKey(options)
    });
};

export const bulkAssignInspectionsQueryKey = (options: Options<BulkAssignInspectionsData>) => createQueryKey('bulkAssignInspections', options);

/**
 * Bulk Assign Inspections
 * Assign pending inspections and grant license access (last-write-wins).
 */
export const bulkAssignInspectionsOptions = (options: Options<BulkAssignInspectionsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await bulkAssignInspections({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: bulkAssignInspectionsQueryKey(options)
    });
};

/**
 * Bulk Assign Inspections
 * Assign pending inspections and grant license access (last-write-wins).
 */
export const bulkAssignInspectionsMutation = (options?: Partial<Options<BulkAssignInspectionsData>>): UseMutationOptions<BulkAssignInspectionsResponse, BulkAssignInspectionsError, Options<BulkAssignInspectionsData>> => {
    const mutationOptions: UseMutationOptions<BulkAssignInspectionsResponse, BulkAssignInspectionsError, Options<BulkAssignInspectionsData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await bulkAssignInspections({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const ensureInspectionLicenseAccessQueryKey = (options: Options<EnsureInspectionLicenseAccessData>) => createQueryKey('ensureInspectionLicenseAccess', options);

/**
 * Ensure Inspection License Access
 * Ensure the current user can open given licenses in the inspection portal.
 *
 * Forces registrant identities to ALL access. SELECTED identities receive
 * unioned license grants. Does not change inspection assignees.
 *
 * Operators open the inspection SPA via impersonation and do not need grants
 * mutated here (including when coming from the registrant portal Perform CTA).
 */
export const ensureInspectionLicenseAccessOptions = (options: Options<EnsureInspectionLicenseAccessData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ensureInspectionLicenseAccess({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: ensureInspectionLicenseAccessQueryKey(options)
    });
};

/**
 * Ensure Inspection License Access
 * Ensure the current user can open given licenses in the inspection portal.
 *
 * Forces registrant identities to ALL access. SELECTED identities receive
 * unioned license grants. Does not change inspection assignees.
 *
 * Operators open the inspection SPA via impersonation and do not need grants
 * mutated here (including when coming from the registrant portal Perform CTA).
 */
export const ensureInspectionLicenseAccessMutation = (options?: Partial<Options<EnsureInspectionLicenseAccessData>>): UseMutationOptions<EnsureInspectionLicenseAccessResponse, EnsureInspectionLicenseAccessError, Options<EnsureInspectionLicenseAccessData>> => {
    const mutationOptions: UseMutationOptions<EnsureInspectionLicenseAccessResponse, EnsureInspectionLicenseAccessError, Options<EnsureInspectionLicenseAccessData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await ensureInspectionLicenseAccess({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const unassignInspectionQueryKey = (options: Options<UnassignInspectionData>) => createQueryKey('unassignInspection', options);

/**
 * Unassign Inspection Endpoint
 * Clear assignee; revoke selected grant when applicable.
 */
export const unassignInspectionOptions = (options: Options<UnassignInspectionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await unassignInspection({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: unassignInspectionQueryKey(options)
    });
};

/**
 * Unassign Inspection Endpoint
 * Clear assignee; revoke selected grant when applicable.
 */
export const unassignInspectionMutation = (options?: Partial<Options<UnassignInspectionData>>): UseMutationOptions<UnassignInspectionResponse, UnassignInspectionError, Options<UnassignInspectionData>> => {
    const mutationOptions: UseMutationOptions<UnassignInspectionResponse, UnassignInspectionError, Options<UnassignInspectionData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await unassignInspection({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const inviteInspectionUserQueryKey = (options: Options<InviteInspectionUserData>) => createQueryKey('inviteInspectionUser', options);

/**
 * Invite Inspection User
 * Invite an inspection user into the registrant org.
 *
 * New invites create a Registrant-Portal identity (``inspection_only``) without
 * pre-creating an Auth0 user — the email deep-link uses Create account (signup).
 * Existing Registrant-Portal users are linked/granted only.
 */
export const inviteInspectionUserOptions = (options: Options<InviteInspectionUserData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await inviteInspectionUser({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: inviteInspectionUserQueryKey(options)
    });
};

/**
 * Invite Inspection User
 * Invite an inspection user into the registrant org.
 *
 * New invites create a Registrant-Portal identity (``inspection_only``) without
 * pre-creating an Auth0 user — the email deep-link uses Create account (signup).
 * Existing Registrant-Portal users are linked/granted only.
 */
export const inviteInspectionUserMutation = (options?: Partial<Options<InviteInspectionUserData>>): UseMutationOptions<InviteInspectionUserResponse, InviteInspectionUserError, Options<InviteInspectionUserData>> => {
    const mutationOptions: UseMutationOptions<InviteInspectionUserResponse, InviteInspectionUserError, Options<InviteInspectionUserData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await inviteInspectionUser({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const disableInspectionUserQueryKey = (options: Options<DisableInspectionUserData>) => createQueryKey('disableInspectionUser', options);

/**
 * Disable Inspection User
 * Soft-disable an inspection user and clear their assignments.
 */
export const disableInspectionUserOptions = (options: Options<DisableInspectionUserData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await disableInspectionUser({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: disableInspectionUserQueryKey(options)
    });
};

/**
 * Disable Inspection User
 * Soft-disable an inspection user and clear their assignments.
 */
export const disableInspectionUserMutation = (options?: Partial<Options<DisableInspectionUserData>>): UseMutationOptions<DisableInspectionUserResponse, DisableInspectionUserError, Options<DisableInspectionUserData>> => {
    const mutationOptions: UseMutationOptions<DisableInspectionUserResponse, DisableInspectionUserError, Options<DisableInspectionUserData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await disableInspectionUser({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const uploadInspectionAnswerFileQueryKey = (options: Options<UploadInspectionAnswerFileData>) => createQueryKey('uploadInspectionAnswerFile', options);

/**
 * Upload Inspection Answer File
 * Upload an answer file for inspection workflow (image/video/document).
 */
export const uploadInspectionAnswerFileOptions = (options: Options<UploadInspectionAnswerFileData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await uploadInspectionAnswerFile({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: uploadInspectionAnswerFileQueryKey(options)
    });
};

/**
 * Upload Inspection Answer File
 * Upload an answer file for inspection workflow (image/video/document).
 */
export const uploadInspectionAnswerFileMutation = (options?: Partial<Options<UploadInspectionAnswerFileData>>): UseMutationOptions<UploadInspectionAnswerFileResponse, UploadInspectionAnswerFileError, Options<UploadInspectionAnswerFileData>> => {
    const mutationOptions: UseMutationOptions<UploadInspectionAnswerFileResponse, UploadInspectionAnswerFileError, Options<UploadInspectionAnswerFileData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await uploadInspectionAnswerFile({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getInspectionServerTimeQueryKey = (options?: Options<GetInspectionServerTimeData>) => createQueryKey('getInspectionServerTime', options);

/**
 * Get Inspection Server Time
 * Return the server's current UTC time for capture clock synchronization.
 */
export const getInspectionServerTimeOptions = (options?: Options<GetInspectionServerTimeData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getInspectionServerTime({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getInspectionServerTimeQueryKey(options)
    });
};

export const getJurisdictionInspectionLogoKeyQueryKey = (options: Options<GetJurisdictionInspectionLogoKeyData>) => createQueryKey('getJurisdictionInspectionLogoKey', options);

/**
 * Get Jurisdiction Inspection Logo Key
 * Return the GCS key for a jurisdiction logo (if set).
 */
export const getJurisdictionInspectionLogoKeyOptions = (options: Options<GetJurisdictionInspectionLogoKeyData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getJurisdictionInspectionLogoKey({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getJurisdictionInspectionLogoKeyQueryKey(options)
    });
};

export const getOmtAmsAccessQueryKey = (options?: Options<GetOmtAmsAccessData>) => createQueryKey('getOmtAmsAccess', options);

/**
 * Get Omt Ams Access
 * Return portal access, org role, and whether this org is listed on licenses.
 */
export const getOmtAmsAccessOptions = (options?: Options<GetOmtAmsAccessData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOmtAmsAccess({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOmtAmsAccessQueryKey(options)
    });
};

export const searchOmtAmsPartiesForImpersonationQueryKey = (options?: Options<SearchOmtAmsPartiesForImpersonationData>) => createQueryKey('searchOmtAmsPartiesForImpersonation', options);

/**
 * Search Omt Ams Parties For Impersonation
 * Search parties by email, name, or company (operators only).
 */
export const searchOmtAmsPartiesForImpersonationOptions = (options?: Options<SearchOmtAmsPartiesForImpersonationData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await searchOmtAmsPartiesForImpersonation({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: searchOmtAmsPartiesForImpersonationQueryKey(options)
    });
};

export const getOmtAmsAccountQueryKey = (options?: Options<GetOmtAmsAccountData>) => createQueryKey('getOmtAmsAccount', options);

/**
 * Get Omt Ams Account
 * Read-only profile for the OMT/AMS portal.
 */
export const getOmtAmsAccountOptions = (options?: Options<GetOmtAmsAccountData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOmtAmsAccount({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOmtAmsAccountQueryKey(options)
    });
};

export const getOmtAmsLicensesQueryKey = (options?: Options<GetOmtAmsLicensesData>) => createQueryKey('getOmtAmsLicenses', options);

/**
 * Get Omt Ams Licenses
 * Page of licenses where the email is listed as OMT and/or AMS.
 */
export const getOmtAmsLicensesOptions = (options?: Options<GetOmtAmsLicensesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOmtAmsLicenses({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOmtAmsLicensesQueryKey(options)
    });
};

export const getOmtAmsLicensesInfiniteQueryKey = (options?: Options<GetOmtAmsLicensesData>): QueryKey<Options<GetOmtAmsLicensesData>> => createQueryKey('getOmtAmsLicenses', options, true);

/**
 * Get Omt Ams Licenses
 * Page of licenses where the email is listed as OMT and/or AMS.
 */
export const getOmtAmsLicensesInfiniteOptions = (options?: Options<GetOmtAmsLicensesData>) => {
    return infiniteQueryOptions<unknown, GetOmtAmsLicensesError, InfiniteData<unknown>, QueryKey<Options<GetOmtAmsLicensesData>>, number | Pick<QueryKey<Options<GetOmtAmsLicensesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetOmtAmsLicensesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getOmtAmsLicenses({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOmtAmsLicensesInfiniteQueryKey(options)
    });
};

export const getOmtAmsLicenseStatsQueryKey = (options?: Options<GetOmtAmsLicenseStatsData>) => createQueryKey('getOmtAmsLicenseStats', options);

/**
 * Get Omt Ams License Stats
 * Dashboard tile aggregates for the OMT/AMS-scoped licenses.
 */
export const getOmtAmsLicenseStatsOptions = (options?: Options<GetOmtAmsLicenseStatsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOmtAmsLicenseStats({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOmtAmsLicenseStatsQueryKey(options)
    });
};

export const getOmtAmsLicenseFilterValuesQueryKey = (options: Options<GetOmtAmsLicenseFilterValuesData>) => createQueryKey('getOmtAmsLicenseFilterValues', options);

/**
 * Get Omt Ams License Filter Values
 * Facet values for an OMT/AMS license-list column.
 */
export const getOmtAmsLicenseFilterValuesOptions = (options: Options<GetOmtAmsLicenseFilterValuesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOmtAmsLicenseFilterValues({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOmtAmsLicenseFilterValuesQueryKey(options)
    });
};

export const getOmtAmsLicenseMapPinsQueryKey = (options?: Options<GetOmtAmsLicenseMapPinsData>) => createQueryKey('getOmtAmsLicenseMapPins', options);

/**
 * Get Omt Ams License Map Pins
 * Pins or clusters for OMT/AMS-scoped licenses.
 */
export const getOmtAmsLicenseMapPinsOptions = (options?: Options<GetOmtAmsLicenseMapPinsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOmtAmsLicenseMapPins({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOmtAmsLicenseMapPinsQueryKey(options)
    });
};

export const getOmtAmsLicenseCommentsQueryKey = (options: Options<GetOmtAmsLicenseCommentsData>) => createQueryKey('getOmtAmsLicenseComments', options);

/**
 * Get Omt Ams License Comments
 * Read-only comments for an OMT/AMS-scoped license.
 */
export const getOmtAmsLicenseCommentsOptions = (options: Options<GetOmtAmsLicenseCommentsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOmtAmsLicenseComments({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOmtAmsLicenseCommentsQueryKey(options)
    });
};

export const getOmtAmsLicensePaymentsQueryKey = (options: Options<GetOmtAmsLicensePaymentsData>) => createQueryKey('getOmtAmsLicensePayments', options);

/**
 * Get Omt Ams License Payments
 * Read-only payments for an OMT/AMS-scoped license.
 */
export const getOmtAmsLicensePaymentsOptions = (options: Options<GetOmtAmsLicensePaymentsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOmtAmsLicensePayments({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOmtAmsLicensePaymentsQueryKey(options)
    });
};

export const getOmtAmsInvoicesQueryKey = (options?: Options<GetOmtAmsInvoicesData>) => createQueryKey('getOmtAmsInvoices', options);

/**
 * Get Omt Ams Invoices
 * Invoices for registrant accounts that own the visible OMT/AMS licenses.
 */
export const getOmtAmsInvoicesOptions = (options?: Options<GetOmtAmsInvoicesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOmtAmsInvoices({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOmtAmsInvoicesQueryKey(options)
    });
};

export const getOmtAmsAccountUsersQueryKey = (options?: Options<GetOmtAmsAccountUsersData>) => createQueryKey('getOmtAmsAccountUsers', options);

/**
 * Get Omt Ams Account Users
 * List primary and secondary users for the OMT/AMS org.
 */
export const getOmtAmsAccountUsersOptions = (options?: Options<GetOmtAmsAccountUsersData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOmtAmsAccountUsers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOmtAmsAccountUsersQueryKey(options)
    });
};

export const addOmtAmsSecondaryUserQueryKey = (options: Options<AddOmtAmsSecondaryUserData>) => createQueryKey('addOmtAmsSecondaryUser', options);

/**
 * Add Omt Ams Secondary User
 * Invite a secondary OMT/AMS user. The org primary cannot be changed.
 */
export const addOmtAmsSecondaryUserOptions = (options: Options<AddOmtAmsSecondaryUserData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await addOmtAmsSecondaryUser({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: addOmtAmsSecondaryUserQueryKey(options)
    });
};

/**
 * Add Omt Ams Secondary User
 * Invite a secondary OMT/AMS user. The org primary cannot be changed.
 */
export const addOmtAmsSecondaryUserMutation = (options?: Partial<Options<AddOmtAmsSecondaryUserData>>): UseMutationOptions<AddOmtAmsSecondaryUserResponse, AddOmtAmsSecondaryUserError, Options<AddOmtAmsSecondaryUserData>> => {
    const mutationOptions: UseMutationOptions<AddOmtAmsSecondaryUserResponse, AddOmtAmsSecondaryUserError, Options<AddOmtAmsSecondaryUserData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await addOmtAmsSecondaryUser({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Cancel Omt Ams Secondary User Invite
 * Cancel a pending invite by clearing primary_id_pending.
 */
export const cancelOmtAmsSecondaryUserInviteMutation = (options?: Partial<Options<CancelOmtAmsSecondaryUserInviteData>>): UseMutationOptions<CancelOmtAmsSecondaryUserInviteResponse, CancelOmtAmsSecondaryUserInviteError, Options<CancelOmtAmsSecondaryUserInviteData>> => {
    const mutationOptions: UseMutationOptions<CancelOmtAmsSecondaryUserInviteResponse, CancelOmtAmsSecondaryUserInviteError, Options<CancelOmtAmsSecondaryUserInviteData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await cancelOmtAmsSecondaryUserInvite({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Disable Omt Ams Secondary User
 * Disable a secondary OMT/AMS user. The primary cannot be disabled.
 */
export const disableOmtAmsSecondaryUserMutation = (options?: Partial<Options<DisableOmtAmsSecondaryUserData>>): UseMutationOptions<DisableOmtAmsSecondaryUserResponse, DisableOmtAmsSecondaryUserError, Options<DisableOmtAmsSecondaryUserData>> => {
    const mutationOptions: UseMutationOptions<DisableOmtAmsSecondaryUserResponse, DisableOmtAmsSecondaryUserError, Options<DisableOmtAmsSecondaryUserData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await disableOmtAmsSecondaryUser({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const reenableOmtAmsSecondaryUserQueryKey = (options: Options<ReenableOmtAmsSecondaryUserData>) => createQueryKey('reenableOmtAmsSecondaryUser', options);

/**
 * Reenable Omt Ams Secondary User
 * Re-enable a disabled secondary OMT/AMS user.
 */
export const reenableOmtAmsSecondaryUserOptions = (options: Options<ReenableOmtAmsSecondaryUserData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await reenableOmtAmsSecondaryUser({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: reenableOmtAmsSecondaryUserQueryKey(options)
    });
};

/**
 * Reenable Omt Ams Secondary User
 * Re-enable a disabled secondary OMT/AMS user.
 */
export const reenableOmtAmsSecondaryUserMutation = (options?: Partial<Options<ReenableOmtAmsSecondaryUserData>>): UseMutationOptions<ReenableOmtAmsSecondaryUserResponse, ReenableOmtAmsSecondaryUserError, Options<ReenableOmtAmsSecondaryUserData>> => {
    const mutationOptions: UseMutationOptions<ReenableOmtAmsSecondaryUserResponse, ReenableOmtAmsSecondaryUserError, Options<ReenableOmtAmsSecondaryUserData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await reenableOmtAmsSecondaryUser({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Omt Ams Account User Admin
 * Grant or revoke admin on a secondary. The primary always stays admin.
 */
export const updateOmtAmsAccountUserAdminMutation = (options?: Partial<Options<UpdateOmtAmsAccountUserAdminData>>): UseMutationOptions<UpdateOmtAmsAccountUserAdminResponse, UpdateOmtAmsAccountUserAdminError, Options<UpdateOmtAmsAccountUserAdminData>> => {
    const mutationOptions: UseMutationOptions<UpdateOmtAmsAccountUserAdminResponse, UpdateOmtAmsAccountUserAdminError, Options<UpdateOmtAmsAccountUserAdminData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateOmtAmsAccountUserAdmin({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getOmtAmsPendingInviteInfoQueryKey = (options?: Options<GetOmtAmsPendingInviteInfoData>) => createQueryKey('getOmtAmsPendingInviteInfo', options);

/**
 * Get Omt Ams Pending Invite Info
 * Return the inviting primary org when this user has a pending invite.
 */
export const getOmtAmsPendingInviteInfoOptions = (options?: Options<GetOmtAmsPendingInviteInfoData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOmtAmsPendingInviteInfo({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOmtAmsPendingInviteInfoQueryKey(options)
    });
};

export const acceptOmtAmsPendingInviteQueryKey = (options?: Options<AcceptOmtAmsPendingInviteData>) => createQueryKey('acceptOmtAmsPendingInvite', options);

/**
 * Accept Omt Ams Pending Invite
 * Accept a pending invite. The inviting primary is never changed.
 */
export const acceptOmtAmsPendingInviteOptions = (options?: Options<AcceptOmtAmsPendingInviteData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await acceptOmtAmsPendingInvite({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: acceptOmtAmsPendingInviteQueryKey(options)
    });
};

/**
 * Accept Omt Ams Pending Invite
 * Accept a pending invite. The inviting primary is never changed.
 */
export const acceptOmtAmsPendingInviteMutation = (options?: Partial<Options<AcceptOmtAmsPendingInviteData>>): UseMutationOptions<AcceptOmtAmsPendingInviteResponse, DefaultError, Options<AcceptOmtAmsPendingInviteData>> => {
    const mutationOptions: UseMutationOptions<AcceptOmtAmsPendingInviteResponse, DefaultError, Options<AcceptOmtAmsPendingInviteData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await acceptOmtAmsPendingInvite({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const rejectOmtAmsPendingInviteQueryKey = (options?: Options<RejectOmtAmsPendingInviteData>) => createQueryKey('rejectOmtAmsPendingInvite', options);

/**
 * Reject Omt Ams Pending Invite
 * Reject a pending invite and remain a standalone primary.
 */
export const rejectOmtAmsPendingInviteOptions = (options?: Options<RejectOmtAmsPendingInviteData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await rejectOmtAmsPendingInvite({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: rejectOmtAmsPendingInviteQueryKey(options)
    });
};

/**
 * Reject Omt Ams Pending Invite
 * Reject a pending invite and remain a standalone primary.
 */
export const rejectOmtAmsPendingInviteMutation = (options?: Partial<Options<RejectOmtAmsPendingInviteData>>): UseMutationOptions<RejectOmtAmsPendingInviteResponse, DefaultError, Options<RejectOmtAmsPendingInviteData>> => {
    const mutationOptions: UseMutationOptions<RejectOmtAmsPendingInviteResponse, DefaultError, Options<RejectOmtAmsPendingInviteData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await rejectOmtAmsPendingInvite({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getJurisdictionsQueryKey = (options?: Options<GetJurisdictionsData>) => createQueryKey('getJurisdictions', options);

/**
 * Get Jurisdictions Endpoint
 * Get all jurisdictions.
 */
export const getJurisdictionsOptions = (options?: Options<GetJurisdictionsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getJurisdictions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getJurisdictionsQueryKey(options)
    });
};

export const createJurisdictionQueryKey = (options: Options<CreateJurisdictionData>) => createQueryKey('createJurisdiction', options);

/**
 * Create Jurisdiction Endpoint
 * Create a jurisdiction.
 *
 * New jurisdictions start with branding ``pending``; when enabled, seal,
 * color, and website are looked up in the background after the response.
 */
export const createJurisdictionOptions = (options: Options<CreateJurisdictionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createJurisdiction({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createJurisdictionQueryKey(options)
    });
};

/**
 * Create Jurisdiction Endpoint
 * Create a jurisdiction.
 *
 * New jurisdictions start with branding ``pending``; when enabled, seal,
 * color, and website are looked up in the background after the response.
 */
export const createJurisdictionMutation = (options?: Partial<Options<CreateJurisdictionData>>): UseMutationOptions<CreateJurisdictionResponse, CreateJurisdictionError, Options<CreateJurisdictionData>> => {
    const mutationOptions: UseMutationOptions<CreateJurisdictionResponse, CreateJurisdictionError, Options<CreateJurisdictionData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createJurisdiction({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getJurisdictionQueryKey = (options: Options<GetJurisdictionData>) => createQueryKey('getJurisdiction', options);

/**
 * Get Jurisdiction Endpoint
 * Get a jurisdiction by ID.
 */
export const getJurisdictionOptions = (options: Options<GetJurisdictionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getJurisdiction({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getJurisdictionQueryKey(options)
    });
};

/**
 * Update Jurisdiction Endpoint
 * Update a jurisdiction + associated license type configurations.
 */
export const updateJurisdictionMutation = (options?: Partial<Options<UpdateJurisdictionData>>): UseMutationOptions<UpdateJurisdictionResponse, UpdateJurisdictionError, Options<UpdateJurisdictionData>> => {
    const mutationOptions: UseMutationOptions<UpdateJurisdictionResponse, UpdateJurisdictionError, Options<UpdateJurisdictionData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateJurisdiction({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const dryrunJurisdictionCreationQueryKey = (options: Options<DryrunJurisdictionCreationData>) => createQueryKey('dryrunJurisdictionCreation', options);

/**
 * Dryrun Jurisdiction Creation Endpoint
 * Dry run jurisdiction creation from uploaded file using field mappings.
 */
export const dryrunJurisdictionCreationOptions = (options: Options<DryrunJurisdictionCreationData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await dryrunJurisdictionCreation({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: dryrunJurisdictionCreationQueryKey(options)
    });
};

/**
 * Dryrun Jurisdiction Creation Endpoint
 * Dry run jurisdiction creation from uploaded file using field mappings.
 */
export const dryrunJurisdictionCreationMutation = (options?: Partial<Options<DryrunJurisdictionCreationData>>): UseMutationOptions<DryrunJurisdictionCreationResponse, DryrunJurisdictionCreationError, Options<DryrunJurisdictionCreationData>> => {
    const mutationOptions: UseMutationOptions<DryrunJurisdictionCreationResponse, DryrunJurisdictionCreationError, Options<DryrunJurisdictionCreationData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await dryrunJurisdictionCreation({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const createJurisdictionsQueryKey = (options: Options<CreateJurisdictionsData>) => createQueryKey('createJurisdictions', options);

/**
 * Create Jurisdictions Endpoint
 * Create jurisdictions and license type configs from uploaded file using field mappings.
 */
export const createJurisdictionsOptions = (options: Options<CreateJurisdictionsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createJurisdictions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createJurisdictionsQueryKey(options)
    });
};

/**
 * Create Jurisdictions Endpoint
 * Create jurisdictions and license type configs from uploaded file using field mappings.
 */
export const createJurisdictionsMutation = (options?: Partial<Options<CreateJurisdictionsData>>): UseMutationOptions<CreateJurisdictionsResponse, CreateJurisdictionsError, Options<CreateJurisdictionsData>> => {
    const mutationOptions: UseMutationOptions<CreateJurisdictionsResponse, CreateJurisdictionsError, Options<CreateJurisdictionsData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createJurisdictions({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Jurisdiction Theme Color
 * Set or clear the brand color for a jurisdiction.
 */
export const updateJurisdictionThemeColorMutation = (options?: Partial<Options<UpdateJurisdictionThemeColorData>>): UseMutationOptions<UpdateJurisdictionThemeColorResponse, UpdateJurisdictionThemeColorError, Options<UpdateJurisdictionThemeColorData>> => {
    const mutationOptions: UseMutationOptions<UpdateJurisdictionThemeColorResponse, UpdateJurisdictionThemeColorError, Options<UpdateJurisdictionThemeColorData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateJurisdictionThemeColor({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Clear Jurisdiction Logo
 * Clear the jurisdiction seal or logo; pages fall back to generic branding.
 */
export const clearJurisdictionLogoMutation = (options?: Partial<Options<ClearJurisdictionLogoData>>): UseMutationOptions<ClearJurisdictionLogoResponse, ClearJurisdictionLogoError, Options<ClearJurisdictionLogoData>> => {
    const mutationOptions: UseMutationOptions<ClearJurisdictionLogoResponse, ClearJurisdictionLogoError, Options<ClearJurisdictionLogoData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await clearJurisdictionLogo({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const uploadJurisdictionLogoQueryKey = (options: Options<UploadJurisdictionLogoData>) => createQueryKey('uploadJurisdictionLogo', options);

/**
 * Upload Jurisdiction Logo
 * Upload or replace the city/county seal or logo for this jurisdiction.
 */
export const uploadJurisdictionLogoOptions = (options: Options<UploadJurisdictionLogoData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await uploadJurisdictionLogo({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: uploadJurisdictionLogoQueryKey(options)
    });
};

/**
 * Upload Jurisdiction Logo
 * Upload or replace the city/county seal or logo for this jurisdiction.
 */
export const uploadJurisdictionLogoMutation = (options?: Partial<Options<UploadJurisdictionLogoData>>): UseMutationOptions<UploadJurisdictionLogoResponse, UploadJurisdictionLogoError, Options<UploadJurisdictionLogoData>> => {
    const mutationOptions: UseMutationOptions<UploadJurisdictionLogoResponse, UploadJurisdictionLogoError, Options<UploadJurisdictionLogoData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await uploadJurisdictionLogo({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listOperatorInspectionImpersonationCandidatesQueryKey = (options: Options<ListOperatorInspectionImpersonationCandidatesData>) => createQueryKey('listOperatorInspectionImpersonationCandidates', options);

/**
 * List Operator Inspection Impersonation Candidates
 * List registrant/inspector users for opening the inspection portal as.
 */
export const listOperatorInspectionImpersonationCandidatesOptions = (options: Options<ListOperatorInspectionImpersonationCandidatesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listOperatorInspectionImpersonationCandidates({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listOperatorInspectionImpersonationCandidatesQueryKey(options)
    });
};

export const getJurisdictionBrandingQueryKey = (options: Options<GetJurisdictionBrandingData>) => createQueryKey('getJurisdictionBranding', options);

/**
 * Get Jurisdiction Branding
 * Branding values, where each came from, and which an operator set by hand.
 */
export const getJurisdictionBrandingOptions = (options: Options<GetJurisdictionBrandingData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getJurisdictionBranding({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getJurisdictionBrandingQueryKey(options)
    });
};

export const refreshJurisdictionBrandingQueryKey = (options: Options<RefreshJurisdictionBrandingData>) => createQueryKey('refreshJurisdictionBranding', options);

/**
 * Refresh Jurisdiction Branding
 * Re-run automatic seal, color, and website lookup for one jurisdiction.
 *
 * Fields an operator set by hand are kept unless listed in ``reset_fields``.
 */
export const refreshJurisdictionBrandingOptions = (options: Options<RefreshJurisdictionBrandingData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await refreshJurisdictionBranding({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: refreshJurisdictionBrandingQueryKey(options)
    });
};

/**
 * Refresh Jurisdiction Branding
 * Re-run automatic seal, color, and website lookup for one jurisdiction.
 *
 * Fields an operator set by hand are kept unless listed in ``reset_fields``.
 */
export const refreshJurisdictionBrandingMutation = (options?: Partial<Options<RefreshJurisdictionBrandingData>>): UseMutationOptions<RefreshJurisdictionBrandingResponse, RefreshJurisdictionBrandingError, Options<RefreshJurisdictionBrandingData>> => {
    const mutationOptions: UseMutationOptions<RefreshJurisdictionBrandingResponse, RefreshJurisdictionBrandingError, Options<RefreshJurisdictionBrandingData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await refreshJurisdictionBranding({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const createOrdinanceVersionQueryKey = (options: Options<CreateOrdinanceVersionData>) => createQueryKey('createOrdinanceVersion', options);

/**
 * Create Ordinance Version Endpoint
 * Add a new time-versioned fee/late/remittance rule snapshot for a license type configuration.
 */
export const createOrdinanceVersionOptions = (options: Options<CreateOrdinanceVersionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createOrdinanceVersion({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createOrdinanceVersionQueryKey(options)
    });
};

/**
 * Create Ordinance Version Endpoint
 * Add a new time-versioned fee/late/remittance rule snapshot for a license type configuration.
 */
export const createOrdinanceVersionMutation = (options?: Partial<Options<CreateOrdinanceVersionData>>): UseMutationOptions<CreateOrdinanceVersionResponse, CreateOrdinanceVersionError, Options<CreateOrdinanceVersionData>> => {
    const mutationOptions: UseMutationOptions<CreateOrdinanceVersionResponse, CreateOrdinanceVersionError, Options<CreateOrdinanceVersionData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createOrdinanceVersion({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Ordinance Version Endpoint
 * Delete a historic ordinance version row.
 */
export const deleteOrdinanceVersionMutation = (options?: Partial<Options<DeleteOrdinanceVersionData>>): UseMutationOptions<DeleteOrdinanceVersionResponse, DeleteOrdinanceVersionError, Options<DeleteOrdinanceVersionData>> => {
    const mutationOptions: UseMutationOptions<DeleteOrdinanceVersionResponse, DeleteOrdinanceVersionError, Options<DeleteOrdinanceVersionData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await deleteOrdinanceVersion({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Ordinance Version Endpoint
 * Update an existing ordinance history row (full replacement body).
 */
export const updateOrdinanceVersionMutation = (options?: Partial<Options<UpdateOrdinanceVersionData>>): UseMutationOptions<UpdateOrdinanceVersionResponse, UpdateOrdinanceVersionError, Options<UpdateOrdinanceVersionData>> => {
    const mutationOptions: UseMutationOptions<UpdateOrdinanceVersionResponse, UpdateOrdinanceVersionError, Options<UpdateOrdinanceVersionData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateOrdinanceVersion({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const exportOrdinancesCsvQueryKey = (options?: Options<ExportOrdinancesCsvData>) => createQueryKey('exportOrdinancesCsv', options);

/**
 * Export Ordinances Csv Endpoint
 * Download all ordinance rows (live + historic) as CSV for round-trip import.
 */
export const exportOrdinancesCsvOptions = (options?: Options<ExportOrdinancesCsvData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await exportOrdinancesCsv({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: exportOrdinancesCsvQueryKey(options)
    });
};

export const dryrunOrdinanceImportQueryKey = (options: Options<DryrunOrdinanceImportData>) => createQueryKey('dryrunOrdinanceImport', options);

/**
 * Dryrun Ordinance Import Endpoint
 * Validate and transform ordinance import rows without writing.
 */
export const dryrunOrdinanceImportOptions = (options: Options<DryrunOrdinanceImportData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await dryrunOrdinanceImport({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: dryrunOrdinanceImportQueryKey(options)
    });
};

/**
 * Dryrun Ordinance Import Endpoint
 * Validate and transform ordinance import rows without writing.
 */
export const dryrunOrdinanceImportMutation = (options?: Partial<Options<DryrunOrdinanceImportData>>): UseMutationOptions<DryrunOrdinanceImportResponse, DryrunOrdinanceImportError, Options<DryrunOrdinanceImportData>> => {
    const mutationOptions: UseMutationOptions<DryrunOrdinanceImportResponse, DryrunOrdinanceImportError, Options<DryrunOrdinanceImportData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await dryrunOrdinanceImport({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const applyOrdinanceImportQueryKey = (options: Options<ApplyOrdinanceImportData>) => createQueryKey('applyOrdinanceImport', options);

/**
 * Apply Ordinance Import Endpoint
 * Upsert ordinance versions from an uploaded spreadsheet (existing jurisdictions only).
 */
export const applyOrdinanceImportOptions = (options: Options<ApplyOrdinanceImportData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await applyOrdinanceImport({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: applyOrdinanceImportQueryKey(options)
    });
};

/**
 * Apply Ordinance Import Endpoint
 * Upsert ordinance versions from an uploaded spreadsheet (existing jurisdictions only).
 */
export const applyOrdinanceImportMutation = (options?: Partial<Options<ApplyOrdinanceImportData>>): UseMutationOptions<ApplyOrdinanceImportResponse, ApplyOrdinanceImportError, Options<ApplyOrdinanceImportData>> => {
    const mutationOptions: UseMutationOptions<ApplyOrdinanceImportResponse, ApplyOrdinanceImportError, Options<ApplyOrdinanceImportData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await applyOrdinanceImport({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const lookupJurisdictionByFipsCodeQueryKey = (options: Options<LookupJurisdictionByFipsCodeData>) => createQueryKey('lookupJurisdictionByFipsCode', options);

/**
 * Lookup Jurisdiction By Fips Endpoint
 * Lookup jurisdiction by FIPS code using TigerWeb.
 */
export const lookupJurisdictionByFipsCodeOptions = (options: Options<LookupJurisdictionByFipsCodeData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await lookupJurisdictionByFipsCode({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: lookupJurisdictionByFipsCodeQueryKey(options)
    });
};

export const lookupJurisdictionByTigerCodeQueryKey = (options: Options<LookupJurisdictionByTigerCodeData>) => createQueryKey('lookupJurisdictionByTigerCode', options);

/**
 * Lookup Jurisdiction By Tiger Code Endpoint
 * Lookup jurisdiction by TIGER code using TigerWeb.
 */
export const lookupJurisdictionByTigerCodeOptions = (options: Options<LookupJurisdictionByTigerCodeData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await lookupJurisdictionByTigerCode({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: lookupJurisdictionByTigerCodeQueryKey(options)
    });
};

export const fuzzySearchJurisdictionsByNameQueryKey = (options: Options<FuzzySearchJurisdictionsByNameData>) => createQueryKey('fuzzySearchJurisdictionsByName', options);

/**
 * Fuzzy Search Jurisdictions By Name Endpoint
 * Fuzzy search for jurisdictions by name using TigerWeb.
 *
 * ``max_results`` caps the list so a very broad name cannot pull an unbounded
 * Census page. Distinct TIGER codes are kept even when the display name matches.
 */
export const fuzzySearchJurisdictionsByNameOptions = (options: Options<FuzzySearchJurisdictionsByNameData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await fuzzySearchJurisdictionsByName({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: fuzzySearchJurisdictionsByNameQueryKey(options)
    });
};

export const operatorGetRegistrantByEmailQueryKey = (options: Options<OperatorGetRegistrantByEmailData>) => createQueryKey('operatorGetRegistrantByEmail', options);

/**
 * Operator Get Registrant By Email Endpoint
 * Look up registrant account by email for form prefilling. Includes deleted accounts.
 */
export const operatorGetRegistrantByEmailOptions = (options: Options<OperatorGetRegistrantByEmailData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await operatorGetRegistrantByEmail({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: operatorGetRegistrantByEmailQueryKey(options)
    });
};

export const listLicenseLinkCandidatesQueryKey = (options: Options<ListLicenseLinkCandidatesData>) => createQueryKey('listLicenseLinkCandidates', options);

/**
 * List License Link Candidates Endpoint
 * List proposed matches, or search every license in this jurisdiction.
 */
export const listLicenseLinkCandidatesOptions = (options: Options<ListLicenseLinkCandidatesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listLicenseLinkCandidates({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listLicenseLinkCandidatesQueryKey(options)
    });
};

export const linkLicenseQueryKey = (options: Options<LinkLicenseData>) => createQueryKey('linkLicense', options);

/**
 * Link License Endpoint
 * Link this license to another license in the same jurisdiction.
 */
export const linkLicenseOptions = (options: Options<LinkLicenseData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await linkLicense({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: linkLicenseQueryKey(options)
    });
};

/**
 * Link License Endpoint
 * Link this license to another license in the same jurisdiction.
 */
export const linkLicenseMutation = (options?: Partial<Options<LinkLicenseData>>): UseMutationOptions<LinkLicenseResponse, LinkLicenseError, Options<LinkLicenseData>> => {
    const mutationOptions: UseMutationOptions<LinkLicenseResponse, LinkLicenseError, Options<LinkLicenseData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await linkLicense({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const operatorCreateLicenseQueryKey = (options: Options<OperatorCreateLicenseData>) => createQueryKey('operatorCreateLicense', options);

/**
 * Operator Create License Endpoint
 * Create a license on behalf of a registrant as an operator.
 */
export const operatorCreateLicenseOptions = (options: Options<OperatorCreateLicenseData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await operatorCreateLicense({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: operatorCreateLicenseQueryKey(options)
    });
};

/**
 * Operator Create License Endpoint
 * Create a license on behalf of a registrant as an operator.
 */
export const operatorCreateLicenseMutation = (options?: Partial<Options<OperatorCreateLicenseData>>): UseMutationOptions<OperatorCreateLicenseResponse, OperatorCreateLicenseError, Options<OperatorCreateLicenseData>> => {
    const mutationOptions: UseMutationOptions<OperatorCreateLicenseResponse, OperatorCreateLicenseError, Options<OperatorCreateLicenseData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await operatorCreateLicense({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listSavedImportMappingsQueryKey = (options: Options<ListSavedImportMappingsData>) => createQueryKey('listSavedImportMappings', options);

/**
 * List Saved Import Mappings Endpoint
 * List saved import mappings for the current user and upload type.
 */
export const listSavedImportMappingsOptions = (options: Options<ListSavedImportMappingsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listSavedImportMappings({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listSavedImportMappingsQueryKey(options)
    });
};

export const createSavedImportMappingQueryKey = (options: Options<CreateSavedImportMappingData>) => createQueryKey('createSavedImportMapping', options);

/**
 * Create Saved Import Mapping Endpoint
 * Create a saved import mapping for the current user.
 */
export const createSavedImportMappingOptions = (options: Options<CreateSavedImportMappingData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createSavedImportMapping({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createSavedImportMappingQueryKey(options)
    });
};

/**
 * Create Saved Import Mapping Endpoint
 * Create a saved import mapping for the current user.
 */
export const createSavedImportMappingMutation = (options?: Partial<Options<CreateSavedImportMappingData>>): UseMutationOptions<CreateSavedImportMappingResponse, CreateSavedImportMappingError, Options<CreateSavedImportMappingData>> => {
    const mutationOptions: UseMutationOptions<CreateSavedImportMappingResponse, CreateSavedImportMappingError, Options<CreateSavedImportMappingData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createSavedImportMapping({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Saved Import Mapping Endpoint
 * Delete one saved import mapping.
 */
export const deleteSavedImportMappingMutation = (options?: Partial<Options<DeleteSavedImportMappingData>>): UseMutationOptions<DeleteSavedImportMappingResponse, DeleteSavedImportMappingError, Options<DeleteSavedImportMappingData>> => {
    const mutationOptions: UseMutationOptions<DeleteSavedImportMappingResponse, DeleteSavedImportMappingError, Options<DeleteSavedImportMappingData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await deleteSavedImportMapping({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Saved Import Mapping Endpoint
 * Update one saved import mapping.
 */
export const updateSavedImportMappingMutation = (options?: Partial<Options<UpdateSavedImportMappingData>>): UseMutationOptions<UpdateSavedImportMappingResponse, UpdateSavedImportMappingError, Options<UpdateSavedImportMappingData>> => {
    const mutationOptions: UseMutationOptions<UpdateSavedImportMappingResponse, UpdateSavedImportMappingError, Options<UpdateSavedImportMappingData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateSavedImportMapping({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const applySavedImportMappingQueryKey = (options: Options<ApplySavedImportMappingData>) => createQueryKey('applySavedImportMapping', options);

/**
 * Apply Saved Import Mapping Endpoint
 * Preview applying one saved mapping to a specific uploaded sheet.
 */
export const applySavedImportMappingOptions = (options: Options<ApplySavedImportMappingData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await applySavedImportMapping({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: applySavedImportMappingQueryKey(options)
    });
};

/**
 * Apply Saved Import Mapping Endpoint
 * Preview applying one saved mapping to a specific uploaded sheet.
 */
export const applySavedImportMappingMutation = (options?: Partial<Options<ApplySavedImportMappingData>>): UseMutationOptions<ApplySavedImportMappingResponse, ApplySavedImportMappingError, Options<ApplySavedImportMappingData>> => {
    const mutationOptions: UseMutationOptions<ApplySavedImportMappingResponse, ApplySavedImportMappingError, Options<ApplySavedImportMappingData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await applySavedImportMapping({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTempFileHeadersAndRowCountsQueryKey = (options: Options<GetTempFileHeadersAndRowCountsData>) => createQueryKey('getTempFileHeadersAndRowCounts', options);

/**
 * Get File Headers And Row Counts Endpoint
 * Get file headers and row counts for a given token.
 */
export const getTempFileHeadersAndRowCountsOptions = (options: Options<GetTempFileHeadersAndRowCountsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getTempFileHeadersAndRowCounts({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getTempFileHeadersAndRowCountsQueryKey(options)
    });
};

export const getJurisdictionFieldMappingForTempFileQueryKey = (options: Options<GetJurisdictionFieldMappingForTempFileData>) => createQueryKey('getJurisdictionFieldMappingForTempFile', options);

/**
 * Get Temp File Field Mapping
 * Get temp file field mapping for a file using OpenAI assuming it is a jurisdiction file.
 */
export const getJurisdictionFieldMappingForTempFileOptions = (options: Options<GetJurisdictionFieldMappingForTempFileData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getJurisdictionFieldMappingForTempFile({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getJurisdictionFieldMappingForTempFileQueryKey(options)
    });
};

export const getOrdinanceFieldMappingForTempFileQueryKey = (options: Options<GetOrdinanceFieldMappingForTempFileData>) => createQueryKey('getOrdinanceFieldMappingForTempFile', options);

/**
 * Get Temp File Ordinance Field Mapping
 * Infer (or load saved) column mapping for ordinance bulk import.
 */
export const getOrdinanceFieldMappingForTempFileOptions = (options: Options<GetOrdinanceFieldMappingForTempFileData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOrdinanceFieldMappingForTempFile({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOrdinanceFieldMappingForTempFileQueryKey(options)
    });
};

export const getLicenseFieldMappingForTempFileQueryKey = (options: Options<GetLicenseFieldMappingForTempFileData>) => createQueryKey('getLicenseFieldMappingForTempFile', options);

/**
 * Get Temp File License Field Mapping
 * Get temp file field mapping for a file using OpenAI assuming it is a license file.
 */
export const getLicenseFieldMappingForTempFileOptions = (options: Options<GetLicenseFieldMappingForTempFileData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getLicenseFieldMappingForTempFile({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getLicenseFieldMappingForTempFileQueryKey(options)
    });
};

export const getGovernmentUserFieldMappingForTempFileQueryKey = (options: Options<GetGovernmentUserFieldMappingForTempFileData>) => createQueryKey('getGovernmentUserFieldMappingForTempFile', options);

/**
 * Get Temp File Government User Field Mapping
 * Infer or load a saved mapping for a government-user spreadsheet.
 */
export const getGovernmentUserFieldMappingForTempFileOptions = (options: Options<GetGovernmentUserFieldMappingForTempFileData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getGovernmentUserFieldMappingForTempFile({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getGovernmentUserFieldMappingForTempFileQueryKey(options)
    });
};

export const dryrunGovernmentUserUpsertQueryKey = (options: Options<DryrunGovernmentUserUpsertData>) => createQueryKey('dryrunGovernmentUserUpsert', options);

/**
 * Dryrun Government User Upsert Endpoint
 * Validate a government-user spreadsheet without writing users or Auth0.
 */
export const dryrunGovernmentUserUpsertOptions = (options: Options<DryrunGovernmentUserUpsertData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await dryrunGovernmentUserUpsert({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: dryrunGovernmentUserUpsertQueryKey(options)
    });
};

/**
 * Dryrun Government User Upsert Endpoint
 * Validate a government-user spreadsheet without writing users or Auth0.
 */
export const dryrunGovernmentUserUpsertMutation = (options?: Partial<Options<DryrunGovernmentUserUpsertData>>): UseMutationOptions<DryrunGovernmentUserUpsertResponse, DryrunGovernmentUserUpsertError, Options<DryrunGovernmentUserUpsertData>> => {
    const mutationOptions: UseMutationOptions<DryrunGovernmentUserUpsertResponse, DryrunGovernmentUserUpsertError, Options<DryrunGovernmentUserUpsertData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await dryrunGovernmentUserUpsert({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const upsertGovernmentUsersQueryKey = (options: Options<UpsertGovernmentUsersData>) => createQueryKey('upsertGovernmentUsers', options);

/**
 * Upsert Government Users Endpoint
 * Create or patch government users from an uploaded spreadsheet.
 */
export const upsertGovernmentUsersOptions = (options: Options<UpsertGovernmentUsersData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await upsertGovernmentUsers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: upsertGovernmentUsersQueryKey(options)
    });
};

/**
 * Upsert Government Users Endpoint
 * Create or patch government users from an uploaded spreadsheet.
 */
export const upsertGovernmentUsersMutation = (options?: Partial<Options<UpsertGovernmentUsersData>>): UseMutationOptions<UpsertGovernmentUsersResponse, UpsertGovernmentUsersError, Options<UpsertGovernmentUsersData>> => {
    const mutationOptions: UseMutationOptions<UpsertGovernmentUsersResponse, UpsertGovernmentUsersError, Options<UpsertGovernmentUsersData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await upsertGovernmentUsers({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const dryrunLicenseCreationQueryKey = (options: Options<DryrunLicenseCreationData>) => createQueryKey('dryrunLicenseCreation', options);

/**
 * Dryrun License Creation Endpoint
 * Dry run license creation from uploaded file using field mappings.
 */
export const dryrunLicenseCreationOptions = (options: Options<DryrunLicenseCreationData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await dryrunLicenseCreation({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: dryrunLicenseCreationQueryKey(options)
    });
};

/**
 * Dryrun License Creation Endpoint
 * Dry run license creation from uploaded file using field mappings.
 */
export const dryrunLicenseCreationMutation = (options?: Partial<Options<DryrunLicenseCreationData>>): UseMutationOptions<DryrunLicenseCreationResponse, DryrunLicenseCreationError, Options<DryrunLicenseCreationData>> => {
    const mutationOptions: UseMutationOptions<DryrunLicenseCreationResponse, DryrunLicenseCreationError, Options<DryrunLicenseCreationData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await dryrunLicenseCreation({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const createLicensesQueryKey = (options: Options<CreateLicensesData>) => createQueryKey('createLicenses', options);

/**
 * Create Licenses Endpoint
 * Create licenses from uploaded file using field mappings.
 */
export const createLicensesOptions = (options: Options<CreateLicensesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createLicenses({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createLicensesQueryKey(options)
    });
};

/**
 * Create Licenses Endpoint
 * Create licenses from uploaded file using field mappings.
 */
export const createLicensesMutation = (options?: Partial<Options<CreateLicensesData>>): UseMutationOptions<CreateLicensesResponse, CreateLicensesError, Options<CreateLicensesData>> => {
    const mutationOptions: UseMutationOptions<CreateLicensesResponse, CreateLicensesError, Options<CreateLicensesData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createLicenses({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getQuestionFieldMappingForTempFileQueryKey = (options: Options<GetQuestionFieldMappingForTempFileData>) => createQueryKey('getQuestionFieldMappingForTempFile', options);

/**
 * Get Temp File Question Field Mapping
 * Get temp file field mapping for a file using OpenAI assuming it is a question file.
 */
export const getQuestionFieldMappingForTempFileOptions = (options: Options<GetQuestionFieldMappingForTempFileData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getQuestionFieldMappingForTempFile({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getQuestionFieldMappingForTempFileQueryKey(options)
    });
};

export const getQuestionGroupFieldMappingForTempFileQueryKey = (options: Options<GetQuestionGroupFieldMappingForTempFileData>) => createQueryKey('getQuestionGroupFieldMappingForTempFile', options);

/**
 * Get Temp File Question Group Field Mapping
 * Field mapping for a spreadsheet with question group name + license type columns.
 */
export const getQuestionGroupFieldMappingForTempFileOptions = (options: Options<GetQuestionGroupFieldMappingForTempFileData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getQuestionGroupFieldMappingForTempFile({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getQuestionGroupFieldMappingForTempFileQueryKey(options)
    });
};

export const dryrunQuestionCreationQueryKey = (options: Options<DryrunQuestionCreationData>) => createQueryKey('dryrunQuestionCreation', options);

/**
 * Dryrun Question Creation Endpoint
 * Dry run question creation from uploaded file. Operator only.
 */
export const dryrunQuestionCreationOptions = (options: Options<DryrunQuestionCreationData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await dryrunQuestionCreation({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: dryrunQuestionCreationQueryKey(options)
    });
};

/**
 * Dryrun Question Creation Endpoint
 * Dry run question creation from uploaded file. Operator only.
 */
export const dryrunQuestionCreationMutation = (options?: Partial<Options<DryrunQuestionCreationData>>): UseMutationOptions<DryrunQuestionCreationResponse, DryrunQuestionCreationError, Options<DryrunQuestionCreationData>> => {
    const mutationOptions: UseMutationOptions<DryrunQuestionCreationResponse, DryrunQuestionCreationError, Options<DryrunQuestionCreationData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await dryrunQuestionCreation({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const createQuestionsQueryKey = (options: Options<CreateQuestionsData>) => createQueryKey('createQuestions', options);

/**
 * Create Questions Endpoint
 * Create questions from uploaded file. Operator only; government users cannot upload questions.
 */
export const createQuestionsOptions = (options: Options<CreateQuestionsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createQuestions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createQuestionsQueryKey(options)
    });
};

/**
 * Create Questions Endpoint
 * Create questions from uploaded file. Operator only; government users cannot upload questions.
 */
export const createQuestionsMutation = (options?: Partial<Options<CreateQuestionsData>>): UseMutationOptions<CreateQuestionsResponse, CreateQuestionsError, Options<CreateQuestionsData>> => {
    const mutationOptions: UseMutationOptions<CreateQuestionsResponse, CreateQuestionsError, Options<CreateQuestionsData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createQuestions({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const dryrunQuestionGroupCreationQueryKey = (options: Options<DryrunQuestionGroupCreationData>) => createQueryKey('dryrunQuestionGroupCreation', options);

/**
 * Dryrun Question Group Creation Endpoint
 * Dry run: parse question group rows from an uploaded file.
 */
export const dryrunQuestionGroupCreationOptions = (options: Options<DryrunQuestionGroupCreationData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await dryrunQuestionGroupCreation({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: dryrunQuestionGroupCreationQueryKey(options)
    });
};

/**
 * Dryrun Question Group Creation Endpoint
 * Dry run: parse question group rows from an uploaded file.
 */
export const dryrunQuestionGroupCreationMutation = (options?: Partial<Options<DryrunQuestionGroupCreationData>>): UseMutationOptions<DryrunQuestionGroupCreationResponse, DryrunQuestionGroupCreationError, Options<DryrunQuestionGroupCreationData>> => {
    const mutationOptions: UseMutationOptions<DryrunQuestionGroupCreationResponse, DryrunQuestionGroupCreationError, Options<DryrunQuestionGroupCreationData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await dryrunQuestionGroupCreation({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const createQuestionGroupsQueryKey = (options: Options<CreateQuestionGroupsData>) => createQueryKey('createQuestionGroups', options);

/**
 * Create Question Groups Bulk Endpoint
 * Bulk-create question groups from an uploaded file (name + license type per row).
 */
export const createQuestionGroupsOptions = (options: Options<CreateQuestionGroupsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createQuestionGroups({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createQuestionGroupsQueryKey(options)
    });
};

/**
 * Create Question Groups Bulk Endpoint
 * Bulk-create question groups from an uploaded file (name + license type per row).
 */
export const createQuestionGroupsMutation = (options?: Partial<Options<CreateQuestionGroupsData>>): UseMutationOptions<CreateQuestionGroupsResponse, CreateQuestionGroupsError, Options<CreateQuestionGroupsData>> => {
    const mutationOptions: UseMutationOptions<CreateQuestionGroupsResponse, CreateQuestionGroupsError, Options<CreateQuestionGroupsData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createQuestionGroups({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPartyFieldMappingForTempFileQueryKey = (options: Options<GetPartyFieldMappingForTempFileData>) => createQueryKey('getPartyFieldMappingForTempFile', options);

/**
 * Get Temp File Party Field Mapping
 * Get temp file field mapping for a file using OpenAI assuming it is a party file.
 */
export const getPartyFieldMappingForTempFileOptions = (options: Options<GetPartyFieldMappingForTempFileData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getPartyFieldMappingForTempFile({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getPartyFieldMappingForTempFileQueryKey(options)
    });
};

export const dryrunPartyCreationQueryKey = (options: Options<DryrunPartyCreationData>) => createQueryKey('dryrunPartyCreation', options);

/**
 * Dryrun Party Creation Endpoint
 * Dry run party creation from uploaded file using field mappings.
 */
export const dryrunPartyCreationOptions = (options: Options<DryrunPartyCreationData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await dryrunPartyCreation({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: dryrunPartyCreationQueryKey(options)
    });
};

/**
 * Dryrun Party Creation Endpoint
 * Dry run party creation from uploaded file using field mappings.
 */
export const dryrunPartyCreationMutation = (options?: Partial<Options<DryrunPartyCreationData>>): UseMutationOptions<DryrunPartyCreationResponse, DryrunPartyCreationError, Options<DryrunPartyCreationData>> => {
    const mutationOptions: UseMutationOptions<DryrunPartyCreationResponse, DryrunPartyCreationError, Options<DryrunPartyCreationData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await dryrunPartyCreation({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const createPartiesQueryKey = (options: Options<CreatePartiesData>) => createQueryKey('createParties', options);

/**
 * Create Parties Endpoint
 * Create parties (name/address/contact) from uploaded file using field mappings.
 */
export const createPartiesOptions = (options: Options<CreatePartiesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createParties({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createPartiesQueryKey(options)
    });
};

/**
 * Create Parties Endpoint
 * Create parties (name/address/contact) from uploaded file using field mappings.
 */
export const createPartiesMutation = (options?: Partial<Options<CreatePartiesData>>): UseMutationOptions<CreatePartiesResponse, CreatePartiesError, Options<CreatePartiesData>> => {
    const mutationOptions: UseMutationOptions<CreatePartiesResponse, CreatePartiesError, Options<CreatePartiesData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createParties({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCaseNumberFieldMappingForTempFileQueryKey = (options: Options<GetCaseNumberFieldMappingForTempFileData>) => createQueryKey('getCaseNumberFieldMappingForTempFile', options);

/**
 * Get Temp File Case Number Field Mapping
 * Get spreadsheet field mapping for a foreclosure case-number upload file.
 */
export const getCaseNumberFieldMappingForTempFileOptions = (options: Options<GetCaseNumberFieldMappingForTempFileData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCaseNumberFieldMappingForTempFile({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getCaseNumberFieldMappingForTempFileQueryKey(options)
    });
};

export const dryrunCaseNumberImportQueryKey = (options: Options<DryrunCaseNumberImportData>) => createQueryKey('dryrunCaseNumberImport', options);

/**
 * Dryrun Case Number Import Endpoint
 * Dry-run applying foreclosure case numbers from an uploaded spreadsheet.
 */
export const dryrunCaseNumberImportOptions = (options: Options<DryrunCaseNumberImportData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await dryrunCaseNumberImport({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: dryrunCaseNumberImportQueryKey(options)
    });
};

/**
 * Dryrun Case Number Import Endpoint
 * Dry-run applying foreclosure case numbers from an uploaded spreadsheet.
 */
export const dryrunCaseNumberImportMutation = (options?: Partial<Options<DryrunCaseNumberImportData>>): UseMutationOptions<DryrunCaseNumberImportResponse, DryrunCaseNumberImportError, Options<DryrunCaseNumberImportData>> => {
    const mutationOptions: UseMutationOptions<DryrunCaseNumberImportResponse, DryrunCaseNumberImportError, Options<DryrunCaseNumberImportData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await dryrunCaseNumberImport({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const applyCaseNumberImportQueryKey = (options: Options<ApplyCaseNumberImportData>) => createQueryKey('applyCaseNumberImport', options);

/**
 * Apply Case Number Import Endpoint
 * Apply foreclosure case numbers from an uploaded spreadsheet onto licenses.
 */
export const applyCaseNumberImportOptions = (options: Options<ApplyCaseNumberImportData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await applyCaseNumberImport({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: applyCaseNumberImportQueryKey(options)
    });
};

/**
 * Apply Case Number Import Endpoint
 * Apply foreclosure case numbers from an uploaded spreadsheet onto licenses.
 */
export const applyCaseNumberImportMutation = (options?: Partial<Options<ApplyCaseNumberImportData>>): UseMutationOptions<ApplyCaseNumberImportResponse, ApplyCaseNumberImportError, Options<ApplyCaseNumberImportData>> => {
    const mutationOptions: UseMutationOptions<ApplyCaseNumberImportResponse, ApplyCaseNumberImportError, Options<ApplyCaseNumberImportData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await applyCaseNumberImport({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const previewBulkServiceTransferQueryKey = (options: Options<PreviewBulkServiceTransferData>) => createQueryKey('previewBulkServiceTransfer', options);

/**
 * Preview Bulk Service Transfer Endpoint
 * Dry-run bulk service transfer for mapped JSON rows (CSV download–ready).
 */
export const previewBulkServiceTransferOptions = (options: Options<PreviewBulkServiceTransferData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await previewBulkServiceTransfer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: previewBulkServiceTransferQueryKey(options)
    });
};

/**
 * Preview Bulk Service Transfer Endpoint
 * Dry-run bulk service transfer for mapped JSON rows (CSV download–ready).
 */
export const previewBulkServiceTransferMutation = (options?: Partial<Options<PreviewBulkServiceTransferData>>): UseMutationOptions<PreviewBulkServiceTransferResponse, PreviewBulkServiceTransferError, Options<PreviewBulkServiceTransferData>> => {
    const mutationOptions: UseMutationOptions<PreviewBulkServiceTransferResponse, PreviewBulkServiceTransferError, Options<PreviewBulkServiceTransferData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await previewBulkServiceTransfer({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const commitBulkServiceTransferQueryKey = (options: Options<CommitBulkServiceTransferData>) => createQueryKey('commitBulkServiceTransfer', options);

/**
 * Commit Bulk Service Transfer Endpoint
 * Commit bulk service transfers for mapped JSON rows.
 */
export const commitBulkServiceTransferOptions = (options: Options<CommitBulkServiceTransferData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await commitBulkServiceTransfer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: commitBulkServiceTransferQueryKey(options)
    });
};

/**
 * Commit Bulk Service Transfer Endpoint
 * Commit bulk service transfers for mapped JSON rows.
 */
export const commitBulkServiceTransferMutation = (options?: Partial<Options<CommitBulkServiceTransferData>>): UseMutationOptions<CommitBulkServiceTransferResponse, CommitBulkServiceTransferError, Options<CommitBulkServiceTransferData>> => {
    const mutationOptions: UseMutationOptions<CommitBulkServiceTransferResponse, CommitBulkServiceTransferError, Options<CommitBulkServiceTransferData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await commitBulkServiceTransfer({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getHeraConfigurationEndpointOperatorHeraConfigurationGetQueryKey = (options?: Options<GetHeraConfigurationEndpointOperatorHeraConfigurationGetData>) => createQueryKey('getHeraConfigurationEndpointOperatorHeraConfigurationGet', options);

/**
 * Get HERA configuration
 * Get all HERA configuration settings
 */
export const getHeraConfigurationEndpointOperatorHeraConfigurationGetOptions = (options?: Options<GetHeraConfigurationEndpointOperatorHeraConfigurationGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getHeraConfigurationEndpointOperatorHeraConfigurationGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getHeraConfigurationEndpointOperatorHeraConfigurationGetQueryKey(options)
    });
};

/**
 * Update HERA configuration
 * Update HERA configuration settings
 */
export const updateHeraConfigurationEndpointOperatorHeraConfigurationPutMutation = (options?: Partial<Options<UpdateHeraConfigurationEndpointOperatorHeraConfigurationPutData>>): UseMutationOptions<UpdateHeraConfigurationEndpointOperatorHeraConfigurationPutResponse, UpdateHeraConfigurationEndpointOperatorHeraConfigurationPutError, Options<UpdateHeraConfigurationEndpointOperatorHeraConfigurationPutData>> => {
    const mutationOptions: UseMutationOptions<UpdateHeraConfigurationEndpointOperatorHeraConfigurationPutResponse, UpdateHeraConfigurationEndpointOperatorHeraConfigurationPutError, Options<UpdateHeraConfigurationEndpointOperatorHeraConfigurationPutData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateHeraConfigurationEndpointOperatorHeraConfigurationPut({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getManualCheckPaymentsQueryKey = (options?: Options<GetManualCheckPaymentsData>) => createQueryKey('getManualCheckPayments', options);

/**
 * Get Manual Check Payments Endpoint
 * List manual check payments for the operator checks tab.
 */
export const getManualCheckPaymentsOptions = (options?: Options<GetManualCheckPaymentsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getManualCheckPayments({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getManualCheckPaymentsQueryKey(options)
    });
};

export const getManualCheckPaymentDetailQueryKey = (options: Options<GetManualCheckPaymentDetailData>) => createQueryKey('getManualCheckPaymentDetail', options);

/**
 * Get Manual Check Payment Detail Endpoint
 * Get full detail for one manual check payment (Check Received dialog).
 */
export const getManualCheckPaymentDetailOptions = (options: Options<GetManualCheckPaymentDetailData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getManualCheckPaymentDetail({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getManualCheckPaymentDetailQueryKey(options)
    });
};

export const cancelManualCheckPaymentQueryKey = (options: Options<CancelManualCheckPaymentData>) => createQueryKey('cancelManualCheckPayment', options);

/**
 * Cancel Manual Check Payment Endpoint
 * Cancel a manual check payment (awaiting payment only).
 */
export const cancelManualCheckPaymentOptions = (options: Options<CancelManualCheckPaymentData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cancelManualCheckPayment({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: cancelManualCheckPaymentQueryKey(options)
    });
};

/**
 * Cancel Manual Check Payment Endpoint
 * Cancel a manual check payment (awaiting payment only).
 */
export const cancelManualCheckPaymentMutation = (options?: Partial<Options<CancelManualCheckPaymentData>>): UseMutationOptions<CancelManualCheckPaymentResponse, CancelManualCheckPaymentError, Options<CancelManualCheckPaymentData>> => {
    const mutationOptions: UseMutationOptions<CancelManualCheckPaymentResponse, CancelManualCheckPaymentError, Options<CancelManualCheckPaymentData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await cancelManualCheckPayment({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const finaliseManualCheckPaymentQueryKey = (options: Options<FinaliseManualCheckPaymentData>) => createQueryKey('finaliseManualCheckPayment', options);

/**
 * Finalise Manual Check Payment Endpoint
 * Mark a manual check payment as received with optional amount adjustments and removals.
 */
export const finaliseManualCheckPaymentOptions = (options: Options<FinaliseManualCheckPaymentData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await finaliseManualCheckPayment({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: finaliseManualCheckPaymentQueryKey(options)
    });
};

/**
 * Finalise Manual Check Payment Endpoint
 * Mark a manual check payment as received with optional amount adjustments and removals.
 */
export const finaliseManualCheckPaymentMutation = (options?: Partial<Options<FinaliseManualCheckPaymentData>>): UseMutationOptions<FinaliseManualCheckPaymentResponse, FinaliseManualCheckPaymentError, Options<FinaliseManualCheckPaymentData>> => {
    const mutationOptions: UseMutationOptions<FinaliseManualCheckPaymentResponse, FinaliseManualCheckPaymentError, Options<FinaliseManualCheckPaymentData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await finaliseManualCheckPayment({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const markManualCheckPaymentDepositedQueryKey = (options: Options<MarkManualCheckPaymentDepositedData>) => createQueryKey('markManualCheckPaymentDeposited', options);

/**
 * Mark Manual Check Payment Deposited
 * Record when a finalized check reaches the trust account.
 */
export const markManualCheckPaymentDepositedOptions = (options: Options<MarkManualCheckPaymentDepositedData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await markManualCheckPaymentDeposited({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: markManualCheckPaymentDepositedQueryKey(options)
    });
};

/**
 * Mark Manual Check Payment Deposited
 * Record when a finalized check reaches the trust account.
 */
export const markManualCheckPaymentDepositedMutation = (options?: Partial<Options<MarkManualCheckPaymentDepositedData>>): UseMutationOptions<MarkManualCheckPaymentDepositedResponse, MarkManualCheckPaymentDepositedError, Options<MarkManualCheckPaymentDepositedData>> => {
    const mutationOptions: UseMutationOptions<MarkManualCheckPaymentDepositedResponse, MarkManualCheckPaymentDepositedError, Options<MarkManualCheckPaymentDepositedData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await markManualCheckPaymentDeposited({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getRefundAllocationsQueryKey = (options?: Options<GetRefundAllocationsData>) => createQueryKey('getRefundAllocations', options);

/**
 * Get Refund Allocations Endpoint
 * List refund allocations for the operator Refunds tab.
 */
export const getRefundAllocationsOptions = (options?: Options<GetRefundAllocationsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getRefundAllocations({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getRefundAllocationsQueryKey(options)
    });
};

export const getRefundAllocationDetailQueryKey = (options: Options<GetRefundAllocationDetailData>) => createQueryKey('getRefundAllocationDetail', options);

/**
 * Get Refund Allocation Detail Endpoint
 * Get detail for the refund allocation dialog.
 */
export const getRefundAllocationDetailOptions = (options: Options<GetRefundAllocationDetailData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getRefundAllocationDetail({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getRefundAllocationDetailQueryKey(options)
    });
};

export const finaliseRefundAllocationQueryKey = (options: Options<FinaliseRefundAllocationData>) => createQueryKey('finaliseRefundAllocation', options);

/**
 * Finalise Refund Allocation Endpoint
 * Apply or re-apply manual refund allocation.
 */
export const finaliseRefundAllocationOptions = (options: Options<FinaliseRefundAllocationData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await finaliseRefundAllocation({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: finaliseRefundAllocationQueryKey(options)
    });
};

/**
 * Finalise Refund Allocation Endpoint
 * Apply or re-apply manual refund allocation.
 */
export const finaliseRefundAllocationMutation = (options?: Partial<Options<FinaliseRefundAllocationData>>): UseMutationOptions<FinaliseRefundAllocationResponse, FinaliseRefundAllocationError, Options<FinaliseRefundAllocationData>> => {
    const mutationOptions: UseMutationOptions<FinaliseRefundAllocationResponse, FinaliseRefundAllocationError, Options<FinaliseRefundAllocationData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await finaliseRefundAllocation({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getManualInvoicePaymentsQueryKey = (options?: Options<GetManualInvoicePaymentsData>) => createQueryKey('getManualInvoicePayments', options);

/**
 * Get Manual Invoice Payments Endpoint
 * List manual invoice payments for the operator invoices tab.
 */
export const getManualInvoicePaymentsOptions = (options?: Options<GetManualInvoicePaymentsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getManualInvoicePayments({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getManualInvoicePaymentsQueryKey(options)
    });
};

export const generateOperatorInvoicesQueryKey = (options?: Options<GenerateOperatorInvoicesData>) => createQueryKey('generateOperatorInvoices', options);

/**
 * Generate Operator Invoices Endpoint
 * Create invoices for registrants with accounts contact; only explicit Pay Later cohort licenses.
 */
export const generateOperatorInvoicesOptions = (options?: Options<GenerateOperatorInvoicesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await generateOperatorInvoices({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: generateOperatorInvoicesQueryKey(options)
    });
};

/**
 * Generate Operator Invoices Endpoint
 * Create invoices for registrants with accounts contact; only explicit Pay Later cohort licenses.
 */
export const generateOperatorInvoicesMutation = (options?: Partial<Options<GenerateOperatorInvoicesData>>): UseMutationOptions<GenerateOperatorInvoicesResponse, GenerateOperatorInvoicesError, Options<GenerateOperatorInvoicesData>> => {
    const mutationOptions: UseMutationOptions<GenerateOperatorInvoicesResponse, GenerateOperatorInvoicesError, Options<GenerateOperatorInvoicesData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await generateOperatorInvoices({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getManualInvoicePaymentDetailQueryKey = (options: Options<GetManualInvoicePaymentDetailData>) => createQueryKey('getManualInvoicePaymentDetail', options);

/**
 * Get Manual Invoice Payment Detail Endpoint
 * Get full detail for one manual invoice payment.
 */
export const getManualInvoicePaymentDetailOptions = (options: Options<GetManualInvoicePaymentDetailData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getManualInvoicePaymentDetail({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getManualInvoicePaymentDetailQueryKey(options)
    });
};

export const getManualInvoicePaymentPdfQueryKey = (options: Options<GetManualInvoicePaymentPdfData>) => createQueryKey('getManualInvoicePaymentPdf', options);

/**
 * Get Manual Invoice Payment Pdf Endpoint
 * Generate or reuse a filled invoice document (per license-type template) and return the PDF.
 */
export const getManualInvoicePaymentPdfOptions = (options: Options<GetManualInvoicePaymentPdfData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getManualInvoicePaymentPdf({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getManualInvoicePaymentPdfQueryKey(options)
    });
};

export const cancelManualInvoicePaymentQueryKey = (options: Options<CancelManualInvoicePaymentData>) => createQueryKey('cancelManualInvoicePayment', options);

/**
 * Cancel Manual Invoice Payment Endpoint
 * Cancel a manual invoice payment (awaiting payment only).
 */
export const cancelManualInvoicePaymentOptions = (options: Options<CancelManualInvoicePaymentData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cancelManualInvoicePayment({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: cancelManualInvoicePaymentQueryKey(options)
    });
};

/**
 * Cancel Manual Invoice Payment Endpoint
 * Cancel a manual invoice payment (awaiting payment only).
 */
export const cancelManualInvoicePaymentMutation = (options?: Partial<Options<CancelManualInvoicePaymentData>>): UseMutationOptions<CancelManualInvoicePaymentResponse, CancelManualInvoicePaymentError, Options<CancelManualInvoicePaymentData>> => {
    const mutationOptions: UseMutationOptions<CancelManualInvoicePaymentResponse, CancelManualInvoicePaymentError, Options<CancelManualInvoicePaymentData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await cancelManualInvoicePayment({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const finaliseManualInvoicePaymentQueryKey = (options: Options<FinaliseManualInvoicePaymentData>) => createQueryKey('finaliseManualInvoicePayment', options);

/**
 * Finalise Manual Invoice Payment Endpoint
 * Mark a manual invoice as paid (same payload as check finalise).
 */
export const finaliseManualInvoicePaymentOptions = (options: Options<FinaliseManualInvoicePaymentData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await finaliseManualInvoicePayment({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: finaliseManualInvoicePaymentQueryKey(options)
    });
};

/**
 * Finalise Manual Invoice Payment Endpoint
 * Mark a manual invoice as paid (same payload as check finalise).
 */
export const finaliseManualInvoicePaymentMutation = (options?: Partial<Options<FinaliseManualInvoicePaymentData>>): UseMutationOptions<FinaliseManualInvoicePaymentResponse, FinaliseManualInvoicePaymentError, Options<FinaliseManualInvoicePaymentData>> => {
    const mutationOptions: UseMutationOptions<FinaliseManualInvoicePaymentResponse, FinaliseManualInvoicePaymentError, Options<FinaliseManualInvoicePaymentData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await finaliseManualInvoicePayment({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Registrant Login Identity Operator Endpoint
 * Mark whether a registrant user is the accounts contact (invoice / billing email).
 */
export const updateRegistrantLoginIdentityOperatorMutation = (options?: Partial<Options<UpdateRegistrantLoginIdentityOperatorData>>): UseMutationOptions<UpdateRegistrantLoginIdentityOperatorResponse, UpdateRegistrantLoginIdentityOperatorError, Options<UpdateRegistrantLoginIdentityOperatorData>> => {
    const mutationOptions: UseMutationOptions<UpdateRegistrantLoginIdentityOperatorResponse, UpdateRegistrantLoginIdentityOperatorError, Options<UpdateRegistrantLoginIdentityOperatorData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateRegistrantLoginIdentityOperator({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Operator Registrant Account Accounts Contact Endpoint
 * Set accounts-contact for a registrant account (portal users and/or pre-login).
 */
export const updateOperatorRegistrantAccountAccountsContactMutation = (options?: Partial<Options<UpdateOperatorRegistrantAccountAccountsContactData>>): UseMutationOptions<UpdateOperatorRegistrantAccountAccountsContactResponse, UpdateOperatorRegistrantAccountAccountsContactError, Options<UpdateOperatorRegistrantAccountAccountsContactData>> => {
    const mutationOptions: UseMutationOptions<UpdateOperatorRegistrantAccountAccountsContactResponse, UpdateOperatorRegistrantAccountAccountsContactError, Options<UpdateOperatorRegistrantAccountAccountsContactData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateOperatorRegistrantAccountAccountsContact({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Operator Disable Registrant User Endpoint
 * Disable an eligible registrant user from the operator portal.
 */
export const operatorDisableRegistrantUserMutation = (options?: Partial<Options<OperatorDisableRegistrantUserData>>): UseMutationOptions<OperatorDisableRegistrantUserResponse, OperatorDisableRegistrantUserError, Options<OperatorDisableRegistrantUserData>> => {
    const mutationOptions: UseMutationOptions<OperatorDisableRegistrantUserResponse, OperatorDisableRegistrantUserError, Options<OperatorDisableRegistrantUserData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await operatorDisableRegistrantUser({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const operatorReenableRegistrantUserQueryKey = (options: Options<OperatorReenableRegistrantUserData>) => createQueryKey('operatorReenableRegistrantUser', options);

/**
 * Operator Reenable Registrant User Endpoint
 * Re-enable a disabled registrant user from the operator portal.
 */
export const operatorReenableRegistrantUserOptions = (options: Options<OperatorReenableRegistrantUserData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await operatorReenableRegistrantUser({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: operatorReenableRegistrantUserQueryKey(options)
    });
};

/**
 * Operator Reenable Registrant User Endpoint
 * Re-enable a disabled registrant user from the operator portal.
 */
export const operatorReenableRegistrantUserMutation = (options?: Partial<Options<OperatorReenableRegistrantUserData>>): UseMutationOptions<OperatorReenableRegistrantUserResponse, OperatorReenableRegistrantUserError, Options<OperatorReenableRegistrantUserData>> => {
    const mutationOptions: UseMutationOptions<OperatorReenableRegistrantUserResponse, OperatorReenableRegistrantUserError, Options<OperatorReenableRegistrantUserData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await operatorReenableRegistrantUser({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const operatorTransferPrimaryOwnershipQueryKey = (options: Options<OperatorTransferPrimaryOwnershipData>) => createQueryKey('operatorTransferPrimaryOwnership', options);

/**
 * Operator Transfer Primary Ownership Endpoint
 * Transfer organization primary ownership to another linked account (operator).
 *
 * ``organization_primary_id`` must be the current primary registrant account for the org.
 * ``new_primary_account_id`` must be an active secondary linked to that primary.
 *
 * Billing stays with the existing billing member unless
 * ``move_billing_to_new_primary`` is set. Stripe customers are never moved, so
 * saved cards and bank accounts stay with the member who owns them.
 */
export const operatorTransferPrimaryOwnershipOptions = (options: Options<OperatorTransferPrimaryOwnershipData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await operatorTransferPrimaryOwnership({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: operatorTransferPrimaryOwnershipQueryKey(options)
    });
};

/**
 * Operator Transfer Primary Ownership Endpoint
 * Transfer organization primary ownership to another linked account (operator).
 *
 * ``organization_primary_id`` must be the current primary registrant account for the org.
 * ``new_primary_account_id`` must be an active secondary linked to that primary.
 *
 * Billing stays with the existing billing member unless
 * ``move_billing_to_new_primary`` is set. Stripe customers are never moved, so
 * saved cards and bank accounts stay with the member who owns them.
 */
export const operatorTransferPrimaryOwnershipMutation = (options?: Partial<Options<OperatorTransferPrimaryOwnershipData>>): UseMutationOptions<OperatorTransferPrimaryOwnershipResponse, OperatorTransferPrimaryOwnershipError, Options<OperatorTransferPrimaryOwnershipData>> => {
    const mutationOptions: UseMutationOptions<OperatorTransferPrimaryOwnershipResponse, OperatorTransferPrimaryOwnershipError, Options<OperatorTransferPrimaryOwnershipData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await operatorTransferPrimaryOwnership({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const operatorAcceptPendingRegistrantInviteQueryKey = (options: Options<OperatorAcceptPendingRegistrantInviteData>) => createQueryKey('operatorAcceptPendingRegistrantInvite', options);

/**
 * Operator Accept Pending Invite Endpoint
 * Accept a pending organization invite on behalf of the registrant account (operator).
 *
 * Same state changes as registrant ``POST /registrant/account/accept-invite``.
 */
export const operatorAcceptPendingRegistrantInviteOptions = (options: Options<OperatorAcceptPendingRegistrantInviteData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await operatorAcceptPendingRegistrantInvite({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: operatorAcceptPendingRegistrantInviteQueryKey(options)
    });
};

/**
 * Operator Accept Pending Invite Endpoint
 * Accept a pending organization invite on behalf of the registrant account (operator).
 *
 * Same state changes as registrant ``POST /registrant/account/accept-invite``.
 */
export const operatorAcceptPendingRegistrantInviteMutation = (options?: Partial<Options<OperatorAcceptPendingRegistrantInviteData>>): UseMutationOptions<OperatorAcceptPendingRegistrantInviteResponse, OperatorAcceptPendingRegistrantInviteError, Options<OperatorAcceptPendingRegistrantInviteData>> => {
    const mutationOptions: UseMutationOptions<OperatorAcceptPendingRegistrantInviteResponse, OperatorAcceptPendingRegistrantInviteError, Options<OperatorAcceptPendingRegistrantInviteData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await operatorAcceptPendingRegistrantInvite({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const createLicenseTypeQueryKey = (options: Options<CreateLicenseTypeData>) => createQueryKey('createLicenseType', options);

/**
 * Create License Type Endpoint
 * Create a new license type.
 */
export const createLicenseTypeOptions = (options: Options<CreateLicenseTypeData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createLicenseType({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createLicenseTypeQueryKey(options)
    });
};

/**
 * Create License Type Endpoint
 * Create a new license type.
 */
export const createLicenseTypeMutation = (options?: Partial<Options<CreateLicenseTypeData>>): UseMutationOptions<CreateLicenseTypeResponse, CreateLicenseTypeError, Options<CreateLicenseTypeData>> => {
    const mutationOptions: UseMutationOptions<CreateLicenseTypeResponse, CreateLicenseTypeError, Options<CreateLicenseTypeData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createLicenseType({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getLicenseTypeQueryKey = (options: Options<GetLicenseTypeData>) => createQueryKey('getLicenseType', options);

/**
 * Get License Type Endpoint
 * Get a license type by ID.
 */
export const getLicenseTypeOptions = (options: Options<GetLicenseTypeData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getLicenseType({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getLicenseTypeQueryKey(options)
    });
};

/**
 * Update License Type Endpoint
 * Update a license type.
 */
export const updateLicenseTypeMutation = (options?: Partial<Options<UpdateLicenseTypeData>>): UseMutationOptions<UpdateLicenseTypeResponse, UpdateLicenseTypeError, Options<UpdateLicenseTypeData>> => {
    const mutationOptions: UseMutationOptions<UpdateLicenseTypeResponse, UpdateLicenseTypeError, Options<UpdateLicenseTypeData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateLicenseType({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAffectedJurisdictionsCountQueryKey = (options: Options<GetAffectedJurisdictionsCountData>) => createQueryKey('getAffectedJurisdictionsCount', options);

/**
 * Get Affected Jurisdictions Count Endpoint
 * Get the count of license type configurations that would be affected by license type status change.
 */
export const getAffectedJurisdictionsCountOptions = (options: Options<GetAffectedJurisdictionsCountData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAffectedJurisdictionsCount({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAffectedJurisdictionsCountQueryKey(options)
    });
};

export const cascadeJurisdictionStatusQueryKey = (options: Options<CascadeJurisdictionStatusData>) => createQueryKey('cascadeJurisdictionStatus', options);

/**
 * Cascade Jurisdiction Status Endpoint
 * Cascade the license type status change to related license type configurations.
 */
export const cascadeJurisdictionStatusOptions = (options: Options<CascadeJurisdictionStatusData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cascadeJurisdictionStatus({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: cascadeJurisdictionStatusQueryKey(options)
    });
};

/**
 * Cascade Jurisdiction Status Endpoint
 * Cascade the license type status change to related license type configurations.
 */
export const cascadeJurisdictionStatusMutation = (options?: Partial<Options<CascadeJurisdictionStatusData>>): UseMutationOptions<CascadeJurisdictionStatusResponse, CascadeJurisdictionStatusError, Options<CascadeJurisdictionStatusData>> => {
    const mutationOptions: UseMutationOptions<CascadeJurisdictionStatusResponse, CascadeJurisdictionStatusError, Options<CascadeJurisdictionStatusData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await cascadeJurisdictionStatus({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAllTemplateDocumentsStatusQueryKey = (options: Options<GetAllTemplateDocumentsStatusData>) => createQueryKey('getAllTemplateDocumentsStatus', options);

/**
 * Get status of all template documents for a license type
 * Returns the status of all template document types for a specific license type (whether they exist or not)
 */
export const getAllTemplateDocumentsStatusOptions = (options: Options<GetAllTemplateDocumentsStatusData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAllTemplateDocumentsStatus({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAllTemplateDocumentsStatusQueryKey(options)
    });
};

/**
 * Delete a template document for a license type
 * Soft deletes a template document from the system for a specific license type
 */
export const deleteTemplateDocumentEndpointMutation = (options?: Partial<Options<DeleteTemplateDocumentEndpointData>>): UseMutationOptions<DeleteTemplateDocumentEndpointResponse, DeleteTemplateDocumentEndpointError, Options<DeleteTemplateDocumentEndpointData>> => {
    const mutationOptions: UseMutationOptions<DeleteTemplateDocumentEndpointResponse, DeleteTemplateDocumentEndpointError, Options<DeleteTemplateDocumentEndpointData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await deleteTemplateDocumentEndpoint({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const createTemplateDocumentEndpointQueryKey = (options: Options<CreateTemplateDocumentEndpointData>) => createQueryKey('createTemplateDocumentEndpoint', options);

/**
 * Create or get a template document for a license type
 * Creates a template document in Google Drive for a specific license type if it doesn't exist, or returns the existing one. If a deleted template exists, will prompt user for action.
 */
export const createTemplateDocumentEndpointOptions = (options: Options<CreateTemplateDocumentEndpointData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createTemplateDocumentEndpoint({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createTemplateDocumentEndpointQueryKey(options)
    });
};

/**
 * Create or get a template document for a license type
 * Creates a template document in Google Drive for a specific license type if it doesn't exist, or returns the existing one. If a deleted template exists, will prompt user for action.
 */
export const createTemplateDocumentEndpointMutation = (options?: Partial<Options<CreateTemplateDocumentEndpointData>>): UseMutationOptions<CreateTemplateDocumentEndpointResponse, CreateTemplateDocumentEndpointError, Options<CreateTemplateDocumentEndpointData>> => {
    const mutationOptions: UseMutationOptions<CreateTemplateDocumentEndpointResponse, CreateTemplateDocumentEndpointError, Options<CreateTemplateDocumentEndpointData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createTemplateDocumentEndpoint({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAllJurisdictionDocumentsStatusQueryKey = (options: Options<GetAllJurisdictionDocumentsStatusData>) => createQueryKey('getAllJurisdictionDocumentsStatus', options);

/**
 * Get status of all documents for a jurisdiction license type configuration
 * Returns the status of all document types for a specific jurisdiction license type configuration
 */
export const getAllJurisdictionDocumentsStatusOptions = (options: Options<GetAllJurisdictionDocumentsStatusData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAllJurisdictionDocumentsStatus({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAllJurisdictionDocumentsStatusQueryKey(options)
    });
};

export const getJurisdictionConfigurationQuestionGroupsQueryKey = (options: Options<GetJurisdictionConfigurationQuestionGroupsData>) => createQueryKey('getJurisdictionConfigurationQuestionGroups', options);

/**
 * Get Jurisdiction Configuration Question Groups
 * Get question groups assigned to a jurisdiction license type configuration.
 */
export const getJurisdictionConfigurationQuestionGroupsOptions = (options: Options<GetJurisdictionConfigurationQuestionGroupsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getJurisdictionConfigurationQuestionGroups({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getJurisdictionConfigurationQuestionGroupsQueryKey(options)
    });
};

/**
 * Update Jurisdiction Configuration Question Groups
 * Set question groups for a jurisdiction license type configuration.
 */
export const updateJurisdictionConfigurationQuestionGroupsMutation = (options?: Partial<Options<UpdateJurisdictionConfigurationQuestionGroupsData>>): UseMutationOptions<UpdateJurisdictionConfigurationQuestionGroupsResponse, UpdateJurisdictionConfigurationQuestionGroupsError, Options<UpdateJurisdictionConfigurationQuestionGroupsData>> => {
    const mutationOptions: UseMutationOptions<UpdateJurisdictionConfigurationQuestionGroupsResponse, UpdateJurisdictionConfigurationQuestionGroupsError, Options<UpdateJurisdictionConfigurationQuestionGroupsData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateJurisdictionConfigurationQuestionGroups({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a jurisdiction document
 * Soft deletes a document from a jurisdiction license type configuration
 */
export const deleteJurisdictionDocumentEndpointMutation = (options?: Partial<Options<DeleteJurisdictionDocumentEndpointData>>): UseMutationOptions<DeleteJurisdictionDocumentEndpointResponse, DeleteJurisdictionDocumentEndpointError, Options<DeleteJurisdictionDocumentEndpointData>> => {
    const mutationOptions: UseMutationOptions<DeleteJurisdictionDocumentEndpointResponse, DeleteJurisdictionDocumentEndpointError, Options<DeleteJurisdictionDocumentEndpointData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await deleteJurisdictionDocumentEndpoint({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const createJurisdictionDocumentEndpointQueryKey = (options: Options<CreateJurisdictionDocumentEndpointData>) => createQueryKey('createJurisdictionDocumentEndpoint', options);

/**
 * Create a document for a jurisdiction license type configuration
 * Creates a document entry for a jurisdiction license type configuration. For now, uses a placeholder document ID.
 */
export const createJurisdictionDocumentEndpointOptions = (options: Options<CreateJurisdictionDocumentEndpointData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createJurisdictionDocumentEndpoint({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createJurisdictionDocumentEndpointQueryKey(options)
    });
};

/**
 * Create a document for a jurisdiction license type configuration
 * Creates a document entry for a jurisdiction license type configuration. For now, uses a placeholder document ID.
 */
export const createJurisdictionDocumentEndpointMutation = (options?: Partial<Options<CreateJurisdictionDocumentEndpointData>>): UseMutationOptions<CreateJurisdictionDocumentEndpointResponse, CreateJurisdictionDocumentEndpointError, Options<CreateJurisdictionDocumentEndpointData>> => {
    const mutationOptions: UseMutationOptions<CreateJurisdictionDocumentEndpointResponse, CreateJurisdictionDocumentEndpointError, Options<CreateJurisdictionDocumentEndpointData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createJurisdictionDocumentEndpoint({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getQuestionGroupsOperatorLicenseTypesLicenseTypeIdQuestionGroupsGetQueryKey = (options: Options<GetQuestionGroupsOperatorLicenseTypesLicenseTypeIdQuestionGroupsGetData>) => createQueryKey('getQuestionGroupsOperatorLicenseTypesLicenseTypeIdQuestionGroupsGet', options);

/**
 * Get Question Groups
 * Get all question groups for a license type and question type (active and inactive).
 */
export const getQuestionGroupsOperatorLicenseTypesLicenseTypeIdQuestionGroupsGetOptions = (options: Options<GetQuestionGroupsOperatorLicenseTypesLicenseTypeIdQuestionGroupsGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getQuestionGroupsOperatorLicenseTypesLicenseTypeIdQuestionGroupsGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getQuestionGroupsOperatorLicenseTypesLicenseTypeIdQuestionGroupsGetQueryKey(options)
    });
};

export const createQuestionGroupOperatorLicenseTypesLicenseTypeIdQuestionGroupsPostQueryKey = (options: Options<CreateQuestionGroupOperatorLicenseTypesLicenseTypeIdQuestionGroupsPostData>) => createQueryKey('createQuestionGroupOperatorLicenseTypesLicenseTypeIdQuestionGroupsPost', options);

/**
 * Create Question Group
 * Create a new question group.
 */
export const createQuestionGroupOperatorLicenseTypesLicenseTypeIdQuestionGroupsPostOptions = (options: Options<CreateQuestionGroupOperatorLicenseTypesLicenseTypeIdQuestionGroupsPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createQuestionGroupOperatorLicenseTypesLicenseTypeIdQuestionGroupsPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createQuestionGroupOperatorLicenseTypesLicenseTypeIdQuestionGroupsPostQueryKey(options)
    });
};

/**
 * Create Question Group
 * Create a new question group.
 */
export const createQuestionGroupOperatorLicenseTypesLicenseTypeIdQuestionGroupsPostMutation = (options?: Partial<Options<CreateQuestionGroupOperatorLicenseTypesLicenseTypeIdQuestionGroupsPostData>>): UseMutationOptions<CreateQuestionGroupOperatorLicenseTypesLicenseTypeIdQuestionGroupsPostResponse, CreateQuestionGroupOperatorLicenseTypesLicenseTypeIdQuestionGroupsPostError, Options<CreateQuestionGroupOperatorLicenseTypesLicenseTypeIdQuestionGroupsPostData>> => {
    const mutationOptions: UseMutationOptions<CreateQuestionGroupOperatorLicenseTypesLicenseTypeIdQuestionGroupsPostResponse, CreateQuestionGroupOperatorLicenseTypesLicenseTypeIdQuestionGroupsPostError, Options<CreateQuestionGroupOperatorLicenseTypesLicenseTypeIdQuestionGroupsPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createQuestionGroupOperatorLicenseTypesLicenseTypeIdQuestionGroupsPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Question Group
 * Soft delete a question group.
 */
export const deleteQuestionGroupOperatorQuestionGroupsGroupIdDeleteMutation = (options?: Partial<Options<DeleteQuestionGroupOperatorQuestionGroupsGroupIdDeleteData>>): UseMutationOptions<DeleteQuestionGroupOperatorQuestionGroupsGroupIdDeleteResponse, DeleteQuestionGroupOperatorQuestionGroupsGroupIdDeleteError, Options<DeleteQuestionGroupOperatorQuestionGroupsGroupIdDeleteData>> => {
    const mutationOptions: UseMutationOptions<DeleteQuestionGroupOperatorQuestionGroupsGroupIdDeleteResponse, DeleteQuestionGroupOperatorQuestionGroupsGroupIdDeleteError, Options<DeleteQuestionGroupOperatorQuestionGroupsGroupIdDeleteData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await deleteQuestionGroupOperatorQuestionGroupsGroupIdDelete({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Question Group
 * Update a question group (name and/or deleted_at).
 */
export const updateQuestionGroupOperatorQuestionGroupsGroupIdPatchMutation = (options?: Partial<Options<UpdateQuestionGroupOperatorQuestionGroupsGroupIdPatchData>>): UseMutationOptions<UpdateQuestionGroupOperatorQuestionGroupsGroupIdPatchResponse, UpdateQuestionGroupOperatorQuestionGroupsGroupIdPatchError, Options<UpdateQuestionGroupOperatorQuestionGroupsGroupIdPatchData>> => {
    const mutationOptions: UseMutationOptions<UpdateQuestionGroupOperatorQuestionGroupsGroupIdPatchResponse, UpdateQuestionGroupOperatorQuestionGroupsGroupIdPatchError, Options<UpdateQuestionGroupOperatorQuestionGroupsGroupIdPatchData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateQuestionGroupOperatorQuestionGroupsGroupIdPatch({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getQuestionGroupJurisdictionsQueryKey = (options: Options<GetQuestionGroupJurisdictionsData>) => createQueryKey('getQuestionGroupJurisdictions', options);

/**
 * Get Question Group Jurisdictions
 * Get jurisdictions that can use a question group, flagging the assigned ones.
 */
export const getQuestionGroupJurisdictionsOptions = (options: Options<GetQuestionGroupJurisdictionsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getQuestionGroupJurisdictions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getQuestionGroupJurisdictionsQueryKey(options)
    });
};

/**
 * Update Question Group Jurisdictions
 * Set which jurisdictions have a question group assigned.
 */
export const updateQuestionGroupJurisdictionsMutation = (options?: Partial<Options<UpdateQuestionGroupJurisdictionsData>>): UseMutationOptions<UpdateQuestionGroupJurisdictionsResponse, UpdateQuestionGroupJurisdictionsError, Options<UpdateQuestionGroupJurisdictionsData>> => {
    const mutationOptions: UseMutationOptions<UpdateQuestionGroupJurisdictionsResponse, UpdateQuestionGroupJurisdictionsError, Options<UpdateQuestionGroupJurisdictionsData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateQuestionGroupJurisdictions({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getOperatorLicenseFeeAnalysisQueryKey = (options?: Options<GetOperatorLicenseFeeAnalysisData>) => createQueryKey('getOperatorLicenseFeeAnalysis', options);

/**
 * Get Operator License Fee Analysis
 * Price-point registration counts and collected fees for the license tab.
 */
export const getOperatorLicenseFeeAnalysisOptions = (options?: Options<GetOperatorLicenseFeeAnalysisData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOperatorLicenseFeeAnalysis({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOperatorLicenseFeeAnalysisQueryKey(options)
    });
};

export const getOperatorRevenueAuditQueryKey = (options?: Options<GetOperatorRevenueAuditData>) => createQueryKey('getOperatorRevenueAudit', options);

/**
 * Get Operator Revenue Audit
 * Return live settled collections and contractual splits for finance audit.
 */
export const getOperatorRevenueAuditOptions = (options?: Options<GetOperatorRevenueAuditData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOperatorRevenueAudit({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOperatorRevenueAuditQueryKey(options)
    });
};

export const getOperatorRevenueAuditStripeCashQueryKey = (options?: Options<GetOperatorRevenueAuditStripeCashData>) => createQueryKey('getOperatorRevenueAuditStripeCash', options);

/**
 * Get Operator Revenue Audit Stripe Cash
 * Return current Stripe settlement and payout timing.
 */
export const getOperatorRevenueAuditStripeCashOptions = (options?: Options<GetOperatorRevenueAuditStripeCashData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOperatorRevenueAuditStripeCash({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOperatorRevenueAuditStripeCashQueryKey(options)
    });
};

export const getOperatorPortalKpisQueryKey = (options?: Options<GetOperatorPortalKpisData>) => createQueryKey('getOperatorPortalKpis', options);

/**
 * Get Operator Portal Kpis
 * Period-comparison KPI tiles for the operator overview.
 */
export const getOperatorPortalKpisOptions = (options?: Options<GetOperatorPortalKpisData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOperatorPortalKpis({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOperatorPortalKpisQueryKey(options)
    });
};

export const getOperatorPortalPaymentPeriodsQueryKey = (options?: Options<GetOperatorPortalPaymentPeriodsData>) => createQueryKey('getOperatorPortalPaymentPeriods', options);

/**
 * Get Operator Portal Payment Periods
 * Four periods of received, new due, and end-of-period outstanding by rail.
 */
export const getOperatorPortalPaymentPeriodsOptions = (options?: Options<GetOperatorPortalPaymentPeriodsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOperatorPortalPaymentPeriods({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOperatorPortalPaymentPeriodsQueryKey(options)
    });
};

export const getOperatorPortalTrendsQueryKey = (options?: Options<GetOperatorPortalTrendsData>) => createQueryKey('getOperatorPortalTrends', options);

/**
 * Get Operator Portal Trends
 * Time-series for the operator portal overview (historic trends).
 */
export const getOperatorPortalTrendsOptions = (options?: Options<GetOperatorPortalTrendsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOperatorPortalTrends({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOperatorPortalTrendsQueryKey(options)
    });
};

export const getOperatorSystemUsageQueryKey = (options?: Options<GetOperatorSystemUsageData>) => createQueryKey('getOperatorSystemUsage', options);

/**
 * Get Operator System Usage
 * Comparison roster and charts reconstructed from nightly usage snapshots.
 */
export const getOperatorSystemUsageOptions = (options?: Options<GetOperatorSystemUsageData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOperatorSystemUsage({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOperatorSystemUsageQueryKey(options)
    });
};

export const getOperatorSystemUsageDetailQueryKey = (options: Options<GetOperatorSystemUsageDetailData>) => createQueryKey('getOperatorSystemUsageDetail', options);

/**
 * Get Operator System Usage Detail
 * Weekly and daily usage for one login identity.
 */
export const getOperatorSystemUsageDetailOptions = (options: Options<GetOperatorSystemUsageDetailData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOperatorSystemUsageDetail({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOperatorSystemUsageDetailQueryKey(options)
    });
};

export const getOperatorPortalForeclosureVsRegistrationsQueryKey = (options?: Options<GetOperatorPortalForeclosureVsRegistrationsData>) => createQueryKey('getOperatorPortalForeclosureVsRegistrations', options);

/**
 * Get Operator Portal Foreclosure Vs Registrations
 * Foreclosure cases by LIS/NOD date vs new registrations for active jurisdictions.
 */
export const getOperatorPortalForeclosureVsRegistrationsOptions = (options?: Options<GetOperatorPortalForeclosureVsRegistrationsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOperatorPortalForeclosureVsRegistrations({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOperatorPortalForeclosureVsRegistrationsQueryKey(options)
    });
};

export const getOperatorPortalNotifiedRenewalsQueryKey = (options?: Options<GetOperatorPortalNotifiedRenewalsData>) => createQueryKey('getOperatorPortalNotifiedRenewals', options);

/**
 * Get Operator Portal Notified Renewals
 * Renewals completed after a matching needs-attention notification.
 */
export const getOperatorPortalNotifiedRenewalsOptions = (options?: Options<GetOperatorPortalNotifiedRenewalsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOperatorPortalNotifiedRenewals({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOperatorPortalNotifiedRenewalsQueryKey(options)
    });
};

export const getOperatorPortalNeedsAttentionComplianceQueryKey = (options?: Options<GetOperatorPortalNeedsAttentionComplianceData>) => createQueryKey('getOperatorPortalNeedsAttentionCompliance', options);

/**
 * Get Operator Portal Needs Attention Compliance
 * Weekly paid and deregistered outcomes after needs-attention mail.
 */
export const getOperatorPortalNeedsAttentionComplianceOptions = (options?: Options<GetOperatorPortalNeedsAttentionComplianceData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOperatorPortalNeedsAttentionCompliance({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOperatorPortalNeedsAttentionComplianceQueryKey(options)
    });
};

export const getOperatorPortalComplianceTrendsQueryKey = (options?: Options<GetOperatorPortalComplianceTrendsData>) => createQueryKey('getOperatorPortalComplianceTrends', options);

/**
 * Get Operator Portal Compliance Trends
 * Registration and renewal compliance rates over time for the operator overview.
 */
export const getOperatorPortalComplianceTrendsOptions = (options?: Options<GetOperatorPortalComplianceTrendsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOperatorPortalComplianceTrends({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOperatorPortalComplianceTrendsQueryKey(options)
    });
};

export const streamOperatorPortalTrendRegistrationsQueryKey = (options?: Options<StreamOperatorPortalTrendRegistrationsData>) => createQueryKey('streamOperatorPortalTrendRegistrations', options);

/**
 * Stream Operator Portal Trend Registrations
 */
export const streamOperatorPortalTrendRegistrationsOptions = (options?: Options<StreamOperatorPortalTrendRegistrationsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await streamOperatorPortalTrendRegistrations({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: streamOperatorPortalTrendRegistrationsQueryKey(options)
    });
};

export const streamOperatorPortalTrendInspectionsQueryKey = (options?: Options<StreamOperatorPortalTrendInspectionsData>) => createQueryKey('streamOperatorPortalTrendInspections', options);

/**
 * Stream Operator Portal Trend Inspections
 */
export const streamOperatorPortalTrendInspectionsOptions = (options?: Options<StreamOperatorPortalTrendInspectionsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await streamOperatorPortalTrendInspections({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: streamOperatorPortalTrendInspectionsQueryKey(options)
    });
};

export const streamOperatorPortalTrendPaymentsQueryKey = (options?: Options<StreamOperatorPortalTrendPaymentsData>) => createQueryKey('streamOperatorPortalTrendPayments', options);

/**
 * Stream Operator Portal Trend Payments
 */
export const streamOperatorPortalTrendPaymentsOptions = (options?: Options<StreamOperatorPortalTrendPaymentsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await streamOperatorPortalTrendPayments({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: streamOperatorPortalTrendPaymentsQueryKey(options)
    });
};

export const streamOperatorPortalTrendInspectionFeesQueryKey = (options?: Options<StreamOperatorPortalTrendInspectionFeesData>) => createQueryKey('streamOperatorPortalTrendInspectionFees', options);

/**
 * Stream Operator Portal Trend Inspection Fees
 */
export const streamOperatorPortalTrendInspectionFeesOptions = (options?: Options<StreamOperatorPortalTrendInspectionFeesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await streamOperatorPortalTrendInspectionFees({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: streamOperatorPortalTrendInspectionFeesQueryKey(options)
    });
};

export const streamOperatorPortalTrendRefundsQueryKey = (options?: Options<StreamOperatorPortalTrendRefundsData>) => createQueryKey('streamOperatorPortalTrendRefunds', options);

/**
 * Stream Operator Portal Trend Refunds
 */
export const streamOperatorPortalTrendRefundsOptions = (options?: Options<StreamOperatorPortalTrendRefundsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await streamOperatorPortalTrendRefunds({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: streamOperatorPortalTrendRefundsQueryKey(options)
    });
};

export const streamOperatorPortalTrendRemittanceQueryKey = (options?: Options<StreamOperatorPortalTrendRemittanceData>) => createQueryKey('streamOperatorPortalTrendRemittance', options);

/**
 * Stream Operator Portal Trend Remittance
 */
export const streamOperatorPortalTrendRemittanceOptions = (options?: Options<StreamOperatorPortalTrendRemittanceData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await streamOperatorPortalTrendRemittance({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: streamOperatorPortalTrendRemittanceQueryKey(options)
    });
};

export const streamOperatorPortalForecastQueryKey = (options?: Options<StreamOperatorPortalForecastData>) => createQueryKey('streamOperatorPortalForecast', options);

/**
 * Stream Operator Portal Forecast
 */
export const streamOperatorPortalForecastOptions = (options?: Options<StreamOperatorPortalForecastData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await streamOperatorPortalForecast({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: streamOperatorPortalForecastQueryKey(options)
    });
};

export const getOperatorPortalPaymentLagQueryKey = (options?: Options<GetOperatorPortalPaymentLagData>) => createQueryKey('getOperatorPortalPaymentLag', options);

/**
 * Get Operator Portal Payment Lag
 */
export const getOperatorPortalPaymentLagOptions = (options?: Options<GetOperatorPortalPaymentLagData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOperatorPortalPaymentLag({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOperatorPortalPaymentLagQueryKey(options)
    });
};

export const getOperatorPortalActivityQueryKey = (options?: Options<GetOperatorPortalActivityData>) => createQueryKey('getOperatorPortalActivity', options);

/**
 * Get Operator Portal Activity
 * Recent activity for the operator portal overview.
 */
export const getOperatorPortalActivityOptions = (options?: Options<GetOperatorPortalActivityData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOperatorPortalActivity({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOperatorPortalActivityQueryKey(options)
    });
};

export const getOperatorHubspotScorecardQueryKey = (options?: Options<GetOperatorHubspotScorecardData>) => createQueryKey('getOperatorHubspotScorecard', options);

/**
 * Get Operator Hubspot Scorecard
 * HubSpot CRM counts for the operator HubSpot and Leadership dashboards.
 */
export const getOperatorHubspotScorecardOptions = (options?: Options<GetOperatorHubspotScorecardData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOperatorHubspotScorecard({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOperatorHubspotScorecardQueryKey(options)
    });
};

export const getOperatorHubspotClosedDealsByWeekQueryKey = (options?: Options<GetOperatorHubspotClosedDealsByWeekData>) => createQueryKey('getOperatorHubspotClosedDealsByWeek', options);

/**
 * Get Operator Hubspot Closed Deals By Week
 * Closed-won HubSpot deals bucketed by Sunday-start week.
 */
export const getOperatorHubspotClosedDealsByWeekOptions = (options?: Options<GetOperatorHubspotClosedDealsByWeekData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOperatorHubspotClosedDealsByWeek({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOperatorHubspotClosedDealsByWeekQueryKey(options)
    });
};

export const getOperatorLeadershipRenewalComplianceQueryKey = (options?: Options<GetOperatorLeadershipRenewalComplianceData>) => createQueryKey('getOperatorLeadershipRenewalCompliance', options);

/**
 * Get Operator Leadership Renewal Compliance
 * License-grain compliant and <30-days-overdue rates as of Pacific today.
 */
export const getOperatorLeadershipRenewalComplianceOptions = (options?: Options<GetOperatorLeadershipRenewalComplianceData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOperatorLeadershipRenewalCompliance({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOperatorLeadershipRenewalComplianceQueryKey(options)
    });
};

export const getOperatorLeadershipReceivablesOverdueQueryKey = (options?: Options<GetOperatorLeadershipReceivablesOverdueData>) => createQueryKey('getOperatorLeadershipReceivablesOverdue', options);

/**
 * Get Operator Leadership Receivables Overdue
 * Open checks and invoices awaiting payment for more than 30 days.
 */
export const getOperatorLeadershipReceivablesOverdueOptions = (options?: Options<GetOperatorLeadershipReceivablesOverdueData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOperatorLeadershipReceivablesOverdue({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOperatorLeadershipReceivablesOverdueQueryKey(options)
    });
};

export const getOperatorLeadershipRegistrationsRenewalsInitiatedQueryKey = (options?: Options<GetOperatorLeadershipRegistrationsRenewalsInitiatedData>) => createQueryKey('getOperatorLeadershipRegistrationsRenewalsInitiated', options);

/**
 * Get Operator Leadership Registrations Renewals Initiated
 * Registration and renewal periods by first genuine payment initiation.
 */
export const getOperatorLeadershipRegistrationsRenewalsInitiatedOptions = (options?: Options<GetOperatorLeadershipRegistrationsRenewalsInitiatedData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOperatorLeadershipRegistrationsRenewalsInitiated({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOperatorLeadershipRegistrationsRenewalsInitiatedQueryKey(options)
    });
};

export const getOperatorLeadershipHeraRemittanceQueryKey = (options?: Options<GetOperatorLeadershipHeraRemittanceData>) => createQueryKey('getOperatorLeadershipHeraRemittance', options);

/**
 * Get Operator Leadership Hera Remittance
 * HERA remittance dollars for this week, last week, this month, and last month.
 */
export const getOperatorLeadershipHeraRemittanceOptions = (options?: Options<GetOperatorLeadershipHeraRemittanceData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOperatorLeadershipHeraRemittance({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOperatorLeadershipHeraRemittanceQueryKey(options)
    });
};

export const getInfoSystemJurisdictionSummariesQueryKey = (options?: Options<GetInfoSystemJurisdictionSummariesData>) => createQueryKey('getInfoSystemJurisdictionSummaries', options);

/**
 * Get Info System Jurisdiction Summaries Endpoint
 * List jurisdictions with license types, FIPS/TIGER codes, and active/inactive counts.
 */
export const getInfoSystemJurisdictionSummariesOptions = (options?: Options<GetInfoSystemJurisdictionSummariesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getInfoSystemJurisdictionSummaries({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getInfoSystemJurisdictionSummariesQueryKey(options)
    });
};

export const getInfoSystemLicensesQueryKey = (options: Options<GetInfoSystemLicensesData>) => createQueryKey('getInfoSystemLicenses', options);

/**
 * Get Info System Licenses Endpoint
 * List lightweight license rows for one jurisdiction and license type.
 */
export const getInfoSystemLicensesOptions = (options: Options<GetInfoSystemLicensesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getInfoSystemLicenses({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getInfoSystemLicensesQueryKey(options)
    });
};

export const getAttomTaxAssessorStatusQueryKey = (options?: Options<GetAttomTaxAssessorStatusData>) => createQueryKey('getAttomTaxAssessorStatus', options);

/**
 * Get Attom Tax Assessor Status Endpoint
 * Live Athena diagnostics for incremental ATTOM tax_assessor extract partitions.
 */
export const getAttomTaxAssessorStatusOptions = (options?: Options<GetAttomTaxAssessorStatusData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAttomTaxAssessorStatus({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAttomTaxAssessorStatusQueryKey(options)
    });
};

export const getAttomIntegrationStatusQueryKey = (options?: Options<GetAttomIntegrationStatusData>) => createQueryKey('getAttomIntegrationStatus', options);

/**
 * Get Attom Integration Status Endpoint
 * Fast ATTOM/Athena integration status for operator Setup.
 */
export const getAttomIntegrationStatusOptions = (options?: Options<GetAttomIntegrationStatusData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAttomIntegrationStatus({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAttomIntegrationStatusQueryKey(options)
    });
};

export const getNextForeclosureLenderPromptQueryKey = (options?: Options<GetNextForeclosureLenderPromptData>) => createQueryKey('getNextForeclosureLenderPrompt', options);

/**
 * Get Next Foreclosure Lender Prompt Endpoint
 * Return the next lender prompts, including a buffer of successors.
 */
export const getNextForeclosureLenderPromptOptions = (options?: Options<GetNextForeclosureLenderPromptData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getNextForeclosureLenderPrompt({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getNextForeclosureLenderPromptQueryKey(options)
    });
};

export const submitForeclosureInstigatorLabelQueryKey = (options: Options<SubmitForeclosureInstigatorLabelData>) => createQueryKey('submitForeclosureInstigatorLabel', options);

/**
 * Submit Foreclosure Instigator Label Endpoint
 * Append one lender/case answer and return its weighted consensus.
 */
export const submitForeclosureInstigatorLabelOptions = (options: Options<SubmitForeclosureInstigatorLabelData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await submitForeclosureInstigatorLabel({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: submitForeclosureInstigatorLabelQueryKey(options)
    });
};

/**
 * Submit Foreclosure Instigator Label Endpoint
 * Append one lender/case answer and return its weighted consensus.
 */
export const submitForeclosureInstigatorLabelMutation = (options?: Partial<Options<SubmitForeclosureInstigatorLabelData>>): UseMutationOptions<SubmitForeclosureInstigatorLabelResponse, SubmitForeclosureInstigatorLabelError, Options<SubmitForeclosureInstigatorLabelData>> => {
    const mutationOptions: UseMutationOptions<SubmitForeclosureInstigatorLabelResponse, SubmitForeclosureInstigatorLabelError, Options<SubmitForeclosureInstigatorLabelData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await submitForeclosureInstigatorLabel({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const undoForeclosureInstigatorLabelQueryKey = (options?: Options<UndoForeclosureInstigatorLabelData>) => createQueryKey('undoForeclosureInstigatorLabel', options);

/**
 * Undo Foreclosure Instigator Label Endpoint
 * Retract this operator's latest effective answer for the Back action.
 */
export const undoForeclosureInstigatorLabelOptions = (options?: Options<UndoForeclosureInstigatorLabelData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await undoForeclosureInstigatorLabel({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: undoForeclosureInstigatorLabelQueryKey(options)
    });
};

/**
 * Undo Foreclosure Instigator Label Endpoint
 * Retract this operator's latest effective answer for the Back action.
 */
export const undoForeclosureInstigatorLabelMutation = (options?: Partial<Options<UndoForeclosureInstigatorLabelData>>): UseMutationOptions<UndoForeclosureInstigatorLabelResponse, DefaultError, Options<UndoForeclosureInstigatorLabelData>> => {
    const mutationOptions: UseMutationOptions<UndoForeclosureInstigatorLabelResponse, DefaultError, Options<UndoForeclosureInstigatorLabelData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await undoForeclosureInstigatorLabel({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getForeclosureInstigatorMetricsQueryKey = (options?: Options<GetForeclosureInstigatorMetricsData>) => createQueryKey('getForeclosureInstigatorMetrics', options);

/**
 * Get Foreclosure Instigator Metrics Endpoint
 * Aggregate label quality for operator admins.
 */
export const getForeclosureInstigatorMetricsOptions = (options?: Options<GetForeclosureInstigatorMetricsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getForeclosureInstigatorMetrics({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getForeclosureInstigatorMetricsQueryKey(options)
    });
};

/**
 * Set Foreclosure Instigator Gold Endpoint
 * Create or update a hidden-gold lender prompt.
 */
export const setForeclosureInstigatorGoldMutation = (options?: Partial<Options<SetForeclosureInstigatorGoldData>>): UseMutationOptions<SetForeclosureInstigatorGoldResponse, SetForeclosureInstigatorGoldError, Options<SetForeclosureInstigatorGoldData>> => {
    const mutationOptions: UseMutationOptions<SetForeclosureInstigatorGoldResponse, SetForeclosureInstigatorGoldError, Options<SetForeclosureInstigatorGoldData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await setForeclosureInstigatorGold({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Adjudicate Foreclosure Instigator Endpoint
 * Publish an expert lender-level or case-level decision.
 */
export const adjudicateForeclosureInstigatorMutation = (options?: Partial<Options<AdjudicateForeclosureInstigatorData>>): UseMutationOptions<AdjudicateForeclosureInstigatorResponse, AdjudicateForeclosureInstigatorError, Options<AdjudicateForeclosureInstigatorData>> => {
    const mutationOptions: UseMutationOptions<AdjudicateForeclosureInstigatorResponse, AdjudicateForeclosureInstigatorError, Options<AdjudicateForeclosureInstigatorData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await adjudicateForeclosureInstigator({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getOperatorForeclosureCasesQueryKey = (options?: Options<GetOperatorForeclosureCasesData>) => createQueryKey('getOperatorForeclosureCases', options);

/**
 * Get Operator Foreclosure Cases Endpoint
 * List indexed ATTOM foreclosure cases, one page at a time.
 *
 * Rows carry license linkage and live-link settings. For unfiltered requests,
 * linkage is limited to jurisdictions represented on the current page.
 * ``total_count`` is the number of rows matching the current filters, not a
 * truncated cap.
 */
export const getOperatorForeclosureCasesOptions = (options?: Options<GetOperatorForeclosureCasesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOperatorForeclosureCases({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOperatorForeclosureCasesQueryKey(options)
    });
};

export const getOperatorForeclosureCasesInfiniteQueryKey = (options?: Options<GetOperatorForeclosureCasesData>): QueryKey<Options<GetOperatorForeclosureCasesData>> => createQueryKey('getOperatorForeclosureCases', options, true);

/**
 * Get Operator Foreclosure Cases Endpoint
 * List indexed ATTOM foreclosure cases, one page at a time.
 *
 * Rows carry license linkage and live-link settings. For unfiltered requests,
 * linkage is limited to jurisdictions represented on the current page.
 * ``total_count`` is the number of rows matching the current filters, not a
 * truncated cap.
 */
export const getOperatorForeclosureCasesInfiniteOptions = (options?: Options<GetOperatorForeclosureCasesData>) => {
    return infiniteQueryOptions<GetOperatorForeclosureCasesResponse, GetOperatorForeclosureCasesError, InfiniteData<GetOperatorForeclosureCasesResponse>, QueryKey<Options<GetOperatorForeclosureCasesData>>, number | Pick<QueryKey<Options<GetOperatorForeclosureCasesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetOperatorForeclosureCasesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getOperatorForeclosureCases({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOperatorForeclosureCasesInfiniteQueryKey(options)
    });
};

export const getOperatorForeclosureCaseFilterValuesQueryKey = (options: Options<GetOperatorForeclosureCaseFilterValuesData>) => createQueryKey('getOperatorForeclosureCaseFilterValues', options);

/**
 * Get Operator Foreclosure Case Filter Values Endpoint
 * Distinct display strings for one Cases-table filter popover.
 */
export const getOperatorForeclosureCaseFilterValuesOptions = (options: Options<GetOperatorForeclosureCaseFilterValuesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOperatorForeclosureCaseFilterValues({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOperatorForeclosureCaseFilterValuesQueryKey(options)
    });
};

export const getOperatorForeclosureCaseMapPinsQueryKey = (options?: Options<GetOperatorForeclosureCaseMapPinsData>) => createQueryKey('getOperatorForeclosureCaseMapPins', options);

/**
 * Get Operator Foreclosure Case Map Pins Endpoint
 * Pins or clusters for cases matching the current list filters.
 */
export const getOperatorForeclosureCaseMapPinsOptions = (options?: Options<GetOperatorForeclosureCaseMapPinsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOperatorForeclosureCaseMapPins({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOperatorForeclosureCaseMapPinsQueryKey(options)
    });
};

export const getOperatorForeclosureReviewStatusSummaryQueryKey = (options?: Options<GetOperatorForeclosureReviewStatusSummaryData>) => createQueryKey('getOperatorForeclosureReviewStatusSummary', options);

/**
 * Get Operator Foreclosure Review Status Summary Endpoint
 * Jurisdiction counts by review status for the Cases overview charts.
 */
export const getOperatorForeclosureReviewStatusSummaryOptions = (options?: Options<GetOperatorForeclosureReviewStatusSummaryData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOperatorForeclosureReviewStatusSummary({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOperatorForeclosureReviewStatusSummaryQueryKey(options)
    });
};

export const getOperatorForeclosureCaseChartDataQueryKey = (options?: Options<GetOperatorForeclosureCaseChartDataData>) => createQueryKey('getOperatorForeclosureCaseChartData', options);

/**
 * Get Operator Foreclosure Case Chart Data Endpoint
 * Start-date counts and review-status activity for Cases insight charts.
 *
 * Omit ``jurisdiction_ids`` for the same universe as the unfiltered case list.
 */
export const getOperatorForeclosureCaseChartDataOptions = (options?: Options<GetOperatorForeclosureCaseChartDataData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOperatorForeclosureCaseChartData({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOperatorForeclosureCaseChartDataQueryKey(options)
    });
};

export const suggestOperatorForeclosureCasePartiesQueryKey = (options: Options<SuggestOperatorForeclosureCasePartiesData>) => createQueryKey('suggestOperatorForeclosureCaseParties', options);

/**
 * Suggest Operator Foreclosure Case Parties Endpoint
 * Explicitly recompute OMT/AMS/registrant suggestions for one case.
 */
export const suggestOperatorForeclosureCasePartiesOptions = (options: Options<SuggestOperatorForeclosureCasePartiesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await suggestOperatorForeclosureCaseParties({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: suggestOperatorForeclosureCasePartiesQueryKey(options)
    });
};

/**
 * Suggest Operator Foreclosure Case Parties Endpoint
 * Explicitly recompute OMT/AMS/registrant suggestions for one case.
 */
export const suggestOperatorForeclosureCasePartiesMutation = (options?: Partial<Options<SuggestOperatorForeclosureCasePartiesData>>): UseMutationOptions<SuggestOperatorForeclosureCasePartiesResponse, SuggestOperatorForeclosureCasePartiesError, Options<SuggestOperatorForeclosureCasePartiesData>> => {
    const mutationOptions: UseMutationOptions<SuggestOperatorForeclosureCasePartiesResponse, SuggestOperatorForeclosureCasePartiesError, Options<SuggestOperatorForeclosureCasePartiesData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await suggestOperatorForeclosureCaseParties({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const suggestOperatorForeclosureCaseReviewQueryKey = (options: Options<SuggestOperatorForeclosureCaseReviewData>) => createQueryKey('suggestOperatorForeclosureCaseReview', options);

/**
 * Suggest Operator Foreclosure Case Review Endpoint
 * Explicitly recompute review status/comment suggestions for one case.
 */
export const suggestOperatorForeclosureCaseReviewOptions = (options: Options<SuggestOperatorForeclosureCaseReviewData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await suggestOperatorForeclosureCaseReview({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: suggestOperatorForeclosureCaseReviewQueryKey(options)
    });
};

/**
 * Suggest Operator Foreclosure Case Review Endpoint
 * Explicitly recompute review status/comment suggestions for one case.
 */
export const suggestOperatorForeclosureCaseReviewMutation = (options?: Partial<Options<SuggestOperatorForeclosureCaseReviewData>>): UseMutationOptions<SuggestOperatorForeclosureCaseReviewResponse, SuggestOperatorForeclosureCaseReviewError, Options<SuggestOperatorForeclosureCaseReviewData>> => {
    const mutationOptions: UseMutationOptions<SuggestOperatorForeclosureCaseReviewResponse, SuggestOperatorForeclosureCaseReviewError, Options<SuggestOperatorForeclosureCaseReviewData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await suggestOperatorForeclosureCaseReview({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getOperatorForeclosureLicenseAssignmentCandidatesQueryKey = (options: Options<GetOperatorForeclosureLicenseAssignmentCandidatesData>) => createQueryKey('getOperatorForeclosureLicenseAssignmentCandidates', options);

/**
 * Get Operator Foreclosure License Assignment Candidates Endpoint
 * List exact address/APN license matches for selected jurisdictions.
 */
export const getOperatorForeclosureLicenseAssignmentCandidatesOptions = (options: Options<GetOperatorForeclosureLicenseAssignmentCandidatesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOperatorForeclosureLicenseAssignmentCandidates({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOperatorForeclosureLicenseAssignmentCandidatesQueryKey(options)
    });
};

export const getOperatorForeclosureLicenseAssignmentCandidatesInfiniteQueryKey = (options: Options<GetOperatorForeclosureLicenseAssignmentCandidatesData>): QueryKey<Options<GetOperatorForeclosureLicenseAssignmentCandidatesData>> => createQueryKey('getOperatorForeclosureLicenseAssignmentCandidates', options, true);

/**
 * Get Operator Foreclosure License Assignment Candidates Endpoint
 * List exact address/APN license matches for selected jurisdictions.
 */
export const getOperatorForeclosureLicenseAssignmentCandidatesInfiniteOptions = (options: Options<GetOperatorForeclosureLicenseAssignmentCandidatesData>) => {
    return infiniteQueryOptions<GetOperatorForeclosureLicenseAssignmentCandidatesResponse, GetOperatorForeclosureLicenseAssignmentCandidatesError, InfiniteData<GetOperatorForeclosureLicenseAssignmentCandidatesResponse>, QueryKey<Options<GetOperatorForeclosureLicenseAssignmentCandidatesData>>, number | Pick<QueryKey<Options<GetOperatorForeclosureLicenseAssignmentCandidatesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetOperatorForeclosureLicenseAssignmentCandidatesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getOperatorForeclosureLicenseAssignmentCandidates({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOperatorForeclosureLicenseAssignmentCandidatesInfiniteQueryKey(options)
    });
};

export const assignOperatorForeclosureLicensesQueryKey = (options: Options<AssignOperatorForeclosureLicensesData>) => createQueryKey('assignOperatorForeclosureLicenses', options);

/**
 * Assign Operator Foreclosure Licenses Endpoint
 * Revalidate and assign selected unique license matches.
 */
export const assignOperatorForeclosureLicensesOptions = (options: Options<AssignOperatorForeclosureLicensesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await assignOperatorForeclosureLicenses({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: assignOperatorForeclosureLicensesQueryKey(options)
    });
};

/**
 * Assign Operator Foreclosure Licenses Endpoint
 * Revalidate and assign selected unique license matches.
 */
export const assignOperatorForeclosureLicensesMutation = (options?: Partial<Options<AssignOperatorForeclosureLicensesData>>): UseMutationOptions<AssignOperatorForeclosureLicensesResponse, AssignOperatorForeclosureLicensesError, Options<AssignOperatorForeclosureLicensesData>> => {
    const mutationOptions: UseMutationOptions<AssignOperatorForeclosureLicensesResponse, AssignOperatorForeclosureLicensesError, Options<AssignOperatorForeclosureLicensesData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await assignOperatorForeclosureLicenses({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getOperatorForeclosureLicenseMatchesQueryKey = (options: Options<GetOperatorForeclosureLicenseMatchesData>) => createQueryKey('getOperatorForeclosureLicenseMatches', options);

/**
 * Get Operator Foreclosure License Matches Endpoint
 * Return the linked license or fuzzy APN/address candidates for a case.
 */
export const getOperatorForeclosureLicenseMatchesOptions = (options: Options<GetOperatorForeclosureLicenseMatchesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOperatorForeclosureLicenseMatches({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOperatorForeclosureLicenseMatchesQueryKey(options)
    });
};

export const linkOperatorForeclosureCaseToLicenseQueryKey = (options: Options<LinkOperatorForeclosureCaseToLicenseData>) => createQueryKey('linkOperatorForeclosureCaseToLicense', options);

/**
 * Link Operator Foreclosure Case To License Endpoint
 * Apply the case number to a selected foreclosure license.
 */
export const linkOperatorForeclosureCaseToLicenseOptions = (options: Options<LinkOperatorForeclosureCaseToLicenseData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await linkOperatorForeclosureCaseToLicense({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: linkOperatorForeclosureCaseToLicenseQueryKey(options)
    });
};

/**
 * Link Operator Foreclosure Case To License Endpoint
 * Apply the case number to a selected foreclosure license.
 */
export const linkOperatorForeclosureCaseToLicenseMutation = (options?: Partial<Options<LinkOperatorForeclosureCaseToLicenseData>>): UseMutationOptions<LinkOperatorForeclosureCaseToLicenseResponse, LinkOperatorForeclosureCaseToLicenseError, Options<LinkOperatorForeclosureCaseToLicenseData>> => {
    const mutationOptions: UseMutationOptions<LinkOperatorForeclosureCaseToLicenseResponse, LinkOperatorForeclosureCaseToLicenseError, Options<LinkOperatorForeclosureCaseToLicenseData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await linkOperatorForeclosureCaseToLicense({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Operator Foreclosure Case Review Endpoint
 * Update reviewed / registration-needed flags for a foreclosure case.
 */
export const updateOperatorForeclosureCaseReviewMutation = (options?: Partial<Options<UpdateOperatorForeclosureCaseReviewData>>): UseMutationOptions<UpdateOperatorForeclosureCaseReviewResponse, UpdateOperatorForeclosureCaseReviewError, Options<UpdateOperatorForeclosureCaseReviewData>> => {
    const mutationOptions: UseMutationOptions<UpdateOperatorForeclosureCaseReviewResponse, UpdateOperatorForeclosureCaseReviewError, Options<UpdateOperatorForeclosureCaseReviewData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateOperatorForeclosureCaseReview({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getOperatorForeclosureCaseReviewHistoryQueryKey = (options: Options<GetOperatorForeclosureCaseReviewHistoryData>) => createQueryKey('getOperatorForeclosureCaseReviewHistory', options);

/**
 * Get Operator Foreclosure Case Review History Endpoint
 * Return newest-first review-status changes for one foreclosure case.
 */
export const getOperatorForeclosureCaseReviewHistoryOptions = (options: Options<GetOperatorForeclosureCaseReviewHistoryData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOperatorForeclosureCaseReviewHistory({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOperatorForeclosureCaseReviewHistoryQueryKey(options)
    });
};

export const preflightOperatorBulkCreateUnregisteredQueryKey = (options: Options<PreflightOperatorBulkCreateUnregisteredData>) => createQueryKey('preflightOperatorBulkCreateUnregistered', options);

/**
 * Preflight Operator Bulk Create Unregistered Endpoint
 * Check which selected foreclosure cases can become unregistered properties.
 */
export const preflightOperatorBulkCreateUnregisteredOptions = (options: Options<PreflightOperatorBulkCreateUnregisteredData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await preflightOperatorBulkCreateUnregistered({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: preflightOperatorBulkCreateUnregisteredQueryKey(options)
    });
};

/**
 * Preflight Operator Bulk Create Unregistered Endpoint
 * Check which selected foreclosure cases can become unregistered properties.
 */
export const preflightOperatorBulkCreateUnregisteredMutation = (options?: Partial<Options<PreflightOperatorBulkCreateUnregisteredData>>): UseMutationOptions<PreflightOperatorBulkCreateUnregisteredResponse, PreflightOperatorBulkCreateUnregisteredError, Options<PreflightOperatorBulkCreateUnregisteredData>> => {
    const mutationOptions: UseMutationOptions<PreflightOperatorBulkCreateUnregisteredResponse, PreflightOperatorBulkCreateUnregisteredError, Options<PreflightOperatorBulkCreateUnregisteredData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await preflightOperatorBulkCreateUnregistered({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const bulkCreateOperatorUnregisteredFromCasesQueryKey = (options: Options<BulkCreateOperatorUnregisteredFromCasesData>) => createQueryKey('bulkCreateOperatorUnregisteredFromCases', options);

/**
 * Bulk Create Operator Unregistered From Cases Endpoint
 * Create unregistered properties for a chunk of foreclosure cases.
 */
export const bulkCreateOperatorUnregisteredFromCasesOptions = (options: Options<BulkCreateOperatorUnregisteredFromCasesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await bulkCreateOperatorUnregisteredFromCases({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: bulkCreateOperatorUnregisteredFromCasesQueryKey(options)
    });
};

/**
 * Bulk Create Operator Unregistered From Cases Endpoint
 * Create unregistered properties for a chunk of foreclosure cases.
 */
export const bulkCreateOperatorUnregisteredFromCasesMutation = (options?: Partial<Options<BulkCreateOperatorUnregisteredFromCasesData>>): UseMutationOptions<BulkCreateOperatorUnregisteredFromCasesResponse, BulkCreateOperatorUnregisteredFromCasesError, Options<BulkCreateOperatorUnregisteredFromCasesData>> => {
    const mutationOptions: UseMutationOptions<BulkCreateOperatorUnregisteredFromCasesResponse, BulkCreateOperatorUnregisteredFromCasesError, Options<BulkCreateOperatorUnregisteredFromCasesData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await bulkCreateOperatorUnregisteredFromCases({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getOperatorForeclosureUnregisteredMatchQueryKey = (options: Options<GetOperatorForeclosureUnregisteredMatchData>) => createQueryKey('getOperatorForeclosureUnregisteredMatch', options);

/**
 * Get Operator Foreclosure Unregistered Match Endpoint
 * Return the case-number attachment or address suggestions for this case.
 */
export const getOperatorForeclosureUnregisteredMatchOptions = (options: Options<GetOperatorForeclosureUnregisteredMatchData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOperatorForeclosureUnregisteredMatch({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOperatorForeclosureUnregisteredMatchQueryKey(options)
    });
};

export const linkOperatorForeclosureCaseToUnregisteredQueryKey = (options: Options<LinkOperatorForeclosureCaseToUnregisteredData>) => createQueryKey('linkOperatorForeclosureCaseToUnregistered', options);

/**
 * Link Operator Foreclosure Case To Unregistered Endpoint
 * Apply the case number to a selected unregistered property.
 */
export const linkOperatorForeclosureCaseToUnregisteredOptions = (options: Options<LinkOperatorForeclosureCaseToUnregisteredData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await linkOperatorForeclosureCaseToUnregistered({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: linkOperatorForeclosureCaseToUnregisteredQueryKey(options)
    });
};

/**
 * Link Operator Foreclosure Case To Unregistered Endpoint
 * Apply the case number to a selected unregistered property.
 */
export const linkOperatorForeclosureCaseToUnregisteredMutation = (options?: Partial<Options<LinkOperatorForeclosureCaseToUnregisteredData>>): UseMutationOptions<LinkOperatorForeclosureCaseToUnregisteredResponse, LinkOperatorForeclosureCaseToUnregisteredError, Options<LinkOperatorForeclosureCaseToUnregisteredData>> => {
    const mutationOptions: UseMutationOptions<LinkOperatorForeclosureCaseToUnregisteredResponse, LinkOperatorForeclosureCaseToUnregisteredError, Options<LinkOperatorForeclosureCaseToUnregisteredData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await linkOperatorForeclosureCaseToUnregistered({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const operatorAddressResolutionLookupQueryKey = (options: Options<OperatorAddressResolutionLookupData>) => createQueryKey('operatorAddressResolutionLookup', options);

/**
 * Operator Address Resolution Lookup Endpoint
 * Resolve an address against the geocoding cache, Geocodio, and Google Maps.
 *
 * Diagnostic lookup for the operator Setup page: shows raw answers from each
 * source (including Geocodio answers the normal pipeline would reject) so the
 * operator can pick or correct the cached resolution.
 */
export const operatorAddressResolutionLookupOptions = (options: Options<OperatorAddressResolutionLookupData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await operatorAddressResolutionLookup({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: operatorAddressResolutionLookupQueryKey(options)
    });
};

/**
 * Operator Address Resolution Lookup Endpoint
 * Resolve an address against the geocoding cache, Geocodio, and Google Maps.
 *
 * Diagnostic lookup for the operator Setup page: shows raw answers from each
 * source (including Geocodio answers the normal pipeline would reject) so the
 * operator can pick or correct the cached resolution.
 */
export const operatorAddressResolutionLookupMutation = (options?: Partial<Options<OperatorAddressResolutionLookupData>>): UseMutationOptions<OperatorAddressResolutionLookupResponse, OperatorAddressResolutionLookupError, Options<OperatorAddressResolutionLookupData>> => {
    const mutationOptions: UseMutationOptions<OperatorAddressResolutionLookupResponse, OperatorAddressResolutionLookupError, Options<OperatorAddressResolutionLookupData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await operatorAddressResolutionLookup({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const operatorAddressResolutionSaveQueryKey = (options: Options<OperatorAddressResolutionSaveData>) => createQueryKey('operatorAddressResolutionSave', options);

/**
 * Operator Address Resolution Save Endpoint
 * Store an operator-chosen resolution in the geocoding cache.
 *
 * The entry is flagged as a manual override: automatic geocoding will not
 * replace it and cache reads trust it without validation or expiry.
 */
export const operatorAddressResolutionSaveOptions = (options: Options<OperatorAddressResolutionSaveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await operatorAddressResolutionSave({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: operatorAddressResolutionSaveQueryKey(options)
    });
};

/**
 * Operator Address Resolution Save Endpoint
 * Store an operator-chosen resolution in the geocoding cache.
 *
 * The entry is flagged as a manual override: automatic geocoding will not
 * replace it and cache reads trust it without validation or expiry.
 */
export const operatorAddressResolutionSaveMutation = (options?: Partial<Options<OperatorAddressResolutionSaveData>>): UseMutationOptions<OperatorAddressResolutionSaveResponse, OperatorAddressResolutionSaveError, Options<OperatorAddressResolutionSaveData>> => {
    const mutationOptions: UseMutationOptions<OperatorAddressResolutionSaveResponse, OperatorAddressResolutionSaveError, Options<OperatorAddressResolutionSaveData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await operatorAddressResolutionSave({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getResidentialOwnerAccessQueryKey = (options?: Options<GetResidentialOwnerAccessData>) => createQueryKey('getResidentialOwnerAccess', options);

/**
 * Get Residential Owner Access
 * Whether the operator catalog is turned on.
 */
export const getResidentialOwnerAccessOptions = (options?: Options<GetResidentialOwnerAccessData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getResidentialOwnerAccess({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getResidentialOwnerAccessQueryKey(options)
    });
};

export const listResidentialOwnerJurisdictionsQueryKey = (options?: Options<ListResidentialOwnerJurisdictionsData>) => createQueryKey('listResidentialOwnerJurisdictions', options);

/**
 * List Residential Owner Jurisdictions
 * Long-Term Rental jurisdictions. Empty when the feature is off.
 */
export const listResidentialOwnerJurisdictionsOptions = (options?: Options<ListResidentialOwnerJurisdictionsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listResidentialOwnerJurisdictions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listResidentialOwnerJurisdictionsQueryKey(options)
    });
};

export const listResidentialOwnerMailingAddressesQueryKey = (options: Options<ListResidentialOwnerMailingAddressesData>) => createQueryKey('listResidentialOwnerMailingAddresses', options);

/**
 * List Mailing Addresses
 */
export const listResidentialOwnerMailingAddressesOptions = (options: Options<ListResidentialOwnerMailingAddressesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listResidentialOwnerMailingAddresses({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listResidentialOwnerMailingAddressesQueryKey(options)
    });
};

export const listResidentialOwnerMailingAddressesInfiniteQueryKey = (options: Options<ListResidentialOwnerMailingAddressesData>): QueryKey<Options<ListResidentialOwnerMailingAddressesData>> => createQueryKey('listResidentialOwnerMailingAddresses', options, true);

/**
 * List Mailing Addresses
 */
export const listResidentialOwnerMailingAddressesInfiniteOptions = (options: Options<ListResidentialOwnerMailingAddressesData>) => {
    return infiniteQueryOptions<ListResidentialOwnerMailingAddressesResponse, ListResidentialOwnerMailingAddressesError, InfiniteData<ListResidentialOwnerMailingAddressesResponse>, QueryKey<Options<ListResidentialOwnerMailingAddressesData>>, number | Pick<QueryKey<Options<ListResidentialOwnerMailingAddressesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListResidentialOwnerMailingAddressesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listResidentialOwnerMailingAddresses({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listResidentialOwnerMailingAddressesInfiniteQueryKey(options)
    });
};

export const getResidentialOwnerMailingAddressQueryKey = (options: Options<GetResidentialOwnerMailingAddressData>) => createQueryKey('getResidentialOwnerMailingAddress', options);

/**
 * Get Mailing Address
 */
export const getResidentialOwnerMailingAddressOptions = (options: Options<GetResidentialOwnerMailingAddressData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getResidentialOwnerMailingAddress({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getResidentialOwnerMailingAddressQueryKey(options)
    });
};

/**
 * Update Mailing Address
 */
export const updateResidentialOwnerMailingAddressMutation = (options?: Partial<Options<UpdateResidentialOwnerMailingAddressData>>): UseMutationOptions<UpdateResidentialOwnerMailingAddressResponse, UpdateResidentialOwnerMailingAddressError, Options<UpdateResidentialOwnerMailingAddressData>> => {
    const mutationOptions: UseMutationOptions<UpdateResidentialOwnerMailingAddressResponse, UpdateResidentialOwnerMailingAddressError, Options<UpdateResidentialOwnerMailingAddressData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateResidentialOwnerMailingAddress({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const unlinkResidentialOwnerMailingAddressQueryKey = (options: Options<UnlinkResidentialOwnerMailingAddressData>) => createQueryKey('unlinkResidentialOwnerMailingAddress', options);

/**
 * Unlink Mailing Address
 */
export const unlinkResidentialOwnerMailingAddressOptions = (options: Options<UnlinkResidentialOwnerMailingAddressData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await unlinkResidentialOwnerMailingAddress({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: unlinkResidentialOwnerMailingAddressQueryKey(options)
    });
};

/**
 * Unlink Mailing Address
 */
export const unlinkResidentialOwnerMailingAddressMutation = (options?: Partial<Options<UnlinkResidentialOwnerMailingAddressData>>): UseMutationOptions<UnlinkResidentialOwnerMailingAddressResponse, UnlinkResidentialOwnerMailingAddressError, Options<UnlinkResidentialOwnerMailingAddressData>> => {
    const mutationOptions: UseMutationOptions<UnlinkResidentialOwnerMailingAddressResponse, UnlinkResidentialOwnerMailingAddressError, Options<UnlinkResidentialOwnerMailingAddressData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await unlinkResidentialOwnerMailingAddress({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const linkResidentialOwnerMailingAddressesQueryKey = (options: Options<LinkResidentialOwnerMailingAddressesData>) => createQueryKey('linkResidentialOwnerMailingAddresses', options);

/**
 * Link Mailing Addresses
 */
export const linkResidentialOwnerMailingAddressesOptions = (options: Options<LinkResidentialOwnerMailingAddressesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await linkResidentialOwnerMailingAddresses({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: linkResidentialOwnerMailingAddressesQueryKey(options)
    });
};

/**
 * Link Mailing Addresses
 */
export const linkResidentialOwnerMailingAddressesMutation = (options?: Partial<Options<LinkResidentialOwnerMailingAddressesData>>): UseMutationOptions<LinkResidentialOwnerMailingAddressesResponse, LinkResidentialOwnerMailingAddressesError, Options<LinkResidentialOwnerMailingAddressesData>> => {
    const mutationOptions: UseMutationOptions<LinkResidentialOwnerMailingAddressesResponse, LinkResidentialOwnerMailingAddressesError, Options<LinkResidentialOwnerMailingAddressesData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await linkResidentialOwnerMailingAddresses({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listResidentialOwnerCompaniesQueryKey = (options: Options<ListResidentialOwnerCompaniesData>) => createQueryKey('listResidentialOwnerCompanies', options);

/**
 * List Companies
 */
export const listResidentialOwnerCompaniesOptions = (options: Options<ListResidentialOwnerCompaniesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listResidentialOwnerCompanies({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listResidentialOwnerCompaniesQueryKey(options)
    });
};

export const listResidentialOwnerCompaniesInfiniteQueryKey = (options: Options<ListResidentialOwnerCompaniesData>): QueryKey<Options<ListResidentialOwnerCompaniesData>> => createQueryKey('listResidentialOwnerCompanies', options, true);

/**
 * List Companies
 */
export const listResidentialOwnerCompaniesInfiniteOptions = (options: Options<ListResidentialOwnerCompaniesData>) => {
    return infiniteQueryOptions<ListResidentialOwnerCompaniesResponse, ListResidentialOwnerCompaniesError, InfiniteData<ListResidentialOwnerCompaniesResponse>, QueryKey<Options<ListResidentialOwnerCompaniesData>>, number | Pick<QueryKey<Options<ListResidentialOwnerCompaniesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListResidentialOwnerCompaniesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listResidentialOwnerCompanies({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listResidentialOwnerCompaniesInfiniteQueryKey(options)
    });
};

export const getResidentialOwnerCompanyQueryKey = (options: Options<GetResidentialOwnerCompanyData>) => createQueryKey('getResidentialOwnerCompany', options);

/**
 * Get Company
 */
export const getResidentialOwnerCompanyOptions = (options: Options<GetResidentialOwnerCompanyData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getResidentialOwnerCompany({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getResidentialOwnerCompanyQueryKey(options)
    });
};

/**
 * Update Company
 */
export const updateResidentialOwnerCompanyMutation = (options?: Partial<Options<UpdateResidentialOwnerCompanyData>>): UseMutationOptions<UpdateResidentialOwnerCompanyResponse, UpdateResidentialOwnerCompanyError, Options<UpdateResidentialOwnerCompanyData>> => {
    const mutationOptions: UseMutationOptions<UpdateResidentialOwnerCompanyResponse, UpdateResidentialOwnerCompanyError, Options<UpdateResidentialOwnerCompanyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateResidentialOwnerCompany({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getResidentialOwnerMailingAddressHistoryQueryKey = (options: Options<GetResidentialOwnerMailingAddressHistoryData>) => createQueryKey('getResidentialOwnerMailingAddressHistory', options);

/**
 * Mailing Address History
 * Return link, confirm, and enrichment history for one mailing address.
 */
export const getResidentialOwnerMailingAddressHistoryOptions = (options: Options<GetResidentialOwnerMailingAddressHistoryData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getResidentialOwnerMailingAddressHistory({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getResidentialOwnerMailingAddressHistoryQueryKey(options)
    });
};

export const confirmResidentialOwnerCompanyFieldsQueryKey = (options: Options<ConfirmResidentialOwnerCompanyFieldsData>) => createQueryKey('confirmResidentialOwnerCompanyFields', options);

/**
 * Confirm Company Fields
 */
export const confirmResidentialOwnerCompanyFieldsOptions = (options: Options<ConfirmResidentialOwnerCompanyFieldsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await confirmResidentialOwnerCompanyFields({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: confirmResidentialOwnerCompanyFieldsQueryKey(options)
    });
};

/**
 * Confirm Company Fields
 */
export const confirmResidentialOwnerCompanyFieldsMutation = (options?: Partial<Options<ConfirmResidentialOwnerCompanyFieldsData>>): UseMutationOptions<ConfirmResidentialOwnerCompanyFieldsResponse, ConfirmResidentialOwnerCompanyFieldsError, Options<ConfirmResidentialOwnerCompanyFieldsData>> => {
    const mutationOptions: UseMutationOptions<ConfirmResidentialOwnerCompanyFieldsResponse, ConfirmResidentialOwnerCompanyFieldsError, Options<ConfirmResidentialOwnerCompanyFieldsData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await confirmResidentialOwnerCompanyFields({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const rejectResidentialOwnerCompanyFieldsQueryKey = (options: Options<RejectResidentialOwnerCompanyFieldsData>) => createQueryKey('rejectResidentialOwnerCompanyFields', options);

/**
 * Reject Company Fields
 */
export const rejectResidentialOwnerCompanyFieldsOptions = (options: Options<RejectResidentialOwnerCompanyFieldsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await rejectResidentialOwnerCompanyFields({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: rejectResidentialOwnerCompanyFieldsQueryKey(options)
    });
};

/**
 * Reject Company Fields
 */
export const rejectResidentialOwnerCompanyFieldsMutation = (options?: Partial<Options<RejectResidentialOwnerCompanyFieldsData>>): UseMutationOptions<RejectResidentialOwnerCompanyFieldsResponse, RejectResidentialOwnerCompanyFieldsError, Options<RejectResidentialOwnerCompanyFieldsData>> => {
    const mutationOptions: UseMutationOptions<RejectResidentialOwnerCompanyFieldsResponse, RejectResidentialOwnerCompanyFieldsError, Options<RejectResidentialOwnerCompanyFieldsData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await rejectResidentialOwnerCompanyFields({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mergeResidentialOwnerCompaniesQueryKey = (options: Options<MergeResidentialOwnerCompaniesData>) => createQueryKey('mergeResidentialOwnerCompanies', options);

/**
 * Merge Owner Companies
 */
export const mergeResidentialOwnerCompaniesOptions = (options: Options<MergeResidentialOwnerCompaniesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mergeResidentialOwnerCompanies({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mergeResidentialOwnerCompaniesQueryKey(options)
    });
};

/**
 * Merge Owner Companies
 */
export const mergeResidentialOwnerCompaniesMutation = (options?: Partial<Options<MergeResidentialOwnerCompaniesData>>): UseMutationOptions<MergeResidentialOwnerCompaniesResponse, MergeResidentialOwnerCompaniesError, Options<MergeResidentialOwnerCompaniesData>> => {
    const mutationOptions: UseMutationOptions<MergeResidentialOwnerCompaniesResponse, MergeResidentialOwnerCompaniesError, Options<MergeResidentialOwnerCompaniesData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await mergeResidentialOwnerCompanies({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const enqueueResidentialOwnerRefreshQueryKey = (options: Options<EnqueueResidentialOwnerRefreshData>) => createQueryKey('enqueueResidentialOwnerRefresh', options);

/**
 * Enqueue Refresh
 */
export const enqueueResidentialOwnerRefreshOptions = (options: Options<EnqueueResidentialOwnerRefreshData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await enqueueResidentialOwnerRefresh({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: enqueueResidentialOwnerRefreshQueryKey(options)
    });
};

/**
 * Enqueue Refresh
 */
export const enqueueResidentialOwnerRefreshMutation = (options?: Partial<Options<EnqueueResidentialOwnerRefreshData>>): UseMutationOptions<EnqueueResidentialOwnerRefreshResponse, EnqueueResidentialOwnerRefreshError, Options<EnqueueResidentialOwnerRefreshData>> => {
    const mutationOptions: UseMutationOptions<EnqueueResidentialOwnerRefreshResponse, EnqueueResidentialOwnerRefreshError, Options<EnqueueResidentialOwnerRefreshData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await enqueueResidentialOwnerRefresh({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const enqueueResidentialOwnerEnrichmentQueryKey = (options: Options<EnqueueResidentialOwnerEnrichmentData>) => createQueryKey('enqueueResidentialOwnerEnrichment', options);

/**
 * Enqueue Enrichment
 */
export const enqueueResidentialOwnerEnrichmentOptions = (options: Options<EnqueueResidentialOwnerEnrichmentData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await enqueueResidentialOwnerEnrichment({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: enqueueResidentialOwnerEnrichmentQueryKey(options)
    });
};

/**
 * Enqueue Enrichment
 */
export const enqueueResidentialOwnerEnrichmentMutation = (options?: Partial<Options<EnqueueResidentialOwnerEnrichmentData>>): UseMutationOptions<EnqueueResidentialOwnerEnrichmentResponse, EnqueueResidentialOwnerEnrichmentError, Options<EnqueueResidentialOwnerEnrichmentData>> => {
    const mutationOptions: UseMutationOptions<EnqueueResidentialOwnerEnrichmentResponse, EnqueueResidentialOwnerEnrichmentError, Options<EnqueueResidentialOwnerEnrichmentData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await enqueueResidentialOwnerEnrichment({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listResidentialOwnerJobsQueryKey = (options: Options<ListResidentialOwnerJobsData>) => createQueryKey('listResidentialOwnerJobs', options);

/**
 * List Jobs
 */
export const listResidentialOwnerJobsOptions = (options: Options<ListResidentialOwnerJobsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listResidentialOwnerJobs({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listResidentialOwnerJobsQueryKey(options)
    });
};

export const cancelResidentialOwnerJobQueryKey = (options: Options<CancelResidentialOwnerJobData>) => createQueryKey('cancelResidentialOwnerJob', options);

/**
 * Cancel Job
 */
export const cancelResidentialOwnerJobOptions = (options: Options<CancelResidentialOwnerJobData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cancelResidentialOwnerJob({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: cancelResidentialOwnerJobQueryKey(options)
    });
};

/**
 * Cancel Job
 */
export const cancelResidentialOwnerJobMutation = (options?: Partial<Options<CancelResidentialOwnerJobData>>): UseMutationOptions<CancelResidentialOwnerJobResponse, CancelResidentialOwnerJobError, Options<CancelResidentialOwnerJobData>> => {
    const mutationOptions: UseMutationOptions<CancelResidentialOwnerJobResponse, CancelResidentialOwnerJobError, Options<CancelResidentialOwnerJobData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await cancelResidentialOwnerJob({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getLatestResidentialOwnerRefreshRunQueryKey = (options: Options<GetLatestResidentialOwnerRefreshRunData>) => createQueryKey('getLatestResidentialOwnerRefreshRun', options);

/**
 * Latest Refresh Run
 */
export const getLatestResidentialOwnerRefreshRunOptions = (options: Options<GetLatestResidentialOwnerRefreshRunData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getLatestResidentialOwnerRefreshRun({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getLatestResidentialOwnerRefreshRunQueryKey(options)
    });
};

export const listCompanyQuestionTabsQueryKey = (options?: Options<ListCompanyQuestionTabsData>) => createQueryKey('listCompanyQuestionTabs', options);

/**
 * List Company Question Tabs
 * List company-question subtabs grouped by their list-column prefix.
 */
export const listCompanyQuestionTabsOptions = (options?: Options<ListCompanyQuestionTabsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listCompanyQuestionTabs({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listCompanyQuestionTabsQueryKey(options)
    });
};

export const listCompanyQuestionAnswersQueryKey = (options: Options<ListCompanyQuestionAnswersData>) => createQueryKey('listCompanyQuestionAnswers', options);

/**
 * List Company Question Answers
 * List deduplicated answers for one company-question subtab.
 */
export const listCompanyQuestionAnswersOptions = (options: Options<ListCompanyQuestionAnswersData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listCompanyQuestionAnswers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listCompanyQuestionAnswersQueryKey(options)
    });
};

export const rewriteCompanyQuestionAnswersQueryKey = (options: Options<RewriteCompanyQuestionAnswersData>) => createQueryKey('rewriteCompanyQuestionAnswers', options);

/**
 * Rewrite Company Question Answers
 * Replace a company answer on licenses that still match the active filters.
 */
export const rewriteCompanyQuestionAnswersOptions = (options: Options<RewriteCompanyQuestionAnswersData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await rewriteCompanyQuestionAnswers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: rewriteCompanyQuestionAnswersQueryKey(options)
    });
};

/**
 * Rewrite Company Question Answers
 * Replace a company answer on licenses that still match the active filters.
 */
export const rewriteCompanyQuestionAnswersMutation = (options?: Partial<Options<RewriteCompanyQuestionAnswersData>>): UseMutationOptions<RewriteCompanyQuestionAnswersResponse, RewriteCompanyQuestionAnswersError, Options<RewriteCompanyQuestionAnswersData>> => {
    const mutationOptions: UseMutationOptions<RewriteCompanyQuestionAnswersResponse, RewriteCompanyQuestionAnswersError, Options<RewriteCompanyQuestionAnswersData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await rewriteCompanyQuestionAnswers({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getStrListingsQueryKey = (options?: Options<GetStrListingsData>) => createQueryKey('getStrListings', options);

/**
 * Get Str Listings
 * List active STR marketplace listings.
 */
export const getStrListingsOptions = (options?: Options<GetStrListingsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getStrListings({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getStrListingsQueryKey(options)
    });
};

export const getStrListingsInfiniteQueryKey = (options?: Options<GetStrListingsData>): QueryKey<Options<GetStrListingsData>> => createQueryKey('getStrListings', options, true);

/**
 * Get Str Listings
 * List active STR marketplace listings.
 */
export const getStrListingsInfiniteOptions = (options?: Options<GetStrListingsData>) => {
    return infiniteQueryOptions<GetStrListingsResponse, GetStrListingsError, InfiniteData<GetStrListingsResponse>, QueryKey<Options<GetStrListingsData>>, number | Pick<QueryKey<Options<GetStrListingsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetStrListingsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getStrListings({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getStrListingsInfiniteQueryKey(options)
    });
};

export const getStrListingFilterValuesQueryKey = (options: Options<GetStrListingFilterValuesData>) => createQueryKey('getStrListingFilterValues', options);

/**
 * Get Str Listing Filter Values
 * Distinct display values for one listing column.
 */
export const getStrListingFilterValuesOptions = (options: Options<GetStrListingFilterValuesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getStrListingFilterValues({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getStrListingFilterValuesQueryKey(options)
    });
};

export const getStrListingMapPinsQueryKey = (options?: Options<GetStrListingMapPinsData>) => createQueryKey('getStrListingMapPins', options);

/**
 * Get Str Listing Map Pins
 * Coordinates for filtered listings. Rows without coordinates are omitted.
 */
export const getStrListingMapPinsOptions = (options?: Options<GetStrListingMapPinsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getStrListingMapPins({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getStrListingMapPinsQueryKey(options)
    });
};

export const getStrPropertiesQueryKey = (options?: Options<GetStrPropertiesData>) => createQueryKey('getStrProperties', options);

/**
 * Get Str Properties
 * List one row per property.
 *
 * Same, two-units-at-one-address, and portion marks share a row.
 */
export const getStrPropertiesOptions = (options?: Options<GetStrPropertiesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getStrProperties({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getStrPropertiesQueryKey(options)
    });
};

export const getStrPropertiesInfiniteQueryKey = (options?: Options<GetStrPropertiesData>): QueryKey<Options<GetStrPropertiesData>> => createQueryKey('getStrProperties', options, true);

/**
 * Get Str Properties
 * List one row per property.
 *
 * Same, two-units-at-one-address, and portion marks share a row.
 */
export const getStrPropertiesInfiniteOptions = (options?: Options<GetStrPropertiesData>) => {
    return infiniteQueryOptions<GetStrPropertiesResponse, GetStrPropertiesError, InfiniteData<GetStrPropertiesResponse>, QueryKey<Options<GetStrPropertiesData>>, number | Pick<QueryKey<Options<GetStrPropertiesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetStrPropertiesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getStrProperties({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getStrPropertiesInfiniteQueryKey(options)
    });
};

export const getStrPropertyFilterValuesQueryKey = (options: Options<GetStrPropertyFilterValuesData>) => createQueryKey('getStrPropertyFilterValues', options);

/**
 * Get Str Property Filter Values
 * Distinct display values for one property column.
 */
export const getStrPropertyFilterValuesOptions = (options: Options<GetStrPropertyFilterValuesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getStrPropertyFilterValues({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getStrPropertyFilterValuesQueryKey(options)
    });
};

export const getStrPropertyMapPinsQueryKey = (options?: Options<GetStrPropertyMapPinsData>) => createQueryKey('getStrPropertyMapPins', options);

/**
 * Get Str Property Map Pins
 * One representative pin per filtered property that has coordinates.
 */
export const getStrPropertyMapPinsOptions = (options?: Options<GetStrPropertyMapPinsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getStrPropertyMapPins({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getStrPropertyMapPinsQueryKey(options)
    });
};

export const getStrPropertyDetailQueryKey = (options: Options<GetStrPropertyDetailData>) => createQueryKey('getStrPropertyDetail', options);

/**
 * Get Str Property Detail
 * One catalog property with listings, regions, and licenses.
 */
export const getStrPropertyDetailOptions = (options: Options<GetStrPropertyDetailData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getStrPropertyDetail({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getStrPropertyDetailQueryKey(options)
    });
};

export const getNextStrAddressMappingQueryKey = (options?: Options<GetNextStrAddressMappingData>) => createQueryKey('getNextStrAddressMapping', options);

/**
 * Get Next Str Address Mapping
 * Return the highest-ranked property awaiting mapping.
 *
 * ``listing_city`` keeps properties whose listing city matches, ignoring
 * case and surrounding spaces. A blank listing city does not match.
 */
export const getNextStrAddressMappingOptions = (options?: Options<GetNextStrAddressMappingData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getNextStrAddressMapping({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getNextStrAddressMappingQueryKey(options)
    });
};

export const getStrAddressMappingCitiesQueryKey = (options?: Options<GetStrAddressMappingCitiesData>) => createQueryKey('getStrAddressMappingCities', options);

/**
 * Get Str Address Mapping Cities
 * Listing cities on properties still waiting in the address-mapping queue.
 */
export const getStrAddressMappingCitiesOptions = (options?: Options<GetStrAddressMappingCitiesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getStrAddressMappingCities({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getStrAddressMappingCitiesQueryKey(options)
    });
};

export const getStrAddressMappingTargetQueryKey = (options?: Options<GetStrAddressMappingTargetData>) => createQueryKey('getStrAddressMappingTarget', options);

/**
 * Get Str Address Mapping Target
 * Load a listing or property selected from a catalog.
 */
export const getStrAddressMappingTargetOptions = (options?: Options<GetStrAddressMappingTargetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getStrAddressMappingTarget({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getStrAddressMappingTargetQueryKey(options)
    });
};

export const confirmStrAddressMappingQueryKey = (options: Options<ConfirmStrAddressMappingData>) => createQueryKey('confirmStrAddressMapping', options);

/**
 * Confirm Str Address Mapping
 * Save an edited address and attach ATTOM when selection did not already.
 */
export const confirmStrAddressMappingOptions = (options: Options<ConfirmStrAddressMappingData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await confirmStrAddressMapping({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: confirmStrAddressMappingQueryKey(options)
    });
};

/**
 * Confirm Str Address Mapping
 * Save an edited address and attach ATTOM when selection did not already.
 */
export const confirmStrAddressMappingMutation = (options?: Partial<Options<ConfirmStrAddressMappingData>>): UseMutationOptions<ConfirmStrAddressMappingResponse, ConfirmStrAddressMappingError, Options<ConfirmStrAddressMappingData>> => {
    const mutationOptions: UseMutationOptions<ConfirmStrAddressMappingResponse, ConfirmStrAddressMappingError, Options<ConfirmStrAddressMappingData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await confirmStrAddressMapping({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const lookupStrAttomParcelQueryKey = (options: Options<LookupStrAttomParcelData>) => createQueryKey('lookupStrAttomParcel', options);

/**
 * Lookup Str Attom Parcel
 * Look up ATTOM for a selected address and attach a single match.
 */
export const lookupStrAttomParcelOptions = (options: Options<LookupStrAttomParcelData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await lookupStrAttomParcel({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: lookupStrAttomParcelQueryKey(options)
    });
};

/**
 * Lookup Str Attom Parcel
 * Look up ATTOM for a selected address and attach a single match.
 */
export const lookupStrAttomParcelMutation = (options?: Partial<Options<LookupStrAttomParcelData>>): UseMutationOptions<LookupStrAttomParcelResponse, LookupStrAttomParcelError, Options<LookupStrAttomParcelData>> => {
    const mutationOptions: UseMutationOptions<LookupStrAttomParcelResponse, LookupStrAttomParcelError, Options<LookupStrAttomParcelData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await lookupStrAttomParcel({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const skipStrAddressMappingQueryKey = (options: Options<SkipStrAddressMappingData>) => createQueryKey('skipStrAddressMapping', options);

/**
 * Skip Str Address Mapping
 * Defer one property from the automatic queue.
 */
export const skipStrAddressMappingOptions = (options: Options<SkipStrAddressMappingData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await skipStrAddressMapping({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: skipStrAddressMappingQueryKey(options)
    });
};

/**
 * Skip Str Address Mapping
 * Defer one property from the automatic queue.
 */
export const skipStrAddressMappingMutation = (options?: Partial<Options<SkipStrAddressMappingData>>): UseMutationOptions<SkipStrAddressMappingResponse, SkipStrAddressMappingError, Options<SkipStrAddressMappingData>> => {
    const mutationOptions: UseMutationOptions<SkipStrAddressMappingResponse, SkipStrAddressMappingError, Options<SkipStrAddressMappingData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await skipStrAddressMapping({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const undoStrAddressMappingQueryKey = (options?: Options<UndoStrAddressMappingData>) => createQueryKey('undoStrAddressMapping', options);

/**
 * Undo Str Address Mapping
 * Remove the current operator's latest address decision.
 */
export const undoStrAddressMappingOptions = (options?: Options<UndoStrAddressMappingData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await undoStrAddressMapping({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: undoStrAddressMappingQueryKey(options)
    });
};

/**
 * Undo Str Address Mapping
 * Remove the current operator's latest address decision.
 */
export const undoStrAddressMappingMutation = (options?: Partial<Options<UndoStrAddressMappingData>>): UseMutationOptions<UndoStrAddressMappingResponse, DefaultError, Options<UndoStrAddressMappingData>> => {
    const mutationOptions: UseMutationOptions<UndoStrAddressMappingResponse, DefaultError, Options<UndoStrAddressMappingData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await undoStrAddressMapping({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getStrAddressMappingNearbyQueryKey = (options: Options<GetStrAddressMappingNearbyData>) => createQueryKey('getStrAddressMappingNearby', options);

/**
 * Get Str Address Mapping Nearby
 * List ATTOM properties near the property centroid with one house number.
 *
 * The pin is the trusted same/portion centroid, not only the opened listing.
 * The ATTOM key stays on the server. A property with no coordinates returns
 * an explanation instead of calling ATTOM.
 */
export const getStrAddressMappingNearbyOptions = (options: Options<GetStrAddressMappingNearbyData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getStrAddressMappingNearby({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getStrAddressMappingNearbyQueryKey(options)
    });
};

export const suggestStrUnitClassificationsQueryKey = (options: Options<SuggestStrUnitClassificationsData>) => createQueryKey('suggestStrUnitClassifications', options);

/**
 * Suggest Str Unit Classifications
 * Suggest property types for listings in the current filter that have no override.
 */
export const suggestStrUnitClassificationsOptions = (options: Options<SuggestStrUnitClassificationsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await suggestStrUnitClassifications({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: suggestStrUnitClassificationsQueryKey(options)
    });
};

/**
 * Suggest Str Unit Classifications
 * Suggest property types for listings in the current filter that have no override.
 */
export const suggestStrUnitClassificationsMutation = (options?: Partial<Options<SuggestStrUnitClassificationsData>>): UseMutationOptions<SuggestStrUnitClassificationsResponse, SuggestStrUnitClassificationsError, Options<SuggestStrUnitClassificationsData>> => {
    const mutationOptions: UseMutationOptions<SuggestStrUnitClassificationsResponse, SuggestStrUnitClassificationsError, Options<SuggestStrUnitClassificationsData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await suggestStrUnitClassifications({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set Str Listing Unit Category
 * Save or clear the property type override for one listing.
 */
export const setStrListingUnitCategoryMutation = (options?: Partial<Options<SetStrListingUnitCategoryData>>): UseMutationOptions<SetStrListingUnitCategoryResponse, SetStrListingUnitCategoryError, Options<SetStrListingUnitCategoryData>> => {
    const mutationOptions: UseMutationOptions<SetStrListingUnitCategoryResponse, SetStrListingUnitCategoryError, Options<SetStrListingUnitCategoryData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await setStrListingUnitCategory({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set Str Property Unit Category
 * Save or clear the property type override for every listing in a property.
 */
export const setStrPropertyUnitCategoryMutation = (options?: Partial<Options<SetStrPropertyUnitCategoryData>>): UseMutationOptions<SetStrPropertyUnitCategoryResponse, SetStrPropertyUnitCategoryError, Options<SetStrPropertyUnitCategoryData>> => {
    const mutationOptions: UseMutationOptions<SetStrPropertyUnitCategoryResponse, SetStrPropertyUnitCategoryError, Options<SetStrPropertyUnitCategoryData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await setStrPropertyUnitCategory({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getNextStrDedupPairQueryKey = (options?: Options<GetNextStrDedupPairData>) => createQueryKey('getNextStrDedupPair', options);

/**
 * Get Next Str Dedup Pair Endpoint
 * Return the next listing pairs, including a buffer of successors.
 */
export const getNextStrDedupPairOptions = (options?: Options<GetNextStrDedupPairData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getNextStrDedupPair({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getNextStrDedupPairQueryKey(options)
    });
};

export const submitStrDedupLabelQueryKey = (options: Options<SubmitStrDedupLabelData>) => createQueryKey('submitStrDedupLabel', options);

/**
 * Submit Str Dedup Label Endpoint
 * Append one yes / no / portion / unknown answer.
 */
export const submitStrDedupLabelOptions = (options: Options<SubmitStrDedupLabelData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await submitStrDedupLabel({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: submitStrDedupLabelQueryKey(options)
    });
};

/**
 * Submit Str Dedup Label Endpoint
 * Append one yes / no / portion / unknown answer.
 */
export const submitStrDedupLabelMutation = (options?: Partial<Options<SubmitStrDedupLabelData>>): UseMutationOptions<SubmitStrDedupLabelResponse, SubmitStrDedupLabelError, Options<SubmitStrDedupLabelData>> => {
    const mutationOptions: UseMutationOptions<SubmitStrDedupLabelResponse, SubmitStrDedupLabelError, Options<SubmitStrDedupLabelData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await submitStrDedupLabel({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const undoStrDedupLabelQueryKey = (options?: Options<UndoStrDedupLabelData>) => createQueryKey('undoStrDedupLabel', options);

/**
 * Undo Str Dedup Label Endpoint
 * Retract this reviewer's latest answer.
 */
export const undoStrDedupLabelOptions = (options?: Options<UndoStrDedupLabelData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await undoStrDedupLabel({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: undoStrDedupLabelQueryKey(options)
    });
};

/**
 * Undo Str Dedup Label Endpoint
 * Retract this reviewer's latest answer.
 */
export const undoStrDedupLabelMutation = (options?: Partial<Options<UndoStrDedupLabelData>>): UseMutationOptions<UndoStrDedupLabelResponse, DefaultError, Options<UndoStrDedupLabelData>> => {
    const mutationOptions: UseMutationOptions<UndoStrDedupLabelResponse, DefaultError, Options<UndoStrDedupLabelData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await undoStrDedupLabel({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const lookupStrDedupListingQueryKey = (options?: Options<LookupStrDedupListingData>) => createQueryKey('lookupStrDedupListing', options);

/**
 * Lookup Str Dedup Listing Endpoint
 * Load one active listing by its Hera id or by platform and marketplace id.
 */
export const lookupStrDedupListingOptions = (options?: Options<LookupStrDedupListingData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await lookupStrDedupListing({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: lookupStrDedupListingQueryKey(options)
    });
};

export const loadManualStrDedupPairQueryKey = (options: Options<LoadManualStrDedupPairData>) => createQueryKey('loadManualStrDedupPair', options);

/**
 * Load Manual Str Dedup Pair Endpoint
 * Show a looked-up listing beside the listing that stays on the other side.
 */
export const loadManualStrDedupPairOptions = (options: Options<LoadManualStrDedupPairData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await loadManualStrDedupPair({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: loadManualStrDedupPairQueryKey(options)
    });
};

/**
 * Load Manual Str Dedup Pair Endpoint
 * Show a looked-up listing beside the listing that stays on the other side.
 */
export const loadManualStrDedupPairMutation = (options?: Partial<Options<LoadManualStrDedupPairData>>): UseMutationOptions<LoadManualStrDedupPairResponse, LoadManualStrDedupPairError, Options<LoadManualStrDedupPairData>> => {
    const mutationOptions: UseMutationOptions<LoadManualStrDedupPairResponse, LoadManualStrDedupPairError, Options<LoadManualStrDedupPairData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await loadManualStrDedupPair({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getStrDedupMetricsQueryKey = (options?: Options<GetStrDedupMetricsData>) => createQueryKey('getStrDedupMetrics', options);

/**
 * Get Str Dedup Metrics Endpoint
 * Cross-check agreement for operator admins.
 */
export const getStrDedupMetricsOptions = (options?: Options<GetStrDedupMetricsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getStrDedupMetrics({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getStrDedupMetricsQueryKey(options)
    });
};

export const listGovernmentStrPropertiesQueryKey = (options?: Options<ListGovernmentStrPropertiesData>) => createQueryKey('listGovernmentStrProperties', options);

/**
 * List Str Properties
 * Paginated short-term rentals for the signed-in jurisdiction.
 */
export const listGovernmentStrPropertiesOptions = (options?: Options<ListGovernmentStrPropertiesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listGovernmentStrProperties({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listGovernmentStrPropertiesQueryKey(options)
    });
};

export const listGovernmentStrPropertiesInfiniteQueryKey = (options?: Options<ListGovernmentStrPropertiesData>): QueryKey<Options<ListGovernmentStrPropertiesData>> => createQueryKey('listGovernmentStrProperties', options, true);

/**
 * List Str Properties
 * Paginated short-term rentals for the signed-in jurisdiction.
 */
export const listGovernmentStrPropertiesInfiniteOptions = (options?: Options<ListGovernmentStrPropertiesData>) => {
    return infiniteQueryOptions<ListGovernmentStrPropertiesResponse, ListGovernmentStrPropertiesError, InfiniteData<ListGovernmentStrPropertiesResponse>, QueryKey<Options<ListGovernmentStrPropertiesData>>, number | Pick<QueryKey<Options<ListGovernmentStrPropertiesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListGovernmentStrPropertiesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listGovernmentStrProperties({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listGovernmentStrPropertiesInfiniteQueryKey(options)
    });
};

export const getGovernmentStrPropertyFilterValuesQueryKey = (options: Options<GetGovernmentStrPropertyFilterValuesData>) => createQueryKey('getGovernmentStrPropertyFilterValues', options);

/**
 * Get Str Property Filter Values
 * Distinct values for one property column in the signed-in jurisdiction.
 */
export const getGovernmentStrPropertyFilterValuesOptions = (options: Options<GetGovernmentStrPropertyFilterValuesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getGovernmentStrPropertyFilterValues({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getGovernmentStrPropertyFilterValuesQueryKey(options)
    });
};

export const listGovernmentStrPropertyPinsQueryKey = (options?: Options<ListGovernmentStrPropertyPinsData>) => createQueryKey('listGovernmentStrPropertyPins', options);

/**
 * List Str Property Pins
 * Map pins for the same jurisdiction scope as the list.
 */
export const listGovernmentStrPropertyPinsOptions = (options?: Options<ListGovernmentStrPropertyPinsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listGovernmentStrPropertyPins({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listGovernmentStrPropertyPinsQueryKey(options)
    });
};

export const getGovernmentStrPropertyQueryKey = (options: Options<GetGovernmentStrPropertyData>) => createQueryKey('getGovernmentStrProperty', options);

/**
 * Get Str Property
 * One property. Foreign and missing groups return the same not-found.
 */
export const getGovernmentStrPropertyOptions = (options: Options<GetGovernmentStrPropertyData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getGovernmentStrProperty({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getGovernmentStrPropertyQueryKey(options)
    });
};

export const searchGovernmentUsersForImpersonationQueryKey = (options?: Options<SearchGovernmentUsersForImpersonationData>) => createQueryKey('searchGovernmentUsersForImpersonation', options);

/**
 * Search Government Users For Impersonation Endpoint
 * Search government users by email, name, or jurisdiction (operators only).
 */
export const searchGovernmentUsersForImpersonationOptions = (options?: Options<SearchGovernmentUsersForImpersonationData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await searchGovernmentUsersForImpersonation({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: searchGovernmentUsersForImpersonationQueryKey(options)
    });
};

export const getGovernmentImpersonationMeQueryKey = (options?: Options<GetGovernmentImpersonationMeData>) => createQueryKey('getGovernmentImpersonationMe', options);

/**
 * Get Government Impersonation Me Endpoint
 * Return the government user an operator is viewing as.
 */
export const getGovernmentImpersonationMeOptions = (options?: Options<GetGovernmentImpersonationMeData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getGovernmentImpersonationMe({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getGovernmentImpersonationMeQueryKey(options)
    });
};

export const getGovernmentJurisdictionQueryKey = (options?: Options<GetGovernmentJurisdictionData>) => createQueryKey('getGovernmentJurisdiction', options);

/**
 * Get Government Jurisdiction Endpoint
 * Get the current government user's jurisdiction.
 */
export const getGovernmentJurisdictionOptions = (options?: Options<GetGovernmentJurisdictionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getGovernmentJurisdiction({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getGovernmentJurisdictionQueryKey(options)
    });
};

export const getGovernmentLicenseTypeConfigurationsQueryKey = (options?: Options<GetGovernmentLicenseTypeConfigurationsData>) => createQueryKey('getGovernmentLicenseTypeConfigurations', options);

/**
 * Get Government License Type Configurations Endpoint
 * Get license type configurations for the current government user's jurisdiction.
 */
export const getGovernmentLicenseTypeConfigurationsOptions = (options?: Options<GetGovernmentLicenseTypeConfigurationsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getGovernmentLicenseTypeConfigurations({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getGovernmentLicenseTypeConfigurationsQueryKey(options)
    });
};

export const createGovernmentOrdinanceVersionQueryKey = (options: Options<CreateGovernmentOrdinanceVersionData>) => createQueryKey('createGovernmentOrdinanceVersion', options);

/**
 * Create Government Ordinance Version Endpoint
 * Add a historic ordinance rule snapshot (same semantics as operator).
 */
export const createGovernmentOrdinanceVersionOptions = (options: Options<CreateGovernmentOrdinanceVersionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createGovernmentOrdinanceVersion({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createGovernmentOrdinanceVersionQueryKey(options)
    });
};

/**
 * Create Government Ordinance Version Endpoint
 * Add a historic ordinance rule snapshot (same semantics as operator).
 */
export const createGovernmentOrdinanceVersionMutation = (options?: Partial<Options<CreateGovernmentOrdinanceVersionData>>): UseMutationOptions<CreateGovernmentOrdinanceVersionResponse, CreateGovernmentOrdinanceVersionError, Options<CreateGovernmentOrdinanceVersionData>> => {
    const mutationOptions: UseMutationOptions<CreateGovernmentOrdinanceVersionResponse, CreateGovernmentOrdinanceVersionError, Options<CreateGovernmentOrdinanceVersionData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createGovernmentOrdinanceVersion({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Government Ordinance Version Endpoint
 * Delete a historic ordinance row for the logged-in government's jurisdiction.
 */
export const deleteGovernmentOrdinanceVersionMutation = (options?: Partial<Options<DeleteGovernmentOrdinanceVersionData>>): UseMutationOptions<DeleteGovernmentOrdinanceVersionResponse, DeleteGovernmentOrdinanceVersionError, Options<DeleteGovernmentOrdinanceVersionData>> => {
    const mutationOptions: UseMutationOptions<DeleteGovernmentOrdinanceVersionResponse, DeleteGovernmentOrdinanceVersionError, Options<DeleteGovernmentOrdinanceVersionData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await deleteGovernmentOrdinanceVersion({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Government Ordinance Version Endpoint
 * Update a historic ordinance row for the logged-in government's jurisdiction.
 */
export const updateGovernmentOrdinanceVersionMutation = (options?: Partial<Options<UpdateGovernmentOrdinanceVersionData>>): UseMutationOptions<UpdateGovernmentOrdinanceVersionResponse, UpdateGovernmentOrdinanceVersionError, Options<UpdateGovernmentOrdinanceVersionData>> => {
    const mutationOptions: UseMutationOptions<UpdateGovernmentOrdinanceVersionResponse, UpdateGovernmentOrdinanceVersionError, Options<UpdateGovernmentOrdinanceVersionData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateGovernmentOrdinanceVersion({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const exportGovernmentOrdinancesCsvQueryKey = (options?: Options<ExportGovernmentOrdinancesCsvData>) => createQueryKey('exportGovernmentOrdinancesCsv', options);

/**
 * Export Government Ordinances Csv Endpoint
 * CSV of ordinance rows (live + historic) for the logged-in jurisdiction only.
 */
export const exportGovernmentOrdinancesCsvOptions = (options?: Options<ExportGovernmentOrdinancesCsvData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await exportGovernmentOrdinancesCsv({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: exportGovernmentOrdinancesCsvQueryKey(options)
    });
};

export const dryrunGovernmentOrdinanceImportQueryKey = (options: Options<DryrunGovernmentOrdinanceImportData>) => createQueryKey('dryrunGovernmentOrdinanceImport', options);

/**
 * Dryrun Government Ordinance Import Endpoint
 * Validate and transform ordinance import rows for this jurisdiction only (no writes).
 */
export const dryrunGovernmentOrdinanceImportOptions = (options: Options<DryrunGovernmentOrdinanceImportData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await dryrunGovernmentOrdinanceImport({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: dryrunGovernmentOrdinanceImportQueryKey(options)
    });
};

/**
 * Dryrun Government Ordinance Import Endpoint
 * Validate and transform ordinance import rows for this jurisdiction only (no writes).
 */
export const dryrunGovernmentOrdinanceImportMutation = (options?: Partial<Options<DryrunGovernmentOrdinanceImportData>>): UseMutationOptions<DryrunGovernmentOrdinanceImportResponse, DryrunGovernmentOrdinanceImportError, Options<DryrunGovernmentOrdinanceImportData>> => {
    const mutationOptions: UseMutationOptions<DryrunGovernmentOrdinanceImportResponse, DryrunGovernmentOrdinanceImportError, Options<DryrunGovernmentOrdinanceImportData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await dryrunGovernmentOrdinanceImport({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const applyGovernmentOrdinanceImportQueryKey = (options: Options<ApplyGovernmentOrdinanceImportData>) => createQueryKey('applyGovernmentOrdinanceImport', options);

/**
 * Apply Government Ordinance Import Endpoint
 * Upsert ordinance versions from a spreadsheet for this jurisdiction only.
 */
export const applyGovernmentOrdinanceImportOptions = (options: Options<ApplyGovernmentOrdinanceImportData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await applyGovernmentOrdinanceImport({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: applyGovernmentOrdinanceImportQueryKey(options)
    });
};

/**
 * Apply Government Ordinance Import Endpoint
 * Upsert ordinance versions from a spreadsheet for this jurisdiction only.
 */
export const applyGovernmentOrdinanceImportMutation = (options?: Partial<Options<ApplyGovernmentOrdinanceImportData>>): UseMutationOptions<ApplyGovernmentOrdinanceImportResponse, ApplyGovernmentOrdinanceImportError, Options<ApplyGovernmentOrdinanceImportData>> => {
    const mutationOptions: UseMutationOptions<ApplyGovernmentOrdinanceImportResponse, ApplyGovernmentOrdinanceImportError, Options<ApplyGovernmentOrdinanceImportData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await applyGovernmentOrdinanceImport({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listGovernmentSavedImportMappingsQueryKey = (options: Options<ListGovernmentSavedImportMappingsData>) => createQueryKey('listGovernmentSavedImportMappings', options);

/**
 * List Government Saved Import Mappings Endpoint
 * List saved import mappings for the current user and upload type.
 */
export const listGovernmentSavedImportMappingsOptions = (options: Options<ListGovernmentSavedImportMappingsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listGovernmentSavedImportMappings({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listGovernmentSavedImportMappingsQueryKey(options)
    });
};

export const createGovernmentSavedImportMappingQueryKey = (options: Options<CreateGovernmentSavedImportMappingData>) => createQueryKey('createGovernmentSavedImportMapping', options);

/**
 * Create Government Saved Import Mapping Endpoint
 * Create a saved import mapping for the current user.
 */
export const createGovernmentSavedImportMappingOptions = (options: Options<CreateGovernmentSavedImportMappingData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createGovernmentSavedImportMapping({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createGovernmentSavedImportMappingQueryKey(options)
    });
};

/**
 * Create Government Saved Import Mapping Endpoint
 * Create a saved import mapping for the current user.
 */
export const createGovernmentSavedImportMappingMutation = (options?: Partial<Options<CreateGovernmentSavedImportMappingData>>): UseMutationOptions<CreateGovernmentSavedImportMappingResponse, CreateGovernmentSavedImportMappingError, Options<CreateGovernmentSavedImportMappingData>> => {
    const mutationOptions: UseMutationOptions<CreateGovernmentSavedImportMappingResponse, CreateGovernmentSavedImportMappingError, Options<CreateGovernmentSavedImportMappingData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createGovernmentSavedImportMapping({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getGovernmentOrdinanceFieldMappingForTempFileQueryKey = (options: Options<GetGovernmentOrdinanceFieldMappingForTempFileData>) => createQueryKey('getGovernmentOrdinanceFieldMappingForTempFile', options);

/**
 * Get Government Temp File Ordinance Field Mapping
 * Infer (or load saved) column mapping for ordinance bulk import.
 */
export const getGovernmentOrdinanceFieldMappingForTempFileOptions = (options: Options<GetGovernmentOrdinanceFieldMappingForTempFileData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getGovernmentOrdinanceFieldMappingForTempFile({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getGovernmentOrdinanceFieldMappingForTempFileQueryKey(options)
    });
};

export const getGovernmentPortalKpisQueryKey = (options?: Options<GetGovernmentPortalKpisData>) => createQueryKey('getGovernmentPortalKpis', options);

/**
 * Get Government Portal Kpis
 * Period-comparison KPI tiles for the government overview.
 */
export const getGovernmentPortalKpisOptions = (options?: Options<GetGovernmentPortalKpisData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getGovernmentPortalKpis({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getGovernmentPortalKpisQueryKey(options)
    });
};

export const getGovernmentPortalTrendsQueryKey = (options?: Options<GetGovernmentPortalTrendsData>) => createQueryKey('getGovernmentPortalTrends', options);

/**
 * Get Government Portal Trends
 * Time-series for the government portal overview (historic trends).
 */
export const getGovernmentPortalTrendsOptions = (options?: Options<GetGovernmentPortalTrendsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getGovernmentPortalTrends({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getGovernmentPortalTrendsQueryKey(options)
    });
};

export const getGovernmentPortalForeclosureVsRegistrationsQueryKey = (options?: Options<GetGovernmentPortalForeclosureVsRegistrationsData>) => createQueryKey('getGovernmentPortalForeclosureVsRegistrations', options);

/**
 * Get Government Portal Foreclosure Vs Registrations
 * Foreclosure cases by LIS/NOD date vs new registrations for this jurisdiction.
 */
export const getGovernmentPortalForeclosureVsRegistrationsOptions = (options?: Options<GetGovernmentPortalForeclosureVsRegistrationsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getGovernmentPortalForeclosureVsRegistrations({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getGovernmentPortalForeclosureVsRegistrationsQueryKey(options)
    });
};

export const getGovernmentPortalNotifiedRenewalsQueryKey = (options?: Options<GetGovernmentPortalNotifiedRenewalsData>) => createQueryKey('getGovernmentPortalNotifiedRenewals', options);

/**
 * Get Government Portal Notified Renewals
 * Renewals completed after a matching needs-attention notification.
 */
export const getGovernmentPortalNotifiedRenewalsOptions = (options?: Options<GetGovernmentPortalNotifiedRenewalsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getGovernmentPortalNotifiedRenewals({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getGovernmentPortalNotifiedRenewalsQueryKey(options)
    });
};

export const getGovernmentPortalComplianceTrendsQueryKey = (options?: Options<GetGovernmentPortalComplianceTrendsData>) => createQueryKey('getGovernmentPortalComplianceTrends', options);

/**
 * Get Government Portal Compliance Trends
 * Registration and renewal compliance rates over time for this jurisdiction.
 */
export const getGovernmentPortalComplianceTrendsOptions = (options?: Options<GetGovernmentPortalComplianceTrendsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getGovernmentPortalComplianceTrends({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getGovernmentPortalComplianceTrendsQueryKey(options)
    });
};

export const streamGovernmentPortalTrendRegistrationsQueryKey = (options?: Options<StreamGovernmentPortalTrendRegistrationsData>) => createQueryKey('streamGovernmentPortalTrendRegistrations', options);

/**
 * Stream Government Portal Trend Registrations
 */
export const streamGovernmentPortalTrendRegistrationsOptions = (options?: Options<StreamGovernmentPortalTrendRegistrationsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await streamGovernmentPortalTrendRegistrations({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: streamGovernmentPortalTrendRegistrationsQueryKey(options)
    });
};

export const streamGovernmentPortalTrendInspectionsQueryKey = (options?: Options<StreamGovernmentPortalTrendInspectionsData>) => createQueryKey('streamGovernmentPortalTrendInspections', options);

/**
 * Stream Government Portal Trend Inspections
 */
export const streamGovernmentPortalTrendInspectionsOptions = (options?: Options<StreamGovernmentPortalTrendInspectionsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await streamGovernmentPortalTrendInspections({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: streamGovernmentPortalTrendInspectionsQueryKey(options)
    });
};

export const streamGovernmentPortalTrendPaymentsQueryKey = (options?: Options<StreamGovernmentPortalTrendPaymentsData>) => createQueryKey('streamGovernmentPortalTrendPayments', options);

/**
 * Stream Government Portal Trend Payments
 */
export const streamGovernmentPortalTrendPaymentsOptions = (options?: Options<StreamGovernmentPortalTrendPaymentsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await streamGovernmentPortalTrendPayments({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: streamGovernmentPortalTrendPaymentsQueryKey(options)
    });
};

export const streamGovernmentPortalTrendInspectionFeesQueryKey = (options?: Options<StreamGovernmentPortalTrendInspectionFeesData>) => createQueryKey('streamGovernmentPortalTrendInspectionFees', options);

/**
 * Stream Government Portal Trend Inspection Fees
 */
export const streamGovernmentPortalTrendInspectionFeesOptions = (options?: Options<StreamGovernmentPortalTrendInspectionFeesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await streamGovernmentPortalTrendInspectionFees({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: streamGovernmentPortalTrendInspectionFeesQueryKey(options)
    });
};

export const streamGovernmentPortalTrendRefundsQueryKey = (options?: Options<StreamGovernmentPortalTrendRefundsData>) => createQueryKey('streamGovernmentPortalTrendRefunds', options);

/**
 * Stream Government Portal Trend Refunds
 */
export const streamGovernmentPortalTrendRefundsOptions = (options?: Options<StreamGovernmentPortalTrendRefundsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await streamGovernmentPortalTrendRefunds({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: streamGovernmentPortalTrendRefundsQueryKey(options)
    });
};

export const streamGovernmentPortalTrendRemittanceQueryKey = (options?: Options<StreamGovernmentPortalTrendRemittanceData>) => createQueryKey('streamGovernmentPortalTrendRemittance', options);

/**
 * Stream Government Portal Trend Remittance
 */
export const streamGovernmentPortalTrendRemittanceOptions = (options?: Options<StreamGovernmentPortalTrendRemittanceData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await streamGovernmentPortalTrendRemittance({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: streamGovernmentPortalTrendRemittanceQueryKey(options)
    });
};

export const getGovernmentPortalPaymentLagQueryKey = (options?: Options<GetGovernmentPortalPaymentLagData>) => createQueryKey('getGovernmentPortalPaymentLag', options);

/**
 * Get Government Portal Payment Lag
 */
export const getGovernmentPortalPaymentLagOptions = (options?: Options<GetGovernmentPortalPaymentLagData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getGovernmentPortalPaymentLag({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getGovernmentPortalPaymentLagQueryKey(options)
    });
};

export const getGovernmentPortalActivityQueryKey = (options?: Options<GetGovernmentPortalActivityData>) => createQueryKey('getGovernmentPortalActivity', options);

/**
 * Get Government Portal Activity
 * Recent activity for the government portal overview.
 */
export const getGovernmentPortalActivityOptions = (options?: Options<GetGovernmentPortalActivityData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getGovernmentPortalActivity({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getGovernmentPortalActivityQueryKey(options)
    });
};

/**
 * Update Registrant Login Identity Government Endpoint
 * Mark whether a registrant portal login receives accounts / invoice emails.
 */
export const updateRegistrantLoginIdentityGovernmentMutation = (options?: Partial<Options<UpdateRegistrantLoginIdentityGovernmentData>>): UseMutationOptions<UpdateRegistrantLoginIdentityGovernmentResponse, UpdateRegistrantLoginIdentityGovernmentError, Options<UpdateRegistrantLoginIdentityGovernmentData>> => {
    const mutationOptions: UseMutationOptions<UpdateRegistrantLoginIdentityGovernmentResponse, UpdateRegistrantLoginIdentityGovernmentError, Options<UpdateRegistrantLoginIdentityGovernmentData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateRegistrantLoginIdentityGovernment({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Government Registrant Account Accounts Contact Endpoint
 * Set accounts-contact for a registrant account (portal users and/or pre-login).
 */
export const updateGovernmentRegistrantAccountAccountsContactMutation = (options?: Partial<Options<UpdateGovernmentRegistrantAccountAccountsContactData>>): UseMutationOptions<UpdateGovernmentRegistrantAccountAccountsContactResponse, UpdateGovernmentRegistrantAccountAccountsContactError, Options<UpdateGovernmentRegistrantAccountAccountsContactData>> => {
    const mutationOptions: UseMutationOptions<UpdateGovernmentRegistrantAccountAccountsContactResponse, UpdateGovernmentRegistrantAccountAccountsContactError, Options<UpdateGovernmentRegistrantAccountAccountsContactData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateGovernmentRegistrantAccountAccountsContact({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getGovernmentForeclosureCasesQueryKey = (options?: Options<GetGovernmentForeclosureCasesData>) => createQueryKey('getGovernmentForeclosureCases', options);

/**
 * Get Government Foreclosure Cases Endpoint
 * List indexed ATTOM foreclosure cases for the government user's jurisdiction.
 */
export const getGovernmentForeclosureCasesOptions = (options?: Options<GetGovernmentForeclosureCasesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getGovernmentForeclosureCases({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getGovernmentForeclosureCasesQueryKey(options)
    });
};

export const getGovernmentForeclosureCasesInfiniteQueryKey = (options?: Options<GetGovernmentForeclosureCasesData>): QueryKey<Options<GetGovernmentForeclosureCasesData>> => createQueryKey('getGovernmentForeclosureCases', options, true);

/**
 * Get Government Foreclosure Cases Endpoint
 * List indexed ATTOM foreclosure cases for the government user's jurisdiction.
 */
export const getGovernmentForeclosureCasesInfiniteOptions = (options?: Options<GetGovernmentForeclosureCasesData>) => {
    return infiniteQueryOptions<GetGovernmentForeclosureCasesResponse, GetGovernmentForeclosureCasesError, InfiniteData<GetGovernmentForeclosureCasesResponse>, QueryKey<Options<GetGovernmentForeclosureCasesData>>, number | Pick<QueryKey<Options<GetGovernmentForeclosureCasesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetGovernmentForeclosureCasesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getGovernmentForeclosureCases({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getGovernmentForeclosureCasesInfiniteQueryKey(options)
    });
};

export const getGovernmentForeclosureCaseFilterValuesQueryKey = (options: Options<GetGovernmentForeclosureCaseFilterValuesData>) => createQueryKey('getGovernmentForeclosureCaseFilterValues', options);

/**
 * Get Government Foreclosure Case Filter Values Endpoint
 * Distinct display strings for one Cases-table filter popover.
 */
export const getGovernmentForeclosureCaseFilterValuesOptions = (options: Options<GetGovernmentForeclosureCaseFilterValuesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getGovernmentForeclosureCaseFilterValues({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getGovernmentForeclosureCaseFilterValuesQueryKey(options)
    });
};

export const getGovernmentForeclosureCaseMapPinsQueryKey = (options?: Options<GetGovernmentForeclosureCaseMapPinsData>) => createQueryKey('getGovernmentForeclosureCaseMapPins', options);

/**
 * Get Government Foreclosure Case Map Pins Endpoint
 * Pins or clusters for cases matching the current list filters.
 */
export const getGovernmentForeclosureCaseMapPinsOptions = (options?: Options<GetGovernmentForeclosureCaseMapPinsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getGovernmentForeclosureCaseMapPins({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getGovernmentForeclosureCaseMapPinsQueryKey(options)
    });
};

export const getGovernmentForeclosureCaseChartDataQueryKey = (options?: Options<GetGovernmentForeclosureCaseChartDataData>) => createQueryKey('getGovernmentForeclosureCaseChartData', options);

/**
 * Get Government Foreclosure Case Chart Data Endpoint
 * Start-date counts and review-status activity for the government Cases page.
 */
export const getGovernmentForeclosureCaseChartDataOptions = (options?: Options<GetGovernmentForeclosureCaseChartDataData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getGovernmentForeclosureCaseChartData({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getGovernmentForeclosureCaseChartDataQueryKey(options)
    });
};

export const suggestGovernmentForeclosureCasePartiesQueryKey = (options: Options<SuggestGovernmentForeclosureCasePartiesData>) => createQueryKey('suggestGovernmentForeclosureCaseParties', options);

/**
 * Suggest Government Foreclosure Case Parties Endpoint
 * Explicitly recompute OMT/AMS/registrant suggestions for one case.
 */
export const suggestGovernmentForeclosureCasePartiesOptions = (options: Options<SuggestGovernmentForeclosureCasePartiesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await suggestGovernmentForeclosureCaseParties({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: suggestGovernmentForeclosureCasePartiesQueryKey(options)
    });
};

/**
 * Suggest Government Foreclosure Case Parties Endpoint
 * Explicitly recompute OMT/AMS/registrant suggestions for one case.
 */
export const suggestGovernmentForeclosureCasePartiesMutation = (options?: Partial<Options<SuggestGovernmentForeclosureCasePartiesData>>): UseMutationOptions<SuggestGovernmentForeclosureCasePartiesResponse, SuggestGovernmentForeclosureCasePartiesError, Options<SuggestGovernmentForeclosureCasePartiesData>> => {
    const mutationOptions: UseMutationOptions<SuggestGovernmentForeclosureCasePartiesResponse, SuggestGovernmentForeclosureCasePartiesError, Options<SuggestGovernmentForeclosureCasePartiesData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await suggestGovernmentForeclosureCaseParties({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const suggestGovernmentForeclosureCaseReviewQueryKey = (options: Options<SuggestGovernmentForeclosureCaseReviewData>) => createQueryKey('suggestGovernmentForeclosureCaseReview', options);

/**
 * Suggest Government Foreclosure Case Review Endpoint
 * Explicitly recompute review status/comment suggestions for one case.
 */
export const suggestGovernmentForeclosureCaseReviewOptions = (options: Options<SuggestGovernmentForeclosureCaseReviewData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await suggestGovernmentForeclosureCaseReview({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: suggestGovernmentForeclosureCaseReviewQueryKey(options)
    });
};

/**
 * Suggest Government Foreclosure Case Review Endpoint
 * Explicitly recompute review status/comment suggestions for one case.
 */
export const suggestGovernmentForeclosureCaseReviewMutation = (options?: Partial<Options<SuggestGovernmentForeclosureCaseReviewData>>): UseMutationOptions<SuggestGovernmentForeclosureCaseReviewResponse, SuggestGovernmentForeclosureCaseReviewError, Options<SuggestGovernmentForeclosureCaseReviewData>> => {
    const mutationOptions: UseMutationOptions<SuggestGovernmentForeclosureCaseReviewResponse, SuggestGovernmentForeclosureCaseReviewError, Options<SuggestGovernmentForeclosureCaseReviewData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await suggestGovernmentForeclosureCaseReview({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getGovernmentForeclosureLicenseAssignmentCandidatesQueryKey = (options?: Options<GetGovernmentForeclosureLicenseAssignmentCandidatesData>) => createQueryKey('getGovernmentForeclosureLicenseAssignmentCandidates', options);

/**
 * Get Government Foreclosure License Assignment Candidates Endpoint
 * List exact address/APN license matches for this jurisdiction.
 */
export const getGovernmentForeclosureLicenseAssignmentCandidatesOptions = (options?: Options<GetGovernmentForeclosureLicenseAssignmentCandidatesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getGovernmentForeclosureLicenseAssignmentCandidates({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getGovernmentForeclosureLicenseAssignmentCandidatesQueryKey(options)
    });
};

export const getGovernmentForeclosureLicenseAssignmentCandidatesInfiniteQueryKey = (options?: Options<GetGovernmentForeclosureLicenseAssignmentCandidatesData>): QueryKey<Options<GetGovernmentForeclosureLicenseAssignmentCandidatesData>> => createQueryKey('getGovernmentForeclosureLicenseAssignmentCandidates', options, true);

/**
 * Get Government Foreclosure License Assignment Candidates Endpoint
 * List exact address/APN license matches for this jurisdiction.
 */
export const getGovernmentForeclosureLicenseAssignmentCandidatesInfiniteOptions = (options?: Options<GetGovernmentForeclosureLicenseAssignmentCandidatesData>) => {
    return infiniteQueryOptions<GetGovernmentForeclosureLicenseAssignmentCandidatesResponse, GetGovernmentForeclosureLicenseAssignmentCandidatesError, InfiniteData<GetGovernmentForeclosureLicenseAssignmentCandidatesResponse>, QueryKey<Options<GetGovernmentForeclosureLicenseAssignmentCandidatesData>>, number | Pick<QueryKey<Options<GetGovernmentForeclosureLicenseAssignmentCandidatesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetGovernmentForeclosureLicenseAssignmentCandidatesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getGovernmentForeclosureLicenseAssignmentCandidates({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getGovernmentForeclosureLicenseAssignmentCandidatesInfiniteQueryKey(options)
    });
};

export const assignGovernmentForeclosureLicensesQueryKey = (options: Options<AssignGovernmentForeclosureLicensesData>) => createQueryKey('assignGovernmentForeclosureLicenses', options);

/**
 * Assign Government Foreclosure Licenses Endpoint
 * Revalidate and assign selected unique license matches.
 */
export const assignGovernmentForeclosureLicensesOptions = (options: Options<AssignGovernmentForeclosureLicensesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await assignGovernmentForeclosureLicenses({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: assignGovernmentForeclosureLicensesQueryKey(options)
    });
};

/**
 * Assign Government Foreclosure Licenses Endpoint
 * Revalidate and assign selected unique license matches.
 */
export const assignGovernmentForeclosureLicensesMutation = (options?: Partial<Options<AssignGovernmentForeclosureLicensesData>>): UseMutationOptions<AssignGovernmentForeclosureLicensesResponse, AssignGovernmentForeclosureLicensesError, Options<AssignGovernmentForeclosureLicensesData>> => {
    const mutationOptions: UseMutationOptions<AssignGovernmentForeclosureLicensesResponse, AssignGovernmentForeclosureLicensesError, Options<AssignGovernmentForeclosureLicensesData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await assignGovernmentForeclosureLicenses({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getGovernmentForeclosureLicenseMatchesQueryKey = (options: Options<GetGovernmentForeclosureLicenseMatchesData>) => createQueryKey('getGovernmentForeclosureLicenseMatches', options);

/**
 * Get Government Foreclosure License Matches Endpoint
 * Return the linked license or fuzzy APN/address candidates for a case.
 */
export const getGovernmentForeclosureLicenseMatchesOptions = (options: Options<GetGovernmentForeclosureLicenseMatchesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getGovernmentForeclosureLicenseMatches({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getGovernmentForeclosureLicenseMatchesQueryKey(options)
    });
};

export const linkGovernmentForeclosureCaseToLicenseQueryKey = (options: Options<LinkGovernmentForeclosureCaseToLicenseData>) => createQueryKey('linkGovernmentForeclosureCaseToLicense', options);

/**
 * Link Government Foreclosure Case To License Endpoint
 * Apply the case number to a selected foreclosure license.
 */
export const linkGovernmentForeclosureCaseToLicenseOptions = (options: Options<LinkGovernmentForeclosureCaseToLicenseData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await linkGovernmentForeclosureCaseToLicense({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: linkGovernmentForeclosureCaseToLicenseQueryKey(options)
    });
};

/**
 * Link Government Foreclosure Case To License Endpoint
 * Apply the case number to a selected foreclosure license.
 */
export const linkGovernmentForeclosureCaseToLicenseMutation = (options?: Partial<Options<LinkGovernmentForeclosureCaseToLicenseData>>): UseMutationOptions<LinkGovernmentForeclosureCaseToLicenseResponse, LinkGovernmentForeclosureCaseToLicenseError, Options<LinkGovernmentForeclosureCaseToLicenseData>> => {
    const mutationOptions: UseMutationOptions<LinkGovernmentForeclosureCaseToLicenseResponse, LinkGovernmentForeclosureCaseToLicenseError, Options<LinkGovernmentForeclosureCaseToLicenseData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await linkGovernmentForeclosureCaseToLicense({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Government Foreclosure Case Review Endpoint
 * Update reviewed / registration-needed flags for a foreclosure case.
 */
export const updateGovernmentForeclosureCaseReviewMutation = (options?: Partial<Options<UpdateGovernmentForeclosureCaseReviewData>>): UseMutationOptions<UpdateGovernmentForeclosureCaseReviewResponse, UpdateGovernmentForeclosureCaseReviewError, Options<UpdateGovernmentForeclosureCaseReviewData>> => {
    const mutationOptions: UseMutationOptions<UpdateGovernmentForeclosureCaseReviewResponse, UpdateGovernmentForeclosureCaseReviewError, Options<UpdateGovernmentForeclosureCaseReviewData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateGovernmentForeclosureCaseReview({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getGovernmentForeclosureCaseReviewHistoryQueryKey = (options: Options<GetGovernmentForeclosureCaseReviewHistoryData>) => createQueryKey('getGovernmentForeclosureCaseReviewHistory', options);

/**
 * Get Government Foreclosure Case Review History Endpoint
 * Return newest-first review-status changes for one foreclosure case.
 */
export const getGovernmentForeclosureCaseReviewHistoryOptions = (options: Options<GetGovernmentForeclosureCaseReviewHistoryData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getGovernmentForeclosureCaseReviewHistory({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getGovernmentForeclosureCaseReviewHistoryQueryKey(options)
    });
};

export const preflightGovernmentBulkCreateUnregisteredQueryKey = (options: Options<PreflightGovernmentBulkCreateUnregisteredData>) => createQueryKey('preflightGovernmentBulkCreateUnregistered', options);

/**
 * Preflight Government Bulk Create Unregistered Endpoint
 * Check which selected foreclosure cases can become unregistered properties.
 */
export const preflightGovernmentBulkCreateUnregisteredOptions = (options: Options<PreflightGovernmentBulkCreateUnregisteredData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await preflightGovernmentBulkCreateUnregistered({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: preflightGovernmentBulkCreateUnregisteredQueryKey(options)
    });
};

/**
 * Preflight Government Bulk Create Unregistered Endpoint
 * Check which selected foreclosure cases can become unregistered properties.
 */
export const preflightGovernmentBulkCreateUnregisteredMutation = (options?: Partial<Options<PreflightGovernmentBulkCreateUnregisteredData>>): UseMutationOptions<PreflightGovernmentBulkCreateUnregisteredResponse, PreflightGovernmentBulkCreateUnregisteredError, Options<PreflightGovernmentBulkCreateUnregisteredData>> => {
    const mutationOptions: UseMutationOptions<PreflightGovernmentBulkCreateUnregisteredResponse, PreflightGovernmentBulkCreateUnregisteredError, Options<PreflightGovernmentBulkCreateUnregisteredData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await preflightGovernmentBulkCreateUnregistered({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const bulkCreateGovernmentUnregisteredFromCasesQueryKey = (options: Options<BulkCreateGovernmentUnregisteredFromCasesData>) => createQueryKey('bulkCreateGovernmentUnregisteredFromCases', options);

/**
 * Bulk Create Government Unregistered From Cases Endpoint
 * Create unregistered properties for a chunk of foreclosure cases.
 */
export const bulkCreateGovernmentUnregisteredFromCasesOptions = (options: Options<BulkCreateGovernmentUnregisteredFromCasesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await bulkCreateGovernmentUnregisteredFromCases({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: bulkCreateGovernmentUnregisteredFromCasesQueryKey(options)
    });
};

/**
 * Bulk Create Government Unregistered From Cases Endpoint
 * Create unregistered properties for a chunk of foreclosure cases.
 */
export const bulkCreateGovernmentUnregisteredFromCasesMutation = (options?: Partial<Options<BulkCreateGovernmentUnregisteredFromCasesData>>): UseMutationOptions<BulkCreateGovernmentUnregisteredFromCasesResponse, BulkCreateGovernmentUnregisteredFromCasesError, Options<BulkCreateGovernmentUnregisteredFromCasesData>> => {
    const mutationOptions: UseMutationOptions<BulkCreateGovernmentUnregisteredFromCasesResponse, BulkCreateGovernmentUnregisteredFromCasesError, Options<BulkCreateGovernmentUnregisteredFromCasesData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await bulkCreateGovernmentUnregisteredFromCases({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getGovernmentForeclosureUnregisteredMatchQueryKey = (options?: Options<GetGovernmentForeclosureUnregisteredMatchData>) => createQueryKey('getGovernmentForeclosureUnregisteredMatch', options);

/**
 * Get Government Foreclosure Unregistered Match Endpoint
 * Return the case-number attachment or address suggestions for this case.
 */
export const getGovernmentForeclosureUnregisteredMatchOptions = (options?: Options<GetGovernmentForeclosureUnregisteredMatchData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getGovernmentForeclosureUnregisteredMatch({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getGovernmentForeclosureUnregisteredMatchQueryKey(options)
    });
};

export const linkGovernmentForeclosureCaseToUnregisteredQueryKey = (options: Options<LinkGovernmentForeclosureCaseToUnregisteredData>) => createQueryKey('linkGovernmentForeclosureCaseToUnregistered', options);

/**
 * Link Government Foreclosure Case To Unregistered Endpoint
 * Apply the case number to a selected unregistered property.
 */
export const linkGovernmentForeclosureCaseToUnregisteredOptions = (options: Options<LinkGovernmentForeclosureCaseToUnregisteredData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await linkGovernmentForeclosureCaseToUnregistered({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: linkGovernmentForeclosureCaseToUnregisteredQueryKey(options)
    });
};

/**
 * Link Government Foreclosure Case To Unregistered Endpoint
 * Apply the case number to a selected unregistered property.
 */
export const linkGovernmentForeclosureCaseToUnregisteredMutation = (options?: Partial<Options<LinkGovernmentForeclosureCaseToUnregisteredData>>): UseMutationOptions<LinkGovernmentForeclosureCaseToUnregisteredResponse, LinkGovernmentForeclosureCaseToUnregisteredError, Options<LinkGovernmentForeclosureCaseToUnregisteredData>> => {
    const mutationOptions: UseMutationOptions<LinkGovernmentForeclosureCaseToUnregisteredResponse, LinkGovernmentForeclosureCaseToUnregisteredError, Options<LinkGovernmentForeclosureCaseToUnregisteredData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await linkGovernmentForeclosureCaseToUnregistered({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getUnregisteredPropertiesQueryKey = (options?: Options<GetUnregisteredPropertiesData>) => createQueryKey('getUnregisteredProperties', options);

/**
 * Get Unregistered Properties Endpoint
 * Get all unregistered properties, optionally filtered by jurisdiction.
 */
export const getUnregisteredPropertiesOptions = (options?: Options<GetUnregisteredPropertiesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getUnregisteredProperties({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getUnregisteredPropertiesQueryKey(options)
    });
};

export const createUnregisteredPropertyQueryKey = (options: Options<CreateUnregisteredPropertyData>) => createQueryKey('createUnregisteredProperty', options);

/**
 * Create Unregistered Property Endpoint
 * Create a new unregistered property record.
 */
export const createUnregisteredPropertyOptions = (options: Options<CreateUnregisteredPropertyData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createUnregisteredProperty({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createUnregisteredPropertyQueryKey(options)
    });
};

/**
 * Create Unregistered Property Endpoint
 * Create a new unregistered property record.
 */
export const createUnregisteredPropertyMutation = (options?: Partial<Options<CreateUnregisteredPropertyData>>): UseMutationOptions<CreateUnregisteredPropertyResponse, CreateUnregisteredPropertyError, Options<CreateUnregisteredPropertyData>> => {
    const mutationOptions: UseMutationOptions<CreateUnregisteredPropertyResponse, CreateUnregisteredPropertyError, Options<CreateUnregisteredPropertyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createUnregisteredProperty({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Unregistered Property Endpoint
 * Delete an unregistered property record.
 */
export const deleteUnregisteredPropertyMutation = (options?: Partial<Options<DeleteUnregisteredPropertyData>>): UseMutationOptions<DeleteUnregisteredPropertyResponse, DeleteUnregisteredPropertyError, Options<DeleteUnregisteredPropertyData>> => {
    const mutationOptions: UseMutationOptions<DeleteUnregisteredPropertyResponse, DeleteUnregisteredPropertyError, Options<DeleteUnregisteredPropertyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await deleteUnregisteredProperty({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getUnregisteredPropertyQueryKey = (options: Options<GetUnregisteredPropertyData>) => createQueryKey('getUnregisteredProperty', options);

/**
 * Get Unregistered Property Endpoint
 * Get an unregistered property by ID.
 */
export const getUnregisteredPropertyOptions = (options: Options<GetUnregisteredPropertyData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getUnregisteredProperty({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getUnregisteredPropertyQueryKey(options)
    });
};

/**
 * Update Unregistered Property Endpoint
 * Update an unregistered property record.
 *
 * Only accessible to government and operator users. Registrants cannot access this endpoint.
 */
export const updateUnregisteredPropertyMutation = (options?: Partial<Options<UpdateUnregisteredPropertyData>>): UseMutationOptions<UpdateUnregisteredPropertyResponse, UpdateUnregisteredPropertyError, Options<UpdateUnregisteredPropertyData>> => {
    const mutationOptions: UseMutationOptions<UpdateUnregisteredPropertyResponse, UpdateUnregisteredPropertyError, Options<UpdateUnregisteredPropertyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateUnregisteredProperty({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listUnregisteredSavedImportMappingsQueryKey = (options?: Options<ListUnregisteredSavedImportMappingsData>) => createQueryKey('listUnregisteredSavedImportMappings', options);

/**
 * List Unregistered Saved Import Mappings Endpoint
 * List saved mappings for unregistered uploads.
 */
export const listUnregisteredSavedImportMappingsOptions = (options?: Options<ListUnregisteredSavedImportMappingsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listUnregisteredSavedImportMappings({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listUnregisteredSavedImportMappingsQueryKey(options)
    });
};

export const createUnregisteredSavedImportMappingQueryKey = (options: Options<CreateUnregisteredSavedImportMappingData>) => createQueryKey('createUnregisteredSavedImportMapping', options);

/**
 * Create Unregistered Saved Import Mapping Endpoint
 * Create a saved mapping for unregistered uploads.
 */
export const createUnregisteredSavedImportMappingOptions = (options: Options<CreateUnregisteredSavedImportMappingData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createUnregisteredSavedImportMapping({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createUnregisteredSavedImportMappingQueryKey(options)
    });
};

/**
 * Create Unregistered Saved Import Mapping Endpoint
 * Create a saved mapping for unregistered uploads.
 */
export const createUnregisteredSavedImportMappingMutation = (options?: Partial<Options<CreateUnregisteredSavedImportMappingData>>): UseMutationOptions<CreateUnregisteredSavedImportMappingResponse, CreateUnregisteredSavedImportMappingError, Options<CreateUnregisteredSavedImportMappingData>> => {
    const mutationOptions: UseMutationOptions<CreateUnregisteredSavedImportMappingResponse, CreateUnregisteredSavedImportMappingError, Options<CreateUnregisteredSavedImportMappingData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createUnregisteredSavedImportMapping({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Unregistered Saved Import Mapping Endpoint
 * Delete one saved mapping for unregistered uploads.
 */
export const deleteUnregisteredSavedImportMappingMutation = (options?: Partial<Options<DeleteUnregisteredSavedImportMappingData>>): UseMutationOptions<DeleteUnregisteredSavedImportMappingResponse, DeleteUnregisteredSavedImportMappingError, Options<DeleteUnregisteredSavedImportMappingData>> => {
    const mutationOptions: UseMutationOptions<DeleteUnregisteredSavedImportMappingResponse, DeleteUnregisteredSavedImportMappingError, Options<DeleteUnregisteredSavedImportMappingData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await deleteUnregisteredSavedImportMapping({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Unregistered Saved Import Mapping Endpoint
 * Update one saved mapping for unregistered uploads.
 */
export const updateUnregisteredSavedImportMappingMutation = (options?: Partial<Options<UpdateUnregisteredSavedImportMappingData>>): UseMutationOptions<UpdateUnregisteredSavedImportMappingResponse, UpdateUnregisteredSavedImportMappingError, Options<UpdateUnregisteredSavedImportMappingData>> => {
    const mutationOptions: UseMutationOptions<UpdateUnregisteredSavedImportMappingResponse, UpdateUnregisteredSavedImportMappingError, Options<UpdateUnregisteredSavedImportMappingData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateUnregisteredSavedImportMapping({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const applyUnregisteredSavedImportMappingQueryKey = (options: Options<ApplyUnregisteredSavedImportMappingData>) => createQueryKey('applyUnregisteredSavedImportMapping', options);

/**
 * Apply Unregistered Saved Import Mapping Endpoint
 * Preview applying one saved mapping to an unregistered upload sheet.
 */
export const applyUnregisteredSavedImportMappingOptions = (options: Options<ApplyUnregisteredSavedImportMappingData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await applyUnregisteredSavedImportMapping({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: applyUnregisteredSavedImportMappingQueryKey(options)
    });
};

/**
 * Apply Unregistered Saved Import Mapping Endpoint
 * Preview applying one saved mapping to an unregistered upload sheet.
 */
export const applyUnregisteredSavedImportMappingMutation = (options?: Partial<Options<ApplyUnregisteredSavedImportMappingData>>): UseMutationOptions<ApplyUnregisteredSavedImportMappingResponse, ApplyUnregisteredSavedImportMappingError, Options<ApplyUnregisteredSavedImportMappingData>> => {
    const mutationOptions: UseMutationOptions<ApplyUnregisteredSavedImportMappingResponse, ApplyUnregisteredSavedImportMappingError, Options<ApplyUnregisteredSavedImportMappingData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await applyUnregisteredSavedImportMapping({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getUnregisteredFieldMappingForTempFileQueryKey = (options: Options<GetUnregisteredFieldMappingForTempFileData>) => createQueryKey('getUnregisteredFieldMappingForTempFile', options);

/**
 * Get Temp File Unregistered Field Mapping
 * Get temp file field mapping for a file using OpenAI assuming it is an unregistered properties file.
 */
export const getUnregisteredFieldMappingForTempFileOptions = (options: Options<GetUnregisteredFieldMappingForTempFileData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getUnregisteredFieldMappingForTempFile({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getUnregisteredFieldMappingForTempFileQueryKey(options)
    });
};

export const dryrunUnregisteredCreationQueryKey = (options: Options<DryrunUnregisteredCreationData>) => createQueryKey('dryrunUnregisteredCreation', options);

/**
 * Dryrun Unregistered Creation Endpoint
 * Dry run unregistered properties creation from uploaded file using field mappings.
 *
 * Note: Geocoding, Tiger, and APN lookup cache entries are committed even during
 * dry runs to avoid wasting API calls on subsequent runs. Only cache writes are
 * committed; all other operations (property/unregistered creation) are skipped during dry_run.
 */
export const dryrunUnregisteredCreationOptions = (options: Options<DryrunUnregisteredCreationData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await dryrunUnregisteredCreation({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: dryrunUnregisteredCreationQueryKey(options)
    });
};

/**
 * Dryrun Unregistered Creation Endpoint
 * Dry run unregistered properties creation from uploaded file using field mappings.
 *
 * Note: Geocoding, Tiger, and APN lookup cache entries are committed even during
 * dry runs to avoid wasting API calls on subsequent runs. Only cache writes are
 * committed; all other operations (property/unregistered creation) are skipped during dry_run.
 */
export const dryrunUnregisteredCreationMutation = (options?: Partial<Options<DryrunUnregisteredCreationData>>): UseMutationOptions<DryrunUnregisteredCreationResponse, DryrunUnregisteredCreationError, Options<DryrunUnregisteredCreationData>> => {
    const mutationOptions: UseMutationOptions<DryrunUnregisteredCreationResponse, DryrunUnregisteredCreationError, Options<DryrunUnregisteredCreationData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await dryrunUnregisteredCreation({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const createUnregisteredPropertiesQueryKey = (options: Options<CreateUnregisteredPropertiesData>) => createQueryKey('createUnregisteredProperties', options);

/**
 * Create Unregistered Properties Endpoint
 * Create unregistered properties from uploaded file using field mappings.
 */
export const createUnregisteredPropertiesOptions = (options: Options<CreateUnregisteredPropertiesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createUnregisteredProperties({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createUnregisteredPropertiesQueryKey(options)
    });
};

/**
 * Create Unregistered Properties Endpoint
 * Create unregistered properties from uploaded file using field mappings.
 */
export const createUnregisteredPropertiesMutation = (options?: Partial<Options<CreateUnregisteredPropertiesData>>): UseMutationOptions<CreateUnregisteredPropertiesResponse, CreateUnregisteredPropertiesError, Options<CreateUnregisteredPropertiesData>> => {
    const mutationOptions: UseMutationOptions<CreateUnregisteredPropertiesResponse, CreateUnregisteredPropertiesError, Options<CreateUnregisteredPropertiesData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createUnregisteredProperties({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getUnregisteredCommentsQueryKey = (options: Options<GetUnregisteredCommentsData>) => createQueryKey('getUnregisteredComments', options);

/**
 * Get Unregistered Comments Endpoint
 * Get all comments for an unregistered property.
 */
export const getUnregisteredCommentsOptions = (options: Options<GetUnregisteredCommentsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getUnregisteredComments({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getUnregisteredCommentsQueryKey(options)
    });
};

export const createUnregisteredCommentQueryKey = (options: Options<CreateUnregisteredCommentData>) => createQueryKey('createUnregisteredComment', options);

/**
 * Create Unregistered Comment Endpoint
 * Create a comment for an unregistered property.
 */
export const createUnregisteredCommentOptions = (options: Options<CreateUnregisteredCommentData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createUnregisteredComment({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createUnregisteredCommentQueryKey(options)
    });
};

/**
 * Create Unregistered Comment Endpoint
 * Create a comment for an unregistered property.
 */
export const createUnregisteredCommentMutation = (options?: Partial<Options<CreateUnregisteredCommentData>>): UseMutationOptions<CreateUnregisteredCommentResponse, CreateUnregisteredCommentError, Options<CreateUnregisteredCommentData>> => {
    const mutationOptions: UseMutationOptions<CreateUnregisteredCommentResponse, CreateUnregisteredCommentError, Options<CreateUnregisteredCommentData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createUnregisteredComment({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const checkApnRegisteredQueryKey = (options: Options<CheckApnRegisteredData>) => createQueryKey('checkApnRegistered', options);

/**
 * Check Apn Registered Endpoint
 * Check if an APN is already registered (has a license) in a jurisdiction.
 *
 * Only accessible to government and operator users. Registrants cannot access this endpoint.
 */
export const checkApnRegisteredOptions = (options: Options<CheckApnRegisteredData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await checkApnRegistered({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: checkApnRegisteredQueryKey(options)
    });
};

/**
 * Check Apn Registered Endpoint
 * Check if an APN is already registered (has a license) in a jurisdiction.
 *
 * Only accessible to government and operator users. Registrants cannot access this endpoint.
 */
export const checkApnRegisteredMutation = (options?: Partial<Options<CheckApnRegisteredData>>): UseMutationOptions<CheckApnRegisteredResponse, CheckApnRegisteredError, Options<CheckApnRegisteredData>> => {
    const mutationOptions: UseMutationOptions<CheckApnRegisteredResponse, CheckApnRegisteredError, Options<CheckApnRegisteredData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await checkApnRegistered({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTitleAccountQueryKey = (options?: Options<GetTitleAccountData>) => createQueryKey('getTitleAccount', options);

/**
 * Get Title Account
 * The signed-in title account, or the account an operator is viewing.
 */
export const getTitleAccountOptions = (options?: Options<GetTitleAccountData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getTitleAccount({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getTitleAccountQueryKey(options)
    });
};

/**
 * Update Title Account
 * Update profile details. A secondary cannot change the organization address.
 */
export const updateTitleAccountMutation = (options?: Partial<Options<UpdateTitleAccountData>>): UseMutationOptions<UpdateTitleAccountResponse, UpdateTitleAccountError, Options<UpdateTitleAccountData>> => {
    const mutationOptions: UseMutationOptions<UpdateTitleAccountResponse, UpdateTitleAccountError, Options<UpdateTitleAccountData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateTitleAccount({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTitleAccountUsersQueryKey = (options?: Options<GetTitleAccountUsersData>) => createQueryKey('getTitleAccountUsers', options);

/**
 * List Title Account Users
 * Primary, secondaries, and pending invites. Disabled users are optional.
 */
export const getTitleAccountUsersOptions = (options?: Options<GetTitleAccountUsersData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getTitleAccountUsers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getTitleAccountUsersQueryKey(options)
    });
};

export const addTitleAccountUserQueryKey = (options: Options<AddTitleAccountUserData>) => createQueryKey('addTitleAccountUser', options);

/**
 * Invite Title Account User
 * Invite a secondary user. A repeat invite to the same pending email is a no-op.
 */
export const addTitleAccountUserOptions = (options: Options<AddTitleAccountUserData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await addTitleAccountUser({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: addTitleAccountUserQueryKey(options)
    });
};

/**
 * Invite Title Account User
 * Invite a secondary user. A repeat invite to the same pending email is a no-op.
 */
export const addTitleAccountUserMutation = (options?: Partial<Options<AddTitleAccountUserData>>): UseMutationOptions<AddTitleAccountUserResponse, AddTitleAccountUserError, Options<AddTitleAccountUserData>> => {
    const mutationOptions: UseMutationOptions<AddTitleAccountUserResponse, AddTitleAccountUserError, Options<AddTitleAccountUserData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await addTitleAccountUser({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Cancel Title Account Invite
 * Cancel a pending invite. Active users are disabled on the other route.
 */
export const cancelTitleAccountInviteMutation = (options?: Partial<Options<CancelTitleAccountInviteData>>): UseMutationOptions<CancelTitleAccountInviteResponse, CancelTitleAccountInviteError, Options<CancelTitleAccountInviteData>> => {
    const mutationOptions: UseMutationOptions<CancelTitleAccountInviteResponse, CancelTitleAccountInviteError, Options<CancelTitleAccountInviteData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await cancelTitleAccountInvite({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Disable Title Account User
 * Disable a secondary user. The primary and the caller cannot be disabled.
 */
export const disableTitleAccountUserMutation = (options?: Partial<Options<DisableTitleAccountUserData>>): UseMutationOptions<DisableTitleAccountUserResponse, DisableTitleAccountUserError, Options<DisableTitleAccountUserData>> => {
    const mutationOptions: UseMutationOptions<DisableTitleAccountUserResponse, DisableTitleAccountUserError, Options<DisableTitleAccountUserData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await disableTitleAccountUser({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const reenableTitleAccountUserQueryKey = (options: Options<ReenableTitleAccountUserData>) => createQueryKey('reenableTitleAccountUser', options);

/**
 * Reenable Title Account User
 * Restore a disabled secondary user.
 */
export const reenableTitleAccountUserOptions = (options: Options<ReenableTitleAccountUserData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await reenableTitleAccountUser({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: reenableTitleAccountUserQueryKey(options)
    });
};

/**
 * Reenable Title Account User
 * Restore a disabled secondary user.
 */
export const reenableTitleAccountUserMutation = (options?: Partial<Options<ReenableTitleAccountUserData>>): UseMutationOptions<ReenableTitleAccountUserResponse, ReenableTitleAccountUserError, Options<ReenableTitleAccountUserData>> => {
    const mutationOptions: UseMutationOptions<ReenableTitleAccountUserResponse, ReenableTitleAccountUserError, Options<ReenableTitleAccountUserData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await reenableTitleAccountUser({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const makeTitleAccountPrimaryQueryKey = (options: Options<MakeTitleAccountPrimaryData>) => createQueryKey('makeTitleAccountPrimary', options);

/**
 * Make Title Account Primary
 * Transfer the primary role. Only the current primary may do this.
 */
export const makeTitleAccountPrimaryOptions = (options: Options<MakeTitleAccountPrimaryData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await makeTitleAccountPrimary({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: makeTitleAccountPrimaryQueryKey(options)
    });
};

/**
 * Make Title Account Primary
 * Transfer the primary role. Only the current primary may do this.
 */
export const makeTitleAccountPrimaryMutation = (options?: Partial<Options<MakeTitleAccountPrimaryData>>): UseMutationOptions<MakeTitleAccountPrimaryResponse, MakeTitleAccountPrimaryError, Options<MakeTitleAccountPrimaryData>> => {
    const mutationOptions: UseMutationOptions<MakeTitleAccountPrimaryResponse, MakeTitleAccountPrimaryError, Options<MakeTitleAccountPrimaryData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await makeTitleAccountPrimary({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Title Account User Admin
 * Grant or revoke admin. The primary stays an admin. You cannot change yourself.
 */
export const updateTitleAccountUserAdminMutation = (options?: Partial<Options<UpdateTitleAccountUserAdminData>>): UseMutationOptions<UpdateTitleAccountUserAdminResponse, UpdateTitleAccountUserAdminError, Options<UpdateTitleAccountUserAdminData>> => {
    const mutationOptions: UseMutationOptions<UpdateTitleAccountUserAdminResponse, UpdateTitleAccountUserAdminError, Options<UpdateTitleAccountUserAdminData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateTitleAccountUserAdmin({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTitlePendingInviteQueryKey = (options?: Options<GetTitlePendingInviteData>) => createQueryKey('getTitlePendingInvite', options);

/**
 * Get Title Pending Invite
 * Organization name for a user who has not accepted an invite.
 */
export const getTitlePendingInviteOptions = (options?: Options<GetTitlePendingInviteData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getTitlePendingInvite({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getTitlePendingInviteQueryKey(options)
    });
};

export const acceptTitlePendingInviteQueryKey = (options?: Options<AcceptTitlePendingInviteData>) => createQueryKey('acceptTitlePendingInvite', options);

/**
 * Accept Title Pending Invite
 * Accept a pending title-account invite.
 */
export const acceptTitlePendingInviteOptions = (options?: Options<AcceptTitlePendingInviteData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await acceptTitlePendingInvite({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: acceptTitlePendingInviteQueryKey(options)
    });
};

/**
 * Accept Title Pending Invite
 * Accept a pending title-account invite.
 */
export const acceptTitlePendingInviteMutation = (options?: Partial<Options<AcceptTitlePendingInviteData>>): UseMutationOptions<AcceptTitlePendingInviteResponse, DefaultError, Options<AcceptTitlePendingInviteData>> => {
    const mutationOptions: UseMutationOptions<AcceptTitlePendingInviteResponse, DefaultError, Options<AcceptTitlePendingInviteData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await acceptTitlePendingInvite({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const rejectTitlePendingInviteQueryKey = (options?: Options<RejectTitlePendingInviteData>) => createQueryKey('rejectTitlePendingInvite', options);

/**
 * Reject Title Pending Invite
 * Reject a pending invite and remove the pending account.
 */
export const rejectTitlePendingInviteOptions = (options?: Options<RejectTitlePendingInviteData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await rejectTitlePendingInvite({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: rejectTitlePendingInviteQueryKey(options)
    });
};

/**
 * Reject Title Pending Invite
 * Reject a pending invite and remove the pending account.
 */
export const rejectTitlePendingInviteMutation = (options?: Partial<Options<RejectTitlePendingInviteData>>): UseMutationOptions<RejectTitlePendingInviteResponse, DefaultError, Options<RejectTitlePendingInviteData>> => {
    const mutationOptions: UseMutationOptions<RejectTitlePendingInviteResponse, DefaultError, Options<RejectTitlePendingInviteData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await rejectTitlePendingInvite({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const searchTitleAccountsForImpersonationQueryKey = (options: Options<SearchTitleAccountsForImpersonationData>) => createQueryKey('searchTitleAccountsForImpersonation', options);

/**
 * Search Title Accounts For Impersonation
 * Operator search for a title account to open. Registrant accounts are not here.
 */
export const searchTitleAccountsForImpersonationOptions = (options: Options<SearchTitleAccountsForImpersonationData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await searchTitleAccountsForImpersonation({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: searchTitleAccountsForImpersonationQueryKey(options)
    });
};

export const searchOperatorTitleAccountsQueryKey = (options: Options<SearchOperatorTitleAccountsData>) => createQueryKey('searchOperatorTitleAccounts', options);

/**
 * Search Operator Title Accounts
 * Find a title requestor by name, company, or email.
 *
 * The title-portal search accepts a title-audience token. This route accepts
 * the operator portal token.
 */
export const searchOperatorTitleAccountsOptions = (options: Options<SearchOperatorTitleAccountsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await searchOperatorTitleAccounts({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: searchOperatorTitleAccountsQueryKey(options)
    });
};

export const createOperatorTitleAccountQueryKey = (options: Options<CreateOperatorTitleAccountData>) => createQueryKey('createOperatorTitleAccount', options);

/**
 * Create Operator Title Account
 * Create a title requestor, or return the account that already uses this email.
 */
export const createOperatorTitleAccountOptions = (options: Options<CreateOperatorTitleAccountData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createOperatorTitleAccount({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createOperatorTitleAccountQueryKey(options)
    });
};

/**
 * Create Operator Title Account
 * Create a title requestor, or return the account that already uses this email.
 */
export const createOperatorTitleAccountMutation = (options?: Partial<Options<CreateOperatorTitleAccountData>>): UseMutationOptions<CreateOperatorTitleAccountResponse, CreateOperatorTitleAccountError, Options<CreateOperatorTitleAccountData>> => {
    const mutationOptions: UseMutationOptions<CreateOperatorTitleAccountResponse, CreateOperatorTitleAccountError, Options<CreateOperatorTitleAccountData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createOperatorTitleAccount({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const lookupTitleRequestAddressQueryKey = (options: Options<LookupTitleRequestAddressData>) => createQueryKey('lookupTitleRequestAddress', options);

/**
 * Lookup Title Request Address
 * Preview a parcel match. Failure still returns a payload the form can submit.
 */
export const lookupTitleRequestAddressOptions = (options: Options<LookupTitleRequestAddressData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await lookupTitleRequestAddress({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: lookupTitleRequestAddressQueryKey(options)
    });
};

/**
 * Lookup Title Request Address
 * Preview a parcel match. Failure still returns a payload the form can submit.
 */
export const lookupTitleRequestAddressMutation = (options?: Partial<Options<LookupTitleRequestAddressData>>): UseMutationOptions<LookupTitleRequestAddressResponse, LookupTitleRequestAddressError, Options<LookupTitleRequestAddressData>> => {
    const mutationOptions: UseMutationOptions<LookupTitleRequestAddressResponse, LookupTitleRequestAddressError, Options<LookupTitleRequestAddressData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await lookupTitleRequestAddress({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const createTitleRequestQueryKey = (options: Options<CreateTitleRequestData>) => createQueryKey('createTitleRequest', options);

/**
 * Create Title Request
 * Save a signed-in requester's title request, and a parcel match when one exists.
 */
export const createTitleRequestOptions = (options: Options<CreateTitleRequestData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createTitleRequest({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createTitleRequestQueryKey(options)
    });
};

/**
 * Create Title Request
 * Save a signed-in requester's title request, and a parcel match when one exists.
 */
export const createTitleRequestMutation = (options?: Partial<Options<CreateTitleRequestData>>): UseMutationOptions<CreateTitleRequestResponse, CreateTitleRequestError, Options<CreateTitleRequestData>> => {
    const mutationOptions: UseMutationOptions<CreateTitleRequestResponse, CreateTitleRequestError, Options<CreateTitleRequestData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createTitleRequest({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const claimTitleRequestQueryKey = (options: Options<ClaimTitleRequestData>) => createQueryKey('claimTitleRequest', options);

/**
 * Claim Title Request
 * Confirm the email on an anonymous request and attach it when logged in.
 */
export const claimTitleRequestOptions = (options: Options<ClaimTitleRequestData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await claimTitleRequest({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: claimTitleRequestQueryKey(options)
    });
};

/**
 * Claim Title Request
 * Confirm the email on an anonymous request and attach it when logged in.
 */
export const claimTitleRequestMutation = (options?: Partial<Options<ClaimTitleRequestData>>): UseMutationOptions<ClaimTitleRequestResponse, ClaimTitleRequestError, Options<ClaimTitleRequestData>> => {
    const mutationOptions: UseMutationOptions<ClaimTitleRequestResponse, ClaimTitleRequestError, Options<ClaimTitleRequestData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await claimTitleRequest({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listMyTitleRequestsQueryKey = (options?: Options<ListMyTitleRequestsData>) => createQueryKey('listMyTitleRequests', options);

/**
 * List My Title Requests
 * Requests belonging to the signed-in title account.
 */
export const listMyTitleRequestsOptions = (options?: Options<ListMyTitleRequestsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listMyTitleRequests({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listMyTitleRequestsQueryKey(options)
    });
};

export const getMyTitleRequestQueryKey = (options: Options<GetMyTitleRequestData>) => createQueryKey('getMyTitleRequest', options);

/**
 * Get My Title Request
 * One request owned by the signed-in title account.
 */
export const getMyTitleRequestOptions = (options: Options<GetMyTitleRequestData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMyTitleRequest({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMyTitleRequestQueryKey(options)
    });
};

export const addMyTitleRequestCommentQueryKey = (options: Options<AddMyTitleRequestCommentData>) => createQueryKey('addMyTitleRequestComment', options);

/**
 * Add My Title Request Comment
 * Comment on a request in the signed-in title account.
 */
export const addMyTitleRequestCommentOptions = (options: Options<AddMyTitleRequestCommentData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await addMyTitleRequestComment({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: addMyTitleRequestCommentQueryKey(options)
    });
};

/**
 * Add My Title Request Comment
 * Comment on a request in the signed-in title account.
 */
export const addMyTitleRequestCommentMutation = (options?: Partial<Options<AddMyTitleRequestCommentData>>): UseMutationOptions<AddMyTitleRequestCommentResponse, AddMyTitleRequestCommentError, Options<AddMyTitleRequestCommentData>> => {
    const mutationOptions: UseMutationOptions<AddMyTitleRequestCommentResponse, AddMyTitleRequestCommentError, Options<AddMyTitleRequestCommentData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await addMyTitleRequestComment({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const requestFurtherTitleReviewQueryKey = (options: Options<RequestFurtherTitleReviewData>) => createQueryKey('requestFurtherTitleReview', options);

/**
 * Request Further Title Review
 * Reopen an active-interest request so Hera reviews the property again.
 */
export const requestFurtherTitleReviewOptions = (options: Options<RequestFurtherTitleReviewData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await requestFurtherTitleReview({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: requestFurtherTitleReviewQueryKey(options)
    });
};

/**
 * Request Further Title Review
 * Reopen an active-interest request so Hera reviews the property again.
 */
export const requestFurtherTitleReviewMutation = (options?: Partial<Options<RequestFurtherTitleReviewData>>): UseMutationOptions<RequestFurtherTitleReviewResponse, RequestFurtherTitleReviewError, Options<RequestFurtherTitleReviewData>> => {
    const mutationOptions: UseMutationOptions<RequestFurtherTitleReviewResponse, RequestFurtherTitleReviewError, Options<RequestFurtherTitleReviewData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await requestFurtherTitleReview({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const cancelMyTitleRequestQueryKey = (options: Options<CancelMyTitleRequestData>) => createQueryKey('cancelMyTitleRequest', options);

/**
 * Cancel My Title Request
 * Cancel a request in the signed-in title account and mark it inactive.
 */
export const cancelMyTitleRequestOptions = (options: Options<CancelMyTitleRequestData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cancelMyTitleRequest({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: cancelMyTitleRequestQueryKey(options)
    });
};

/**
 * Cancel My Title Request
 * Cancel a request in the signed-in title account and mark it inactive.
 */
export const cancelMyTitleRequestMutation = (options?: Partial<Options<CancelMyTitleRequestData>>): UseMutationOptions<CancelMyTitleRequestResponse, CancelMyTitleRequestError, Options<CancelMyTitleRequestData>> => {
    const mutationOptions: UseMutationOptions<CancelMyTitleRequestResponse, CancelMyTitleRequestError, Options<CancelMyTitleRequestData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await cancelMyTitleRequest({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMyTitleRequestAttachmentQueryKey = (options: Options<GetMyTitleRequestAttachmentData>) => createQueryKey('getMyTitleRequestAttachment', options);

/**
 * Get My Title Request Attachment
 * Download a receipt stored on an email for a request this account owns.
 */
export const getMyTitleRequestAttachmentOptions = (options: Options<GetMyTitleRequestAttachmentData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMyTitleRequestAttachment({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMyTitleRequestAttachmentQueryKey(options)
    });
};

export const listOperatorTitleRequestsQueryKey = (options?: Options<ListOperatorTitleRequestsData>) => createQueryKey('listOperatorTitleRequests', options);

/**
 * List Operator Title Requests
 * Every title request, newest first.
 */
export const listOperatorTitleRequestsOptions = (options?: Options<ListOperatorTitleRequestsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listOperatorTitleRequests({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listOperatorTitleRequestsQueryKey(options)
    });
};

export const getOperatorTitleRequestQueryKey = (options: Options<GetOperatorTitleRequestData>) => createQueryKey('getOperatorTitleRequest', options);

/**
 * Get Operator Title Request
 * Request details plus licenses and foreclosure cases on the property.
 */
export const getOperatorTitleRequestOptions = (options: Options<GetOperatorTitleRequestData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOperatorTitleRequest({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOperatorTitleRequestQueryKey(options)
    });
};

/**
 * Update Operator Title Request
 * Change status, the submitted property details, or an operator note.
 */
export const updateOperatorTitleRequestMutation = (options?: Partial<Options<UpdateOperatorTitleRequestData>>): UseMutationOptions<UpdateOperatorTitleRequestResponse, UpdateOperatorTitleRequestError, Options<UpdateOperatorTitleRequestData>> => {
    const mutationOptions: UseMutationOptions<UpdateOperatorTitleRequestResponse, UpdateOperatorTitleRequestError, Options<UpdateOperatorTitleRequestData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateOperatorTitleRequest({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const cancelOperatorTitleRequestQueryKey = (options: Options<CancelOperatorTitleRequestData>) => createQueryKey('cancelOperatorTitleRequest', options);

/**
 * Cancel Operator Title Request
 * Cancel any title request and mark it inactive.
 */
export const cancelOperatorTitleRequestOptions = (options: Options<CancelOperatorTitleRequestData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cancelOperatorTitleRequest({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: cancelOperatorTitleRequestQueryKey(options)
    });
};

/**
 * Cancel Operator Title Request
 * Cancel any title request and mark it inactive.
 */
export const cancelOperatorTitleRequestMutation = (options?: Partial<Options<CancelOperatorTitleRequestData>>): UseMutationOptions<CancelOperatorTitleRequestResponse, CancelOperatorTitleRequestError, Options<CancelOperatorTitleRequestData>> => {
    const mutationOptions: UseMutationOptions<CancelOperatorTitleRequestResponse, CancelOperatorTitleRequestError, Options<CancelOperatorTitleRequestData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await cancelOperatorTitleRequest({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const addOperatorTitleRequestCommentQueryKey = (options: Options<AddOperatorTitleRequestCommentData>) => createQueryKey('addOperatorTitleRequestComment', options);

/**
 * Add Operator Title Request Comment
 * Comment on any title request as an operator.
 */
export const addOperatorTitleRequestCommentOptions = (options: Options<AddOperatorTitleRequestCommentData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await addOperatorTitleRequestComment({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: addOperatorTitleRequestCommentQueryKey(options)
    });
};

/**
 * Add Operator Title Request Comment
 * Comment on any title request as an operator.
 */
export const addOperatorTitleRequestCommentMutation = (options?: Partial<Options<AddOperatorTitleRequestCommentData>>): UseMutationOptions<AddOperatorTitleRequestCommentResponse, AddOperatorTitleRequestCommentError, Options<AddOperatorTitleRequestCommentData>> => {
    const mutationOptions: UseMutationOptions<AddOperatorTitleRequestCommentResponse, AddOperatorTitleRequestCommentError, Options<AddOperatorTitleRequestCommentData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await addOperatorTitleRequestComment({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const sendTitleRequestPropertyCompliantQueryKey = (options: Options<SendTitleRequestPropertyCompliantData>) => createQueryKey('sendTitleRequestPropertyCompliant', options);

/**
 * Send Title Request Property Compliant
 * Email the edited no-known-interest message and attach the selected certificates.
 */
export const sendTitleRequestPropertyCompliantOptions = (options: Options<SendTitleRequestPropertyCompliantData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await sendTitleRequestPropertyCompliant({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: sendTitleRequestPropertyCompliantQueryKey(options)
    });
};

/**
 * Send Title Request Property Compliant
 * Email the edited no-known-interest message and attach the selected certificates.
 */
export const sendTitleRequestPropertyCompliantMutation = (options?: Partial<Options<SendTitleRequestPropertyCompliantData>>): UseMutationOptions<SendTitleRequestPropertyCompliantResponse, SendTitleRequestPropertyCompliantError, Options<SendTitleRequestPropertyCompliantData>> => {
    const mutationOptions: UseMutationOptions<SendTitleRequestPropertyCompliantResponse, SendTitleRequestPropertyCompliantError, Options<SendTitleRequestPropertyCompliantData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await sendTitleRequestPropertyCompliant({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const draftTitleRequestPropertyNonCompliantQueryKey = (options: Options<DraftTitleRequestPropertyNonCompliantData>) => createQueryKey('draftTitleRequestPropertyNonCompliant', options);

/**
 * Draft Title Request Property Non Compliant
 * Draft the active-interest email, including the balance due for the licenses.
 */
export const draftTitleRequestPropertyNonCompliantOptions = (options: Options<DraftTitleRequestPropertyNonCompliantData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await draftTitleRequestPropertyNonCompliant({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: draftTitleRequestPropertyNonCompliantQueryKey(options)
    });
};

/**
 * Draft Title Request Property Non Compliant
 * Draft the active-interest email, including the balance due for the licenses.
 */
export const draftTitleRequestPropertyNonCompliantMutation = (options?: Partial<Options<DraftTitleRequestPropertyNonCompliantData>>): UseMutationOptions<DraftTitleRequestPropertyNonCompliantResponse, DraftTitleRequestPropertyNonCompliantError, Options<DraftTitleRequestPropertyNonCompliantData>> => {
    const mutationOptions: UseMutationOptions<DraftTitleRequestPropertyNonCompliantResponse, DraftTitleRequestPropertyNonCompliantError, Options<DraftTitleRequestPropertyNonCompliantData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await draftTitleRequestPropertyNonCompliant({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const sendTitleRequestPropertyNonCompliantQueryKey = (options: Options<SendTitleRequestPropertyNonCompliantData>) => createQueryKey('sendTitleRequestPropertyNonCompliant', options);

/**
 * Send Title Request Property Non Compliant
 * Email the edited active-interest message and attach the selected certificates.
 */
export const sendTitleRequestPropertyNonCompliantOptions = (options: Options<SendTitleRequestPropertyNonCompliantData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await sendTitleRequestPropertyNonCompliant({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: sendTitleRequestPropertyNonCompliantQueryKey(options)
    });
};

/**
 * Send Title Request Property Non Compliant
 * Email the edited active-interest message and attach the selected certificates.
 */
export const sendTitleRequestPropertyNonCompliantMutation = (options?: Partial<Options<SendTitleRequestPropertyNonCompliantData>>): UseMutationOptions<SendTitleRequestPropertyNonCompliantResponse, SendTitleRequestPropertyNonCompliantError, Options<SendTitleRequestPropertyNonCompliantData>> => {
    const mutationOptions: UseMutationOptions<SendTitleRequestPropertyNonCompliantResponse, SendTitleRequestPropertyNonCompliantError, Options<SendTitleRequestPropertyNonCompliantData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await sendTitleRequestPropertyNonCompliant({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getOperatorTitleRequestAttachmentQueryKey = (options: Options<GetOperatorTitleRequestAttachmentData>) => createQueryKey('getOperatorTitleRequestAttachment', options);

/**
 * Get Operator Title Request Attachment
 * Download a receipt stored on a title-request email.
 */
export const getOperatorTitleRequestAttachmentOptions = (options: Options<GetOperatorTitleRequestAttachmentData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOperatorTitleRequestAttachment({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOperatorTitleRequestAttachmentQueryKey(options)
    });
};

export const listPublicCommunitiesQueryKey = (options?: Options<ListPublicCommunitiesData>) => createQueryKey('listPublicCommunities', options);

/**
 * List Public Communities
 * List all active jurisdictions (communities) configured in the system.
 *
 * No authentication required. Intended for the public marketing site directory.
 */
export const listPublicCommunitiesOptions = (options?: Options<ListPublicCommunitiesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listPublicCommunities({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listPublicCommunitiesQueryKey(options)
    });
};

export const listPublicRegistrationCommunitiesQueryKey = (options: Options<ListPublicRegistrationCommunitiesData>) => createQueryKey('listPublicRegistrationCommunities', options);

/**
 * List Public Registration Communities
 * Active jurisdictions that have any active license type matching **marketing_key**.
 */
export const listPublicRegistrationCommunitiesOptions = (options: Options<ListPublicRegistrationCommunitiesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listPublicRegistrationCommunities({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listPublicRegistrationCommunitiesQueryKey(options)
    });
};

export const getPublicJurisdictionQueryKey = (options: Options<GetPublicJurisdictionData>) => createQueryKey('getPublicJurisdiction', options);

/**
 * Get Public Jurisdiction
 * One active jurisdiction (for registrant deep links); 404 if missing or soft-deleted.
 */
export const getPublicJurisdictionOptions = (options: Options<GetPublicJurisdictionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getPublicJurisdiction({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getPublicJurisdictionQueryKey(options)
    });
};

export const listPublicLicenseTypesQueryKey = (options?: Options<ListPublicLicenseTypesData>) => createQueryKey('listPublicLicenseTypes', options);

/**
 * List Public License Types
 * List active license types for marketing registration deep links.
 *
 * Excludes soft-deleted types and types marked **under_development** so the
 * marketing site only offers registrant flows that are production-ready.
 *
 * **marketing_key** is derived from the type name (e.g. names containing
 * "Foreclosure", "Vacant", or "Long-Term Rental") and is stable for the
 * hera-web site to match.
 */
export const listPublicLicenseTypesOptions = (options?: Options<ListPublicLicenseTypesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listPublicLicenseTypes({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listPublicLicenseTypesQueryKey(options)
    });
};

export const getPublicHeraConfigurationQueryKey = (options?: Options<GetPublicHeraConfigurationData>) => createQueryKey('getPublicHeraConfiguration', options);

/**
 * Get Public Hera Configuration
 * Public support/sales contacts for marketing site footer.
 */
export const getPublicHeraConfigurationOptions = (options?: Options<GetPublicHeraConfigurationData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getPublicHeraConfiguration({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getPublicHeraConfigurationQueryKey(options)
    });
};

export const listPublicJurisdictionPagesQueryKey = (options?: Options<ListPublicJurisdictionPagesData>) => createQueryKey('listPublicJurisdictionPages', options);

/**
 * List Public Jurisdiction Pages
 * Jurisdictions that get a public registration page on heraregistry.com.
 *
 * Only jurisdictions with at least one configured, production-ready license
 * type are listed; the static site builds ``/jurisdictions/{fips_code}`` for each.
 */
export const listPublicJurisdictionPagesOptions = (options?: Options<ListPublicJurisdictionPagesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listPublicJurisdictionPages({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listPublicJurisdictionPagesQueryKey(options)
    });
};

export const getPublicJurisdictionPageQueryKey = (options: Options<GetPublicJurisdictionPageData>) => createQueryKey('getPublicJurisdictionPage', options);

/**
 * Get Public Jurisdiction Page
 * Registration programs, requirements, fees and branding for one jurisdiction.
 */
export const getPublicJurisdictionPageOptions = (options: Options<GetPublicJurisdictionPageData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getPublicJurisdictionPage({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getPublicJurisdictionPageQueryKey(options)
    });
};

export const getPublicJurisdictionPageLogoQueryKey = (options: Options<GetPublicJurisdictionPageLogoData>) => createQueryKey('getPublicJurisdictionPageLogo', options);

/**
 * Get Public Jurisdiction Page Logo
 * Jurisdiction seal for its public page (public so ``<img src>`` works).
 */
export const getPublicJurisdictionPageLogoOptions = (options: Options<GetPublicJurisdictionPageLogoData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getPublicJurisdictionPageLogo({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getPublicJurisdictionPageLogoQueryKey(options)
    });
};

export const getPublicDemoPlaceSealQueryKey = (options: Options<GetPublicDemoPlaceSealData>) => createQueryKey('getPublicDemoPlaceSeal', options);

/**
 * Get Public Demo Place Seal
 * Municipal seal/logo image (public; ``<img src>`` cannot send Bearer).
 */
export const getPublicDemoPlaceSealOptions = (options: Options<GetPublicDemoPlaceSealData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getPublicDemoPlaceSeal({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getPublicDemoPlaceSealQueryKey(options)
    });
};

export const listPublicDemoStateTopPlacesQueryKey = (options: Options<ListPublicDemoStateTopPlacesData>) => createQueryKey('listPublicDemoStateTopPlaces', options);

/**
 * List Public Demo State Top Places
 * Top jurisdictions in a US state by foreclosure count (map browse mode).
 *
 * ``is_hera_customer`` is true when an active jurisdiction row shares the
 * place FIPS (partner community), not a synthetic demo flag.
 */
export const listPublicDemoStateTopPlacesOptions = (options: Options<ListPublicDemoStateTopPlacesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listPublicDemoStateTopPlaces({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listPublicDemoStateTopPlacesQueryKey(options)
    });
};

export const listPublicDemoHeraCustomersHeatmapQueryKey = (options?: Options<ListPublicDemoHeraCustomersHeatmapData>) => createQueryKey('listPublicDemoHeraCustomersHeatmap', options);

/**
 * List Public Demo Hera Customers Heatmap
 * National (or state-scoped) HERA partner choropleth with yearly counts.
 *
 * Reads precomputed ``demo_hera_customer_heatmap`` rows only (no GCS seal
 * probes, no live TIGER). Fill color encodes foreclosure count; simplified
 * boundaries are included when the offline rebuild cached them.
 */
export const listPublicDemoHeraCustomersHeatmapOptions = (options?: Options<ListPublicDemoHeraCustomersHeatmapData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listPublicDemoHeraCustomersHeatmap({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listPublicDemoHeraCustomersHeatmapQueryKey(options)
    });
};

export const resolvePublicDemoPlaceQueryKey = (options: Options<ResolvePublicDemoPlaceData>) => createQueryKey('resolvePublicDemoPlace', options);

/**
 * Resolve Public Demo Place
 * Place match for the foreclosure demo (heuristic by default; operator auth).
 */
export const resolvePublicDemoPlaceOptions = (options: Options<ResolvePublicDemoPlaceData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await resolvePublicDemoPlace({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: resolvePublicDemoPlaceQueryKey(options)
    });
};

/**
 * Resolve Public Demo Place
 * Place match for the foreclosure demo (heuristic by default; operator auth).
 */
export const resolvePublicDemoPlaceMutation = (options?: Partial<Options<ResolvePublicDemoPlaceData>>): UseMutationOptions<ResolvePublicDemoPlaceResponse, ResolvePublicDemoPlaceError, Options<ResolvePublicDemoPlaceData>> => {
    const mutationOptions: UseMutationOptions<ResolvePublicDemoPlaceResponse, ResolvePublicDemoPlaceError, Options<ResolvePublicDemoPlaceData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await resolvePublicDemoPlace({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const resolvePublicDemoPlaceAtQueryKey = (options: Options<ResolvePublicDemoPlaceAtData>) => createQueryKey('resolvePublicDemoPlaceAt', options);

/**
 * Resolve Public Demo Place At
 * Reverse-lookup a demo place from map click coordinates (operator auth).
 */
export const resolvePublicDemoPlaceAtOptions = (options: Options<ResolvePublicDemoPlaceAtData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await resolvePublicDemoPlaceAt({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: resolvePublicDemoPlaceAtQueryKey(options)
    });
};

/**
 * Resolve Public Demo Place At
 * Reverse-lookup a demo place from map click coordinates (operator auth).
 */
export const resolvePublicDemoPlaceAtMutation = (options?: Partial<Options<ResolvePublicDemoPlaceAtData>>): UseMutationOptions<ResolvePublicDemoPlaceAtResponse, ResolvePublicDemoPlaceAtError, Options<ResolvePublicDemoPlaceAtData>> => {
    const mutationOptions: UseMutationOptions<ResolvePublicDemoPlaceAtResponse, ResolvePublicDemoPlaceAtError, Options<ResolvePublicDemoPlaceAtData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await resolvePublicDemoPlaceAt({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPublicDemoPlaceSummaryQueryKey = (options: Options<GetPublicDemoPlaceSummaryData>) => createQueryKey('getPublicDemoPlaceSummary', options);

/**
 * Get Public Demo Place Summary
 * Yearly foreclosure counts and fee for the demo dashboard.
 */
export const getPublicDemoPlaceSummaryOptions = (options: Options<GetPublicDemoPlaceSummaryData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getPublicDemoPlaceSummary({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getPublicDemoPlaceSummaryQueryKey(options)
    });
};

export const getPublicDemoPlaceHubSpotCompanyQueryKey = (options: Options<GetPublicDemoPlaceHubSpotCompanyData>) => createQueryKey('getPublicDemoPlaceHubSpotCompany', options);

/**
 * Get Public Demo Place Hubspot Company
 * Return the matching HubSpot company URL without creating a record.
 */
export const getPublicDemoPlaceHubSpotCompanyOptions = (options: Options<GetPublicDemoPlaceHubSpotCompanyData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getPublicDemoPlaceHubSpotCompany({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getPublicDemoPlaceHubSpotCompanyQueryKey(options)
    });
};

export const createPublicDemoPlaceHubSpotCompanyQueryKey = (options: Options<CreatePublicDemoPlaceHubSpotCompanyData>) => createQueryKey('createPublicDemoPlaceHubSpotCompany', options);

/**
 * Create Public Demo Place Hubspot Company
 * Create a missing HubSpot lead and return its company record URL.
 */
export const createPublicDemoPlaceHubSpotCompanyOptions = (options: Options<CreatePublicDemoPlaceHubSpotCompanyData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createPublicDemoPlaceHubSpotCompany({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createPublicDemoPlaceHubSpotCompanyQueryKey(options)
    });
};

/**
 * Create Public Demo Place Hubspot Company
 * Create a missing HubSpot lead and return its company record URL.
 */
export const createPublicDemoPlaceHubSpotCompanyMutation = (options?: Partial<Options<CreatePublicDemoPlaceHubSpotCompanyData>>): UseMutationOptions<CreatePublicDemoPlaceHubSpotCompanyResponse, CreatePublicDemoPlaceHubSpotCompanyError, Options<CreatePublicDemoPlaceHubSpotCompanyData>> => {
    const mutationOptions: UseMutationOptions<CreatePublicDemoPlaceHubSpotCompanyResponse, CreatePublicDemoPlaceHubSpotCompanyError, Options<CreatePublicDemoPlaceHubSpotCompanyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createPublicDemoPlaceHubSpotCompany({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPublicDemoPlaceEventsQueryKey = (options: Options<GetPublicDemoPlaceEventsData>) => createQueryKey('getPublicDemoPlaceEvents', options);

/**
 * Get Public Demo Place Events
 * Compact foreclosure events for the map timeline.
 */
export const getPublicDemoPlaceEventsOptions = (options: Options<GetPublicDemoPlaceEventsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getPublicDemoPlaceEvents({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getPublicDemoPlaceEventsQueryKey(options)
    });
};

export const getPublicDemoPlaceBoundaryQueryKey = (options: Options<GetPublicDemoPlaceBoundaryData>) => createQueryKey('getPublicDemoPlaceBoundary', options);

/**
 * Get Public Demo Place Boundary
 * GeoJSON boundary for stylized map framing (cached on first fetch).
 */
export const getPublicDemoPlaceBoundaryOptions = (options: Options<GetPublicDemoPlaceBoundaryData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getPublicDemoPlaceBoundary({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getPublicDemoPlaceBoundaryQueryKey(options)
    });
};

export const emailPublicDemoPlaceSummaryQueryKey = (options: Options<EmailPublicDemoPlaceSummaryData>) => createQueryKey('emailPublicDemoPlaceSummary', options);

/**
 * Email Public Demo Place Summary
 * Email a jurisdiction map snapshot and end-of-year stats (operator auth).
 */
export const emailPublicDemoPlaceSummaryOptions = (options: Options<EmailPublicDemoPlaceSummaryData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await emailPublicDemoPlaceSummary({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: emailPublicDemoPlaceSummaryQueryKey(options)
    });
};

/**
 * Email Public Demo Place Summary
 * Email a jurisdiction map snapshot and end-of-year stats (operator auth).
 */
export const emailPublicDemoPlaceSummaryMutation = (options?: Partial<Options<EmailPublicDemoPlaceSummaryData>>): UseMutationOptions<EmailPublicDemoPlaceSummaryResponse, EmailPublicDemoPlaceSummaryError, Options<EmailPublicDemoPlaceSummaryData>> => {
    const mutationOptions: UseMutationOptions<EmailPublicDemoPlaceSummaryResponse, EmailPublicDemoPlaceSummaryError, Options<EmailPublicDemoPlaceSummaryData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await emailPublicDemoPlaceSummary({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listJurisdictionRegionsQueryKey = (options?: Options<ListJurisdictionRegionsData>) => createQueryKey('listJurisdictionRegions', options);

/**
 * List Regions Endpoint
 * Regions for the requested jurisdictions.
 */
export const listJurisdictionRegionsOptions = (options?: Options<ListJurisdictionRegionsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listJurisdictionRegions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listJurisdictionRegionsQueryKey(options)
    });
};

export const createJurisdictionRegionQueryKey = (options: Options<CreateJurisdictionRegionData>) => createQueryKey('createJurisdictionRegion', options);

/**
 * Create Region Endpoint
 * Save a drawn, uploaded, or prompted polygon.
 */
export const createJurisdictionRegionOptions = (options: Options<CreateJurisdictionRegionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createJurisdictionRegion({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createJurisdictionRegionQueryKey(options)
    });
};

/**
 * Create Region Endpoint
 * Save a drawn, uploaded, or prompted polygon.
 */
export const createJurisdictionRegionMutation = (options?: Partial<Options<CreateJurisdictionRegionData>>): UseMutationOptions<CreateJurisdictionRegionResponse, CreateJurisdictionRegionError, Options<CreateJurisdictionRegionData>> => {
    const mutationOptions: UseMutationOptions<CreateJurisdictionRegionResponse, CreateJurisdictionRegionError, Options<CreateJurisdictionRegionData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createJurisdictionRegion({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getJurisdictionRegionBoundaryQueryKey = (options: Options<GetJurisdictionRegionBoundaryData>) => createQueryKey('getJurisdictionRegionBoundary', options);

/**
 * Get Boundary Endpoint
 * Census boundary that every region in this jurisdiction is clipped to.
 */
export const getJurisdictionRegionBoundaryOptions = (options: Options<GetJurisdictionRegionBoundaryData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getJurisdictionRegionBoundary({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getJurisdictionRegionBoundaryQueryKey(options)
    });
};

export const previewJurisdictionRegionUploadQueryKey = (options: Options<PreviewJurisdictionRegionUploadData>) => createQueryKey('previewJurisdictionRegionUpload', options);

/**
 * Preview Upload Endpoint
 * Parse a shapefile zip or GeoJSON and clip it to the jurisdiction.
 */
export const previewJurisdictionRegionUploadOptions = (options: Options<PreviewJurisdictionRegionUploadData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await previewJurisdictionRegionUpload({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: previewJurisdictionRegionUploadQueryKey(options)
    });
};

/**
 * Preview Upload Endpoint
 * Parse a shapefile zip or GeoJSON and clip it to the jurisdiction.
 */
export const previewJurisdictionRegionUploadMutation = (options?: Partial<Options<PreviewJurisdictionRegionUploadData>>): UseMutationOptions<PreviewJurisdictionRegionUploadResponse, PreviewJurisdictionRegionUploadError, Options<PreviewJurisdictionRegionUploadData>> => {
    const mutationOptions: UseMutationOptions<PreviewJurisdictionRegionUploadResponse, PreviewJurisdictionRegionUploadError, Options<PreviewJurisdictionRegionUploadData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await previewJurisdictionRegionUpload({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const commitJurisdictionRegionUploadQueryKey = (options: Options<CommitJurisdictionRegionUploadData>) => createQueryKey('commitJurisdictionRegionUpload', options);

/**
 * Commit Upload Endpoint
 * Save a preview as one region or one region per named feature.
 */
export const commitJurisdictionRegionUploadOptions = (options: Options<CommitJurisdictionRegionUploadData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await commitJurisdictionRegionUpload({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: commitJurisdictionRegionUploadQueryKey(options)
    });
};

/**
 * Commit Upload Endpoint
 * Save a preview as one region or one region per named feature.
 */
export const commitJurisdictionRegionUploadMutation = (options?: Partial<Options<CommitJurisdictionRegionUploadData>>): UseMutationOptions<CommitJurisdictionRegionUploadResponse, CommitJurisdictionRegionUploadError, Options<CommitJurisdictionRegionUploadData>> => {
    const mutationOptions: UseMutationOptions<CommitJurisdictionRegionUploadResponse, CommitJurisdictionRegionUploadError, Options<CommitJurisdictionRegionUploadData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await commitJurisdictionRegionUpload({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const promptJurisdictionRegionsQueryKey = (options: Options<PromptJurisdictionRegionsData>) => createQueryKey('promptJurisdictionRegions', options);

/**
 * Prompt Regions Endpoint
 * Turn a description into clipped region drafts. Nothing is saved.
 */
export const promptJurisdictionRegionsOptions = (options: Options<PromptJurisdictionRegionsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await promptJurisdictionRegions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: promptJurisdictionRegionsQueryKey(options)
    });
};

/**
 * Prompt Regions Endpoint
 * Turn a description into clipped region drafts. Nothing is saved.
 */
export const promptJurisdictionRegionsMutation = (options?: Partial<Options<PromptJurisdictionRegionsData>>): UseMutationOptions<PromptJurisdictionRegionsResponse, PromptJurisdictionRegionsError, Options<PromptJurisdictionRegionsData>> => {
    const mutationOptions: UseMutationOptions<PromptJurisdictionRegionsResponse, PromptJurisdictionRegionsError, Options<PromptJurisdictionRegionsData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await promptJurisdictionRegions({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const commandJurisdictionRegionsQueryKey = (options: Options<CommandJurisdictionRegionsData>) => createQueryKey('commandJurisdictionRegions', options);

/**
 * Command Regions Endpoint
 * Apply a chat command immediately. The response includes undo steps.
 */
export const commandJurisdictionRegionsOptions = (options: Options<CommandJurisdictionRegionsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await commandJurisdictionRegions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: commandJurisdictionRegionsQueryKey(options)
    });
};

/**
 * Command Regions Endpoint
 * Apply a chat command immediately. The response includes undo steps.
 */
export const commandJurisdictionRegionsMutation = (options?: Partial<Options<CommandJurisdictionRegionsData>>): UseMutationOptions<CommandJurisdictionRegionsResponse, CommandJurisdictionRegionsError, Options<CommandJurisdictionRegionsData>> => {
    const mutationOptions: UseMutationOptions<CommandJurisdictionRegionsResponse, CommandJurisdictionRegionsError, Options<CommandJurisdictionRegionsData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await commandJurisdictionRegions({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const downloadRegionDraftShapefileQueryKey = (options: Options<DownloadRegionDraftShapefileData>) => createQueryKey('downloadRegionDraftShapefile', options);

/**
 * Download Draft Shapefile Endpoint
 * Download one preview feature as a zipped shapefile.
 */
export const downloadRegionDraftShapefileOptions = (options: Options<DownloadRegionDraftShapefileData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await downloadRegionDraftShapefile({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: downloadRegionDraftShapefileQueryKey(options)
    });
};

/**
 * Delete Region Endpoint
 * Delete a disabled region. An enabled region must be turned off first.
 */
export const deleteJurisdictionRegionMutation = (options?: Partial<Options<DeleteJurisdictionRegionData>>): UseMutationOptions<DeleteJurisdictionRegionResponse, DeleteJurisdictionRegionError, Options<DeleteJurisdictionRegionData>> => {
    const mutationOptions: UseMutationOptions<DeleteJurisdictionRegionResponse, DeleteJurisdictionRegionError, Options<DeleteJurisdictionRegionData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await deleteJurisdictionRegion({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Region Endpoint
 * Rename a region, replace its polygon, or enable and disable it.
 */
export const updateJurisdictionRegionMutation = (options?: Partial<Options<UpdateJurisdictionRegionData>>): UseMutationOptions<UpdateJurisdictionRegionResponse, UpdateJurisdictionRegionError, Options<UpdateJurisdictionRegionData>> => {
    const mutationOptions: UseMutationOptions<UpdateJurisdictionRegionResponse, UpdateJurisdictionRegionError, Options<UpdateJurisdictionRegionData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateJurisdictionRegion({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const downloadJurisdictionRegionShapefileQueryKey = (options: Options<DownloadJurisdictionRegionShapefileData>) => createQueryKey('downloadJurisdictionRegionShapefile', options);

/**
 * Download Region Shapefile Endpoint
 * Download a saved region as a zipped shapefile.
 */
export const downloadJurisdictionRegionShapefileOptions = (options: Options<DownloadJurisdictionRegionShapefileData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await downloadJurisdictionRegionShapefile({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: downloadJurisdictionRegionShapefileQueryKey(options)
    });
};

export const checkHealthQueryKey = (options?: Options<CheckHealthData>) => createQueryKey('checkHealth', options);

/**
 * Health Check Endpoint
 * Health check endpoint.
 *
 * By default checks that the route is reachable, but can be called with optional query params that specify additional checks (like DB connectivity).
 */
export const checkHealthOptions = (options?: Options<CheckHealthData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await checkHealth({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: checkHealthQueryKey(options)
    });
};

export const onAuth0LoginQueryKey = (options: Options<OnAuth0LoginData>) => createQueryKey('onAuth0Login', options);

/**
 * On Auth0 Login Endpoint
 * Login webhook target called by Auth0 post-login action.
 */
export const onAuth0LoginOptions = (options: Options<OnAuth0LoginData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await onAuth0Login({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: onAuth0LoginQueryKey(options)
    });
};

/**
 * On Auth0 Login Endpoint
 * Login webhook target called by Auth0 post-login action.
 */
export const onAuth0LoginMutation = (options?: Partial<Options<OnAuth0LoginData>>): UseMutationOptions<OnAuth0LoginResponse, OnAuth0LoginError, Options<OnAuth0LoginData>> => {
    const mutationOptions: UseMutationOptions<OnAuth0LoginResponse, OnAuth0LoginError, Options<OnAuth0LoginData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await onAuth0Login({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const onStripeEventQueryKey = (options: Options<OnStripeEventData>) => createQueryKey('onStripeEvent', options);

/**
 * On Stripe Event Endpoint
 * Webhook target called by Stripe for various events.
 *
 * This endpoint handles Stripe webhook events. It verifies the webhook signature
 * using the Stripe webhook secret to ensure the request is legitimate.
 *
 * The endpoint can handle various Stripe events such as:
 * - payment_intent.succeeded
 * - payment_intent.payment_failed
 */
export const onStripeEventOptions = (options: Options<OnStripeEventData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await onStripeEvent({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: onStripeEventQueryKey(options)
    });
};

/**
 * On Stripe Event Endpoint
 * Webhook target called by Stripe for various events.
 *
 * This endpoint handles Stripe webhook events. It verifies the webhook signature
 * using the Stripe webhook secret to ensure the request is legitimate.
 *
 * The endpoint can handle various Stripe events such as:
 * - payment_intent.succeeded
 * - payment_intent.payment_failed
 */
export const onStripeEventMutation = (options?: Partial<Options<OnStripeEventData>>): UseMutationOptions<OnStripeEventResponse, OnStripeEventError, Options<OnStripeEventData>> => {
    const mutationOptions: UseMutationOptions<OnStripeEventResponse, OnStripeEventError, Options<OnStripeEventData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await onStripeEvent({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const onHubSpotCompanyEventQueryKey = (options?: Options<OnHubSpotCompanyEventData>) => createQueryKey('onHubSpotCompanyEvent', options);

/**
 * On Hubspot Company Event Endpoint
 * Refresh HubSpot companies after GEOID, fee, or lifecycle changes.
 *
 * HubSpot CRM app webhooks POST ``company.creation`` and
 * ``company.propertyChange`` here. Signature v3 is verified, then matching
 * companies are recalculated in the background so HubSpot's 5s timeout is
 * not blocked by remittance math.
 */
export const onHubSpotCompanyEventOptions = (options?: Options<OnHubSpotCompanyEventData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await onHubSpotCompanyEvent({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: onHubSpotCompanyEventQueryKey(options)
    });
};

/**
 * On Hubspot Company Event Endpoint
 * Refresh HubSpot companies after GEOID, fee, or lifecycle changes.
 *
 * HubSpot CRM app webhooks POST ``company.creation`` and
 * ``company.propertyChange`` here. Signature v3 is verified, then matching
 * companies are recalculated in the background so HubSpot's 5s timeout is
 * not blocked by remittance math.
 */
export const onHubSpotCompanyEventMutation = (options?: Partial<Options<OnHubSpotCompanyEventData>>): UseMutationOptions<OnHubSpotCompanyEventResponse, DefaultError, Options<OnHubSpotCompanyEventData>> => {
    const mutationOptions: UseMutationOptions<OnHubSpotCompanyEventResponse, DefaultError, Options<OnHubSpotCompanyEventData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await onHubSpotCompanyEvent({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listHubSpotCompanyGeofipsOptionsQueryKey = (options: Options<ListHubSpotCompanyGeofipsOptionsData>) => createQueryKey('listHubSpotCompanyGeofipsOptions', options);

/**
 * List Hubspot Company Geofips Options Endpoint
 * List Census GEOID choices for a HubSpot company name.
 */
export const listHubSpotCompanyGeofipsOptionsOptions = (options: Options<ListHubSpotCompanyGeofipsOptionsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listHubSpotCompanyGeofipsOptions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listHubSpotCompanyGeofipsOptionsQueryKey(options)
    });
};

export const selectHubSpotCompanyGeofipsQueryKey = (options: Options<SelectHubSpotCompanyGeofipsData>) => createQueryKey('selectHubSpotCompanyGeofips', options);

/**
 * Select Hubspot Company Geofips Endpoint
 * Save the GEOID chosen on the HubSpot company card.
 */
export const selectHubSpotCompanyGeofipsOptions = (options: Options<SelectHubSpotCompanyGeofipsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await selectHubSpotCompanyGeofips({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: selectHubSpotCompanyGeofipsQueryKey(options)
    });
};

/**
 * Select Hubspot Company Geofips Endpoint
 * Save the GEOID chosen on the HubSpot company card.
 */
export const selectHubSpotCompanyGeofipsMutation = (options?: Partial<Options<SelectHubSpotCompanyGeofipsData>>): UseMutationOptions<SelectHubSpotCompanyGeofipsResponse, SelectHubSpotCompanyGeofipsError, Options<SelectHubSpotCompanyGeofipsData>> => {
    const mutationOptions: UseMutationOptions<SelectHubSpotCompanyGeofipsResponse, SelectHubSpotCompanyGeofipsError, Options<SelectHubSpotCompanyGeofipsData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await selectHubSpotCompanyGeofips({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const onHubSpotContactEventQueryKey = (options?: Options<OnHubSpotContactEventData>) => createQueryKey('onHubSpotContactEvent', options);

/**
 * On Hubspot Contact Event Endpoint
 * Apply HubSpot Contact Type changes to matching VPRO government users.
 */
export const onHubSpotContactEventOptions = (options?: Options<OnHubSpotContactEventData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await onHubSpotContactEvent({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: onHubSpotContactEventQueryKey(options)
    });
};

/**
 * On Hubspot Contact Event Endpoint
 * Apply HubSpot Contact Type changes to matching VPRO government users.
 */
export const onHubSpotContactEventMutation = (options?: Partial<Options<OnHubSpotContactEventData>>): UseMutationOptions<OnHubSpotContactEventResponse, DefaultError, Options<OnHubSpotContactEventData>> => {
    const mutationOptions: UseMutationOptions<OnHubSpotContactEventResponse, DefaultError, Options<OnHubSpotContactEventData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await onHubSpotContactEvent({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};